webpackJsonp([0],Array(322).concat([
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(323);
module.exports = __webpack_require__(324);


/***/ }),
/* 323 */,
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(flatpickr, Isotope) {

__webpack_require__(326);

var _storefront = __webpack_require__(327);

var _storefront2 = _interopRequireDefault(_storefront);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

angular.element(document).ready(function () {
    angular.bootstrap(document, [_storefront2.default.name], {
        strictDi: true
    });
    (function () {
        if (typeof window.CustomEvent === "function") return false; //If not IE

        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    (function ($) {

        // Polyfill for nodelist not supporting forEach()
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        $(document).foundation();

        window.resetFilters = function () {
            $('[data-grid-filter]').val('*').trigger('change');
        };

        var gridContainerEl = document.querySelectorAll('.js-grid-container');
        var gridItemsEl = document.querySelectorAll('.js-grid__item');

        function initCalendar() {
            var flatpickrEl = $('.js-flatpickr');

            if (flatpickrEl.length && flatpickr) {
                var minDate = 'today';
                var maxDate = (0, _moment2.default)().add(1, 'year').format('YYYY-MM-DD');

                var startDate = localStorage.getItem('start_date');
                if (startDate) {
                    minDate = (0, _moment2.default)(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD');
                    maxDate = (0, _moment2.default)(localStorage.getItem('end_date'), 'YYYY-MM-DD').format('YYYY-MM-DD');
                }

                var fpOptions = {
                    altInput: true,
                    minDate: minDate,
                    maxDate: maxDate,
                    disableMobile: "true"
                };

                window.fpInput = flatpickr(".js-flatpickr", fpOptions);
            }
        }
        initCalendar();

        window.addEventListener('initCalendar', function () {
            initCalendar();
        });

        if (gridContainerEl.length && gridItemsEl.length && Isotope) {
            var isotopeContainers = [];
            gridContainerEl.forEach(function (gridContainer) {
                var grid = gridContainer.querySelectorAll('.js-grid') && gridContainer.querySelectorAll('.js-grid')[0];

                if (grid) {
                    isotopeContainers.push({
                        el: gridContainer,
                        isotope: new Isotope(grid, {
                            itemSelector: '.js-grid__item',
                            layoutMode: 'fitRows',
                            getSortData: {
                                a_z: '.js-grid__item__heading',
                                z_a: '.js-grid__item__heading',
                                highest: function highest(elem) {
                                    return parseFloat(elem.getAttribute('value'));
                                },
                                lowest: function lowest(elem) {
                                    return parseFloat(elem.getAttribute('value'));
                                },
                                available: function available(elem) {
                                    return elem.classList.contains('js-grid__item--not-available') ? 0 : 1;
                                }
                            },
                            sortAscending: {
                                a_z: true,
                                z_a: false,
                                highest: false,
                                lowest: true,
                                available: false
                            },
                            visibleStyle: {
                                opacity: 1,
                                transform: 'translateY(0)'
                            },
                            hiddenStyle: {
                                opacity: 0,
                                transform: 'translateY(100px)'
                            }
                        })
                    });
                }
            });
            window.isotope = isotopeContainers;

            $('[data-grid-filter]').on('change', function () {
                var thisEl = $(this);
                var thisVal = thisEl.val();

                var otherFilter = $('[data-grid-filter]').not(thisEl).val();
                if (otherFilter && otherFilter !== '*') {
                    thisVal += '' + otherFilter;
                }

                var noResultsEl = document.querySelectorAll('.js-search-message') && document.querySelectorAll('.js-search-message')[0];
                var hasNoResults = [];

                if (noResultsEl) {
                    noResultsEl.classList.remove('is-active');
                };

                isotopeContainers.forEach(function (container) {
                    var heading = container.el.querySelectorAll('.js-grid__heading') && container.el.querySelectorAll('.js-grid__heading')[0];

                    container.isotope.arrange({ filter: thisVal, sortBy: 'available' });

                    if (!container.isotope.filteredItems.length) {
                        hasNoResults.push(true);

                        if (heading) {
                            heading.classList.add('is-hidden');
                        }
                        return;
                    }

                    if (heading) {
                        heading.classList.remove('is-hidden');
                    }
                });

                if (hasNoResults.length === isotopeContainers.length && noResultsEl) {
                    noResultsEl.classList.add('is-active');
                }

                setTimeout(function () {
                    window.dispatchEvent(new CustomEvent('imgixRefresh'));
                }, 250);
            });

            $('[data-grid-sort]').on('change', function () {
                var thisVal = $(this).val();
                isotopeContainers.forEach(function (container) {
                    container.isotope.arrange({ sortBy: ['available', thisVal] });
                });
            });

            var category = void 0;
            try {
                category = new URL(window.location).searchParams.get('category');
            } catch (error) {
                var url = window.location.href;
                var regex = new RegExp("[?&]category(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (results && results[2]) {
                    category = decodeURIComponent(results[2].replace(/\+/g, " "));
                }
            }
            if (category) setTimeout(function () {
                return $('.c-select--categories').val('.' + category).trigger('change');
            }, 750);
        }

        var offcanvasLeftEl = $('.off-canvas.position-left'),
            offcanvasRightEl = $('.off-canvas.position-right');

        new Foundation.OffCanvas(offcanvasLeftEl);
        new Foundation.OffCanvas(offcanvasRightEl);

        offcanvasLeftEl.on('opened.zf.offcanvas', function () {
            document.body.classList.add('offcanvas-open');
        });
        offcanvasRightEl.on('opened.zf.offcanvas', function () {
            document.body.classList.add('offcanvas-open');
        });

        offcanvasLeftEl.on('closed.zf.offcanvas', function () {
            document.body.classList.remove('offcanvas-open');
        });
        offcanvasRightEl.on('closed.zf.offcanvas', function () {
            document.body.classList.remove('offcanvas-open');
        });

        var groupDropdownEl = $('.js-dropdown');
        if (groupDropdownEl.length) {
            new Foundation.Dropdown(groupDropdownEl);
        }

        // Detect request animation frame
        var scroll = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || window.oRequestAnimationFrame ||
        // IE Fallback, you can even fallback to onscroll
        function (callback) {
            window.setTimeout(callback, 1000 / 60);
        };

        function scrollLoop() {

            var top = window.pageYOffset;

            if (top > 100) {
                document.body.classList.add('has-scrolled');
            } else {
                document.body.classList.remove('has-scrolled');
            }

            // Recall the scrollLoop
            scroll(scrollLoop);
        }
        // Call the scrollLoop for the first time
        scrollLoop();

        $('.js-flickity').on('change.flickity', function () {
            setTimeout(function () {
                window.dispatchEvent(new CustomEvent('imgixRefresh'));
            }, 750);
        });
    })(jQuery);
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127), __webpack_require__(128)))

/***/ }),
/* 325 */,
/* 326 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(328);

var _vendor = __webpack_require__(354);

var _modules = __webpack_require__(586);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var app = angular.module('spabooker', [].concat(_toConsumableArray(_vendor.vendor), _toConsumableArray(_modules.modules))).config(['$locationProvider', '$urlRouterProvider', function ($locationProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: false,
        rewriteLinks: false
    });
}]).config(['uiSelectConfig', function (uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
}]).run(['$transitions', '$window', '$rootScope', '$state', function ($transitions, $window, $rootScope, $state) {
    $transitions.onSuccess({}, function () {
        $window.scrollTo(0, 280);
    });

    // Silence transition errors (and any other $state error...)
    $state.defaultErrorHandler(function (error) {
        console.log(error);
    });

    $rootScope.$on('$locationChangeSuccess', function () {
        if (typeof analytics !== 'undefined') {
            analytics.page();
        }
    });
}]);

exports.default = app;

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(329);

__webpack_require__(331);

__webpack_require__(333);

__webpack_require__(334);

__webpack_require__(335);

__webpack_require__(336);

__webpack_require__(337);

__webpack_require__(338);

__webpack_require__(128);

__webpack_require__(127);

__webpack_require__(130);

__webpack_require__(86);

__webpack_require__(340);

var Flickity = __webpack_require__(342);

/***/ }),
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendor = undefined;

__webpack_require__(86);

__webpack_require__(355);

__webpack_require__(357);

__webpack_require__(359);

__webpack_require__(380);

__webpack_require__(382);

__webpack_require__(383);

__webpack_require__(585);

var vendor = exports.vendor = ['ngAnimate', 'ngSanitize', 'ngMessages', 'ui.router', 'angularModalService', 'ngMask'];

/***/ }),
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modules = undefined;

var _availability = __webpack_require__(587);

var _availability2 = _interopRequireDefault(_availability);

var _base = __webpack_require__(600);

var _base2 = _interopRequireDefault(_base);

var _guest = __webpack_require__(629);

var _guest2 = _interopRequireDefault(_guest);

var _item = __webpack_require__(632);

var _item2 = _interopRequireDefault(_item);

var _checkout = __webpack_require__(635);

var _checkout2 = _interopRequireDefault(_checkout);

var _core = __webpack_require__(647);

var _core2 = _interopRequireDefault(_core);

var _payment = __webpack_require__(649);

var _payment2 = _interopRequireDefault(_payment);

var _services = __webpack_require__(672);

var _services2 = _interopRequireDefault(_services);

var _basket = __webpack_require__(674);

var _basket2 = _interopRequireDefault(_basket);

var _guest3 = __webpack_require__(703);

var _guest4 = _interopRequireDefault(_guest3);

var _page = __webpack_require__(716);

var _page2 = _interopRequireDefault(_page);

var _widget = __webpack_require__(775);

var _widget2 = _interopRequireDefault(_widget);

var _popup = __webpack_require__(802);

var _popup2 = _interopRequireDefault(_popup);

var _checkout3 = __webpack_require__(807);

var _checkout4 = _interopRequireDefault(_checkout3);

var _order = __webpack_require__(845);

var _order2 = _interopRequireDefault(_order);

var _availability3 = __webpack_require__(848);

var _availability4 = _interopRequireDefault(_availability3);

var _user = __webpack_require__(853);

var _user2 = _interopRequireDefault(_user);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var modules = exports.modules = [_availability2.default, _base2.default, _guest2.default, _item2.default, _checkout2.default, _core2.default, _payment2.default, _services2.default, _guest4.default, _page2.default, _basket2.default, _widget2.default, _popup2.default, _checkout4.default, _order2.default, _availability4.default, _user2.default];

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _preferredTime = __webpack_require__(588);

var _preferredTime2 = _interopRequireDefault(_preferredTime);

var _staffPicker = __webpack_require__(589);

var _staffPicker2 = _interopRequireDefault(_staffPicker);

var _preferredTime3 = __webpack_require__(590);

var _preferredTime4 = _interopRequireDefault(_preferredTime3);

var _staffPicker3 = __webpack_require__(592);

var _staffPicker4 = _interopRequireDefault(_staffPicker3);

var _availability = __webpack_require__(594);

var _availability2 = _interopRequireDefault(_availability);

var _availabilityCache = __webpack_require__(595);

var _availabilityCache2 = _interopRequireDefault(_availabilityCache);

var _startTime = __webpack_require__(597);

var _startTime2 = _interopRequireDefault(_startTime);

var _quantity = __webpack_require__(598);

var _quantity2 = _interopRequireDefault(_quantity);

var _suggestions = __webpack_require__(599);

var _suggestions2 = _interopRequireDefault(_suggestions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedAvailabilityModule = angular.module('spabooker.shared.availability', []).component('preferredTime', _preferredTime4.default).component('staffPicker', _staffPicker4.default).controller('preferredTimeController', _preferredTime2.default).controller('staffPickerController', _staffPicker2.default).factory('availabilityService', _availability2.default).factory('availabilityCacheService', _availabilityCache2.default).factory('startTimeService', _startTime2.default).factory('quantityService', _quantity2.default).factory('suggestionsService', _suggestions2.default);

exports.default = sharedAvailabilityModule.name;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PreferredTimeController = function () {
  function PreferredTimeController(basket, availabilityService, itemService, loadingService, configService) {
    _classCallCheck(this, PreferredTimeController);

    this.basket = basket;
    this.availabilityService = availabilityService;
    this.itemService = itemService;
    this.loadingService = loadingService;
    this.configService = configService;
  }

  _createClass(PreferredTimeController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.item = this.itemService.getItem();

      var integration = this.configService.get('integration');

      if (integration) {
        this.requestAttendees = this.configService.get('integration').type === 'concept';

        if (this.requestAttendees) {
          var minimum_guests = this.item.minimum_guests || 1;
          this.guestArray = [1 * minimum_guests, 2 * minimum_guests, 3 * minimum_guests];
        }
      }

      return this.basket.promise.then(function () {
        _this.isSuggestedEvent();
      });
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      return this.loadingService.isLoading('times') || !this.loadingService.isLoading('times') && !this.hasTimes();
    }
  }, {
    key: 'hasTimes',
    value: function hasTimes() {
      if (this.availabilityService.hasSingleTimes()) {
        return true;
      }

      return false;
    }
  }, {
    key: 'isDisabled',
    value: function isDisabled() {
      var times = this.availabilityService.getSingleTimes();
      return !times || times && times.length < 2;
    }
  }, {
    key: 'displayTime',
    value: function displayTime() {
      var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!startTime) {
        return null;
      }

      return startTime.substring(0, 5);
    }
  }, {
    key: 'isSuggestedEvent',
    value: function isSuggestedEvent() {
      if (this.basket.contents.suggested_event && this.item.type === this.basket.contents.suggested_event.type && this.item.id === parseInt(this.basket.contents.suggested_event.id)) {
        this.item.suggested = true;
        return true;
      }
    }
  }, {
    key: 'selectTime',
    value: function selectTime(selectedTime) {
      var numberOfGuests = this.numberOfGuests || undefined;

      if (selectedTime.price) {
        this.item.price = selectedTime.price;
        this.item.original = selectedTime.original_price;
        this.item.end_time = selectedTime.end;
        this.itemService.setItem(this.item);
      }
      this.resetStaff();
      this.getQuantity({ numberOfGuests: numberOfGuests });
    }
  }, {
    key: 'updateTimes',
    value: function updateTimes(numberOfGuests) {
      if (this.item && this.item.price && this.numberOfGuests) {
        this.resetStaff();
        this.getQuantity({ numberOfGuests: this.numberOfGuests });
      }
    }
  }]);

  return PreferredTimeController;
}();

PreferredTimeController.$inject = ['basket', 'availabilityService', 'itemService', 'loadingService', 'configService'];

exports.default = PreferredTimeController;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StaffPickerController = function () {
  function StaffPickerController() {
    _classCallCheck(this, StaffPickerController);
  }

  _createClass(StaffPickerController, [{
    key: "displayStaff",
    value: function displayStaff() {
      if (this.staff.length > 0) {

        if (!this.guest.staff) {
          this.guest.staff = this.staff.find(function (staff) {
            return !staff.disabled;
          });
          this.guest.staff.disabled = true;
        }
      }

      return this.staff;
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.canDisable && this.staff.length <= 1;
    }
  }, {
    key: "updateStaff",
    value: function updateStaff(oldStaff, newStaff) {
      if (oldStaff) {
        var staff = this.staff.find(function (staff) {
          return staff.id === oldStaff.id;
        });
        if (staff) {
          delete staff.disabled;
        }
      }

      if (newStaff.id) {
        newStaff.disabled = true;
      }
    }
  }]);

  return StaffPickerController;
}();

StaffPickerController.$inject = [];

exports.default = StaffPickerController;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'availability': '<',
        'item': '<',
        'getQuantity': '&',
        'resetStaff': '&'
    },
    controller: 'preferredTimeController',
    template: __webpack_require__(591)
};

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = "<section class=\"c-guest-count / grid-x\" ng-if=$ctrl.requestAttendees> <div class=\"c-guest-counter / cell medium-auto\" ng-repeat=\"guestNumber in $ctrl.guestArray\"> <input type=radio id=\"guests-{{ guestNumber }}\" name=numberOfGuests value=\"{{ guestNumber }}\" ng-model=$ctrl.numberOfGuests ng-change=$ctrl.updateTimes() /> <label for=\"guests-{{ guestNumber }}\"> {{ guestNumber }} {{ guestNumber === 1 ? 'Guest' : 'Guests' }} </label> </div> </section> <div ng-if=!$ctrl.isSuggestedEvent() ng-show=\"!$ctrl.requestAttendees || $ctrl.numberOfGuests\"> <div class=\"c-form__field c-form__field--select / c-time-picker__container\"> <div ng-show=!$ctrl.isLoading()> <ui-select class=\"c-form__select / c-time-picker\" ng-model=$ctrl.item.preferred_time ng-disabled=$ctrl.isDisabled() input-id=preferredTime on-select=$ctrl.selectTime($item)> <ui-select-match placeholder=\"- Please select a time -\"> <div class=\"c-time-picker__values c-time-picker__values--selected\"> <div class=c-time-picker__time ng-bind-html=$ctrl.displayTime($ctrl.item.preferred_time)></div> <span> <s ng-if=\"$ctrl.item.original !== $ctrl.item.price\"> <money class=c-time-picker__price amount=\"$ctrl.item.original * $ctrl.item.minimum_guests\" decorate=true></money> </s> <money class=c-time-picker__price amount=\"$ctrl.item.price * $ctrl.item.minimum_guests\" decorate=true></money> </span> </div> </ui-select-match> <ui-select-choices repeat=\"time.time as time in $ctrl.availabilityService.getSingleTimes() track by $index\"> <div class=c-time-picker__values> <div class=c-time-picker__time ng-bind-html=$ctrl.displayTime(time.time)></div> <span> <s ng-if=\"time.original_price !== time.price\"> <money class=c-time-picker__price amount=\"time.original_price * $ctrl.item.minimum_guests\" decorate=true></money> </s> <money class=c-time-picker__price amount=\"time.price * $ctrl.item.minimum_guests\" decorate=true></money> </span> </div> </ui-select-choices> </ui-select> <label class=\"c-form__label t-text--secondary\" for=preferredTime ng-if=$ctrl.isDisabled()> Your arrival time will be... </label> <label class=\"c-form__label t-text--secondary\" for=preferredTime ng-if=!$ctrl.isDisabled()> Select your arrival time... </label> </div> <spinner ng-if=$ctrl.isLoading() class=c-time-picker__spinner></spinner>  </div> </div>";

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guest: '=',
        staff: '<',
        appendToBody: '<',
        canDisable: '<'
    },
    controller: 'staffPickerController',
    template: __webpack_require__(593)
};

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-staff-select__container / c-form__field c-form__field--select\"> <ui-select class=\"c-form__select c-staff-select\" ng-model=$ctrl.guest.staff ng-change=\"$ctrl.updateStaff({{$ctrl.guest.staff || 0}}, $ctrl.guest.staff)\" ng-disabled=$ctrl.isDisabled() append-to-body=$ctrl.appendToBody> <ui-select-match> {{ $select.selected.label }} </ui-select-match> <ui-select-choices repeat=\"staff in $ctrl.displayStaff() | filter: { label: $select.search } track by staff.id\" ui-disable-choice=staff.disabled> <span ng-bind=staff.label></span> </ui-select-choices> </ui-select> <label class=\"c-form__label t-text--secondary\">With...</label> </div> ";

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    var _this = this;

    this.availability = [];
    this.singleDays = [];
    this.singleTimes = [];

    return {
        resetAvailability: function resetAvailability() {
            _this.availability = [];
        },
        getAvailability: function getAvailability() {
            return _this.availability;
        },
        setAvailability: function setAvailability(availability) {
            _this.availability = availability;
        },
        hasAvailability: function hasAvailability() {
            return !!_this.availability.length;
        },
        resetSingleDays: function resetSingleDays() {
            _this.singleDays = [];
        },
        getSingleDays: function getSingleDays() {
            return _this.singleDays;
        },
        setSingleDays: function setSingleDays(days) {
            _this.singleDays = days;
        },
        hasSingleDays: function hasSingleDays() {
            return !!_this.singleDays.length;
        },
        resetSingleTimes: function resetSingleTimes() {
            _this.singleTimes = [];
        },
        getSingleTimes: function getSingleTimes() {
            if (_this.singleTimes === false) {
                return [];
            }
            return _this.singleTimes;
        },
        setSingleTimes: function setSingleTimes(times) {
            _this.singleTimes = times;
        },
        hasSingleTimes: function hasSingleTimes() {
            if (_this.singleTimes === false) {
                return true;
            }
            return !!_this.singleTimes.length;
        }
    };
}];

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [function () {
    var cachedAvailability = {};

    var datesCached = function datesCached(eventType, eventId, fromDate, toDate) {
        var cache = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

        var cached = checkCache(eventType, eventId, fromDate);

        if (!cached) {
            return [];
        }

        cache.push(cached);

        if (fromDate === toDate) {
            return cache;
        }

        fromDate = (0, _moment2.default)(fromDate).add(1, 'day').format('YYYY-MM-DD');

        return datesCached(eventType, eventId, fromDate, toDate, cache);
    };

    var updateCache = function updateCache(eventType, eventId, response) {
        response.forEach(function (availability) {
            cachedAvailability[eventType] = cachedAvailability[eventType] || {};
            cachedAvailability[eventType][eventId] = cachedAvailability[eventType][eventId] || {};

            cachedAvailability[eventType][eventId][availability.date] = availability;
        });

        return cachedAvailability;
    };

    var uncacheDate = function uncacheDate(eventType, eventId, date) {
        if (cachedAvailability[eventType] && cachedAvailability[eventType][eventId]) {
            delete cachedAvailability[eventType][eventId][date];
            return cachedAvailability[eventType][eventId];
        }
    };

    var checkCache = function checkCache(eventType, eventId, date) {
        if (cachedAvailability[eventType] && cachedAvailability[eventType][eventId] && cachedAvailability[eventType][eventId][date]) {
            return cachedAvailability[eventType][eventId][date];
        }
    };

    return {
        updateCache: updateCache,
        datesCached: datesCached,
        uncacheDate: uncacheDate
    };
}];

/***/ }),
/* 596 */,
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['startTimeApiService', 'availabilityService', 'loadingService', function (startTimeApiService, availabilityService, loadingService) {
  var getStartTimes = function getStartTimes(item) {
    return startTimeApiService.find(item.date, item.type || item.type_name, item.id).then(function (response) {
      availabilityService.setSingleTimes(response);

      loadingService.stopLoading('times');
      return response;
    });
  };

  var getStartTimesSetPreferred = function getStartTimesSetPreferred(item) {
    return getStartTimes(item).then(function () {
      return setPreferred(item);
    });
  };

  var standardiseTime = function standardiseTime(time) {
    if (time.split(':').length === 2) {
      return time + ':00';
    }

    return time;
  };

  var displayTime = function displayTime(time) {
    return time.substring(0, 5);
  };

  var setPreferred = function setPreferred(item) {
    if (!availabilityService.hasSingleTimes()) {
      item.preferred_time = undefined;
      return item;
    }

    var times = availabilityService.getSingleTimes();
    if (times.length === 1) {
      var startTime = (0, _lodash.head)(times);
      item.preferred_time = '' + startTime.time;
      item.end_time = '' + startTime.end;
      item.original = startTime.original_price || item.original;
      item.price = startTime.price || item.price;

      return item;
    }

    if (item.preferred_time && !times.some(function (startTime) {
      if (standardiseTime(item.preferred_time) === startTime.time) {
        item.original = startTime.original_price || item.original;
        item.price = startTime.price || item.price;
        return true;
      }
    })) {
      item.preferred_time = undefined;
    }

    return item;
  };

  return {
    getStartTimes: getStartTimes,
    getStartTimesSetPreferred: getStartTimesSetPreferred,
    standardiseTime: standardiseTime,
    displayTime: displayTime
  };
}];

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

exports.default = ['quantityApiService', 'availabilityApiService', 'configService', function (quantityApiService, availabilityApiService, configService) {
  var getQuantity = function getQuantity(item) {
    var numberOfGuests = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

    return quantityApiService.find(item.date, item.type || item.type_name, item.id, item.preferred_time, numberOfGuests).then(function (response) {
      return response;
    });
  };

  var getContentsQuantity = function getContentsQuantity(date, startTime, endTime, packageContents) {
    var promises = [];
    var dateFrom = date + 'T' + startTime;
    var dateTo = date + 'T' + endTime;

    var _loop = function _loop(group) {
      var groupPromises = [];
      var numberOfSuccesses = 1;

      var _loop2 = function _loop2(item) {
        item.isAvailable = false;

        if (item.number_required) {
          numberOfSuccesses = item.number_required;
        }

        switch (item.type) {
          case 'activity':
            if (configService.get('integration').preventActivityAvailability) {
              item.isAvailable = true;
              groupPromises.push(Promise.resolve(true));
            }
            break;
          case 'extra':
          case 'facility':
            // Temporary
            item.isAvailable = true;
            groupPromises.push(Promise.resolve(true));
            break;
        }

        if (item.isAvailable) {
          return 'break';
        }

        groupPromises.push(availabilityApiService.requestExternalAvailability(item.type, dateFrom, dateTo, item.integration_identity).then(function (response) {
          if (response && response.length > 0) {
            item.isAvailable = true;

            switch (item.type) {
              case 'activity':
                item.numberAvailable = Math.min.apply(Math, _toConsumableArray(response.map(function (activity) {
                  return activity.quantity;
                })));
                break;
              default:
                item.numberAvailable = response.length;
                break;
            }
          }
        }).catch(function () {
          //
        }));
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = group[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var item = _step2.value;

          var _ret2 = _loop2(item);

          if (_ret2 === 'break') break;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      promises.push(new Promise(function (resolve) {
        return Promise.all(groupPromises).then(function () {
          if (numberOfSuccesses <= group.filter(function (item) {
            return item.isAvailable;
          }).length) {
            var quantities = group.map(function (item) {
              return item.numberAvailable || null;
            }).filter(function (number) {
              return number;
            });

            if (quantities && quantities.length) {
              resolve(Math.min.apply(Math, _toConsumableArray(quantities)));
            }

            resolve(true);
          }

          resolve(false);
        });
      }));
    };

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = packageContents[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var group = _step.value;

        _loop(group);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return Promise.all(promises).then(function (response) {
      if (response.length === response.filter(function (group) {
        return group;
      }).length) {
        var quantities = response.filter(function (quantity) {
          return Number.isInteger(quantity);
        });

        if (quantities && quantities.length) {
          return Math.min.apply(Math, _toConsumableArray(quantities));
        }

        return true;
      }

      return false;
    });
  };

  return {
    getQuantity: getQuantity,
    getContentsQuantity: getContentsQuantity
  };
}];

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['basket', 'suggestionsApiService', 'availabilityApiService', 'startTimeApiService', 'startTimeService', 'quantityApiService', 'propertyService', function (basket, suggestionsApiService, availabilityApiService, startTimeApiService, startTimeService, quantityApiService, propertyService) {
  var _this = this;

  this.suggestions = null;
  this.availableUpgrades = {};
  this.availableRelated = {};
  this.startTimes = {};

  var getSuggestions = function getSuggestions() {
    if (!_this.gettingSuggestions) {
      _this.gettingSuggestions = true;

      return suggestionsApiService.find(basket.contents.identity_code).then(function (response) {
        _this.gettingSuggestions = false;
        _this.suggestions = response;

        var subRequests = [];

        if (response.upgrades) {
          subRequests.push(getUpgradeAvailability(response.upgrades));
        }

        if (response.events) {
          _this.availableRelated = response.events;
        }

        return Promise.all(subRequests);
      });
    }

    return Promise.resolve();
  };

  var hasRelated = function hasRelated() {
    for (var type in _this.availableRelated) {
      if (_this.availableRelated[type].length > 0) {
        return true;
      }
    }

    return false;
  };

  var getAvailableUpgrade = function getAvailableUpgrade(date, type, upgradeId, startTime) {
    var upgradeQuantity = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 1;

    if (_this.availableUpgrades[type] && _this.availableUpgrades[type][date]) {
      var upgrade = _this.availableUpgrades[type][date].find(function (upgrade) {
        return upgrade.id === upgradeId;
      });
      if (upgrade && upgrade.availability && upgrade.availability.available) {
        if (startTime && noStartTime(date, type, upgrade.id, startTime)) {
          return false;
        }

        if (upgradeQuantity >= 1 && noAvailableQuantity(date, type, upgrade.id, startTime, upgradeQuantity)) {
          return false;
        }

        return upgrade;
      }
    }
  };

  // Private functions
  var getUpgradeAvailability = function getUpgradeAvailability(responseUpgrades) {
    _this.availableUpgrades = {};
    _this.startTimes = {};
    var upgradeRequests = [];

    Object.keys(responseUpgrades).forEach(function (type) {
      if (type === 'OptionGroupOption') {
        return;
      }

      if (Object.keys(responseUpgrades[type]).length) {
        Object.keys(responseUpgrades[type]).forEach(function (date) {
          upgradeRequests.push(new Promise(function (resolve) {
            return availabilityApiService.requestAvailabilityList(date, type.toLowerCase(), Object.values(responseUpgrades[type][date]), 'upsell').then(function (response) {
              assignUpgradeResponse(date, type, response);

              return startTimePromises(date, type, response).then(function () {
                resolve();
              });
            });
          }));
        });
      }
    });

    return Promise.all(upgradeRequests).then(function () {
      return assignBasketUpgrades();
    });
  };

  var assignUpgradeResponse = function assignUpgradeResponse(date, type, response) {
    if (!_this.availableUpgrades[type]) {
      _this.availableUpgrades[type] = {};
    }
    _this.availableUpgrades[type][date] = response;
  };

  var startTimePromises = function startTimePromises(date, type, events) {
    var startTimeRequests = [];

    events.forEach(function (event) {
      if (event.availability && event.availability.available) {
        startTimeRequests.push(new Promise(function (resolve) {
          return startTimeApiService.find(date, type.toLowerCase(), event.id).then(function (timeResponse) {
            assignStartTimeResponse(date, type, event.id, timeResponse);

            resolve();
          });
        }));
      }
    });

    return Promise.all(startTimeRequests);
  };

  var assignStartTimeResponse = function assignStartTimeResponse(date, type, eventId, response) {
    if (!_this.startTimes[type]) {
      _this.startTimes[type] = {};
    }

    if (!_this.startTimes[type][date]) {
      _this.startTimes[type][date] = {};
    }

    if (!_this.startTimes[type][date][eventId]) {
      _this.startTimes[type][date][eventId] = {};
    }

    if (response) {
      response.forEach(function (startTime) {
        startTime = startTimeService.standardiseTime(startTime.time);
        _this.startTimes[type][date][eventId][startTime] = null;
      });
    }
  };

  var assignBasketUpgrades = function assignBasketUpgrades() {
    var upgradePromises = [];

    basket.contents.guest_details.forEach(function (guest) {
      guest.item_details.forEach(function (basketItem) {
        upgradePromises.push(new Promise(function (resolve) {
          return findItemUpgrade(basketItem).then(function () {
            if (basketItem.item_children) {
              basketItem.item_children.forEach(function (child) {
                return findItemUpgrade(child);
              });
            }

            resolve();
          });
        }));
      });
    });

    return Promise.all(upgradePromises);
  };

  var findItemUpgrade = function findItemUpgrade(basketItem) {
    var date = (0, _moment2.default)(basketItem.date).format('YYYY-MM-DD');

    return new Promise(function (resolve) {
      if (!basketItem.upgraded && basketItem.item_summary) {
        if (basketItem.item_summary.type_name === 'OptionGroupOption') {
          setOptionUpgrade(basketItem, date);
          return resolve();
        }

        setEventUpgrade(basketItem, date);

        if (basketItem.canUpgradeTo && propertyService.get('hasIntegration')) {
          return getUpgradeQuantity(basketItem, date).then(function () {
            resolve();
          });
        }
      }

      resolve();
    });
  };

  var setOptionUpgrade = function setOptionUpgrade(basketItem, date) {
    if (basketItem.item.option_id > 0 && canUpgrade(date, 'Treatment', basketItem.item.option_id)) {
      basketItem.canUpgradeTo = _this.suggestions.upgrades['Treatment'][date][basketItem.item.option_id];
      return;
    }

    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = true;
    }
  };

  var setEventUpgrade = function setEventUpgrade(basketItem, date) {
    if (canUpgrade(date, basketItem.item_summary.type_name, basketItem.item_summary.id)) {
      basketItem.canUpgradeTo = _this.suggestions.upgrades[basketItem.item_summary.type_name][date][basketItem.item_summary.id];
    }
  };

  var canUpgrade = function canUpgrade(date, type, eventId) {
    if (_this.suggestions.upgrades && _this.suggestions.upgrades[type] && _this.suggestions.upgrades[type][date]) {

      if (type === 'OptionGroupOption') {
        return _this.suggestions.upgrades[type][date].indexOf(eventId) > -1;
      }

      return !!_this.suggestions.upgrades[type][date][eventId];
    }
  };

  var containerHasAvailability = function containerHasAvailability(container) {
    var checkDates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    return typeHasAvailability(container.Treatment, checkDates) || typeHasAvailability(container.SpaDay, checkDates) || typeHasAvailability(container.OptionGroupOption, checkDates);
  };

  var typeHasAvailability = function typeHasAvailability(type, checkDates) {
    return !!(type && Object.keys(type).length && findAvailableEvents(type, checkDates));
  };

  var findAvailableEvents = function findAvailableEvents(events, byDate) {
    if (byDate) {
      Object.keys(events).some(function (date) {
        return findAvailable(events[date]);
      });
    }

    return findAvailable(events);
  };

  var findAvailable = function findAvailable(events) {
    return !!events.find(function (event) {
      return event.availability && event.availability.available === true;
    });
  };

  var noStartTime = function noStartTime(date, type, eventId, eventStartTime) {
    if (_this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId]) {
      return !Object.keys(_this.startTimes[type][date][eventId]).find(function (startTime) {
        return startTime === startTimeService.standardiseTime(eventStartTime);
      });
    }

    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    return _this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId] && _this.startTimes[type][date][eventId][eventStartTime] === undefined;
  };

  var noAvailableQuantity = function noAvailableQuantity(date, type, eventId, eventStartTime, quantity) {
    eventStartTime = startTimeService.standardiseTime(eventStartTime);

    if (propertyService.get('hasIntegration')) {
      if (_this.startTimes[type] && _this.startTimes[type][date] && _this.startTimes[type][date][eventId] && _this.startTimes[type][date][eventId][eventStartTime]) {
        if (_this.startTimes[type][date][eventId][eventStartTime] !== null) {
          return _this.startTimes[type][date][eventId][eventStartTime] < quantity;
        } else if (_this.startTimes[type][date][eventId][eventStartTime] === null && quantity === 1) {
          return false;
        }
      }

      return true;
    }

    return false;
  };

  var getUpgradeQuantity = function getUpgradeQuantity(basketItem, date) {
    return new Promise(function (resolve) {
      var type = basketItem.item_summary.type_name;
      var eventId = basketItem.canUpgradeTo;
      var time = startTimeService.standardiseTime(basketItem.preferred_time);

      if (!type || !date || !eventId || !time) {
        resolve();
      }

      buildStartTimesStructure(type, date, eventId);

      if (_this.startTimes[type][date][eventId][time] !== null) {
        resolve();
      }

      if (basketItem.item_summary.minimum_guests === 1) {
        _this.startTimes[type][date][eventId][time] = 1;
        resolve();
      }

      return quantityApiService.find(date, type.toLowerCase(), eventId, time).then(function (response) {
        _this.startTimes[type][date][eventId][time] = response.quantity;
        resolve();
      });
    });
  };

  var buildStartTimesStructure = function buildStartTimesStructure(type, date, eventId) {
    if (!_this.startTimes[type]) {
      _this.startTimes[type] = {};
    }

    if (!_this.startTimes[type][date]) {
      _this.startTimes[type][date] = {};
    }

    if (!_this.startTimes[type][date][eventId]) {
      _this.startTimes[type][date][eventId] = {};
    }
  };

  return {
    getSuggestions: getSuggestions,
    hasRelated: hasRelated,
    getAvailableUpgrade: getAvailableUpgrade,
    getRelated: function getRelated() {
      return _this.availableRelated;
    }
  };
}];

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moneyInput = __webpack_require__(601);

var _moneyInput2 = _interopRequireDefault(_moneyInput);

var _money = __webpack_require__(603);

var _money2 = _interopRequireDefault(_money);

var _moneyInput3 = __webpack_require__(605);

var _moneyInput4 = _interopRequireDefault(_moneyInput3);

var _money3 = __webpack_require__(606);

var _money4 = _interopRequireDefault(_money3);

var _imgixSrc = __webpack_require__(607);

var _imgixSrc2 = _interopRequireDefault(_imgixSrc);

var _imgixRefresh = __webpack_require__(608);

var _imgixRefresh2 = _interopRequireDefault(_imgixRefresh);

var _config = __webpack_require__(609);

var _config2 = _interopRequireDefault(_config);

var _store = __webpack_require__(610);

var _store2 = _interopRequireDefault(_store);

var _imgix = __webpack_require__(622);

var _imgix2 = _interopRequireDefault(_imgix);

var _time = __webpack_require__(623);

var _time2 = _interopRequireDefault(_time);

var _money5 = __webpack_require__(626);

var _money6 = _interopRequireDefault(_money5);

var _date = __webpack_require__(627);

var _date2 = _interopRequireDefault(_date);

var _loading = __webpack_require__(628);

var _loading2 = _interopRequireDefault(_loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedBaseModule = angular.module('spabooker.shared.base', []).component('moneyInput', _moneyInput2.default).component('money', _money2.default).controller('moneyInputController', _moneyInput4.default).controller('moneyController', _money4.default).directive('imgixSrc', _imgixSrc2.default).directive('imgixRefresh', _imgixRefresh2.default).factory('configService', _config2.default).factory('storeService', _store2.default).factory('imgix', _imgix2.default).factory('time', _time2.default).factory('moneyService', _money6.default).factory('dateService', _date2.default).factory('loadingService', _loading2.default);

exports.default = sharedBaseModule.name;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    require: {
        ngModel: 'ngModel'
    },
    bindings: {
        disabled: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyInputController',
    template: __webpack_require__(602)
};

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = "<div class=\"input-group input-group__money\"> <span class=input-group-label--currency ng-if=\"$ctrl.shouldDecorate('currency')\" ng-bind-html=$ctrl.currency.symbol></span> <input type=text ng-model=$ctrl.value class=input-group-field ng-change=$ctrl.onChange() ng-focus=$ctrl.onFocus() ng-blur=$ctrl.onBlur() ng-disabled=$ctrl.disabled> <span class=input-group-label--percentage ng-if=\"$ctrl.shouldDecorate('percentage')\"> % </span> </div> ";

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        amount: '<',
        round: '<',
        decorate: '@',
        currencyCode: '<'
    },
    controller: 'moneyController',
    template: __webpack_require__(604)
};

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = "<span>{{ $ctrl.formatAmount() }}</span>";

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MoneyInputController = function () {
    function MoneyInputController($element, moneyService) {
        _classCallCheck(this, MoneyInputController);

        this.$element = $element;
        this.moneyService = moneyService;
    }

    _createClass(MoneyInputController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);

            this.ngModel.$render = function () {
                if (!isNaN(_this.ngModel.$viewValue) && _this.ngModel.$viewValue !== null) {
                    _this.value = (_this.ngModel.$viewValue / _this.currency.magnitude).toFixed(_this.currency.decimals);
                } else {
                    _this.value = undefined;
                }
            };
        }
    }, {
        key: 'onChange',
        value: function onChange() {
            if (this.value) {
                return this.ngModel.$setViewValue(Math.round(this.value * this.currency.magnitude).toFixed(this.currency.decimals));
            }
            return this.ngModel.$setViewValue(undefined);
        }
    }, {
        key: 'onFocus',
        value: function onFocus() {
            this.$element.addClass('focus');
        }
    }, {
        key: 'onBlur',
        value: function onBlur() {
            this.$element.removeClass('focus');

            this.ngModel.$setTouched();

            if (this.$element.find('input')[0].value) {
                this.ngModel.$setDirty();
            } else {
                this.ngModel.$setPristine();
            }
        }
    }, {
        key: 'shouldDecorate',
        value: function shouldDecorate(type) {
            if (!this.decorate && type === 'currency' || this.decorate === type) {
                return true;
            }
            return false;
        }
    }]);

    return MoneyInputController;
}();

MoneyInputController.$inject = ['$element', 'moneyService'];

exports.default = MoneyInputController;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MoneyController = function () {
    function MoneyController(moneyService, configService) {
        _classCallCheck(this, MoneyController);

        this.moneyService = moneyService;
        this.configService = configService;
    }

    _createClass(MoneyController, [{
        key: 'formatAmount',
        value: function formatAmount() {
            if (this.decorate) {
                this.decorate = this.decorate.toUpperCase();
                switch (this.decorate) {
                    case 'GBP':
                    case 'EUR':
                    case 'USD':
                    case 'JPY':
                        this.currencyCode = this.decorate;
                        break;

                    default:
                        this.currencyCode = this.configService.get('currency') || 'GBP';
                        break;
                }
            }

            if (!isNaN(this.amount)) {
                this.currency = this.moneyService.getCurrencyDetails(this.currencyCode || null);
                var amount = (this.amount / this.currency.magnitude).toFixed(this.currency.decimals);

                if (this.round) {
                    amount = parseInt(amount);
                }

                if (this.decorate) {
                    amount = this.decorateValue(amount);
                }

                return amount;
            }
        }
    }, {
        key: 'decorateValue',
        value: function decorateValue(amount) {
            switch (this.decorate) {
                default:
                case 'true':
                case 'currency':
                case '#':
                case '=':
                    amount = amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    amount = this.currency.symbol + amount;
                    break;

                case '%':
                case 'percent':
                case 'percentage':
                    amount = amount.toString().replace('.00', '');
                    amount = amount + '%';
                    break;
            }

            return amount;
        }
    }]);

    return MoneyController;
}();

MoneyController.$inject = ['moneyService', 'configService'];

exports.default = MoneyController;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['imgix', 'configService', function (imgix, configService) {
    return {
        restrict: 'A',
        scope: {
            url: '@imgixSrc'
        },
        link: function link($scope, element, attrs) {
            var imgixBaseUrl = configService.get('imgix.source');
            var uploadBaseUrl = configService.get('uploadsBaseUrl');

            var fit = '';
            switch (attrs.fit) {
                case 'fit':
                    fit = 'fit=clip';
                    break;

                case 'crop':
                    fit = 'fit=crop';
                    break;

                default:
                case 'auto':
                    fit = 'fit=crop&crop=faces,edges';
                    break;
            }
            var imgixQuery = '?auto=format&ch=DPR,Width&q=65&' + fit;
            var dataSrc = '';

            if (uploadBaseUrl && imgixBaseUrl) {
                if (attrs.imgixSrc.indexOf('//') === 0) {
                    dataSrc = 'https:';
                } else if (uploadBaseUrl.indexOf('http') === 0 && attrs.imgixSrc.indexOf('//') !== 0) {
                    dataSrc = 'https://';
                }
                dataSrc += attrs.imgixSrc.replace(uploadBaseUrl, imgixBaseUrl) + imgixQuery;
                element.attr('data-src', dataSrc).addClass('imgix-fluid');
            } else {
                dataSrc += attrs.imgixSrc;
                if (element[0].tagName === 'IMG') {
                    element.attr('src', dataSrc);
                } else {
                    element.attr('style', 'background-image: url("' + dataSrc + '")').addClass('no-imgix');
                }
            }
        }
    };
}];

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var imgixRefresh = function imgixRefresh($timeout, imgix) {
    return {
        restrict: 'A',
        link: function link(scope, element, attr) {
            if (scope.$last === true) {
                imgix.reload();
                element[0].classList.add('has-loaded');
            } else {
                $timeout(function () {
                    imgix.reload();
                    element[0].classList.add('has-loaded');
                });
            }
        }
    };
};

imgixRefresh.$inject = ['$timeout', 'imgix'];

exports.default = imgixRefresh;

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(13);

var configService = function configService($window) {
    return {
        load: function load() {
            return Promise.resolve();
        },
        get: function get(key) {
            return (0, _lodash.get)($window.config, key);
        }
    };
};

configService.$inject = ['$window'];

exports.default = configService;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _store = __webpack_require__(611);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = [function () {
    var storeService = { functions: {} };

    storeService.functions.get = function (key) {
        return _store2.default.get(key);
    };

    storeService.functions.set = function (key, value) {
        return _store2.default.set(key, value);
    };

    storeService.functions.remove = function (key) {
        return _store2.default.remove(key);
    };

    return storeService.functions;
}];

/***/ }),
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _imgix = __webpack_require__(130);

var _imgix2 = _interopRequireDefault(_imgix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['$rootScope', '$timeout', function ($rootScope, $timeout) {

    function closestNum(num, arr) {
        var curr = arr[0];
        var key = 0;
        var diff = Math.abs(num - curr);
        for (var val = 0; val < arr.length; val++) {
            var newdiff = Math.abs(num - arr[val]);
            if (newdiff < diff) {
                diff = newdiff;
                curr = arr[val];
                key = val;
            }
        }
        if (num >= curr && key !== arr.length - 1) {
            return arr[key + 1];
        }
        return curr;
    }

    var acceptable_sizes = {
        widths: [100, 150, 250, 300, 500, 640, 800, 1000, 1500, 2000, 2560],
        heights: [100, 150, 250, 300, 500, 640, 800, 1000, 1500]
    };

    var imgixFluid = _imgix2.default.fluid({
        lazyLoad: true,
        lazyLoadOffsetVertical: 150,
        pixelStep: 50,
        lazyLoadColor: false,
        onChangeParamOverride: function onChangeParamOverride(w, h, params, elem) {
            switch (elem.getAttribute('data-fit')) {
                case 'fit':
                    params.fit = 'clip';
                    break;

                case 'crop':
                    params.fit = 'crop';
                    break;

                default:
                case 'auto':
                    params.fit = 'crop';
                    params.crop = 'faces,edges';
            }

            params.auto = 'format';
            params.ch = 'DPR,Width';
            params.q = 65;
            params.w = closestNum(w, acceptable_sizes.widths).toString();
            params.h = closestNum(h, acceptable_sizes.heights).toString();

            return params;
        },
        onLoad: function onLoad(elem) {
            if (!elem.className.match('has-loaded')) {
                elem.classList.add('has-loaded');
            }
        }
    });

    function reload() {
        $timeout(function () {
            return imgixFluid.reload();
        });
    }

    $rootScope.$watch('image', function (newVal, oldVal) {
        if (oldVal && oldVal !== newVal) {
            imgixFluid.reload();
        }
    });

    $rootScope.$on("$locationChangeSuccess", function () {
        imgixFluid.reload();
    });

    angular.element(window).on('imgixRefresh', function () {
        imgixFluid.reload();
    });

    return {
        imgixFluid: imgixFluid,
        reload: reload
    };
}];

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(0);

__webpack_require__(125);

exports.default = ['currentPropertyService', function (currentPropertyService) {
    var timeCheck = function timeCheck(time) {
        if (!(0, _moment.isMoment)(time)) {
            time = moment.utc(time);
        }
        return time.tz(currentPropertyService.get().timezone);
    };

    var readableTime = function readableTime(input) {
        return timeCheck(input).format('MMMM Do YYYY, h:mm:ss A');
    };
    var readableDate = function readableDate(input) {
        return timeCheck(input).format('MMMM Do YYYY');
    };
    var shortTime = function shortTime(input) {
        return timeCheck(input).format('D/M/Y HH:mm');
    };
    var shortDate = function shortDate(input) {
        return timeCheck(input).format('D/M/Y');
    };
    var readable = function readable(input, format) {
        return timeCheck(input).format(format);
    };

    return {
        readableTime: readableTime,
        readableDate: readableDate,
        shortTime: shortTime,
        shortDate: shortDate,
        readable: readable
    };
}];

/***/ }),
/* 624 */,
/* 625 */,
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var moneyService = function moneyService($rootScope, $window) {
    var getCurrencyDetails = function getCurrencyDetails() {
        var currencyCode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (currencyCode) {
            return determineCurrency(currencyCode);
        }

        if ($window.config && $window.config.currency) {
            return determineCurrency($window.config.currency);
        }

        return determineCurrency($rootScope.currentProperty.currency_code);
    };

    var determineCurrency = function determineCurrency(currencyCode) {
        switch (currencyCode) {
            case 'EUR':
                return {
                    symbol: '€',
                    magnitude: 100,
                    decimals: 2
                };
            case 'JPY':
                return {
                    symbol: '¥',
                    magnitude: 1,
                    decimals: 0
                };
            case 'USD':
                return {
                    symbol: '$',
                    magnitude: 100,
                    decimals: 2
                };
            default:
            case 'GBP':
                return {
                    symbol: '£',
                    magnitude: 100,
                    decimals: 2
                };
        }
    };

    var reduce = function reduce(amount) {
        var decorate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var currency = getCurrencyDetails(decorate);
        var decoration = '';
        if (decorate) {
            decoration = currency.symbol;
        }
        return '' + decoration + (amount / currency.magnitude).toFixed(currency.decimals);
    };

    var magnify = function magnify(amount) {
        var currency = getCurrencyDetails();
        return amount * currency.magnitude;
    };

    return {
        getCurrencyDetails: getCurrencyDetails,
        reduce: reduce,
        magnify: magnify
    };
};

moneyService.$inject = ['$rootScope', '$window'];

exports.default = moneyService;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

__webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateService = function dateService($window, $timeout, storeService, propertyService) {
  var propertyTimezone = undefined;

  var checkMaxDate = function checkMaxDate(momentDate) {
    var isStartDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!_moment2.default.isMoment(momentDate)) {
      momentDate = convertToMoment(momentDate);
    }

    if (momentDate.diff((0, _moment2.default)(), "days") > 357) {
      momentDate = (0, _moment2.default)().add(1, "years");

      if (isStartDate) {
        momentDate.subtract(6, "days");
      }
    }

    return momentDate;
  };

  var verifyDateGteToday = function verifyDateGteToday(momentDate) {
    var minDate = getMinDate();
    if (momentDate && momentDate.isSameOrAfter(minDate, "day")) {
      return momentDate;
    }

    return minDate;
  };

  var checkStoredDate = function checkStoredDate() {
    var setDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var returnAsMoment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var incomingDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var timezone = getTimezone();

    var momentDate = void 0;
    var searchDate = storeService.get("searchDate");

    if (searchDate || !searchDate && incomingDate) {
      if (!incomingDate) {
        momentDate = buildMomentDate(searchDate);
      } else {
        momentDate = incomingDate;
      }

      if (momentDate.isBefore((0, _moment2.default)(), "day")) {
        storeService.remove("searchDate");
      }
    }

    if (!momentDate || !momentDate.isValid()) {
      momentDate = (0, _moment2.default)();
    }
    momentDate = withinRestrictedDates(momentDate);
    momentDate = verifyDateGteToday(momentDate);
    momentDate = momentDate.tz(timezone);

    if (setDates) {
      storeService.set("searchDate", momentDate.format("YYYY-MM-DD"));
    }

    if (returnAsMoment) {
      return momentDate;
    }

    return momentDate.format("YYYY-MM-DD");
  };

  var convertToMoment = function convertToMoment(date) {
    var timezone = getTimezone();

    return (0, _moment2.default)(date).tz(timezone);
  };

  var checkDate = function checkDate(date) {
    var returnAsMoment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!_moment2.default.isMoment(date)) {
      date = convertToMoment(date);
    }

    return checkStoredDate(true, returnAsMoment, date);
  };

  var getTimezone = function getTimezone() {
    if (!propertyTimezone) {
      propertyTimezone = propertyService.get("timezone");
    }

    return propertyTimezone;
  };

  var displayFromToDate = function displayFromToDate(fromDate, toDate) {
    if (!fromDate || !toDate) {
      return false;
    }

    var startDate = buildMomentDate(fromDate);
    var endDate = buildMomentDate(toDate);

    if (startDate.isSame(endDate, "day")) {
      return "on " + startDate.format("Do MMMM YYYY");
    }

    if (startDate.isSame(endDate, "month")) {
      return "from " + startDate.format("Do") + " to " + endDate.format("Do MMMM YYYY");
    }

    if (startDate.isSame(endDate, "year")) {
      return "from " + startDate.format("Do MMMM") + " to " + endDate.format("Do MMMM YYYY");
    }

    return "from " + startDate.format("Do MMMM YYYY") + " to " + endDate.format("Do MMMM YYYY");
  };

  var buildMomentDate = function buildMomentDate(date) {
    if (date.length === 10) {
      date += " 00:00:00";
    }

    return (0, _moment2.default)(date.replace("T", " ") + "+00:00");
  };

  var getMinDate = function getMinDate() {
    var minDate = (0, _moment2.default)();

    var closeDays = propertyService.get("stopDays");
    var minSearchDays = propertyService.get("minSearchDays");
    var closeTime = propertyService.get("stopTime");

    if (closeDays && (!minSearchDays || closeDays > minSearchDays)) {
      var date = minDate.add(closeDays, "day");
      setCalendarParameter('minDate', date);
      return date;
    }

    if (minSearchDays) {
      return minDate.add(minSearchDays, "days");
    }

    if (closeTime && minDate.diff((0, _moment2.default)(closeTime, "HH:mm:ss")) > 0) {
      var _date = minDate.add(1, "day");
      setCalendarParameter('minDate', _date);
      return _date;
    }

    return minDate;
  };

  var setCalendarParameter = function setCalendarParameter(param, value) {
    $timeout(function () {
      if ($window.fpInput && _typeof($window.fpInput) === "object" && typeof $window.fpInput.set === "function") {
        if (value && (0, _moment2.default)().isValid(value)) {
          value = value.format('YYYY-MM-DD');
        }
        $window.fpInput.set(param, value);
      }
    }, 1000);
  };

  var withinRestrictedDates = function withinRestrictedDates(date) {
    if (date && (0, _moment2.default)().isValid(date)) {
      var startEditBooking = storeService.get("start_date");
      var endEditBooking = storeService.get("end_date");
      var maxSearchDays = propertyService.get('maxActivitySearchDays');

      if (startEditBooking && endEditBooking) {
        startEditBooking = (0, _moment2.default)(startEditBooking);
        endEditBooking = (0, _moment2.default)(endEditBooking);

        if (date.diff(startEditBooking, "days") < 0 || date.diff(endEditBooking, "days") > 0) {
          date = startEditBooking;
          return date;
        }
      }

      if ($window.location.pathname.includes('/classes') && maxSearchDays && maxSearchDays > 0) {
        if (date.diff((0, _moment2.default)().add(maxSearchDays, 'days'), 'hours') > 0) {
          date = (0, _moment2.default)();
        }
      }
    }

    return date;
  };

  return {
    checkMaxDate: checkMaxDate,
    verifyDateGteToday: verifyDateGteToday,
    checkStoredDate: checkStoredDate,
    convertToMoment: convertToMoment,
    checkDate: checkDate,
    displayFromToDate: displayFromToDate,
    setCalendarParameter: setCalendarParameter
  };
};

dateService.$inject = ["$window", "$timeout", "storeService", "propertyService"];

exports.default = dateService;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadingService = function loadingService() {
    var _this = this;

    this.loading = [];

    var startLoading = function startLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return startLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return startLoadingSingle(param);
    };

    var stopLoading = function stopLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return stopLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }

        return stopLoadingSingle(param);
    };

    var isLoading = function isLoading(param) {
        if (Array.isArray(param)) {
            var returns = param.map(function (value) {
                return isLoadingSingle(value);
            });
            return returns.indexOf(true) > -1;
        }
        return isLoadingSingle(param);
    };

    var clearLoading = function clearLoading() {
        _this.loading = [];
    };

    var startLoadingSingle = function startLoadingSingle(param) {
        if (_this.loading.indexOf(param) === -1) {
            _this.loading.push(param);
            return true;
        }

        return false;
    };

    var stopLoadingSingle = function stopLoadingSingle(param) {
        var index = _this.loading.indexOf(param);

        if (index > -1) {
            _this.loading.splice(index, 1);
            return true;
        }

        return false;
    };

    var isLoadingSingle = function isLoadingSingle(param) {
        if (param) {
            return _this.loading.indexOf(param) > -1;
        }

        return _this.loading.length > 0;
    };

    return {
        startLoading: startLoading,
        stopLoading: stopLoading,
        isLoading: isLoading,
        clearLoading: clearLoading
    };
};

loadingService.$inject = [];

exports.default = loadingService;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _guestAdd = __webpack_require__(630);

var _guestAdd2 = _interopRequireDefault(_guestAdd);

var _guestName = __webpack_require__(631);

var _guestName2 = _interopRequireDefault(_guestName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedGuestModule = angular.module('spabooker.shared.guest', []).factory('addGuestService', _guestAdd2.default).factory('guestnameService', _guestName2.default);

exports.default = sharedGuestModule.name;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['basket', 'propertyService', 'messageService', 'guestnameService', 'storeService', function (basket, propertyService, messageService, guestnameService, storeService) {
  var state = {
    existingGuests: null,
    gender: null,
    guests: [],
    maximumGuests: null,
    minimumGuests: null,
    staff: null,
    titles: []
  };

  var setState = function setState(stateToSet) {
    var param = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (param) {
      state[param] = stateToSet;
      return;
    }

    state = Object.assign({}, state, stateToSet);
  };

  var getState = function getState() {
    var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    if (param) {
      return state[param];
    }

    return state;
  };

  var getGuests = function getGuests() {
    return state.guests;
  };

  var buildTitlesList = function buildTitlesList() {
    var male = ['Mr.'];
    var female = ['Miss', 'Mrs.', 'Ms.'];
    var output = ['Dr.', 'Rev.'];

    switch (state.gender) {
      case 'M':
        output = male.concat(output);
        break;

      case 'F':
        output = female.concat(output);
        break;

      default:
        output = female.concat(male).concat(output);
        break;
    }

    state.titles = output;
    return output;
  };

  var setInitialGuests = function setInitialGuests() {
    var guests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    state.guests = guests;

    if (state.guests.length) {
      state.guests = filterGuestsByGender(state.guests, true);
    }

    if (state.guests.length < state.minimumGuests && notEditing()) {
      addEmptyGuests(state.guests.length);
      return state.guests;
    }

    if (state.guests.length > state.maximumGuests) {
      state.guests.splice(state.maximumGuests);
    }

    return state.guests;
  };

  var canAddGuest = function canAddGuest() {
    return parseInt(state.guests.length) + parseInt(state.minimumGuests) <= parseInt(state.maximumGuests);
  };

  var addEmptyGuests = function addEmptyGuests() {
    var startingIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    if (!reference) {
      reference = basket.referenceGenerator();
    }

    for (var index = startingIndex; index < state.minimumGuests; index++) {
      pushGuest(reference);
    }
  };

  var pushGuest = function pushGuest(reference) {
    var attributes = {
      reference: reference,
      item_children: []
    };

    if (state.gender) {
      attributes.gender = state.gender;
    }

    if (state.staff && state.staff.length === 1) {
      attributes.staff = state.staff[0];
    }

    state.guests.push(attributes);
  };

  var hasMaxGuests = function hasMaxGuests() {
    return parseInt(state.guests.length) === parseInt(state.maximumGuests);
  };

  var maxGuestsAdded = function maxGuestsAdded() {
    return hasMaxGuests() && firstEmptyGuest() === -1;
  };

  var firstEmptyGuest = function firstEmptyGuest() {
    return state.guests.findIndex(function (guest) {
      return !guest.title && !guest.first_name && !guest.last_name;
    });
  };

  var filterGuestsByGender = function filterGuestsByGender(guests) {
    var ignoreTitle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return guests.filter(function (guest) {
      if (state.gender && guest.gender) {
        return state.gender.toLowerCase() === guest.gender.toLowerCase();
      }

      if (guest.integration_reference) {
        return !!state.existingGuests.find(function (existing) {
          return guest.integration_reference === existing.integration_reference;
        });
      }

      if (ignoreTitle) {
        return true;
      }

      return state.titles.indexOf(guest.title) > -1;
    });
  };

  var filterExistingGuests = function filterExistingGuests() {
    setInitialGuests(getGuests());

    state.existingGuests.forEach(function (guest) {
      if (!guest.disabled) {
        if (state.gender && guest.gender && state.gender.toLowerCase() !== guest.gender.toLowerCase()) {
          guest.disabled = true;
        }

        return;
      }

      if (guest.disabled && !state.guests.find(function (newGuest) {
        return guest.id && guest.id === newGuest.id;
      })) {
        if (!state.gender || state.gender && guest.gender && state.gender.toLowerCase() === guest.gender.toLowerCase()) {
          delete guest.disabled;
        }
      }
    });

    return state.existingGuests;
  };

  var addExistingGuest = function addExistingGuest(existingGuestId) {
    if (maxGuestsAdded()) {
      return;
    }

    var existingGuest = {};

    if (existingGuestId) {
      existingGuest = state.existingGuests.find(function (guest) {
        return guest.id === existingGuestId;
      });
      existingGuest.disabled = true;

      if (!state.guests.find(function (guest) {
        return guest.id === existingGuest.id;
      })) {
        var emptyGuest = firstEmptyGuest();
        var cloneGuest = (0, _lodash.clone)(existingGuest);
        cloneGuest.item_children = [];

        if (state.guests[emptyGuest] && state.guests[emptyGuest].staff) {
          delete state.guests[emptyGuest].staff.disabled;
        }

        if (state.staff && state.staff.length === 1) {
          cloneGuest.staff = state.staff[0];
        }

        if (emptyGuest !== -1) {
          cloneGuest.reference = state.guests[emptyGuest].reference;
          state.guests[emptyGuest] = cloneGuest;
          return;
        }

        var reference = basket.referenceGenerator();
        cloneGuest.reference = reference;

        state.guests.push(cloneGuest);

        if (state.minimumGuests > 1) {
          addEmptyGuests(1, reference);
        }
      }
    }
  };

  var removeGuest = function removeGuest(selectedGuest) {
    var reference = selectedGuest.reference;

    var _loop = function _loop(index) {
      var guest = state.guests[index];

      if (guest.reference === reference) {
        if (guest.staff) {
          delete guest.staff.disabled;
        }

        var existingGuest = guest.id && state.existingGuests.find(function (existingGuest) {
          return existingGuest.id === guest.id;
        });
        if (existingGuest) {
          delete existingGuest.disabled;
        }

        state.guests.splice(index, 1);
      }
    };

    for (var index = state.guests.length - 1; index >= 0; index--) {
      _loop(index);
    }
  };

  var guestNameOrPlaceholder = function guestNameOrPlaceholder(guest) {
    if (guest.title || guest.first_name || guest.last_name) {
      return guestnameService.format(guest);
    }

    return 'New Guest';
  };

  var showTitle = function showTitle(guest) {
    if (!guest.id) {
      return true;
    }

    return state.titles.indexOf(guest.title) !== -1;
  };

  var showGenderSelection = function showGenderSelection(guest) {
    return propertyService.get('hasIntegration') && !state.gender && !guest.id;
  };

  var guessGender = function guessGender(guest) {
    var female = ['Miss', 'Mrs.', 'Ms.'];

    if (guest.title) {
      if (guest.title === 'Mr.') {
        guest.gender = 'M';
        return;
      }

      if (female.find(function (title) {
        return title === guest.title;
      })) {
        guest.gender = 'F';
      }
    }
  };

  var digitToWord = function digitToWord(digit) {
    switch (parseInt(digit)) {
      case 1:
        return 'one';
      case 2:
        return 'two';
      case 3:
        return 'three';
      case 4:
        return 'four';
      case 5:
        return 'five';
      case 6:
        return 'six';
      case 7:
        return 'seven';
      case 8:
        return 'eight';
      case 9:
        return 'nine';
    }

    return digit;
  };

  var displayGuestQuantity = function displayGuestQuantity(type, minGuests, quantity) {
    var eventGender = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var maxGuests = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

    if (!!type && quantity > 0) {
      var string = 'This ' + type + ' can be booked for ' + numberOfGuests(minGuests, quantity, maxGuests) + '.';

      if (eventGender && eventGender !== 'false') {
        var gender = eventGender === 'M' ? 'male' : 'female';
        string += ' It is only available to ' + gender + ' guests.';
      }

      return string;
    }
  };

  var numberOfGuests = function numberOfGuests(minGuests, quantity, maxGuests) {
    if (!propertyService.get('hasIntegration') && !!maxGuests) {
      quantity = maxGuests;
    }

    if (parseInt(minGuests) !== parseInt(quantity)) {
      return minGuests + ' to ' + quantity + ' guests';
    }

    if (quantity > 1) {
      return quantity + ' guests';
    }

    return quantity + ' guest';
  };

  var notEditing = function notEditing() {
    return !storeService.get('reservation');
  };

  return {
    setState: setState,
    getState: getState,
    getGuests: getGuests,
    buildTitlesList: buildTitlesList,
    setInitialGuests: setInitialGuests,
    canAddGuest: canAddGuest,
    addEmptyGuests: addEmptyGuests,
    maxGuestsAdded: maxGuestsAdded,
    filterGuestsByGender: filterGuestsByGender,
    filterExistingGuests: filterExistingGuests,
    addExistingGuest: addExistingGuest,
    removeGuest: removeGuest,
    guestNameOrPlaceholder: guestNameOrPlaceholder,
    showTitle: showTitle,
    showGenderSelection: showGenderSelection,
    guessGender: guessGender,
    digitToWord: digitToWord,
    displayGuestQuantity: displayGuestQuantity
  };
}];

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    var addPossessive = function addPossessive(string) {
        if (string.substr(-1, 1) === 's') {
            string += "'";
            return string;
        }

        string += "'s";

        return string;
    };

    var addSuffix = function addSuffix(string, suffix, pluralCount, suffixPlural) {
        string += " " + suffix;
        if (pluralCount > 1 && string.substr(-1, 1) !== 's') {
            string += suffixPlural;
        }

        return string;
    };

    return {
        format: function format(guest) {
            var possessive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var suffix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
            var pluralCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
            var suffixPlural = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 's';

            var formatted = ((guest.title || '') + " " + (guest.first_name || '') + " " + (guest.last_name || '')).trim();

            if (possessive) {
                formatted = addPossessive(formatted);
            }
            if (suffix) {
                formatted = addSuffix(formatted, suffix, pluralCount, suffixPlural);
            }

            return formatted;
        }
    };
}];

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _item = __webpack_require__(633);

var _item2 = _interopRequireDefault(_item);

var _validate = __webpack_require__(634);

var _validate2 = _interopRequireDefault(_validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedItemModule = angular.module('spabooker.shared.item', []).factory('itemService', _item2.default).factory('validateService', _validate2.default);

exports.default = sharedItemModule.name;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(13);

exports.default = ['$window', 'offerService', 'startTimeService', 'availabilityService', function ($window, offerService, startTimeService, availabilityService) {
  var _this = this;

  this.item = null;

  var setItem = function setItem(item) {
    _this.item = item;
  };

  var getItem = function getItem() {
    return _this.item;
  };

  var hasItem = function hasItem() {
    return !!(_this.item && Object.keys(_this.item).length > 0);
  };

  var updateAvailability = function updateAvailability(availableDay) {
    return new Promise(function (resolve) {
      if (!availableDay) {
        return resolve();
      }

      _this.item.date = availableDay.date;
      _this.item.available = availableDay.available;

      if (!_this.item.available) {
        return resolve();
      }

      _this.item.price = availableDay.price;
      _this.item.original = availableDay.original_price;
      _this.item.phone_only = availableDay.phone_only;

      if (_this.item.phone_only) {
        _this.item.available = false;
      }

      availabilityService.resetSingleTimes();

      var apiRequests = [];

      if (_this.item.available) {
        apiRequests.push(new Promise(function (resolves) {
          return startTimeService.getStartTimesSetPreferred(_this.item).then(function (itemWithTimes) {
            setItem(itemWithTimes);
            resolves();
          });
        }));
      }

      if (availableDay.offer) {
        if (!_this.item.offer || _this.item.offer && _this.item.offer.id !== availableDay.offer.id) {
          _this.item.offer = {};

          apiRequests.push(new Promise(function (resolves) {
            return offerService.getDetails(availableDay.offer.id).then(function (offerDetails) {
              _this.item.offer = offerDetails;
              resolves();
            });
          }));
        }
      } else {
        _this.item.offer = null;
      }

      if ($window.fpInput && _typeof($window.fpInput) === 'object' && typeof $window.fpInput.setDate === 'function') {
        $window.fpInput.setDate(_this.item.date, false, 'Y-m-d');
      }

      return Promise.all(apiRequests).then(function () {
        resolve();
      });
    });
  };

  var setupItemAvailability = function setupItemAvailability(availability, date) {
    return updateAvailability(availability.find(function (event) {
      return event.date === date && event.available === true;
    }) || availability.find(function (event) {
      return event.available === true;
    }) || (0, _lodash.head)(availability));
  };

  return {
    getItem: getItem,
    setItem: setItem,
    hasItem: hasItem,
    updateAvailability: updateAvailability,
    setupItemAvailability: setupItemAvailability
  };
}];

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['propertyService', function (propertyService) {

    var invalidItemOrGuests = function invalidItemOrGuests(item, guests) {
        var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

        var error = itemError(item, status);

        if (!error) {
            error = guestInputError(guests, item);
        }

        if (error) {
            return error;
        }

        return false;
    };

    var itemError = function itemError(item, status) {
        if (item.available === false) {
            return 'Sorry, this event is not currently available.';
        }

        if (!item.preferred_time && !item.suggested) {
            return 'Please select your arrival time.';
        }

        if (item.phone_only || status === 1) {
            return 'Please call us to book this event.';
        }
    };

    var optionError = function optionError(item) {
        var error = 'Please choose included options for all events';

        if (!item.requiredOptions || item.requiredOptions === 0) {
            return false;
        }

        if (item.item_children.length < item.requiredOptions) {
            return error;
        }

        if (item.item_children.filter(function (child) {
            return child.item_type === 'App\\OptionGroupOption' || child.type_name === 'OptionGroupOption';
        }).length !== item.requiredOptions) {
            return error;
        }
    };

    var guestLoop = function guestLoop(guests, item) {
        var errors = {
            errorFields: [],
            guestCounter: []
        };

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = guests[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var guest = _step.value;

                if (!guest.integration_reference && !guest.title || !guest.integration_reference && !guest.first_name || !guest.last_name || propertyService.get('hasIntegration') && !guest.gender) {
                    errors.errorFields.push('required');
                    continue;
                }

                if (item.gender && item.gender !== guest.gender) {
                    errors.errorFields.push('gender');
                    continue;
                }

                errors.guestCounter.push(guest.title + guest.first_name + guest.last_name);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return errors;
    };

    var guestInputError = function guestInputError(guests, item) {
        var errors = guestLoop(guests, item);

        if (errors.errorFields.length) {
            return setGuestInputError(errors.errorFields, item);
        }

        if ((0, _lodash.uniq)(errors.guestCounter).length !== guests.length && errors.guestCounter.length <= item.quantity && errors.guestCounter.length >= item.minimum_guests) {
            return 'You\'ve entered the same guest details more than once.';
        }

        if (errors.guestCounter.length < item.minimum_guests) {
            return 'Too few guests added.';
        }

        if (item.quantity + item.minimum_guests < errors.guestCounter.length) {
            return 'Not enough available quantity to add that many guests. You can add up to a total of ' + (item.quantity + item.minimum_guests) + ' guests.';
        }
    };

    var setGuestInputError = function setGuestInputError(errorFields, item) {
        var genderErrors = errorFields.filter(function (error) {
            return error === 'gender';
        });
        var requiredErrors = errorFields.filter(function (error) {
            return error === 'required';
        });

        if (genderErrors.length === 1) {
            return 'A guest has the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (genderErrors.length > 1) {
            return 'Several guests have the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (requiredErrors.length === 1) {
            return 'A guest is missing required fields.';
        }

        if (requiredErrors.length > 1) {
            return 'Several guests are missing required fields.';
        }
    };

    var guestInputCustomiseError = function guestInputCustomiseError(guests, item) {
        var error = guestInputError(guests, item);

        if (error) {
            return error;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = guests[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var guest = _step2.value;

                error = optionError(guest);
                if (error) {
                    return error;
                }
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }
    };

    return {
        invalidItemOrGuests: invalidItemOrGuests,
        itemError: itemError,
        guestInputCustomiseError: guestInputCustomiseError,
        optionError: optionError
    };
}];

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _displaySuggestions = __webpack_require__(636);

var _displaySuggestions2 = _interopRequireDefault(_displaySuggestions);

var _displaySuggestionsUpgrade = __webpack_require__(638);

var _displaySuggestionsUpgrade2 = _interopRequireDefault(_displaySuggestionsUpgrade);

var _upgradeEvent = __webpack_require__(640);

var _upgradeEvent2 = _interopRequireDefault(_upgradeEvent);

var _upgradeOption = __webpack_require__(642);

var _upgradeOption2 = _interopRequireDefault(_upgradeOption);

var _displaySuggestions3 = __webpack_require__(644);

var _displaySuggestions4 = _interopRequireDefault(_displaySuggestions3);

var _displaySuggestionsUpgrade3 = __webpack_require__(645);

var _displaySuggestionsUpgrade4 = _interopRequireDefault(_displaySuggestionsUpgrade3);

var _upgradeEvent3 = __webpack_require__(646);

var _upgradeEvent4 = _interopRequireDefault(_upgradeEvent3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedCheckoutModule = angular.module('spabooker.shared.checkout', ['spabooker.basket', 'spabooker.shared.availability']).component('displaySuggestions', _displaySuggestions2.default).component('displaySuggestionsUpgrade', _displaySuggestionsUpgrade2.default).component('upgradeEvent', _upgradeEvent2.default).component('upgradeOption', _upgradeOption2.default).controller('displaySuggestionsController', _displaySuggestions4.default).controller('displaySuggestionsUpgradeController', _displaySuggestionsUpgrade4.default).controller('upgradeEventController', _upgradeEvent4.default);

exports.default = sharedCheckoutModule.name;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        isAdmin: '<',
        canLoadStaff: '<',
        selectEvent: '&'
    },
    controller: 'displaySuggestionsController',
    template: __webpack_require__(637)
};

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout__spinner ng-if=\"$ctrl.loadingService.isLoading('suggestions')\"> <spinner></spinner> </div> <div class=c-upsell__container ng-if=\"!$ctrl.loadingService.isLoading('suggestions')\"> <div class=c-upsell__upgrades ng-if=$ctrl.canShowUpgrades()> <hr> <div ng-if=$ctrl.content.settings.load_staff> <p><em>When upgrading an event, please be aware that you may not get the same member of staff.</em></p> <hr> </div> <h3>Upgrade your experience</h3> <div ng-repeat=\"upgrade in $ctrl.multiGuestUpgrades\" ng-if=$ctrl.multiGuestUpgrades.length> <h4>{{ upgrade.guests.join(', ') }} upgrades</h4> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() items=upgrade.items upgrade=\"$ctrl.findAvailableUpgrade(upgrade.items[0], upgrade.items.length)\" guests=upgrade.guests></display-suggestions-upgrade> </div> <div ng-repeat=\"guest in $ctrl.basket.contents.guest_details\" ng-if=$ctrl.guestCanUpgrade(guest)> <h4>{{ $ctrl.guestName(guest, 'upgrades') }}</h4> <div ng-repeat=\"item in guest.item_details\" ng-if=$ctrl.itemOrChildrenCanUpgrade(item)> <div ng-if=\"item.canUpgradeTo || item.upgraded\"> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() item=item upgrade=$ctrl.findAvailableUpgrade(item) guest=guest></display-suggestions-upgrade> </div> <div ng-if=item.item_children ng-repeat=\"child in item.item_children\"> <div ng-if=\"child.canUpgradeTo || child.upgraded\"> <display-suggestions-upgrade get-suggestions=$ctrl.getSuggestions() parent=item item=child upgrade=$ctrl.findAvailableUpgrade(child) guest=guest></display-suggestions-upgrade> </div> </div> </div> </div> </div> <div class=\"c-upsell__events c-upsell__events--treatment\" ng-if=\"$ctrl.canShowRelated('Treatment')\"> <hr> <h3>Add another Treatment</h3> <event-tile ng-if=!$ctrl.isAdmin type=Treatment event=event class=c-upsell__event add-class=c-tile--thin ng-repeat=\"event in $ctrl.getRelated('Treatment')\"></event-tile> <div ng-if=$ctrl.isAdmin> <ul> <li ng-repeat=\"event in $ctrl.getRelated('Treatment')\"> <a ng-click=\"$ctrl.selectEvent({ type: 'Treatment', eventId: event.id })\">{{ event.name }}</a> </li> </ul> </div> </div> <div class=\"c-upsell__events c-upsell__events--spaday\" ng-if=\"$ctrl.canShowRelated('SpaDay')\"> <hr> <h3>Add another Spa Day</h3> <event-tile ng-if=!$ctrl.isAdmin type=\"Spa Day\" event=event class=c-upsell__event add-class=c-tile--thin ng-repeat=\"event in $ctrl.getRelated('SpaDay')\"></event-tile> <div ng-if=$ctrl.isAdmin> <ul> <li ng-repeat=\"event in $ctrl.getRelated('SpaDay')\"> <a ng-click=\"$ctrl.selectEvent({ type: 'SpaDay', eventId: event.id })\">{{ event.name }}</a> </li> </ul> </div> </div> <div class=c-upsell__empty ng-if=$ctrl.hasNoSuggestions()> <div class=c-checkout__empty> <span>We couldn't find any suggestions for you.<span ng-if=!$ctrl.isAdmin> Please proceed to the next step.</span></span> </div> </div> </div> ";

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        items: '=?',
        item: '=?',
        upgrade: '<',
        parent: '<',
        guests: '<?',
        guest: '<?'
    },
    controller: 'displaySuggestionsUpgradeController',
    template: __webpack_require__(639)
};

/***/ }),
/* 639 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upsell__upgrades--treatment ng-if=\"$ctrl.itemIs('Treatment') && $ctrl.showUpgrade()\"> <div class=c-upsell__upgrade> <upgrade-event get-suggestions=$ctrl.getSuggestions() events=$ctrl.items event=$ctrl.item upgrade=$ctrl.upgrade parent=$ctrl.parent type=Treatment guest=$ctrl.guest></upgrade-event> </div> </div> <div class=c-upsell__upgrades--spaday ng-if=\"$ctrl.itemIs('SpaDay')\"> <div class=c-upsell__upgrade> <upgrade-event get-suggestions=$ctrl.getSuggestions() events=$ctrl.items event=$ctrl.item upgrade=$ctrl.upgrade parent=$ctrl.parent type=SpaDay guest=$ctrl.guest></upgrade-event> </div> </div> <div class=c-upsell__upgrades--options ng-if=\"$ctrl.itemIs('OptionGroupOption')\"> <div class=c-upsell__upgrade> <upgrade-option get-suggestions=$ctrl.getSuggestions() event=$ctrl.item parent=$ctrl.parent></upgrade-option> </div> </div> <div ng-if=$ctrl.unavailable class=\"c-empty c-empty--box\"> <p class=\"c-empty__message text-center\"> Sorry, not enough availability to upgrade. </p> </div> ";

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        events: '<',
        event: '<',
        upgrade: '<',
        parent: '<',
        type: '@',
        guest: '<'
    },
    controller: 'upgradeEventController',
    template: __webpack_require__(641)
};

/***/ }),
/* 641 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upgrade__success ng-show=$ctrl.event.upgraded> <icon icon=tick></icon><span>{{ $ctrl.eventOriginalName() }} upgraded to {{ $ctrl.eventUpgradedName() }}</span> </div> <div ng-show=!$ctrl.event.upgraded> <div class=grid-x> <div class=\"cell small-12 / c-upgrade__container\"> <div class=grid-x> <div class=\"cell small-12 medium-auto\"> <div class=\"c-upgrade__image c-upgrade__image--original\" ng-if=$ctrl.event.item.image_url imgix-src=\"{{ $ctrl.event.item.override_image_url || $ctrl.event.item.image_url }}\"></div> <div class=\"c-upgrade__event c-upgrade__event--original\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item.name }}</h4> </div> </div> <div class=c-upgrade__chevron> <div class=c-upgrade__chevron__text> Upgrade to </div> <icon icon=chevron-right class=\"c-upgrade__right c-upgrade__icon\"></icon> <icon icon=chevron-down class=\"c-upgrade__down c-upgrade__icon\"></icon> </div> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=$ctrl.upgrade.image imgix-src=\"{{ $ctrl.upgrade.image }}\" imgix-refresh> <div class=\"c-upgrade__event__price / c-tile__price\" ng-class=\"{' / t-text--secondary--background': $ctrl.upgrade.availability.offer }\"> Upgrade for <s ng-if=\"$ctrl.upgrade.availability.offer && $ctrl.originalPrice() > 0\"> <money amount=$ctrl.originalPrice() decorate=true></money> </s> <money amount=$ctrl.upgradePrice() decorate=true ng-if=\"$ctrl.upgradePrice() > 0\"></money> <span ng-if=\"$ctrl.upgradePrice() <= 0\"> FREE </span> </div> </div> <div class=\"c-upgrade__event c-upgrade__event--upgrade\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.upgrade.name }}</h4> </div> </div> </div> </div> </div> <div class=grid-x> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <button class=c-button ng-click=$ctrl.upgradeEvent() ng-disabled=$ctrl.basket.saving> <span ng-if=!$ctrl.events>Upgrade this {{ $ctrl.eventTypeDisplayName() }}</span> <span ng-if=$ctrl.events>Upgrade {{ $ctrl.events.length }} {{ $ctrl.eventTypeDisplayName() }}s</span> </button> </div> <div class=\"cell auto\"></div> </div> </div> ";

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getSuggestions: '&',
        event: '=',
        parent: '<'
    },
    controller: 'upgradeEventController',
    template: __webpack_require__(643)
};

/***/ }),
/* 643 */
/***/ (function(module, exports) {

module.exports = "<div class=c-upgrade__success ng-if=$ctrl.event.upgraded> <icon icon=tick></icon><span>{{ $ctrl.eventOriginalName() }} upgraded to {{ $ctrl.eventUpgradedName() }}</span> </div> <div ng-if=!$ctrl.event.upgraded> <div class=grid-x> <div class=\"cell small-12 / c-upgrade__container c-upgrade__container--option\"> <div class=grid-x> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=\"$ctrl.event.item.override_image_url && $ctrl.event.item.upgrade_image_url\" imgix-src=\"{{ $ctrl.event.item.override_image_url }}\" imgix-refresh></div> <div class=\"c-upgrade__event c-upgrade__event--original\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item_summary.name }}</h4> </div> </div> <div class=c-upgrade__chevron ng-class=\"{ 'c-upgrade__chevron--short' : !$ctrl.event.item.override_image_url || !$ctrl.event.item.upgrade_image_url }\"> <div class=c-upgrade__chevron__text> Upgrade to </div> <icon icon=chevron-right class=\"c-upgrade__right c-upgrade__icon\"></icon> <icon icon=chevron-down class=\"c-upgrade__down c-upgrade__icon\"></icon> </div> <div class=\"cell small-12 medium-auto\"> <div class=c-upgrade__image ng-if=\"$ctrl.event.item.override_image_url && $ctrl.event.item.upgrade_image_url\" imgix-src=\"{{ $ctrl.event.item.upgrade_image_url }}\" imgix-refresh> <div class=\"c-upgrade__event__price / c-tile__price\"> Upgrade for <span ng-if=\"$ctrl.event.item.upgrade_value > 0\"> <money amount=$ctrl.event.item.upgrade_value decorate=true> </money></span> <span ng-if=\"!$ctrl.event.item.upgrade_value || $ctrl.event.item.upgrade_value <= 0\"> FREE </span> </div> </div> <div class=\"c-upgrade__event c-upgrade__event--upgrade\"> <span class=c-upgrade__event__parent>{{ $ctrl.displayDate() }}</span> <h4>{{ $ctrl.event.item.upgrade_name }}</h4> </div> <div class=c-upgrade__option-price ng-if=\"!$ctrl.event.item.override_image_url || !$ctrl.event.item.upgrade_image_url\"> <div class=\"c-upgrade__event__price / c-tile__price\"> Upgrade for <span ng-if=\"$ctrl.event.item.upgrade_value > 0\"> <money amount=$ctrl.event.item.upgrade_value decorate=true> </money></span> <span ng-if=\"!$ctrl.event.item.upgrade_value || $ctrl.event.item.upgrade_value <= 0\"> FREE </span> </div> </div> </div> </div> </div> </div> <div class=grid-x> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <button class=c-button ng-disabled=$ctrl.basket.saving ng-click=$ctrl.upgradeEvent()>Upgrade this experience</button> </div> <div class=\"cell auto\"></div> </div> </div> ";

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplaySuggestionsController = function () {
    function DisplaySuggestionsController(basket, checkout, suggestionsService, guestnameService, loadingService) {
        _classCallCheck(this, DisplaySuggestionsController);

        this.basket = basket;
        this.checkout = checkout;
        this.suggestionsService = suggestionsService;
        this.guestname = guestnameService;
        this.loadingService = loadingService;
    }

    _createClass(DisplaySuggestionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            if (this.basket.contents.has_suggestions) {
                return this.loadSuggestions().then(function () {
                    if (!_this.isAdmin) {
                        _this.checkout.setStepByName('suggestions');
                    }
                });
            }
        }
    }, {
        key: 'loadSuggestions',
        value: function loadSuggestions() {
            var _this2 = this;

            this.loadingService.startLoading('suggestions');
            return this.requestSuggestions().then(function () {
                _this2.loadingService.stopLoading('suggestions');
            });
        }
    }, {
        key: 'getSuggestions',
        value: function getSuggestions() {
            var _this3 = this;

            this.loadingService.startLoading('suggestions');
            return this.basket.submit('delete_orders').then(function () {
                return _this3.requestSuggestions();
            }).then(function () {
                _this3.loadingService.stopLoading('suggestions');
            });
        }
    }, {
        key: 'requestSuggestions',
        value: function requestSuggestions() {
            var _this4 = this;

            return this.basket.promise.then(function () {
                return _this4.suggestionsService.getSuggestions().then(function () {
                    _this4.setMultiGuestUpgrades();
                    return;
                });
            });
        }
    }, {
        key: 'findAvailableUpgrade',
        value: function findAvailableUpgrade(item) {
            var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            var type = item.item_summary.type_name;
            var date = (0, _moment2.default)(item.date).format('YYYY-MM-DD');

            if (item.item_summary.type_name === 'OptionGroupOption') {
                if (item.item.option_type === 'Custom') {
                    return true;
                }

                type = 'Treatment';
            }

            if (item.canUpgradeTo) {
                return this.getUpgradeOrUnset(date, type, item, quantity);
            }
        }
    }, {
        key: 'getUpgradeOrUnset',
        value: function getUpgradeOrUnset(date, type, item, quantity) {
            var upgrade = this.suggestionsService.getAvailableUpgrade(date, type, item.canUpgradeTo, item.preferred_time, quantity);
            if (upgrade) {
                return upgrade;
            }

            item.canUpgradeTo = false;
            return false;
        }
    }, {
        key: 'itemOrChildrenCanUpgrade',
        value: function itemOrChildrenCanUpgrade(item) {
            if (this.canUpgradeSingleItem(item)) {
                return true;
            }

            if (item.item_children) {
                return !!item.item_children.find(function (child) {
                    return child.canUpgradeTo || child.upgraded;
                });
            }

            return false;
        }
    }, {
        key: 'upgradeAvailable',
        value: function upgradeAvailable() {
            var _this5 = this;

            return !!this.basket.contents.guest_details.find(function (guest) {
                return _this5.guestCanUpgrade(guest);
            });
        }
    }, {
        key: 'guestCanUpgrade',
        value: function guestCanUpgrade(guest) {
            var _this6 = this;

            return !!guest.item_details.find(function (item) {
                return _this6.itemOrChildrenCanUpgrade(item);
            });
        }
    }, {
        key: 'canShowUpgrades',
        value: function canShowUpgrades() {
            return !this.loadingService.isLoading('suggestions') && (this.upgradeAvailable() || !!(this.multiGuestUpgrades && this.multiGuestUpgrades.length > 0));
        }
    }, {
        key: 'canShowRelated',
        value: function canShowRelated(type) {
            if (this.loadingService.isLoading('suggestions')) {
                return false;
            }

            this.related = this.related || this.suggestionsService.getRelated();

            return !!(this.related[type] && Object.keys(this.related[type]).length > 0);
        }
    }, {
        key: 'getRelated',
        value: function getRelated(type) {
            return this.related[type];
        }
    }, {
        key: 'guestName',
        value: function guestName(guest, suffix) {
            return this.guestname.format(guest, true, suffix);
        }
    }, {
        key: 'hasNoSuggestions',
        value: function hasNoSuggestions() {
            return !this.loadingService.isLoading('suggestions') && !this.upgradeAvailable() && !this.suggestionsService.hasRelated();
        }
    }, {
        key: 'canUpgradeSingleItem',
        value: function canUpgradeSingleItem(item) {
            return item.item_summary && item.item_summary.minimum_guests === 1 && (!!item.canUpgradeTo || item.upgraded === 1);
        }
    }, {
        key: 'setMultiGuestUpgrades',
        value: function setMultiGuestUpgrades() {
            var _this7 = this;

            this.multiGuestUpgrades = [];
            this.basket.contents.guest_details.forEach(function (guest) {
                guest.item_details.forEach(function (item) {
                    if (item.item_summary.minimum_guests > 1 && (item.canUpgradeTo || item.upgraded === 1)) {

                        var guestName = _this7.guestname.format(guest, true);

                        if (_this7.multiGuestUpgrades.length > 0) {
                            var foundUpgrade = _this7.multiGuestUpgrades.find(function (upgrade) {
                                return upgrade.reference === item.reference;
                            });

                            if (foundUpgrade) {
                                foundUpgrade.guests.push(guestName);
                                foundUpgrade.items.push(item);
                                return;
                            }
                        }

                        _this7.multiGuestUpgrades.push({
                            guests: [guestName],
                            items: [item],
                            reference: item.reference
                        });
                    }
                });
            });
        }
    }]);

    return DisplaySuggestionsController;
}();

DisplaySuggestionsController.$inject = ['basket', 'checkout', 'suggestionsService', 'guestnameService', 'loadingService'];

exports.default = DisplaySuggestionsController;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplaySuggestionsUpgradeController = function () {
    function DisplaySuggestionsUpgradeController() {
        _classCallCheck(this, DisplaySuggestionsUpgradeController);
    }

    _createClass(DisplaySuggestionsUpgradeController, [{
        key: '$onInit',
        value: function $onInit() {
            if (this.items && !this.item) {
                this.item = this.items[0];
            }

            this.unavailable = false;
        }
    }, {
        key: 'itemIs',
        value: function itemIs(type) {
            if (!this.item || !this.item.upgraded && !this.upgrade) {
                this.unavailable = true;
                return false;
            }

            if (this.upgrade && this.upgrade.availability && !this.upgrade.availability.available) {
                this.unavailable = true;
                return false;
            }

            if (type === 'Treatment' && this.item.item.type_name === 'OptionGroupOption') {
                return this.item.item.option_id > 0;
            }

            if (type === 'OptionGroupOption' && this.item.item.option_id > 0) {
                return false;
            }

            return this.item && this.item.item && this.item.item.type_name === type;
        }
    }, {
        key: 'showUpgrade',
        value: function showUpgrade() {
            // Don't show upgrades to linked integrated treatments
            return !!(this.item && !this.item.item.option_is_integrated);
        }
    }]);

    return DisplaySuggestionsUpgradeController;
}();

exports.default = DisplaySuggestionsUpgradeController;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UpgradeEventController = function () {
    function UpgradeEventController(upgradeService, basket, messageService) {
        _classCallCheck(this, UpgradeEventController);

        this.upgradeService = upgradeService;
        this.basket = basket;
        this.messageService = messageService;
    }

    _createClass(UpgradeEventController, [{
        key: 'originalPrice',
        value: function originalPrice() {
            var price = this.upgrade.availability.original_price - this.event.item_summary.price.original_price;
            if (this.events) {
                price = price * this.events.length;
            }
            return price;
        }
    }, {
        key: 'upgradePrice',
        value: function upgradePrice() {
            if (this.event.item.type_name === 'OptionGroupOption') {
                return this.upgrade.availability.price - this.event.item_summary.price.original_price;
            }

            var price = this.upgrade.availability.price - this.event.item_summary.price.price;
            if (this.events) {
                price = price * this.events.length;
            }
            return price;
        }
    }, {
        key: 'eventTypeDisplayName',
        value: function eventTypeDisplayName() {
            var eventType = this.event.item.type_name;

            switch (eventType) {
                case 'SpaDay':
                    return 'Spa Day';
                case 'OptionGroupOption':
                    return 'Treatment';
                default:
                    return eventType;
            }
        }
    }, {
        key: 'upgradeEvent',
        value: function upgradeEvent() {
            var _this = this;

            if (this.events || this.event) {
                if (!this.events) {
                    this.events = [this.event];
                }
                return this.upgradeService.upgrade(this.events).then(function () {
                    _this.getSuggestions();
                }).catch(function () {
                    var string = 'one or more events could not be upgraded';
                    if (_this.events.length === 1) {
                        string = 'we could not upgrade ' + ((0, _lodash.head)(_this.events).item.override_name || (0, _lodash.head)(_this.events).item_summary.name);
                    }
                    _this.messageService.failure('Sorry, ' + string + '. Please try again or contact us for help.');
                    _this.messageService.push();
                });
            }
        }
    }, {
        key: 'eventOriginalName',
        value: function eventOriginalName() {
            if (this.event.item_summary.type_name === 'OptionGroupOption') {
                return this.event.item.override_name || this.event.item.name;
            }

            return this.event.upgrade_from_name;
        }
    }, {
        key: 'eventUpgradedName',
        value: function eventUpgradedName() {
            if (this.event.item_summary.type_name === 'OptionGroupOption') {
                return this.event.item.upgrade_name || this.event.item_summary.name;
            }

            return this.event.item.name;
        }
    }, {
        key: 'displayDate',
        value: function displayDate() {
            var date = (0, _moment2.default)(this.event.date).format('dddd, Do MMMM, YYYY');
            if (this.event.preferred_time) {
                date = date + ' at ' + this.event.preferred_time.substring(0, 5);
            }
            return date;
        }
    }]);

    return UpgradeEventController;
}();

UpgradeEventController.$inject = ['upgradeService', 'basket', 'messageService'];

exports.default = UpgradeEventController;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _externalScript = __webpack_require__(648);

var _externalScript2 = _interopRequireDefault(_externalScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var coreModule = angular.module('journey-ui.shared.core', []).factory('externalScriptService', _externalScript2.default);

exports.default = coreModule.name;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scriptjs = __webpack_require__(320);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var externalScriptService = function externalScriptService() {
  return {
    load: function load(url) {
      return new Promise(function (resolve) {
        return (0, _scriptjs2.default)(url, resolve);
      });
    }
  };
};

externalScriptService.$inject = [];

exports.default = externalScriptService;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _billingDetails = __webpack_require__(650);

var _billingDetails2 = _interopRequireDefault(_billingDetails);

var _customerDetails = __webpack_require__(652);

var _customerDetails2 = _interopRequireDefault(_customerDetails);

var _paymentDetails = __webpack_require__(654);

var _paymentDetails2 = _interopRequireDefault(_paymentDetails);

var _countrySelector = __webpack_require__(656);

var _countrySelector2 = _interopRequireDefault(_countrySelector);

var _paymentRequestButton = __webpack_require__(658);

var _paymentRequestButton2 = _interopRequireDefault(_paymentRequestButton);

var _countrySelector3 = __webpack_require__(660);

var _countrySelector4 = _interopRequireDefault(_countrySelector3);

var _paymentDetails3 = __webpack_require__(661);

var _paymentDetails4 = _interopRequireDefault(_paymentDetails3);

var _customerDetails3 = __webpack_require__(662);

var _customerDetails4 = _interopRequireDefault(_customerDetails3);

var _paymentRequestButton3 = __webpack_require__(663);

var _paymentRequestButton4 = _interopRequireDefault(_paymentRequestButton3);

var _paymentToken = __webpack_require__(664);

var _paymentToken2 = _interopRequireDefault(_paymentToken);

var _cardAction = __webpack_require__(665);

var _cardAction2 = _interopRequireDefault(_cardAction);

var _paysafeError = __webpack_require__(666);

var _paysafeError2 = _interopRequireDefault(_paysafeError);

var _paymentGateway = __webpack_require__(667);

var _paymentGateway2 = _interopRequireDefault(_paymentGateway);

var _paysafeGateway = __webpack_require__(668);

var _paysafeGateway2 = _interopRequireDefault(_paysafeGateway);

var _paymentError = __webpack_require__(669);

var _paymentError2 = _interopRequireDefault(_paymentError);

var _stripeGateway = __webpack_require__(670);

var _stripeGateway2 = _interopRequireDefault(_stripeGateway);

var _paymentConnect = __webpack_require__(671);

var _paymentConnect2 = _interopRequireDefault(_paymentConnect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentModule = angular.module('journey-ui.shared.payment', ['journey-ui.shared.core']).component('billingDetails', _billingDetails2.default).component('countrySelector', _countrySelector2.default).component('customerDetails', _customerDetails2.default).component('paymentDetails', _paymentDetails2.default).component('paymentRequestButton', _paymentRequestButton2.default).controller('countrySelectorController', _countrySelector4.default).controller('paymentDetailsController', _paymentDetails4.default).controller('customerDetailsController', _customerDetails4.default).controller('paymentRequestButtonController', _paymentRequestButton4.default).factory('paymentTokenService', _paymentToken2.default).factory('cardActionService', _cardAction2.default).factory('paymentGatewayService', _paymentGateway2.default).factory('paymentConnectService', _paymentConnect2.default).factory('paymentErrorService', _paymentError2.default).factory('paysafeGatewayService', _paysafeGateway2.default).factory('stripeGatewayService', _stripeGateway2.default).factory('paysafeErrorService', _paysafeError2.default);

exports.default = paymentModule.name;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '='
  },
  template: __webpack_require__(651)
};

/***/ }),
/* 651 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x grid-padding-x\"> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment billing address</h5> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=bill-address autocomplete=\"billing street-address\" class=\"field c-payment__input\" type=text placeholder=Street ng-model=$ctrl.model.avs_street required form-field-errors/> <span class=c-payment__label__label><span>Street</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=bill-city autocomplete=\"billing address-level2\" class=\"field c-payment__input\" type=text placeholder=City ng-model=$ctrl.model.avs_city required form-field-errors/> <span class=c-payment__label__label><span>City</span></span> </label> </div> <div class=\"cell medium-6 large-4\"> <label class=c-payment__label> <input name=bill-state autocomplete=\"billing address-level1\" class=\"field c-payment__input\" type=text placeholder=State/County ng-model=$ctrl.model.avs_state required form-field-errors/> <span class=c-payment__label__label><span>State/County</span></span> </label> </div> <div class=\"cell medium-6 large-4\"> <label class=c-payment__label> <input name=bill-postal autocomplete=\"billing postal-code\" class=\"field c-payment__input\" type=text placeholder=\"Post Code\" ng-model=$ctrl.model.avs_zip required form-field-errors/> <span class=c-payment__label__label><span>Post Code</span></span> </label> </div> <div class=\"cell large-4\"> <label class=c-payment__label> <country-selector model=$ctrl.model.avs_country></country-selector> <span class=\"c-payment__label__label c-payment__label--up\"><span>Country</span></span> </label> </div> </div>";

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '=',
    propertyName: '<',
    existingDetails: '<'
  },
  controller: 'customerDetailsController',
  template: __webpack_require__(653)
};

/***/ }),
/* 653 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x grid-padding-x\"> <div class=\"cell medium-12\"> <h5 class=c-payment__subheading>Your details</h5> </div> <div class=\"cell medium-12\" ng-if=$ctrl.existingDetails.length> <div class=c-payment__guest-select> <p>Use an existing guest or enter new details:</p> <div class=grid-x ng-if=\"$ctrl.existingDetails.length < 3\"> <button ng-repeat=\"guest in $ctrl.existingDetails\" class=\"cell medium-auto / c-payment__guest-select__button\" ng-class=\"{'c-payment__guest-select__button--selected': $ctrl.isGuestSelected(guest)}\" type=button ng-click=$ctrl.useDetails(guest)> {{ guest.fullName }} </button> <button class=\"cell medium-auto / c-payment__guest-select__button c-payment__guest-select__button--manual\" ng-class=\"{'c-payment__guest-select__button--selected': $ctrl.model.selectedGuest === ''}\" type=button ng-click=$ctrl.manualDetails()> Enter new details </button> </div> <div class=\"grid-x grid-margin-x medium-up-2\" ng-if=\"$ctrl.existingDetails.length >= 3\"> <select ng-model=$ctrl.model.selectedGuest class=\"cell / c-payment__guest-select__select\" ng-change=$ctrl.useDetails()> <option value=\"\" disabled=disabled>-- Choose an existing guest --</option> <option ng-repeat=\"guest in $ctrl.existingDetails\" ng-value=guest> {{ guest.fullName }} </option> </select> <button class=\"cell / c-payment__guest-select__button c-payment__guest-select__button--manual\" type=button ng-click=$ctrl.manualDetails()> Enter new details </button> </div> </div> </div> <div class=\"cell medium-6\" ng-show=$ctrl.showManualDetails()> <label class=c-payment__label> <input id=firstName name=firstname type=text class=\"field c-payment__input\" autocomplete=fname ng-model=$ctrl.model.first_name required form-field-errors/> <span class=c-payment__label__label><span>First Name</span></span> </label> </div> <div class=\"cell medium-6\" ng-show=$ctrl.showManualDetails()> <label class=c-payment__label> <input id=lastName name=lastname type=text class=\"field c-payment__input\" autocomplete=lname ng-model=$ctrl.model.last_name required form-field-errors/> <span class=c-payment__label__label><span>Last Name</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input name=tel class=\"field c-payment__input\" type=tel autocomplete=tel maxlength=20 ng-model=$ctrl.model.phone required form-field-errors/> <span class=c-payment__label__label><span>Phone number</span></span> </label> </div> <div class=\"cell medium-6\"> <label class=c-payment__label> <input id=emailAddress class=\"field c-payment__input\" type=email autocomplete=email ng-model=$ctrl.model.email required form-field-errors/> <span class=c-payment__label__label><span>Email</span></span> </label> </div> <div class=\"cell medium-12\" ng-show=$ctrl.notLoggedInDetails()> <label class=c-payment__marketing> <input type=checkbox ng-model=$ctrl.model.marketing /> <span> By ticking this box I consent to receive email marketing from {{$ctrl.propertyName}}. </span> </label> </div> </div> ";

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    totalAmount: '<'
  },
  controller: 'paymentDetailsController',
  template: __webpack_require__(655)
};

/***/ }),
/* 655 */
/***/ (function(module, exports) {

module.exports = "<div id=payment-details class=\"grid-x grid-padding-x / c-payment-details c-payment-details--paysafe\" ng-if=$ctrl.gateway.paysafe> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment card details</h5> </div> <div class=\"cell medium-6\"> <div id=card-number class=\"paysafe-field / t-border-bottom--primary\"></div> </div> <div class=\"cell medium-3\"> <div id=card-cvv class=\"paysafe-field / t-border-bottom--primary\"></div> </div> <div class=\"cell medium-3\"> <div id=card-expiry class=\"paysafe-field / t-border-bottom--primary\"></div> </div> </div> <div class=\"grid-x grid-padding-x\" ng-if=$ctrl.gateway.stripe> <div class=\"cell small-12\"> <h5 class=c-payment__subheading>Payment card details</h5> </div> <div id=payment-details class=\"c-payment-details c-payment-details--stripe\"></div> </div> <div id=totalPaymentAmount style=display:none>{{ $ctrl.totalAmount }}</div> ";

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    model: '='
  },
  controller: 'countrySelectorController',
  template: __webpack_require__(657)
};

/***/ }),
/* 657 */
/***/ (function(module, exports) {

module.exports = "<ui-select ng-model=$ctrl.model name=bill-country autocomplete=\"billing country\" required form-field-errors> <ui-select-match placeholder=Country> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"item.key as item in $ctrl.countries | filter: $select.search track by item.key\"> <span ng-bind=item.name></span> </ui-select-choices> </ui-select>";

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    gateway: '<',
    errorCallback: '&',
    successCallback: '&',
    paymentConfig: '<'
  },
  controller: 'paymentRequestButtonController',
  template: __webpack_require__(659)
};

/***/ }),
/* 659 */
/***/ (function(module, exports) {

module.exports = "<div class=c-payment__request> <div id=payment-request-button></div> <p class=c-payment__request__text><span>Or enter your payment details below</span></p> </div> ";

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CountrySelectorController = function () {
  function CountrySelectorController() {
    _classCallCheck(this, CountrySelectorController);
  }

  _createClass(CountrySelectorController, [{
    key: '$onInit',
    value: function $onInit() {
      this.setCountries();
    }
  }, {
    key: 'setCountries',
    value: function setCountries() {
      this.countries = [{
        'key': 'GB',
        'name': 'Great Britain',
        'search': 'United Kingdom, UK, England, Wales, Scotland, Northern Ireland'
      }, {
        'key': 'US',
        'name': 'United States of America',
        'search': 'USA'
      }, {
        'key': 'AF',
        'name': 'Afghanistan'
      }, {
        'key': 'AX',
        'name': 'Åland Islands'
      }, {
        'key': 'AL',
        'name': 'Albania'
      }, {
        'key': 'DZ',
        'name': 'Algeria'
      }, {
        'key': 'AS',
        'name': 'American Samoa'
      }, {
        'key': 'AD',
        'name': 'Andorra'
      }, {
        'key': 'AO',
        'name': 'Angola'
      }, {
        'key': 'AI',
        'name': 'Anguilla'
      }, {
        'key': 'AQ',
        'name': 'Antarctica'
      }, {
        'key': 'AG',
        'name': 'Antigua and Barbuda'
      }, {
        'key': 'AR',
        'name': 'Argentina'
      }, {
        'key': 'AM',
        'name': 'Armenia'
      }, {
        'key': 'AW',
        'name': 'Aruba'
      }, {
        'key': 'AU',
        'name': 'Australia'
      }, {
        'key': 'AT',
        'name': 'Austria'
      }, {
        'key': 'AZ',
        'name': 'Azerbaijan'
      }, {
        'key': 'BS',
        'name': 'Bahamas'
      }, {
        'key': 'BH',
        'name': 'Bahrain'
      }, {
        'key': 'BD',
        'name': 'Bangladesh'
      }, {
        'key': 'BB',
        'name': 'Barbados'
      }, {
        'key': 'BY',
        'name': 'Belarus'
      }, {
        'key': 'BE',
        'name': 'Belgium'
      }, {
        'key': 'BZ',
        'name': 'Belize'
      }, {
        'key': 'BJ',
        'name': 'Benin'
      }, {
        'key': 'BM',
        'name': 'Bermuda'
      }, {
        'key': 'BT',
        'name': 'Bhutan'
      }, {
        'key': 'BO',
        'name': 'Bolivia, Plurinational State of'
      }, {
        'key': 'BQ',
        'name': 'Bonaire, Sint Eustatius and Saba'
      }, {
        'key': 'BA',
        'name': 'Bosnia and Herzegovina'
      }, {
        'key': 'BW',
        'name': 'Botswana'
      }, {
        'key': 'BV',
        'name': 'Bouvet Island'
      }, {
        'key': 'BR',
        'name': 'Brazil'
      }, {
        'key': 'IO',
        'name': 'British Indian Ocean Territory'
      }, {
        'key': 'BN',
        'name': 'Brunei Darussalam'
      }, {
        'key': 'BG',
        'name': 'Bulgaria'
      }, {
        'key': 'BF',
        'name': 'Burkina Faso'
      }, {
        'key': 'BI',
        'name': 'Burundi'
      }, {
        'key': 'KH',
        'name': 'Cambodia'
      }, {
        'key': 'CM',
        'name': 'Cameroon'
      }, {
        'key': 'CA',
        'name': 'Canada'
      }, {
        'key': 'CV',
        'name': 'Cape Verde'
      }, {
        'key': 'KY',
        'name': 'Cayman Islands'
      }, {
        'key': 'CF',
        'name': 'Central African Republic'
      }, {
        'key': 'TD',
        'name': 'Chad'
      }, {
        'key': 'CL',
        'name': 'Chile'
      }, {
        'key': 'CN',
        'name': 'China'
      }, {
        'key': 'CX',
        'name': 'Christmas Island'
      }, {
        'key': 'CC',
        'name': 'Cocos (Keeling) Islands'
      }, {
        'key': 'CO',
        'name': 'Colombia'
      }, {
        'key': 'KM',
        'name': 'Comoros'
      }, {
        'key': 'CG',
        'name': 'Congo'
      }, {
        'key': 'CD',
        'name': 'Congo, the Democratic Republic of the'
      }, {
        'key': 'CK',
        'name': 'Cook Islands'
      }, {
        'key': 'CR',
        'name': 'Costa Rica'
      }, {
        'key': 'CI',
        'name': 'Côte d\'Ivoire'
      }, {
        'key': 'HR',
        'name': 'Croatia'
      }, {
        'key': 'CU',
        'name': 'Cuba'
      }, {
        'key': 'CW',
        'name': 'Curaçao'
      }, {
        'key': 'CY',
        'name': 'Cyprus'
      }, {
        'key': 'CZ',
        'name': 'Czech Republic'
      }, {
        'key': 'DK',
        'name': 'Denmark'
      }, {
        'key': 'DJ',
        'name': 'Djibouti'
      }, {
        'key': 'DM',
        'name': 'Dominica'
      }, {
        'key': 'DO',
        'name': 'Dominican Republic'
      }, {
        'key': 'EC',
        'name': 'Ecuador'
      }, {
        'key': 'EG',
        'name': 'Egypt'
      }, {
        'key': 'SV',
        'name': 'El Salvador'
      }, {
        'key': 'GQ',
        'name': 'Equatorial Guinea'
      }, {
        'key': 'ER',
        'name': 'Eritrea'
      }, {
        'key': 'EE',
        'name': 'Estonia'
      }, {
        'key': 'ET',
        'name': 'Ethiopia'
      }, {
        'key': 'FK',
        'name': 'Falkland Islands (Malvinas)'
      }, {
        'key': 'FO',
        'name': 'Faroe Islands'
      }, {
        'key': 'FJ',
        'name': 'Fiji'
      }, {
        'key': 'FI',
        'name': 'Finland'
      }, {
        'key': 'FR',
        'name': 'France'
      }, {
        'key': 'GF',
        'name': 'French Guiana'
      }, {
        'key': 'PF',
        'name': 'French Polynesia'
      }, {
        'key': 'TF',
        'name': 'French Southern Territories'
      }, {
        'key': 'GA',
        'name': 'Gabon'
      }, {
        'key': 'GM',
        'name': 'Gambia'
      }, {
        'key': 'GE',
        'name': 'Georgia'
      }, {
        'key': 'DE',
        'name': 'Germany'
      }, {
        'key': 'GH',
        'name': 'Ghana'
      }, {
        'key': 'GI',
        'name': 'Gibraltar'
      }, {
        'key': 'GR',
        'name': 'Greece'
      }, {
        'key': 'GL',
        'name': 'Greenland'
      }, {
        'key': 'GD',
        'name': 'Grenada'
      }, {
        'key': 'GP',
        'name': 'Guadeloupe'
      }, {
        'key': 'GU',
        'name': 'Guam'
      }, {
        'key': 'GT',
        'name': 'Guatemala'
      }, {
        'key': 'GG',
        'name': 'Guernsey'
      }, {
        'key': 'GN',
        'name': 'Guinea'
      }, {
        'key': 'GW',
        'name': 'Guinea-Bissau'
      }, {
        'key': 'GY',
        'name': 'Guyana'
      }, {
        'key': 'HT',
        'name': 'Haiti'
      }, {
        'key': 'HM',
        'name': 'Heard Island and McDonald Islands'
      }, {
        'key': 'VA',
        'name': 'Holy See (Vatican City State)'
      }, {
        'key': 'HN',
        'name': 'Honduras'
      }, {
        'key': 'HK',
        'name': 'Hong Kong'
      }, {
        'key': 'HU',
        'name': 'Hungary'
      }, {
        'key': 'IS',
        'name': 'Iceland'
      }, {
        'key': 'IN',
        'name': 'India'
      }, {
        'key': 'ID',
        'name': 'Indonesia'
      }, {
        'key': 'IR',
        'name': 'Iran, Islamic Republic of'
      }, {
        'key': 'IQ',
        'name': 'Iraq'
      }, {
        'key': 'IE',
        'name': 'Ireland'
      }, {
        'key': 'IM',
        'name': 'Isle of Man'
      }, {
        'key': 'IL',
        'name': 'Israel'
      }, {
        'key': 'IT',
        'name': 'Italy'
      }, {
        'key': 'JM',
        'name': 'Jamaica'
      }, {
        'key': 'JP',
        'name': 'Japan'
      }, {
        'key': 'JE',
        'name': 'Jersey'
      }, {
        'key': 'JO',
        'name': 'Jordan'
      }, {
        'key': 'KZ',
        'name': 'Kazakhstan'
      }, {
        'key': 'KE',
        'name': 'Kenya'
      }, {
        'key': 'KI',
        'name': 'Kiribati'
      }, {
        'key': 'KP',
        'name': 'Korea, Democratic People\'s Republic of'
      }, {
        'key': 'KR',
        'name': 'Korea, Republic of'
      }, {
        'key': 'KW',
        'name': 'Kuwait'
      }, {
        'key': 'KG',
        'name': 'Kyrgyzstan'
      }, {
        'key': 'LA',
        'name': 'Lao People\'s Democratic Republic'
      }, {
        'key': 'LV',
        'name': 'Latvia'
      }, {
        'key': 'LB',
        'name': 'Lebanon'
      }, {
        'key': 'LS',
        'name': 'Lesotho'
      }, {
        'key': 'LR',
        'name': 'Liberia'
      }, {
        'key': 'LY',
        'name': 'Libya'
      }, {
        'key': 'LI',
        'name': 'Liechtenstein'
      }, {
        'key': 'LT',
        'name': 'Lithuania'
      }, {
        'key': 'LU',
        'name': 'Luxembourg'
      }, {
        'key': 'MO',
        'name': 'Macao'
      }, {
        'key': 'MK',
        'name': 'Macedonia, the Former Yugoslav Republic of'
      }, {
        'key': 'MG',
        'name': 'Madagascar'
      }, {
        'key': 'MW',
        'name': 'Malawi'
      }, {
        'key': 'MY',
        'name': 'Malaysia'
      }, {
        'key': 'MV',
        'name': 'Maldives'
      }, {
        'key': 'ML',
        'name': 'Mali'
      }, {
        'key': 'MT',
        'name': 'Malta'
      }, {
        'key': 'MH',
        'name': 'Marshall Islands'
      }, {
        'key': 'MQ',
        'name': 'Martinique'
      }, {
        'key': 'MR',
        'name': 'Mauritania'
      }, {
        'key': 'MU',
        'name': 'Mauritius'
      }, {
        'key': 'YT',
        'name': 'Mayotte'
      }, {
        'key': 'MX',
        'name': 'Mexico'
      }, {
        'key': 'FM',
        'name': 'Micronesia, Federated States of'
      }, {
        'key': 'MD',
        'name': 'Moldova, Republic of'
      }, {
        'key': 'MC',
        'name': 'Monaco'
      }, {
        'key': 'MN',
        'name': 'Mongolia'
      }, {
        'key': 'ME',
        'name': 'Montenegro'
      }, {
        'key': 'MS',
        'name': 'Montserrat'
      }, {
        'key': 'MA',
        'name': 'Morocco'
      }, {
        'key': 'MZ',
        'name': 'Mozambique'
      }, {
        'key': 'MM',
        'name': 'Myanmar'
      }, {
        'key': 'NA',
        'name': 'Namibia'
      }, {
        'key': 'NR',
        'name': 'Nauru'
      }, {
        'key': 'NP',
        'name': 'Nepal'
      }, {
        'key': 'NL',
        'name': 'Netherlands'
      }, {
        'key': 'NC',
        'name': 'New Caledonia'
      }, {
        'key': 'NZ',
        'name': 'New Zealand'
      }, {
        'key': 'NI',
        'name': 'Nicaragua'
      }, {
        'key': 'NE',
        'name': 'Niger'
      }, {
        'key': 'NG',
        'name': 'Nigeria'
      }, {
        'key': 'NU',
        'name': 'Niue'
      }, {
        'key': 'NF',
        'name': 'Norfolk Island'
      }, {
        'key': 'MP',
        'name': 'Northern Mariana Islands'
      }, {
        'key': 'NO',
        'name': 'Norway'
      }, {
        'key': 'OM',
        'name': 'Oman'
      }, {
        'key': 'PK',
        'name': 'Pakistan'
      }, {
        'key': 'PW',
        'name': 'Palau'
      }, {
        'key': 'PS',
        'name': 'Palestine, State of'
      }, {
        'key': 'PA',
        'name': 'Panama'
      }, {
        'key': 'PG',
        'name': 'Papua New Guinea'
      }, {
        'key': 'PY',
        'name': 'Paraguay'
      }, {
        'key': 'PE',
        'name': 'Peru'
      }, {
        'key': 'PH',
        'name': 'Philippines'
      }, {
        'key': 'PN',
        'name': 'Pitcairn'
      }, {
        'key': 'PL',
        'name': 'Poland'
      }, {
        'key': 'PT',
        'name': 'Portugal'
      }, {
        'key': 'PR',
        'name': 'Puerto Rico'
      }, {
        'key': 'QA',
        'name': 'Qatar'
      }, {
        'key': 'RE',
        'name': 'Réunion'
      }, {
        'key': 'RO',
        'name': 'Romania'
      }, {
        'key': 'RU',
        'name': 'Russian Federation'
      }, {
        'key': 'RW',
        'name': 'Rwanda'
      }, {
        'key': 'BL',
        'name': 'Saint Barthélemy'
      }, {
        'key': 'SH',
        'name': 'Saint Helena, Ascension and Tristan da Cunha'
      }, {
        'key': 'KN',
        'name': 'Saint Kitts and Nevis'
      }, {
        'key': 'LC',
        'name': 'Saint Lucia'
      }, {
        'key': 'MF',
        'name': 'Saint Martin (French part)'
      }, {
        'key': 'PM',
        'name': 'Saint Pierre and Miquelon'
      }, {
        'key': 'VC',
        'name': 'Saint Vincent and the Grenadines'
      }, {
        'key': 'WS',
        'name': 'Samoa'
      }, {
        'key': 'SM',
        'name': 'San Marino'
      }, {
        'key': 'ST',
        'name': 'Sao Tome and Principe'
      }, {
        'key': 'SA',
        'name': 'Saudi Arabia'
      }, {
        'key': 'SN',
        'name': 'Senegal'
      }, {
        'key': 'RS',
        'name': 'Serbia'
      }, {
        'key': 'SC',
        'name': 'Seychelles'
      }, {
        'key': 'SL',
        'name': 'Sierra Leone'
      }, {
        'key': 'SG',
        'name': 'Singapore'
      }, {
        'key': 'SX',
        'name': 'Sint Maarten (Dutch part)'
      }, {
        'key': 'SK',
        'name': 'Slovakia'
      }, {
        'key': 'SI',
        'name': 'Slovenia'
      }, {
        'key': 'SB',
        'name': 'Solomon Islands'
      }, {
        'key': 'SO',
        'name': 'Somalia'
      }, {
        'key': 'ZA',
        'name': 'South Africa'
      }, {
        'key': 'GS',
        'name': 'South Georgia and the South Sandwich Islands'
      }, {
        'key': 'SS',
        'name': 'South Sudan'
      }, {
        'key': 'ES',
        'name': 'Spain'
      }, {
        'key': 'LK',
        'name': 'Sri Lanka'
      }, {
        'key': 'SD',
        'name': 'Sudan'
      }, {
        'key': 'SR',
        'name': 'Suriname'
      }, {
        'key': 'SJ',
        'name': 'Svalbard and Jan Mayen'
      }, {
        'key': 'SZ',
        'name': 'Swaziland'
      }, {
        'key': 'SE',
        'name': 'Sweden'
      }, {
        'key': 'CH',
        'name': 'Switzerland'
      }, {
        'key': 'SY',
        'name': 'Syrian Arab Republic'
      }, {
        'key': 'TW',
        'name': 'Taiwan, Province of China'
      }, {
        'key': 'TJ',
        'name': 'Tajikistan'
      }, {
        'key': 'TZ',
        'name': 'Tanzania, United Republic of'
      }, {
        'key': 'TH',
        'name': 'Thailand'
      }, {
        'key': 'TL',
        'name': 'Timor-Leste'
      }, {
        'key': 'TG',
        'name': 'Togo'
      }, {
        'key': 'TK',
        'name': 'Tokelau'
      }, {
        'key': 'TO',
        'name': 'Tonga'
      }, {
        'key': 'TT',
        'name': 'Trinidad and Tobago'
      }, {
        'key': 'TN',
        'name': 'Tunisia'
      }, {
        'key': 'TR',
        'name': 'Turkey'
      }, {
        'key': 'TM',
        'name': 'Turkmenistan'
      }, {
        'key': 'TC',
        'name': 'Turks and Caicos Islands'
      }, {
        'key': 'TV',
        'name': 'Tuvalu'
      }, {
        'key': 'UG',
        'name': 'Uganda'
      }, {
        'key': 'UA',
        'name': 'Ukraine'
      }, {
        'key': 'AE',
        'name': 'United Arab Emirates'
      }, {
        'key': 'UM',
        'name': 'United States Minor Outlying Islands'
      }, {
        'key': 'UY',
        'name': 'Uruguay'
      }, {
        'key': 'UZ',
        'name': 'Uzbekistan'
      }, {
        'key': 'VU',
        'name': 'Vanuatu'
      }, {
        'key': 'VE',
        'name': 'Venezuela, Bolivarian Republic of'
      }, {
        'key': 'VN',
        'name': 'Viet Nam'
      }, {
        'key': 'VG',
        'name': 'Virgin Islands, British'
      }, {
        'key': 'VI',
        'name': 'Virgin Islands, U.S.'
      }, {
        'key': 'WF',
        'name': 'Wallis and Futuna'
      }, {
        'key': 'EH',
        'name': 'Western Sahara'
      }, {
        'key': 'YE',
        'name': 'Yemen'
      }, {
        'key': 'ZM',
        'name': 'Zambia'
      }, {
        'key': 'ZW',
        'name': 'Zimbabwe'
      }];
    }
  }]);

  return CountrySelectorController;
}();

CountrySelectorController.$inject = [];

exports.default = CountrySelectorController;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentDetailsController = function () {
  function PaymentDetailsController(paymentGatewayService, paymentTokenService, cardActionService) {
    _classCallCheck(this, PaymentDetailsController);

    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
    this.cardActionService = cardActionService;
  }

  _createClass(PaymentDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!this.gateway) {
        return this.handleError(['Please contact us for help.'], true, 'No gateway set up.');
      }

      return this.paymentGatewayService.mount(this.gateway).then(function (response) {
        if (response) {
          _this.paymentTokenService.setCreateToken(response.createToken);
          _this.cardActionService.setHandleCardAction(response.createAction);
        }
      }).catch(function () {
        return _this.handleError(['Please contact us for help.'], true, 'Fail setting up gateway');
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(error, report, text) {
      this.errorCallback({ error: error, report: report, text: text });
    }
  }]);

  return PaymentDetailsController;
}();

PaymentDetailsController.$inject = ['paymentGatewayService', 'paymentTokenService', 'cardActionService'];

exports.default = PaymentDetailsController;

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomerDetailsController = function () {
  function CustomerDetailsController() {
    _classCallCheck(this, CustomerDetailsController);
  }

  _createClass(CustomerDetailsController, [{
    key: '$onInit',
    value: function $onInit() {
      this.initModel();
      this.model.selectedGuest = '';
    }
  }, {
    key: 'initModel',
    value: function initModel() {
      this.model = this.model || {};
    }
  }, {
    key: 'useDetails',
    value: function useDetails(guest) {
      this.initModel();
      if (guest) {
        this.model.selectedGuest = guest;
      }

      if (this.model.selectedGuest) {
        this.model.first_name = this.model.selectedGuest.firstName || '';
        this.model.last_name = this.model.selectedGuest.lastName || '';
        this.model.email = this.model.selectedGuest.email || '';
        this.model.phone = this.model.selectedGuest.phone || '';
      }
    }
  }, {
    key: 'isGuestSelected',
    value: function isGuestSelected(guest) {
      this.initModel();
      return !!(this.model.integration_reference && this.model.integration_reference === guest.integrationReference || this.model.selectedGuest && this.model.selectedGuest.integrationReference === guest.integrationReference);
    }
  }, {
    key: 'manualDetails',
    value: function manualDetails() {
      this.initModel();
      this.model.selectedGuest = '';
      this.model.first_name = '';
      this.model.last_name = '';
      this.model.email = '';
      this.model.phone = '';
      this.model.integration_reference = null;
    }
  }, {
    key: 'showManualDetails',
    value: function showManualDetails() {
      this.initModel();
      return !this.model.integration_reference && !this.model.selectedGuest;
    }
  }, {
    key: 'notLoggedInDetails',
    value: function notLoggedInDetails() {
      this.initModel();
      return !!(!this.model.selectedGuest || this.model.selectedGuest && !this.model.selectedGuest.loggedIn);
    }
  }]);

  return CustomerDetailsController;
}();

CustomerDetailsController.$inject = [];

exports.default = CustomerDetailsController;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentRequestButtonController = function () {
  function PaymentRequestButtonController(paymentGatewayService, paymentTokenService) {
    _classCallCheck(this, PaymentRequestButtonController);

    this.paymentGatewayService = paymentGatewayService;
    this.paymentTokenService = paymentTokenService;
  }

  _createClass(PaymentRequestButtonController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!this.gateway) {
        return this.handleError(['Please contact us for help.'], 'No gateway set up.');
      }

      return this.paymentGatewayService.mount(this.gateway).then(function (response) {
        return _this.paymentTokenService.generatePaymentButtonToken(response.createPaymentRequestButton, _this.paymentConfig).then(function (token) {
          return _this.handleSuccess(token);
        });
      }).catch(function () {
        _this.handleError(['Please contact us for help.'], 'Fail setting up payment request button');
      });
    }
  }, {
    key: 'handleError',
    value: function handleError(error, report) {
      this.errorCallback({ error: error, report: report });
    }
  }, {
    key: 'handleSuccess',
    value: function handleSuccess(token) {
      if (token) {
        if (token.paymentMethod) {
          var response = {
            timestamp: this.paymentTokenService.getExpiryTimestamp(5),
            token: token.paymentMethod.id,
            customer: {
              first_name: '',
              last_name: '',
              phone: token.payerPhone || '',
              email: token.payerEmail || ''
            },
            card: token.paymentMethod.card || {}
          };

          if (token.payerName) {
            var customerName = token.payerName.split(' ');
            response.customer.first_name = customerName.shift();
            if (customerName.length > 0) {
              response.customer.last_name = customerName.join(' ');
            } else {
              response.customer.last_name = response.customer.first_name;
            }
          }

          return this.successCallback({ response: response });
        }

        this.handleError(['Sorry, there was a problem, please try again.']);
      }
    }
  }]);

  return PaymentRequestButtonController;
}();

PaymentRequestButtonController.$inject = ['paymentGatewayService', 'paymentTokenService'];

exports.default = PaymentRequestButtonController;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var paymentTokenService = function paymentTokenService(paymentErrorService) {
  var createToken = void 0;

  var setCreateToken = function setCreateToken(tokenCreator) {
    return createToken = tokenCreator;
  };

  var getExpiryTimestamp = function getExpiryTimestamp() {
    var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5;

    return (0, _moment2.default)().add(duration, 'minutes').unix();
  };

  var generateToken = function generateToken() {
    if (createToken) {
      return createToken().then(function (token) {
        if (!token.id) {
          throw { message: paymentErrorService.formatError(null) };
        }

        return {
          timestamp: getExpiryTimestamp(5),
          token: token.id,
          card: token.card || {}
        };
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  var generatePaymentButtonToken = function generatePaymentButtonToken(createPaymentRequestButton, requestConfig) {
    if (createPaymentRequestButton) {
      return createPaymentRequestButton(requestConfig).then(function (paymentRequest) {
        if (paymentRequest) {
          return new Promise(function (resolve, reject) {
            paymentRequest.on('paymentmethod', function (response) {
              if (response.error || !response.paymentMethod) {
                response.complete('fail');
                reject({ message: paymentErrorService.formatError(null) });
              }

              if (response.paymentMethod) {
                response.complete('success');
                resolve(response);
              }
            });
          });
        }
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  return {
    setCreateToken: setCreateToken,
    generateToken: generateToken,
    generatePaymentButtonToken: generatePaymentButtonToken,
    getExpiryTimestamp: getExpiryTimestamp
  };
};

paymentTokenService.$inject = ['paymentErrorService'];

exports.default = paymentTokenService;

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var cardActionService = function cardActionService(paymentErrorService) {
  var handleCardActionGateway = void 0;

  var setHandleCardAction = function setHandleCardAction(actionCreator) {
    return handleCardActionGateway = actionCreator;
  };

  var handleCardAction = function handleCardAction(clientSecret) {
    if (handleCardActionGateway) {
      return handleCardActionGateway(clientSecret).then(function (response) {
        if (!response.paymentIntent || response.paymentIntent && !response.paymentIntent.id) {
          throw { message: paymentErrorService.formatError('Sorry, your card could not be authorised.') };
        }

        return true;
      }).catch(function (error) {
        throw [error.message];
      });
    }

    return Promise.reject(['No valid gateway found']);
  };

  return {
    setHandleCardAction: setHandleCardAction,
    handleCardAction: handleCardAction
  };
};

cardActionService.$inject = ['paymentErrorService'];

exports.default = cardActionService;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Converts a Paysafe error code into a Stripe error code (our standard)
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just converts to human-readable strings.
 */
var paymentErrorService = function paymentErrorService() {
  var formatError = function formatError(error) {
    var message = '';
    var defaultMessage = 'Please check your card details and try again or contact us for help.';

    if (!error || !error.code) {
      return defaultMessage;
    }

    switch (error.code) {
      case 'neverload':
        message = 'There is a problem with the payment gateway please contact us to complete your order.';
        break;
      case '3002':
      case '3005':
      case '3006':
      case '5068':
        message = 'The card details provided may not be correct, please try again.';
        break;
      case '3009':
      case '3011':
      case '3012':
      case '3013':
      case '3014':
      case '3016':
      case '3022':
      case '3023':
      case '3024':
      case '3032':
      case '3035':
        message = 'The issuing bank has declined your transaction.';
        break;
      case '3036':
      case '3037':
      case '3038':
      case '3039':
      case '3046':
      case '3047':
      case '3048':
      case '3054':
      case '5021':
        message = 'Your transaction was denied.';
        break;
      case '9003':
      default:
        message = defaultMessage;
        break;
    }

    return message;
  };

  return {
    formatError: formatError
  };
};

paymentErrorService.$inject = [];

exports.default = paymentErrorService;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paymentGatewayService = function paymentGatewayService(paysafeGatewayService, stripeGatewayService) {

  var isLoaded = void 0;

  /*
            * Automatically gets called by mount() but can optionally
            * be called globally on every page (recommended for Stripe for fraud
            * tracking). load() will only ever load a script once.
            */
  var load = function load(options) {
    if (isLoaded) {
      return Promise.resolve();
    }

    var promise = void 0;

    if (options.none) {
      promise = Promise.resolve();
    }

    if (options.paysafe) {
      promise = paysafeGatewayService.load();
    }

    if (options.stripe) {
      promise = stripeGatewayService.load();
    }

    if (promise) {
      return promise.then(function () {
        return isLoaded = true;
      });
    }

    return Promise.reject();
  };

  var mount = function mount(options) {
    return load(options).then(function () {
      if (options.paysafe) {
        return paysafeGatewayService.mount(options.paysafe);
      }

      if (options.stripe) {
        return stripeGatewayService.mount(options.stripe);
      }
    });
  };

  return {
    load: load,
    mount: mount
  };
};

paymentGatewayService.$inject = ['paysafeGatewayService', 'stripeGatewayService'];

exports.default = paymentGatewayService;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var paysafeGatewayService = function paysafeGatewayService($window, externalScriptService, paysafeErrorService) {

  var load = function load() {
    return externalScriptService.load('https://hosted.paysafe.com/js/v1/latest/paysafe.min.js');
  };

  var mount = function mount(gatewayDetails) {
    return setup(gatewayDetails).then(function (instance) {
      return {
        createToken: function createToken() {
          var options = {
            threeDS: {
              amount: parseInt($window.document.getElementById('totalPaymentAmount').innerText),
              currency: '' + $window.config.currency,
              accountId: parseInt('' + $window.config.gateways.paysafe.accountId),
              useThreeDSecureVersion2: true
            },
            vault: {
              holderName: $window.document.getElementById('firstName').value + ' ' + $window.document.getElementById('lastName').value
            }
          };
          return new Promise(function (resolve, reject) {
            instance.tokenize(options, function (instance, error, result) {
              if (error) {
                reject({ message: paysafeErrorService.formatError(error) });
              }

              resolve({ id: result ? result.token : undefined });
            });
          });
        },
        createAction: function createAction() {
          return Promise.resolve();
        },
        createPaymentRequestbutton: function createPaymentRequestbutton() {
          return Promise.resolve();
        }
      };
    });
  };

  var setup = function setup(gatewayDetails) {
    var options = getOptions(gatewayDetails);

    return new Promise(function (resolve, reject) {
      $window.paysafe.fields.setup(gatewayDetails.key, options, function (instance, error) {
        if (error && error !== 'true') {
          reject(error);
        }

        resolve(instance);
      });
    });
  };

  var getOptions = function getOptions(gatewayDetails) {
    return {
      environment: gatewayDetails.env,
      fields: {
        cardNumber: {
          selector: '#card-number',
          placeholder: 'Card Number'
        },
        expiryDate: {
          selector: '#card-expiry',
          placeholder: 'Expiry'
        },
        cvv: {
          selector: '#card-cvv',
          placeholder: 'CVV'
        }
      }
    };
  };

  return {
    load: load,
    mount: mount
  };
};

paysafeGatewayService.$inject = ['$window', 'externalScriptService', 'paysafeErrorService'];

exports.default = paysafeGatewayService;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Converts a Stripe error code into a human readable string
 *
 * Currently the Stripe error handling has not been implemented so this service actually
 * just passes through all messages except for the default.
 */
var paymentErrorService = function paymentErrorService() {
  var defaultMessage = 'Please check your card details and try again or contact us for help.';

  return {
    formatError: function formatError(error) {
      return error ? error : defaultMessage;
    }
  };
};

paymentErrorService.$inject = [];

exports.default = paymentErrorService;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var stripeGatewayService = function stripeGatewayService($window, externalScriptService) {

  var options = {
    style: {
      base: {
        fontSize: '16px'
      }
    }
  };

  var isMounted = false;
  var createToken = void 0;
  var createAction = void 0;
  var createPaymentRequestButton = void 0;

  var load = function load() {
    return externalScriptService.load('https://js.stripe.com/v3/');
  };

  var mount = function mount(gatewayDetails) {
    if (!isMounted) {
      isMounted = true;
      var stripe = $window.Stripe(gatewayDetails.key);
      var element = stripe.elements();

      var cardInput = element.create('card', options);
      cardInput.mount('#payment-details');

      createToken = function createToken() {
        var billingName = $window.document.getElementById('firstName').value + ' ' + $window.document.getElementById('lastName').value;
        var billingEmail = $window.document.getElementById('emailAddress').value;

        return stripe.createPaymentMethod('card', cardInput, {
          billing_details: {
            name: billingName,
            email: billingEmail
          }
        }).then(function (response) {
          if (response.error) {
            throw response.error;
          }

          return response.paymentMethod;
        });
      };

      createAction = function createAction(clientSecret) {
        return stripe.handleCardAction(clientSecret).then(function (response) {
          if (response.error) {
            throw response.error;
          }

          return response;
        });
      };

      createPaymentRequestButton = function createPaymentRequestButton(requestConfig) {
        var paymentRequest = stripe.paymentRequest({
          country: requestConfig.country,
          currency: requestConfig.currency,
          total: {
            label: 'Order total',
            amount: requestConfig.amount
          },
          requestPayerName: true,
          requestPayerEmail: true,
          requestPayerPhone: true
        });

        var prButton = element.getElement('paymentRequestButton');
        if (!prButton) {
          prButton = element.create('paymentRequestButton', {
            paymentRequest: paymentRequest
          });
        }

        return paymentRequest.canMakePayment().then(function (result) {
          if (result) {
            prButton.mount('#payment-request-button');
            $window.document.getElementsByClassName('c-payment__request')[0].style.display = 'block';
            return paymentRequest;
          }
        });
      };
    }

    return Promise.resolve({
      createToken: createToken,
      createAction: createAction,
      createPaymentRequestButton: createPaymentRequestButton
    });
  };

  return {
    load: load,
    mount: mount
  };
};

stripeGatewayService.$inject = ['$window', 'externalScriptService'];

exports.default = stripeGatewayService;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['api', function (api) {
  return {
    connect: function connect(authCode, modelId, endpoint) {
      return api.post('' + endpoint, { code: authCode, modelId: modelId }).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _googleAnalytics = __webpack_require__(673);

var _googleAnalytics2 = _interopRequireDefault(_googleAnalytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var servicesModule = angular.module('journey-ui.services', []).factory('googleAnalytics', _googleAnalytics2.default);

exports.default = servicesModule.name;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scriptjs = __webpack_require__(320);

var _scriptjs2 = _interopRequireDefault(_scriptjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var googleAnalytics = function googleAnalytics($window, configService) {
  var googleAnalyticsContainer = { functions: {} };
  googleAnalyticsContainer.trackers = [];
  googleAnalyticsContainer.instance = undefined;
  googleAnalyticsContainer.load = configService.get('analytics.loadAnalytics') || false;

  googleAnalyticsContainer.loadScript = function () {
    return new Promise(function (resolve) {
      googleAnalyticsContainer.callExternalScript('https://www.google-analytics.com/analytics.js', function () {
        if ($window.ga) {
          googleAnalyticsContainer.collectAutoloaded();
          resolve();
        }
        resolve();
      });
    });
  };

  googleAnalyticsContainer.create = function (tracker) {
    if (!googleAnalyticsContainer.load || !$window.ga) {
      return false;
    }

    $window.ga('create', tracker.id, 'auto', tracker.name);
    $window.ga(tracker.name + '.require', 'ecommerce');
    googleAnalyticsContainer.trackers.push(tracker);
  };

  googleAnalyticsContainer.sendData = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'pageview';
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = googleAnalyticsContainer.trackers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var tracker = _step.value;

        $window.ga(tracker.name + '.send', data);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  googleAnalyticsContainer.sendEcommerce = function () {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = googleAnalyticsContainer.trackers[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var tracker = _step2.value;

        $window.ga(tracker.name + '.set', 'page', 'review');
        $window.ga(tracker.name + '.ecommerce:send');
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  };

  googleAnalyticsContainer.setData = function (actionKey, actionValue) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = googleAnalyticsContainer.trackers[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var tracker = _step3.value;

        $window.ga(tracker.name + '.set', actionKey, actionValue);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  };

  googleAnalyticsContainer.setEcommerce = function (ecommerceType, ecommerceData) {
    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = googleAnalyticsContainer.trackers[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var tracker = _step4.value;

        $window.ga(tracker.name + '.ecommerce:' + ecommerceType, ecommerceData);
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  };

  googleAnalyticsContainer.collectAutoloaded = function () {
    if ($window.ga && $window.ga.getAll) {
      var currentTrackers = $window.ga.getAll();
      var trackers = [];
      if (currentTrackers.length) {
        for (var i = 0; i < currentTrackers.length; i++) {
          var gtmTrackerName = currentTrackers[i].get('name');
          if (!gtmTrackerName) {
            gtmTrackerName = 'gtm' + (i + 1);
            $window.ga('set', 'name', gtmTrackerName);
          }

          $window.ga(gtmTrackerName + '.require', 'ecommerce');
          googleAnalyticsContainer.trackers.push({ name: gtmTrackerName });
        }
      }

      return trackers;
    }
  };

  googleAnalyticsContainer.callExternalScript = function (url, callback) {
    return (0, _scriptjs2.default)(url, callback);
  };

  return googleAnalyticsContainer;
};

googleAnalytics.$inject = ['$window', 'configService'];

exports.default = googleAnalytics;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basket = __webpack_require__(675);

var _basket2 = _interopRequireDefault(_basket);

var _basketItems = __webpack_require__(676);

var _basketItems2 = _interopRequireDefault(_basketItems);

var _addButton = __webpack_require__(677);

var _addButton2 = _interopRequireDefault(_addButton);

var _basketIndicator = __webpack_require__(678);

var _basketIndicator2 = _interopRequireDefault(_basketIndicator);

var _expiresAt = __webpack_require__(679);

var _expiresAt2 = _interopRequireDefault(_expiresAt);

var _editReservationDetails = __webpack_require__(680);

var _editReservationDetails2 = _interopRequireDefault(_editReservationDetails);

var _reservationItems = __webpack_require__(681);

var _reservationItems2 = _interopRequireDefault(_reservationItems);

var _membershipBanner = __webpack_require__(682);

var _membershipBanner2 = _interopRequireDefault(_membershipBanner);

var _basket3 = __webpack_require__(683);

var _basket4 = _interopRequireDefault(_basket3);

var _basketItems3 = __webpack_require__(685);

var _basketItems4 = _interopRequireDefault(_basketItems3);

var _addButton3 = __webpack_require__(687);

var _addButton4 = _interopRequireDefault(_addButton3);

var _basketIndicator3 = __webpack_require__(689);

var _basketIndicator4 = _interopRequireDefault(_basketIndicator3);

var _expiresAt3 = __webpack_require__(691);

var _expiresAt4 = _interopRequireDefault(_expiresAt3);

var _editReservationDetails3 = __webpack_require__(693);

var _editReservationDetails4 = _interopRequireDefault(_editReservationDetails3);

var _reservationItems3 = __webpack_require__(695);

var _reservationItems4 = _interopRequireDefault(_reservationItems3);

var _membershipBanner3 = __webpack_require__(697);

var _membershipBanner4 = _interopRequireDefault(_membershipBanner3);

var _apiBasket = __webpack_require__(699);

var _apiBasket2 = _interopRequireDefault(_apiBasket);

var _basketItem = __webpack_require__(700);

var _basketItem2 = _interopRequireDefault(_basketItem);

var _basket5 = __webpack_require__(701);

var _basket6 = _interopRequireDefault(_basket5);

var _api = __webpack_require__(702);

var _api2 = _interopRequireDefault(_api);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var basketModule = angular.module('spabooker.basket', []).controller('basketController', _basket2.default).controller('basketItemsController', _basketItems2.default).controller('addButtonController', _addButton2.default).controller('basketIndicatorController', _basketIndicator2.default).controller('expiresAtController', _expiresAt2.default).controller('editReservationDetailsController', _editReservationDetails2.default).controller('reservationItemsController', _reservationItems2.default).controller('membershipBannerController', _membershipBanner2.default).component('basket', _basket4.default).component('basketItems', _basketItems4.default).component('addButton', _addButton4.default).component('basketIndicator', _basketIndicator4.default).component('expiresAt', _expiresAt4.default).component('editReservationDetails', _editReservationDetails4.default).component('reservationItems', _reservationItems4.default).component('membershipBanner', _membershipBanner4.default).factory('basketApiService', _apiBasket2.default).factory('basketItemService', _basketItem2.default).factory('basket', _basket6.default).factory('api', _api2.default);
exports.default = basketModule.name;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketController = function BasketController(basket, order, checkout) {
    _classCallCheck(this, BasketController);

    this.basket = basket;
    this.order = order;
    this.basket.contents.currency = this.currency;
    this.checkout = checkout;
};

BasketController.$inject = ['basket', 'order', 'checkout'];

exports.default = BasketController;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketItemsController = function () {
  function BasketItemsController(basket, prompt, basketItemService) {
    var _this = this;

    _classCallCheck(this, BasketItemsController);

    this.prompt = prompt;
    this.basketItemService = basketItemService;
    basket.promise && basket.promise.then(function () {
      return _this.basket = basket;
    });
  }

  _createClass(BasketItemsController, [{
    key: 'price',
    value: function price(guest) {
      return this.basketItemService.price(guest);
    }
  }, {
    key: 'removeGuest',
    value: function removeGuest(id) {
      this.basket.removeGuestFromBasket(id);
    }
  }, {
    key: 'removeGuestItem',
    value: function removeGuestItem(guest, index) {
      this.basket.removeItemFromGuest(guest, index);
    }
  }, {
    key: 'typeDisplay',
    value: function typeDisplay(type) {
      if (type.indexOf('App\\') > -1) {
        type = type.slice(4);
      }

      if (type === 'SpaDay') {
        return 'Spa Day';
      }

      return type;
    }
  }, {
    key: 'childPrice',
    value: function childPrice(item, index, child) {
      if (item.credit_state) {
        return item.credit_state[index];
      } else if (child) {
        var price = void 0;
        if (child.item_summary) {
          price = child.item_summary.price;
        } else {
          price = child.price;
        }
        price = parseFloat(price['price']);
        return price > 0 ? price : 0;
      }

      return 0;
    }
  }, {
    key: 'displayTime',
    value: function displayTime(time) {
      var newTime = time.match(/\d{2}:\d{2}/);
      if (Array.isArray(newTime)) {
        return newTime[0];
      }

      return time;
    }
  }, {
    key: 'hasItems',
    value: function hasItems() {
      return this.basket.contents.guest_details.length > 0 && !!this.basket.contents.guest_details.find(function (guest) {
        return guest && guest.item_details && guest.item_details.length > 0;
      });
    }
  }, {
    key: 'guestHasMultipleItems',
    value: function guestHasMultipleItems(guest) {
      return !!(guest.item_details.length > 1 || guest.item_details.find(function (item) {
        return item.item_children && item.item_children.length > 0;
      }));
    }
  }]);

  return BasketItemsController;
}();

BasketItemsController.$inject = ['basket', 'prompt', 'basketItemService'];

exports.default = BasketItemsController;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddButtonController = function () {
    function AddButtonController($timeout, messageService, loginoutService, validateService, addGuestService) {
        _classCallCheck(this, AddButtonController);

        this.$timeout = $timeout;
        this.messageService = messageService;
        this.loginoutService = loginoutService;
        this.validateService = validateService;
        this.addGuestService = addGuestService;
    }

    _createClass(AddButtonController, [{
        key: '$onInit',
        value: function $onInit() {
            this.clearTimer = undefined;
        }
    }, {
        key: 'addToBasket',
        value: function addToBasket() {
            var _this = this;

            this.error = null;
            this.loading = false;
            this.success = false;
            this.errorFields = [];
            this.guests = this.addGuestService.getGuests();

            if (!this.validate()) {
                return;
            }

            this.loading = true;

            return this.checkLogin().then(function (response) {
                if (!response) {
                    _this.messageService.add('Sorry, you must log in to continue.');
                    _this.messageService.failure();
                    _this.loading = false;
                    return;
                }

                var oldOffer = _this.item.offer;

                if (_this.item.offer) {
                    _this.item.offer = _this.item.offer.id;
                }

                _this.$timeout.cancel(_this.clearTimer);
                _this.basket.changeStatus('checkout');

                return _this.basket.addToBasket(_this.guests, _this.item).then(function () {
                    _this.loading = false;
                    _this.item.offer = oldOffer;
                    _this.addGuestService.setState({
                        existingGuests: _this.basket.contents.guest_details,
                        guests: []
                    });

                    if (_this.basket.success) {
                        _this.success = true;
                        _this.clearTimer = _this.$timeout(function () {
                            _this.success = false;
                        }, 3000);
                    }

                    // Get new availability
                    return _this.getAvailabilitySingle(false);
                });
            });
        }
    }, {
        key: 'validate',
        value: function validate() {
            this.item.gender = this.gender;

            var error = this.validateService.invalidItemOrGuests(this.item, this.guests, this.status);

            if (error) {
                this.messageService.add(error);
                this.messageService.failure();
                return false;
            }

            return true;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            if (this.loading || this.status === 1) {
                return true;
            }

            if (this.item) {
                if (!this.item.available || this.item.quantity + this.item.minimum_guests < this.item.minimum_guests) {
                    return true;
                }
            }

            return false;
        }
    }, {
        key: 'canAddToBasket',
        value: function canAddToBasket() {
            var checkForPhone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            if (this.status === 1) {
                return false;
            }

            if (this.item) {
                if (this.item.available && checkForPhone) {
                    return this.item.phone_only;
                }

                return this.item.available;
            }

            return false;
        }
    }, {
        key: 'checkLogin',
        value: function checkLogin() {
            var _this2 = this;

            return new Promise(function (resolve) {
                if (_this2.basket.empty() && _this2.loginoutService.isAllowed()) {
                    return _this2.loginoutService.login(true).then(function (response) {
                        resolve(response);
                    });
                }
                resolve(true);
            });
        }
    }]);

    return AddButtonController;
}();

AddButtonController.$inject = ['$timeout', 'messageService', 'loginoutService', 'validateService', 'addGuestService'];

exports.default = AddButtonController;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketIndicatorController = function BasketIndicatorController(basket) {
    _classCallCheck(this, BasketIndicatorController);

    this.basket = basket;
};

BasketIndicatorController.$inject = ['basket'];

exports.default = BasketIndicatorController;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ExpiresAtController = function () {
  function ExpiresAtController() {
    _classCallCheck(this, ExpiresAtController);
  }

  _createClass(ExpiresAtController, [{
    key: 'shouldDisplayDate',
    value: function shouldDisplayDate() {
      if (!this.dateTime && this.displayDate) {
        this.displayDate = undefined;
      }

      if (this.dateTime && !this.displayDate) {
        var dateTime = (0, _moment2.default)(this.dateTime + '+00:00');
        var day = 'Today';
        var suffix = ' at ' + dateTime.format('h:mma');
        var dateDiff = dateTime.format('YYYYMMDD') - (0, _moment2.default)().format('YYYYMMDD');

        if (dateDiff > 0) {
          day = 'Tomorrow';
        }

        if (dateDiff < 0) {
          day = 'Basket has expired';
          suffix = '';
        }

        this.displayDate = '' + day + suffix;
        this.displayInline = !!this.inline;
      }

      return !!this.displayDate;
    }
  }]);

  return ExpiresAtController;
}();

ExpiresAtController.$inject = [];

exports.default = ExpiresAtController;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditReservationDetailsController = function () {
    function EditReservationDetailsController(storeService, dateService, basket) {
        _classCallCheck(this, EditReservationDetailsController);

        this.storeService = storeService;
        this.dateService = dateService;
        this.basket = basket;
    }

    _createClass(EditReservationDetailsController, [{
        key: 'displayReference',
        value: function displayReference() {
            return this.basket.contents.reservation_reference;
        }
    }, {
        key: 'displayDates',
        value: function displayDates() {
            return this.dateService.displayFromToDate(this.storeService.get('start_date'), this.storeService.get('end_date'));
        }
    }]);

    return EditReservationDetailsController;
}();

EditReservationDetailsController.$inject = ['storeService', 'dateService', 'basket'];

exports.default = EditReservationDetailsController;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReservationItemsController = function () {
    function ReservationItemsController(basket) {
        var _this = this;

        _classCallCheck(this, ReservationItemsController);

        basket.promise && basket.promise.then(function () {
            _this.basket = basket;
            _this.transformReservationItems();
        });
    }

    _createClass(ReservationItemsController, [{
        key: 'transformReservationItems',
        value: function transformReservationItems() {
            if (this.hasReservation()) {

                this.reservation = (0, _lodash.groupBy)(this.basket.contents.reservation.guests, function (reservation) {
                    return reservation.guest;
                });
            }
        }
    }, {
        key: 'hasReservation',
        value: function hasReservation() {
            return !!(this.basket && this.basket.contents && this.basket.contents.reservation);
        }
    }]);

    return ReservationItemsController;
}();

ReservationItemsController.$inject = ['basket'];

exports.default = ReservationItemsController;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MembershipBannerController = function () {
    function MembershipBannerController(basket, loginoutService) {
        _classCallCheck(this, MembershipBannerController);

        this.basket = basket;
        this.loginoutService = loginoutService;
    }

    _createClass(MembershipBannerController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.basket.promise && this.basket.promise.then(function () {
                _this.setDiscount();
            });
        }
    }, {
        key: 'showDiscount',
        value: function showDiscount() {
            this.setDiscount();

            if (!this.details || this.event && !this.event.date || !this.loginoutService.isLoggedIn()) {
                return false;
            }

            if (this.details && !this.event) {
                return true;
            }

            var dayOfWeek = (0, _moment2.default)(this.event.date).day();

            return this.discounts[dayOfWeek] > 0 && this.matchedEventType();
        }
    }, {
        key: 'matchedEventType',
        value: function matchedEventType() {
            return this.event.type === 'Treatment' && this.details.treatments || this.event.type === 'Spa Day' && this.details.spa_days;
        }
    }, {
        key: 'setDiscount',
        value: function setDiscount() {
            if (this.details) {
                return false;
            }

            this.details = this.basket.contents.membership_discount;

            if (this.details) {
                this.discounts = [this.details.sun_discount, this.details.mon_discount, this.details.tue_discount, this.details.wed_discount, this.details.thu_discount, this.details.fri_discount, this.details.sat_discount];
            }
        }
    }]);

    return MembershipBannerController;
}();

MembershipBannerController.$inject = ['basket', 'loginoutService'];

exports.default = MembershipBannerController;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        currency: '<'
    },
    controller: 'basketController',
    template: __webpack_require__(684)
};

/***/ }),
/* 684 */
/***/ (function(module, exports) {

module.exports = "<div class=c-basket__items> <edit-reservation-details></edit-reservation-details> <expires-at date-time=$ctrl.basket.contents.expires_at></expires-at> <basket-items basket=$ctrl.basket></basket-items> <reservation-items></reservation-items> <div ng-if=$ctrl.basket.contents.guest_details.length> <div class=c-basket__footer> <div class=c-basket__total> <div class=grid-x> <div class=\"cell shrink\"> <span>Grand Total</span> </div> <div class=\"cell auto\"> <money amount=$ctrl.basket.contents.total decorate=true></money> </div> </div> </div> <div class=c-basket__actions> <div class=cell> <a class=c-button href=\"{{ '/checkout/'+$ctrl.basket.contents.first_step }}\">Go to checkout</a> </div> </div> <div class=\"c-basket__actions--secondary / grid-x medium-up-2\"> <div class=cell> <a class=t-text--secondary--action--dark href=/guests>Edit guest information</a> </div> <div class=cell> <a class=t-text--secondary--action--dark href=/terms-conditions>Terms and conditions</a> </div> </div> </div> </div> </div> <div class=c-basket__overlay ng-class=\"{ 'is-active': $ctrl.basket.saving }\"> <spinner></spinner> </div> ";

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'basket': '=',
        'noedit': '<'
    },
    controller: 'basketItemsController',
    template: __webpack_require__(686)
};

/***/ }),
/* 686 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.hasItems() class=c-basket__guests> <div class=\"c-basket__guest / c-guest\" ng-repeat=\"(gkey, guest) in $ctrl.basket.contents.guest_details track by $index\" ng-if=\"guest.item_details.length > 0\"> <div class=c-guest__header> <div class=grid-x> <div class=\"cell auto / c-guest__name\"> {{ guest.title }} {{ guest.first_name }} {{ guest.last_name }} </div> <div class=\"cell shrink / c-guest__total\" ng-if=\"$ctrl.price(guest).total > 0\"> <money amount=$ctrl.price(guest).total decorate=true></money> </div> </div> </div> <div class=c-guest__events ng-if=guest.item_details> <div ng-repeat=\"item in guest.item_details\" class=c-guest__event> <div class=c-guest__event__header> <span class=c-guest__event__name>{{ item.item_summary.name }}</span> <div class=grid-x> <div class=\"cell auto\"> <span class=c-guest__event__date> {{ item.date.replace(' ','T') | date:'d MMMM, y' }} <span ng-if=item.preferred_time> at {{ $ctrl.displayTime(item.preferred_time) }} </span> <span ng-if=item.integration_staff_name> <br/>with {{ (item.integration_staff) ? item.integration_staff_name : item.integration_staff_name[0].toLowerCase() + item.integration_staff_name.substr(1) }} </span> </span> </div> <div class=\"cell shrink\"> <span class=c-guest__event__price ng-if=$ctrl.guestHasMultipleItems(guest)> <s ng-if=\"item.item_summary.price.price != item.item_summary.price.original_price\"> <money amount=item.item_summary.price.original_price decorate=true></money> </s> <money amount=item.item_summary.price.price decorate=true></money> </span> </div> </div> <div class=c-guest__remove ng-if=!$ctrl.noedit ng-click=\"$ctrl.removeGuestItem(gkey, $index)\"> <span class=c-guest__remove__inner> <span class=c-guest__remove__text>Remove </span> <icon icon=bin></icon> </span> </div> </div> <div class=c-guest__event__details ng-class=\"{ 'hidden': !item.hideDetails }\"> <div class=c-guest__event__header ng-repeat=\"child in item.item_children track by $index\"> <div class=grid-x> <div class=\"cell auto\"> <span class=c-guest__event__name><span ng-if=\"$ctrl.childPrice(item, $index, child) > 0\">+</span> <span ng-if=child.name> {{ child.upgraded ? child.upgraded_name || child.name : child.name }} </span> <span ng-if=child.item_summary.name> {{ child.upgraded ? child.upgraded_name || child.item_summary.name : child.item_summary.name }} </span> </span> </div> <div class=\"cell shrink\"> <span class=c-guest__event__price ng-if=\"$ctrl.childPrice(item, $index, child) > 0\"> + <money amount=\"$ctrl.childPrice(item, $index, child)\" decorate=true></money> </span> </div> </div> </div> </div> </div> </div> </div> </div> <div class=c-basket__empty ng-if=\"!$ctrl.basket.contents.guest_details.length && !$ctrl.basket.saving\"> <p>Your order is currently empty.</p> <a href=/ class=c-button>Return to homepage</a> </div> ";

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'item': '=',
        'basket': '=',
        'status': '<',
        'gender': '@',
        'getQuantity': '&',
        'getAvailabilitySingle': '&'
    },
    controller: 'addButtonController',
    template: __webpack_require__(688)
};

/***/ }),
/* 688 */
/***/ (function(module, exports) {

module.exports = "<button type=button class=\"c-button c-button--icon\" ng-click=\"!$ctrl.isDisabled() && $ctrl.addToBasket()\" ng-disabled=$ctrl.isDisabled() ng-class=\"{\n        'c-button--loading': $ctrl.loading,\n        'c-button--success': $ctrl.success\n    }\"> <span class=c-button__text ng-if=\"$ctrl.status !== 1 && !$ctrl.item.phone_only\">Add to basket</span> <span class=c-button__text ng-if=\"$ctrl.status === 1 || $ctrl.item.phone_only\">Telephone Only</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.loading> <spinner></spinner> </span> <span class=c-button__success ng-if=$ctrl.success> <icon icon=tick></icon> </span> </span> </button> ";

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'displayType': '@'
    },
    controller: 'basketIndicatorController',
    template: __webpack_require__(690)
};

/***/ }),
/* 690 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.basket.contents.guest_details.length class=c-basket-indicator> <div class=\"c-basket-indicator--dot t-text--primary\" ng-if=\"$ctrl.displayType === 'dot'\"> <span ng-bind=$ctrl.basket.contents.aggregate_total></span> </div> <div class=c-basket-indicator--bar ng-if=\"$ctrl.displayType === 'bar'\" ng-bind=\"$ctrl.basket.contents.item_total + ($ctrl.basket.contents.item_total > 1 ? ' events' : ' event') + ' and ' + $ctrl.basket.contents.guest_total + ' guests'\"> </div> </div>";

/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'inline': '<',
        'dateTime': '<'
    },
    controller: 'expiresAtController',
    template: __webpack_require__(692)
};

/***/ }),
/* 692 */
/***/ (function(module, exports) {

module.exports = "<div class=c-basket__expires ng-if=$ctrl.shouldDisplayDate()> Your basket is valid until <br ng-if=!$ctrl.displayInline> <span>{{ $ctrl.displayDate }}</span> </div> ";

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'editReservationDetailsController',
    template: __webpack_require__(694)
};

/***/ }),
/* 694 */
/***/ (function(module, exports) {

module.exports = "<div class=c-basket__reservation-details ng-if=$ctrl.displayReference()> <span class=c-basket__reservation__reference>Currently editing {{ $ctrl.displayReference() }}</span> <span class=c-basket__reservation__dates>{{ $ctrl.displayDates() }}</span> <hr> </div> ";

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'reservationItemsController',
    template: __webpack_require__(696)
};

/***/ }),
/* 696 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.hasReservation()> <div class=c-basket__reservation__heading>Existing booking details</div> <div class=\"c-basket__guests / c-basket__reservation-items\"> <div class=\"c-basket__guest / c-guest\" ng-repeat=\"(guestName, reservation) in $ctrl.reservation track by $index\"> <div class=c-guest__header> <div class=grid-x> <div class=\"cell auto / c-guest__name\">{{ guestName }}</div> </div> </div> <div class=c-guest__events> <div ng-repeat=\"item in reservation\" class=c-guest__event> <div class=c-guest__event__header> <span class=c-guest__event__name>{{ item.name }}</span> <div class=grid-x ng-if=item.start> <div class=\"cell auto\"> <span class=c-guest__event__date> {{ item.start.replace(' ','T') | date:'d MMMM, y' }} at {{ item.start.replace(' ','T') | date:'HH:mm' }} <span ng-if=item.staff><br>with {{ item.staff }}</span> </span> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        short: '<',
        event: '<',
        header: '<'
    },
    controller: 'membershipBannerController',
    template: __webpack_require__(698)
};

/***/ }),
/* 698 */
/***/ (function(module, exports) {

module.exports = "<div ng-cloak ng-if=$ctrl.showDiscount() class=\"c-membership c-membership__banner\" ng-class=\"{ 'c-membership__header' : $ctrl.header }\"> <span ng-if=!$ctrl.short> Your membership discount is currently active and will be applied during the payment step of the checkout </span> <span ng-if=$ctrl.short> Your membership discount will show on the payment screen before completion </span> </div> ";

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = 'checkout';

exports.default = ['api', function (api) {
    return {
        submitBasket: function submitBasket(basket) {
            return api.post(endpoint, basket).then(function (response) {
                return response.data;
            });
        },
        retrieveBasket: function retrieveBasket(basketCode) {
            var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            return api.get(endpoint + '/basket/' + basketCode + (items ? '?items=true' : '')).then(function (response) {
                return response.data;
            });
        },
        generateBasket: function generateBasket() {
            return api.post(endpoint + '/basket', {}).then(function (response) {
                return response.data;
            });
        },
        deleteBasket: function deleteBasket(basketCode) {
            return api.delete(endpoint + '/basket/' + basketCode).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['configService', 'storeService', function (configService, storeService) {

    var setGuestInputError = function setGuestInputError(errorFields, item) {
        var genderErrors = errorFields.filter(function (error) {
            return error === 'gender';
        });
        var requiredErrors = errorFields.filter(function (error) {
            return error === 'required';
        });

        if (genderErrors.length === 1) {
            return 'A guest has the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (genderErrors.length > 1) {
            return 'Several guests have the wrong gender for this ' + (item.type || item.type_display) + '.';
        }

        if (requiredErrors.length === 1) {
            return 'A guest is missing required fields.';
        }

        if (requiredErrors.length > 1) {
            return 'Several guests are missing required fields.';
        }
    };

    var price = function price(guest) {
        var prices = {
            'base': 0,
            'additionals': 0,
            'total': 0
        };

        if (guest && guest.item_details) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = guest.item_details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    if (item.item_summary && item.item_summary.price.price) {
                        prices.base += parseFloat(item.item_summary.price.price);
                    }
                    if (item.credit_state) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = item.credit_state[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var credit = _step2.value;

                                if (parseFloat(credit) > 0) {
                                    prices.additionals += parseFloat(credit);
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    } else if (item.item_children) {
                        var _iteratorNormalCompletion3 = true;
                        var _didIteratorError3 = false;
                        var _iteratorError3 = undefined;

                        try {
                            for (var _iterator3 = item.item_children[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                var child = _step3.value;

                                var _price = void 0;
                                if (child.item_type === 'App\\OptionGroupOption' || child.item_type === 'App\\EventExtra') {
                                    if (child.item_summary) {
                                        _price = child.item_summary.price;
                                    } else {
                                        _price = child.price;
                                    }
                                    _price = parseFloat(_price['price']);
                                    if (_price > 0) prices.additionals += _price;
                                }
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }
                            } finally {
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }

        prices.total = prices.base + prices.additionals;

        return prices;
    };

    var validateAdd = function validateAdd(item, guests) {
        var status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

        var guestCounter = [];
        var errorFields = [];

        if (item.available === false) {
            return 'Sorry, this event is not currently available.';
        }

        if (!item.preferred_time && !item.suggested) {
            return 'Please select your arrival time.';
        }

        if (item.phone_only || status === 1) {
            return 'Please call us to book this event.';
        }

        var property = configService.get('property');

        for (var index in guests) {
            var guest = guests[index];

            if (!guest.integration_reference && !guest.title || !guest.first_name || !guest.last_name || property.hasIntegration && !guest.gender) {
                errorFields.push('required');
                continue;
            }

            if (item.gender && item.gender !== guest.gender) {
                errorFields.push('gender');
                continue;
            }

            guestCounter.push(guest.title + guest.first_name + guest.last_name);
        }

        if (errorFields.length) {
            return setGuestInputError(errorFields, item);
        }

        if ((0, _lodash.uniq)(guestCounter).length !== guests.length && guestCounter.length <= item.quantity && guestCounter.length >= item.minimum_guests) {
            return 'You\'ve entered the same guest details more than once.';
        }

        if (guestCounter.length < item.minimum_guests) {
            return 'Too few guests added.';
        }
    };

    return {
        price: price,
        validateAdd: validateAdd
    };
}];

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(13);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = ['$window', 'basketApiService', 'messageService', 'basketPopupService', '$timeout', 'prompt', 'storeService', function ($window, basketApiService, messageService, basketPopupService, $timeout, prompt, storeService) {

  var basketItemByReference = function basketItemByReference(reference) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = basket.contents.guest_details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var guest = _step.value;

        var item = guest.item_details.find(function (item) {
          return item.reference === reference;
        });
        if (item) {
          return item;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  };

  var basket = {};

  basket.build = function () {
    basket.days = [];
    basket.treatments = [];
    basket.contents = {
      'guest_details': [],
      'voucher_details': {},
      'promo_details': {},
      'basket_status': 'checkout',
      'customer_details': {}
    };
    basket.saving = false;
    basket.success = null;
    basket.hasLoaded = false;
  };

  basket.shouldGetBasket = function () {
    if ($window.location.pathname.indexOf('/confirmation/') === -1) {
      return true;
    }

    return false;
  };

  basket.getApiBasket = function () {
    return new Promise(function (resolve) {

      if (basket.shouldGetBasket()) {
        var basketId = storeService.get('basket');

        if (basketId === 'undefined' || basketId === 'null') {
          basketId = null;
          storeService.set('basket', '');
        }

        if (basketId) {
          basket.promise = basket.getExistingBasket(basketId).then(function () {
            resolve();
          });
        } else {
          basket.promise = basket.getNewBasket().then(function () {
            resolve();
          });
        }
      }

      resolve();
    });
  };

  basket.getExistingBasket = function (basketId) {
    basket.saving = true;
    var withItems = $window.location.pathname.indexOf('/checkout/') > -1;
    return basketApiService.retrieveBasket(basketId, withItems).then(function (response) {
      if (response && response.guest_details) {
        basket.contents = response;
        if (basketId !== response.identity_code) {
          storeService.set('basket', response.identity_code);
        }
      }

      basket.saving = false;
      basket.hasLoaded = true;

      if (response.errors) {
        displayErrors(response.errors);
      }
    }).catch(function (error) {
      if (error.status === 410) {
        $window.location = '/confirmation/' + basketId;
      }

      if (error.status === 400 || error.status === 404) {
        basket.errorHandler(error, 'retrieve');
        return basket.getApiBasket();
      }
    });
  };

  basket.getNewBasket = function () {
    return basketApiService.generateBasket().then(function (response) {
      if (response && response.id && response.basket) {
        storeService.set('basket', response.id);
        basket.contents = response.basket;
      }

      basket.saving = false;
      basket.hasLoaded = true;
    }).catch(function (error) {
      basket.errorHandler(error, 'retrieve');
      $window.location = '/';
    });
  };

  basket.addToBasket = function (guests, item) {
    var showPopup = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    basket.success = null;
    basket.saving = true;
    var instanceref = basket.referenceGenerator();

    basket.contents.suggested_event = undefined;

    basket.guestSearch(guests, item, instanceref);

    basket.popup = showPopup;
    basketPopupService.remove();
    basket.setOption('delete_orders');

    return basketApiService.submitBasket(basket.contents).then(function (response) {
      if (response.basket_status && response.basket_status !== '-1') {
        basket.contents = response;
        storeService.set('basket', response.identity_code);

        if (response.errors && response.errors.length) {
          basket.success = false;
          basket.popup = false;

          displayErrors(response.errors);
          return;
        }

        basket.success = true;
        return;
      }

      basket.popup = false;
      basket.success = false;
    }).catch(function (error) {
      basket.success = false;
      basket.popup = false;

      if (error.status === 404) {
        basket.errorHandler(error, 'retrieve');
        return basket.getApiBasket();
      }

      basket.errorHandler(error, 'add', item);
    }).then(function () {
      if (basket.popup) {
        basketPopupService.success(basketItemByReference(instanceref), guests, basket.contents.expires_at);
      }
      basket.saving = false;
    });
  };

  basket.removeGuestFromBasket = function (index) {
    basket.saving = true;
    basket.removeItemCheck(basket.contents.guest_details[index], 'Due to the minimum guest requirement, the following event will be removed from all guests: ').then(function (result) {
      basketPopupService.remove();
      if (!result) {
        basket.saving = false;
        return;
      }

      if (Array.isArray(result)) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = result[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var reference = _step2.value;

            basket.purgeItem(reference);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      if (basket.contents.guest_details[index]) {
        basket.contents.guest_details.splice(index, 1);
      }

      basket.setOption('reset_steps');

      return basketApiService.submitBasket(basket.contents).then(function (response) {
        if (response.basket_status !== '-1') {
          basket.contents = response;

          if (response.errors) {
            displayErrors(response.errors);
          }
        }

        $timeout(function () {
          return basket.saving = false;
        }, 500);
      }).catch(function (error) {
        basket.errorHandler(error, 'guestremove');
        basket.saving = false;
      });
    });
  };

  basket.removeItemFromGuest = function (guestIndex, itemIndex) {
    basket.saving = true;
    basket.removeItemCheck(basket.contents.guest_details[guestIndex], 'Due to the minimum guest requirement, the following event will be removed from all guests: ', basket.contents.guest_details[guestIndex].item_details[itemIndex]).then(function (result) {
      basketPopupService.remove();
      if (!result) {
        basket.saving = false;
        return;
      }

      if (Array.isArray(result)) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = result[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var reference = _step3.value;

            basket.purgeItem(reference);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      } else {
        basket.contents.guest_details[guestIndex].item_details.splice(itemIndex, 1);
      }

      basket.setOption('reset_steps');

      return basketApiService.submitBasket(basket.contents).then(function (response) {
        if (response.basket_status !== '-1') {
          basket.contents = response;

          if (response.errors) {
            displayErrors(response.errors);
          }
        }

        $timeout(function () {
          return basket.saving = false;
        }, 500);
      }).catch(function (error) {
        basket.errorHandler(error, 'itemremove');
        basket.saving = false;
      });
    });
  };

  basket.guestSearch = function (guests, item, instanceref) {
    if (guests.length) {
      var _loop = function _loop(guest) {
        var find = (0, _lodash.findKey)(basket.contents.guest_details, function (basketguest) {
          return (basketguest.title ? basketguest.title === guest.title : true) && (basketguest.first_name ? basketguest.first_name === guest.first_name : true) && (basketguest.last_name ? basketguest.last_name === guest.last_name : true);
        });

        if (guest.staff) {
          item.staff = (0, _lodash.clone)(guest.staff);
        }

        if ((guest.first_name || guest.integration_reference && !guest.first_name) && guest.last_name) {
          if (!find) {
            guest.item_details = [basket.assignItem(item, instanceref)];
            basket.contents.guest_details.push((0, _lodash.clone)(guest));
            return 'continue';
          }

          basket.updateGuest(find, item, instanceref);
          return 'continue';
        }

        // Throw error?
      };

      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = guests[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var guest = _step4.value;

          var _ret = _loop(guest);

          if (_ret === 'continue') continue;
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }
  };

  basket.updateGuest = function (guest, item, instanceref) {
    guest = basket.contents.guest_details[guest];
    guest.item_details = guest.item_details || [];

    var find = (0, _lodash.findKey)(guest.item_details, function (item) {
      return item.reference === instanceref;
    });

    if (!find) {
      guest.item_details.push(basket.assignItem(item, instanceref));
    }
  };

  basket.assignItem = function (item) {
    var instanceRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var upgradeChildren = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    if (_typeof(item.price) === 'object') {
      item.original_price = item.price.original_price;
      item.price = item.price.price;
    }

    var assigned = {
      'reference': instanceRef || basket.referenceGenerator(),
      'item_id': item.id,
      'name': item.name.replace('/\\/g', ''),
      'price': item.price || 0,
      'original_price': item.original_price || 0,
      'minimum_guests': item.minimum_guests || 1,
      'maximum_guests': item.maximum_guests || 1,
      'date': item.date,
      'preferred_time': item.preferred_time,
      'credit': item.credit || null,
      'currency': basket.contents.currency,
      'offer_id': item.offer,
      'upgraded': item.upgraded || 0,
      'upgrade_from_id': item.upgrade_from_id,
      'upgrade_from_name': item.upgrade_from_name,
      'upgrade_from_type': item.upgrade_from_type,
      'upgrade_from_offer': item.upgrade_from_offer,
      'upgrade_from_price': item.upgrade_from_price
    };
    if (item.staff) {
      assigned.integration_staff = item.staff.id;
      assigned.integration_staff_name = item.staff.label;
    }

    if (item.end_date_time) {
      assigned.integration_end_time = item.end_date_time;
    }

    if (item.type_name) {
      assigned.item_type = 'App\\' + item.type_name.replace(/\s/g, '');
    } else {
      assigned.item_type = 'App\\' + item.type.replace(/\s/g, '');
    }

    if (upgradeChildren) {
      assigned.item_children = upgradeChildren;
    }

    if (item.group_id) {
      assigned.item = {
        'option_group_id': item.group_id,
        'option_type': item.option_type,
        'option_id': item.option_id
      };
    }

    return assigned;
  };

  basket.changeStatus = function (status) {
    basket.contents.basket_status = status;
  };

  basket.referenceGenerator = function () {
    var instanceref = '';
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < 16; i++) {
      instanceref += possible.charAt(Math.floor(Math.random() * possible.length));
    }

    return instanceref;
  };

  basket.submit = function () {
    var basketOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var removeSaving = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    basket.success = null;
    basket.saving = true;

    if (basketOption) {
      basket.setOption(basketOption);
    }

    delete basket.contents.client_secret;

    return basketApiService.submitBasket(basket.contents).then(function (response) {
      if (response && response.basket_status !== '-1' && response.basket_status !== 'ordered') {
        basket.contents = response;
        basket.success = true;

        if (basket.contents.errors) {
          displayErrors(basket.contents.errors);
        }
      }

      if (removeSaving) {
        $timeout(function () {
          return basket.saving = false;
        }, 500);
      }
    }).catch(function (error) {
      return basket.submitCatch(error);
    });
  };

  basket.submitCatch = function (error) {
    if (error.status === 404) {
      basket.errorHandler(error, 'retrieve');
      $window.location = '/';
      return;
    }

    basket.errorHandler(error, 'submit');

    $timeout(function () {
      return basket.saving = false;
    }, 5000);

    $window.scrollTo(0, 280);

    return true;
  };

  basket.empty = function () {
    return basket.contents && basket.contents.aggregate_total > 0 ? false : true;
  };

  basket.isEmpty = basket.empty();

  basket.removeItemCheck = function (guest, message) {
    var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var problems = [];
    var ids = [];

    if (!item) {
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = guest.item_details[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _item = _step5.value;

          if (_item && _item.item_summary && _item.item_summary.minimum_guests > 1 && _item.assigned_guests - 1 < _item.item_summary.minimum_guests) {
            problems.push(_item.item_summary.name + ' ON ' + (0, _moment2.default)(_item.date).format('DD MMMM, YYYY'));
            ids.push(_item.reference);
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }
    } else {
      if (item && item.item_summary && item.item_summary.minimum_guests > 1 && item.assigned_guests - 1 < item.item_summary.minimum_guests) {
        problems.push(item.item_summary.name + ' ON ' + (0, _moment2.default)(item.date).format('DD MMMM, YYYY'));
        ids.push(item.reference);
      }
    }

    return new Promise(function (resolve) {
      if (problems.length) {
        prompt.openProblemPrompt('Confirmation', message, problems).then(function (modal) {
          modal.closed.then(function (result) {
            switch (result) {
              case 'all':
                resolve(ids);
                break;

              default:
                resolve(result);
                break;
            }
          });
        });
      } else {
        resolve(true);
      }
    });
  };

  basket.purgeItem = function (reference) {
    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = basket.contents.guest_details[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var guest = _step6.value;

        var match = (0, _lodash.findKey)(guest.item_details, { 'reference': reference });
        if (match) {
          guest.item_details.splice(match, 1);
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }

    for (var _guest in basket.contents.guest_details) {
      if (!basket.contents.guest_details[_guest].item_details.length) {
        basket.contents.guest_details.splice(_guest, 1);
      }
    }
  };

  basket.errorHandler = function (error, type) {
    var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    basket.saving = false;
    basket.hasLoaded = true;

    if (error.xhrStatus && error.xhrStatus === 'abort') {
      return false;
    }

    var errors = [];

    if (error.data) {
      if (error.data.identity_code) {
        basket.contents = error.data;
      }

      if (error.data.errors && !error.data.errors[0].includes(' ')) {
        basket.paymentErrors = error.data.errors;
        return;
      }

      if (error.data.errors) {
        errors = error.data.errors;
      }
    }

    if (!errors.length) {
      switch (type) {
        case 'retrieve':
          if (error && error.status && error.status == 410) {
            var basketId = storeService.get('basket');
            storeService.set('basket', '');

            if (basketId) {
              $window.location = '/confirmation/' + basketId;
            }

            return;
          }

          errors.push('Sorry, your basket has expired.');
          break;

        case 'submit':
          errors.push('Sorry, something went wrong. Please try again.');
          basket.reportSentryError('Fail submitting basket', error.data);
          break;

        case 'add':
          errors.push('Sorry, we could not add ' + additional.name + ' to your basket.');
          basket.popup = false;
          basket.reportSentryError('Fail adding to basket', error.data);
          break;

        case 'popupremove':
          errors.push('Sorry, we could not remove that item from your basket.');
          basket.reportSentryError('Fail removing item from basket', error.data);
          break;

        case 'create':
          errors.push('Sorry, something went wrong. Please try again.');
          basket.reportSentryError('Fail creating basket', error.data);
          break;

        case 'guestremove':
          errors.push('Sorry, we could not remove that guest.');
          basket.reportSentryError('Fail removing guest from basket', error.data);
          break;

        case 'itemremove':
          errors.push('Sorry, we could not remove that item.');
          basket.reportSentryError('Fail removing item from guest', error.data);
          break;

        default:
          errors.push('Sorry, something has gone wrong.');
      }
    }

    errors.forEach(function (e) {
      return messageService.add(e);
    });
    messageService.failure();
  };

  basket.containsCreditItems = function () {
    return !!basket.contents.has_credit;
  };

  basket.setOption = function (option) {
    basket.contents.option = option;
  };

  basket.reportSentryError = function (description, extraDetails) {
    if ($window.Sentry) {
      $window.Sentry.withScope(function (scope) {
        if (extraDetails) {
          Object.keys(extraDetails).forEach(function (key) {
            scope.setExtra(key, extraDetails[key]);
          });
        }
        scope.setExtra('basketId', basket.contents.id);
        $window.Sentry.captureMessage(description);
      });
    }
  };

  basket.earliestDate = function () {
    var dates = [];
    basket.contents.guest_details.forEach(function (guest) {
      guest.item_details.forEach(function (item) {
        dates.push(item.date + ' ' + item.preferred_time);
      });
    });

    return (0, _lodash.min)(dates);
  };

  basket.init = function () {
    basket.build();
    basket.getApiBasket();
  };

  var displayErrors = function displayErrors(errors) {
    errors.forEach(function (error) {
      return messageService.add(error);
    });
    messageService.failure();
  };

  basket.init();

  return basket;
}];

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['$http', '$location', 'storeService', function ($http, $location, storeService) {
    var defaultConfig = {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
        }
    };

    var buildUrl = function buildUrl(url) {
        return '//' + $location.host() + '/' + url;
    };

    var fieldBlacklist = ['uuid', 'id', '_embedded', '_links', 'created_at', 'updated_at'];

    var makeRequest = function makeRequest(method, url, data) {
        var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : defaultConfig;

        config = Object.assign({}, defaultConfig, config);

        // Header seems to be cached somehow, so forcing a reset if not valid
        config.headers['Core-Client'] = storeService.get('client_id') || undefined;
        config.headers['Reservation'] = storeService.get('reservation') || undefined;

        url = buildUrl(url);

        data = data ? (0, _lodash.omit)(data, fieldBlacklist) : data;

        return data ? method(url, data, config) : method(url, config);
    };

    return {
        get: function get(url, config) {
            return makeRequest($http.get, url, null, config);
        },
        post: function post(url, data) {
            return makeRequest($http.post, url, data);
        },
        delete: function _delete(url) {
            return makeRequest($http.delete, url, null);
        }
    };
}];

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _guest = __webpack_require__(704);

var _guest2 = _interopRequireDefault(_guest);

var _guestAddition = __webpack_require__(705);

var _guestAddition2 = _interopRequireDefault(_guestAddition);

var _guestEdit = __webpack_require__(706);

var _guestEdit2 = _interopRequireDefault(_guestEdit);

var _prompt = __webpack_require__(707);

var _prompt2 = _interopRequireDefault(_prompt);

var _guestAddition3 = __webpack_require__(708);

var _guestAddition4 = _interopRequireDefault(_guestAddition3);

var _guestEdit3 = __webpack_require__(710);

var _guestEdit4 = _interopRequireDefault(_guestEdit3);

var _guestPage = __webpack_require__(712);

var _guestPage2 = _interopRequireDefault(_guestPage);

var _prompt3 = __webpack_require__(714);

var _prompt4 = _interopRequireDefault(_prompt3);

var _guestApi = __webpack_require__(715);

var _guestApi2 = _interopRequireDefault(_guestApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var guestModule = angular.module('spabooker.guest', ['ngAnimate']).config(_guest2.default).controller('guestAdditionController', _guestAddition2.default).controller('guestEditController', _guestEdit2.default).controller('promptController', _prompt2.default).component('guestAddition', _guestAddition4.default).component('guestEdit', _guestEdit4.default).component('guestPage', _guestPage2.default).factory('prompt', _prompt4.default).factory('guestApi', _guestApi2.default);
exports.default = guestModule.name;

/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('guestpage', {
    url: '/guests',
    component: 'guestPage'
  });
}];

/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GuestAdditionController = function () {
  function GuestAdditionController(basket, guestnameService, propertyService, loginoutService, addGuestService, configService) {
    _classCallCheck(this, GuestAdditionController);

    this.basket = basket;
    this.guestnameService = guestnameService;
    this.propertyService = propertyService;
    this.loginoutService = loginoutService;
    this.addGuestService = addGuestService;
    this.configService = configService;
  }

  _createClass(GuestAdditionController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.displayGender = this.configService.get('property').displayGender;

      if (this.basket && this.basket.promise) {
        return this.basket.promise.then(function () {
          _this.addGuestService.setState({
            existingGuests: _this.basket.contents.guest_details,
            gender: _this.gender,
            minimumGuests: _this.minimumGuests,
            maximumGuests: _this.maximumGuests
          });
          _this.addGuestService.buildTitlesList();
          var existingGuests = _this.addGuestService.filterExistingGuests().filter(function (guest) {
            return !guest.disabled;
          });

          if (_this.loginoutService.isEditing()) {
            if (existingGuests.length === 0) {
              _this.error = 'Sorry, you are not able to add any guests to this event.';
              return;
            }

            if (existingGuests.length < _this.minimumGuests) {
              _this.error = 'Sorry, you do not have enough guests available to add this event.';
            }
          }
        });
      }
    }
  }, {
    key: 'canAddGuest',
    value: function canAddGuest() {
      if (this.loginoutService.isEditing()) {
        return false;
      }

      return this.addGuestService.canAddGuest();
    }
  }, {
    key: 'addExistingGuest',
    value: function addExistingGuest() {
      this.addGuestService.addExistingGuest(this.existingGuestId);
    }
  }, {
    key: 'loadStaff',
    value: function loadStaff() {
      return !!(this.propertyService.get('loadStaff') && this.staff && this.staff.length);
    }
  }, {
    key: 'allGuestsSelected',
    value: function allGuestsSelected() {
      return !this.addGuestService.getState('existingGuests').find(function (guest) {
        return !guest.disabled;
      });
    }
  }, {
    key: 'showRemoveButton',
    value: function showRemoveButton() {
      return this.addGuestService.getGuests().length > this.minimumGuests;
    }
  }, {
    key: 'disableExistingGuests',
    value: function disableExistingGuests() {
      return this.addGuestService.maxGuestsAdded() || this.allGuestsSelected() || this.basket.saving;
    }
  }]);

  return GuestAdditionController;
}();

GuestAdditionController.$inject = ['basket', 'guestnameService', 'propertyService', 'loginoutService', 'addGuestService', 'configService'];

exports.default = GuestAdditionController;

/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GuestPageController = function () {
    function GuestPageController($window, basket, guestApi, messageService, loginoutService) {
        _classCallCheck(this, GuestPageController);

        this.$window = $window;
        this.basket = basket;
        this.guestApi = guestApi;
        this.messageService = messageService;
        this.loginoutService = loginoutService;
    }

    _createClass(GuestPageController, [{
        key: 'basketUrl',
        value: function basketUrl() {
            var status = this.basket.contents.basket_status;
            if (this.basket.contents.basket_status === 'checkout') {
                status = this.basket.contents.first_step;
            }
            return '/checkout/' + status;
        }
    }, {
        key: 'validate',
        value: function validate() {
            if (this.saving) {
                return false;
            }

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this.basket.contents.guest_details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var guest = _step.value;

                    if (!guest.last_name || !guest.first_name || !guest.title) {
                        this.messageService.add('Please check the fields for errors and try saving again.');
                        this.messageService.failure();
                        return false;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return true;
        }
    }, {
        key: 'saveGuests',
        value: function saveGuests() {
            var _this = this;

            this.saving = true;
            return this.guestApi.save(this.basket.contents.identity_code, this.basket.contents.guest_details).then(function () {
                _this.messageService.add('Guests updated successfully.');
                _this.messageService.success();
            }).catch(function (error) {
                _this.saving = false;
                _this.messageService.add('Sorry, there was an error updating your details. Please try again or contact us if the problem persists.');
                _this.messageService.failure();

                throw error;
            });
        }
    }, {
        key: 'goToHome',
        value: function goToHome() {
            var _this2 = this;

            if (!this.validate()) {
                return;
            }

            return this.saveGuests().then(function () {
                _this2.$window.location = '/';
            }).catch(function () {});
        }
    }, {
        key: 'goToCheckout',
        value: function goToCheckout() {
            var _this3 = this;

            if (!this.validate()) {
                return;
            }

            return this.saveGuests().then(function () {
                _this3.$window.location = _this3.basketUrl();
            }).catch(function () {});
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled(guest) {
            if (this.saving) {
                return true;
            }

            if (this.basket.contents.client_id && guest.integration_reference) {
                return this.basket.contents.client_id === guest.integration_reference;
            }

            return false;
        }
    }, {
        key: 'titleIsAvailable',
        value: function titleIsAvailable(guest) {
            if (this.basket.contents.client_id && guest.integration_reference && this.basket.contents.client_id === guest.integration_reference) {
                return false;
            }

            return true;
        }
    }, {
        key: 'showForm',
        value: function showForm() {
            return !this.loginoutService.isEditing();
        }
    }]);

    return GuestPageController;
}();

GuestPageController.$inject = ['$window', 'basket', 'guestApi', 'messageService', 'loginoutService'];

exports.default = GuestPageController;

/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromptController = function () {
  function PromptController(close, authenticateApi, storeService, basket, basketApiService, loginoutService, $window) {
    _classCallCheck(this, PromptController);

    this.close = close;
    this.authenticateApi = authenticateApi;
    this.storeService = storeService;
    this.basket = basket;
    this.basketApiService = basketApiService;
    this.loginoutService = loginoutService;
    this.$window = $window;
  }

  _createClass(PromptController, [{
    key: 'login',
    value: function login() {
      var _this = this;

      this.error = null;

      if (this.email && this.password && !this.storeService.get('client_id')) {
        this.saving = true;

        return this.authenticateApi.login({
          EmailAddress: this.email,
          Password: this.password,
          basketCode: this.basket.contents.identity_code
        }).then(function (response) {
          if (!response || !response.client) {
            throw 'Invalid response';
          }

          _this.storeService.set('client_id', response.client);
          _this.storeService.set('client_name', response.name);
          _this.storeService.set('basket', response.basket);
          _this.success = 'Welcome back, ' + (response.name || '') + '...';

          _this.close(true, 1500);

          return _this.basket.getApiBasket();
        }).catch(function () {
          _this.error = "Sorry, we did not recognise those details, please try again.";
        }).then(function () {
          _this.saving = false;
        });
      }
    }
  }, {
    key: 'logout',
    value: function logout() {
      var _this2 = this;

      if (this.storeService.get('client_name')) {
        this.saving = true;

        return new Promise(function (resolve) {
          _this2.storeService.remove('client_id');
          _this2.storeService.remove('client_name');
          _this2.loginoutService.removeReservationData();

          return _this2.resetBasket().then(function () {
            resolve();
          });
        }).then(function () {
          return _this2.close(true);
        }).then(function () {
          _this2.saving = false;
        });
      }
    }
  }, {
    key: 'editReservation',
    value: function editReservation() {
      var _this3 = this;

      this.error = null;

      if (this.reference && this.surname && this.date) {
        this.saving = true;

        return this.authenticateApi.byReference({
          reference: this.reference,
          surname: this.surname,
          date: this.date,
          basketCode: this.basket.contents.identity_code
        }).then(function (response) {
          _this3.storeService.set('reservation', response.reference);
          _this3.storeService.set('client_name', response.name);
          _this3.storeService.set('basket', response.basket);
          _this3.storeService.set('start_date', response.startDate);
          _this3.storeService.set('end_date', response.endDate);
          _this3.storeService.set('searchDate', response.startDate);

          return _this3.goToManageBooking();
        }).catch(function (error) {
          _this3.error = 'Sorry, we could not authenticate you with those details';
          _this3.saving = false;
        });
      }
    }
  }, {
    key: 'resetBasket',
    value: function resetBasket() {
      var _this4 = this;

      this.storeService.set('basket', '');

      return this.basketApiService.deleteBasket(this.basket.contents.identity_code).then(function () {
        return _this4.basket.getApiBasket();
      }).catch(function () {});
    }
  }, {
    key: 'isGuestAllowed',
    value: function isGuestAllowed() {
      return !this.loginoutService.isRequired();
    }
  }, {
    key: 'closePrompt',
    value: function closePrompt() {
      this.close(this.isGuestAllowed());
    }
  }, {
    key: 'setTab',
    value: function setTab(param) {
      this.error = '';
      this.tab = param;
    }
  }, {
    key: 'activeTab',
    value: function activeTab(param) {
      return this.tab === param;
    }
  }, {
    key: 'goToManageBooking',
    value: function goToManageBooking() {
      return this.$window.location = '/manage-booking';
    }
  }, {
    key: 'canRegister',
    value: function canRegister() {
      return this.loginoutService.canRegister();
    }
  }]);

  return PromptController;
}();

PromptController.$inject = ['close', 'authenticateApi', 'storeService', 'basket', 'basketApiService', 'loginoutService', '$window'];

exports.default = PromptController;

/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  bindings: {
    'minimumGuests': '<',
    'maximumGuests': '<',
    'gender': '<',
    'staff': '=',
    'showGuestLabels': '<'
  },
  controller: 'guestAdditionController',
  template: __webpack_require__(709)
};

/***/ }),
/* 709 */
/***/ (function(module, exports) {

module.exports = "<form class=\"c-guest__form c-form\"> <div class=c-guest__error ng-if=$ctrl.error ng-bind-html=$ctrl.error></div> <div class=\"c-guest__form__row c-guest__form__row--{{ $ctrl.minimumGuests }}\" ng-repeat=\"(key, guest) in $ctrl.addGuestService.getGuests()\"> <div ng-if=$ctrl.showGuestLabels> <label class=c-guest__form__label ng-bind-html=$ctrl.addGuestService.guestNameOrPlaceholder(guest)></label> <p class=c-guest__info ng-if=\"key === 0 && !guest.id\">Please enter your information below. If you are booking as a gift or on behalf of someone else, please enter the recipient's details here.</p> </div> <div class=grid-x> <div class=\"cell medium-shrink\" ng-class=\"{'small-11': !$ctrl.showGuestLabels && $ctrl.showRemoveButton()}\" ng-if=$ctrl.addGuestService.showTitle(guest)> <div class=\"c-form__field c-form__field--select\"> <select class=\"c-form__select / c-guest__select\" name=title autocomplete=title ng-model=guest.title ng-options=\"title for title in $ctrl.addGuestService.getState('titles')\" form-field-errors required ng-disabled=\"guest.id || $ctrl.basket.saving\" ng-change=$ctrl.addGuestService.guessGender(guest)> <option value=\"\" disabled=disabled>Select...</option> </select> <label class=\"c-form__label t-text--secondary\" for=title>Title</label> </div> </div> <div class=\"cell small-6 medium-4\" ng-class=\"{'large-auto': $ctrl.loadStaff(), 'large-3': !$ctrl.loadStaff()}\"> <div class=c-form__field> <input name=first_name class=\"c-form__input / c-guest__input c-guest__firstname\" type=text autocomplete=fname ng-model=guest.first_name form-field-errors required ng-disabled=\"guest.id || $ctrl.basket.saving\"> <label class=\"c-form__label t-text--secondary\" for=first_name>First Name</label> </div> </div> <div class=\"cell small-6 medium-4\" ng-class=\"{'large-auto': $ctrl.loadStaff(), 'large-3': !$ctrl.loadStaff()}\"> <div class=c-form__field> <input name=last_name class=\"c-form__input / c-guest__input c-guest__lastname\" type=text autocomplete=lname ng-model=guest.last_name form-field-errors required ng-disabled=\"guest.id || $ctrl.basket.saving\"> <label class=\"c-form__label t-text--secondary\" for=last_name>Last Name</label> </div> </div> <div class=\"cell medium-shrink\" ng-if=\"$ctrl.displayGender && $ctrl.addGuestService.showGenderSelection(guest)\"> <div class=\"c-form__field--radio c-form__field--gender\"> <label class=show-for-sr>Gender</label> <span class=c-form__required></span> <button type=button ng-model=guest.gender ng-click=\"guest.gender = 'F'\" class=c-form__radio ng-class=\"{'active': guest.gender === 'F'}\" ng-disabled=\"guest.id || $ctrl.basket.saving\">Female</button> <button type=button ng-model=guest.gender ng-click=\"guest.gender = 'M'\" class=c-form__radio ng-class=\"{'active': guest.gender === 'M'}\" ng-disabled=\"guest.id || $ctrl.basket.saving\">Male</button> </div> </div> <div class=\"cell medium-shrink large-auto\" ng-if=$ctrl.loadStaff()> <staff-picker guest=guest staff=$ctrl.staff can-disable=true></staff-picker> </div> </div> <a ng-if=$ctrl.showRemoveButton() class=\"c-guest__form__remove t-text--secondary--action--dark\" ng-click=$ctrl.addGuestService.removeGuest(guest) title=\"Remove this guest\">&times;</a> </div> <div class=grid-x> <div class=\"cell medium-auto\" ng-if=$ctrl.canAddGuest()> <button type=button ng-click=$ctrl.addGuestService.addEmptyGuests() class=c-guest__button title=\"Add new guest\" ng-disabled=\"guest.id || $ctrl.basket.saving\"> <span class=\"c-guest__button-icon t-background--secondary\"> <icon icon=plus></icon> </span><span class=c-guest__button-text>Add {{ $ctrl.addGuestService.digitToWord($ctrl.minimumGuests) }} more Guest<span ng-if=\"$ctrl.minimumGuests > 1\">s</span></span> </button> </div> <div class=\"cell shrink / c-guest__form__or\" ng-if=\"$ctrl.canAddGuest() && $ctrl.addGuestService.getState('existingGuests').length > 0\"><span>or</span></div> <div class=\"cell medium-auto\"> <div class=c-guest__form__existing ng-if=\"$ctrl.addGuestService.getState('existingGuests').length > 0\" ng-class=\"{'text-right': $ctrl.canAddGuest()}\"> <select class=\"c-guest__form__existing-guests / c-form__select\" ng-model=$ctrl.existingGuestId ng-options=\"guest.id as $ctrl.guestnameService.format(guest) disable when guest.disabled for guest in $ctrl.addGuestService.getState('existingGuests')\" ng-disabled=$ctrl.disableExistingGuests() ng-change=$ctrl.addExistingGuest()> <option value=\"\" disabled=disabled>Select an existing guest...</option> </select> </div> </div> </div> </form> ";

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'guestEditController',
    template: __webpack_require__(711)
};

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports = "<h3 class=c-review__heading>Edit Guest Information</h3> <div class=c-review__guests ng-if=$ctrl.showForm()> <form> <div class=c-review__guest__edit ng-repeat=\"guest in $ctrl.basket.contents.guest_details\"> <div class=\"grid-x / c-review__guest__name\"> <div class=\"cell medium-3\" ng-if=$ctrl.titleIsAvailable(guest)> <div class=\"c-form__field c-form__field--select\"> <select name=title class=c-form__select ng-model=guest.title required form-field-errors ng-disabled=$ctrl.isDisabled(guest)> <option>Mr.</option> <option>Mrs.</option> <option>Miss</option> <option>Ms.</option> <option>Dr.</option> <option>Rev.</option> </select> <label class=\"c-form__label t-text--secondary\" for=title>Title</label> </div> </div> <div class=\"cell medium-auto\"> <div class=c-form__field> <input type=text class=c-form__input name=fname ng-model=guest.first_name required form-field-errors ng-disabled=$ctrl.isDisabled(guest) /> <label class=\"c-form__label t-text--secondary\" for=fname>First name</label> </div> </div> <div class=\"cell medium-auto\"> <div class=c-form__field> <input type=text class=c-form__input name=lname ng-model=guest.last_name required form-field-errors ng-disabled=$ctrl.isDisabled(guest) /> <label class=\"c-form__label t-text--secondary\" for=lname>Last name</label> </div> </div> </div> </div> <div class=c-review__buttons> <button type=button class=\"c-button c-button--hollow / c-review__home\" ng-click=$ctrl.goToHome() ng-disabled=$ctrl.saving> Save & return to homepage </button> <button type=button class=\"c-button / c-review__home\" ng-click=$ctrl.goToCheckout() ng-disabled=$ctrl.saving> Save & go to Checkout </button> <spinner ng-if=$ctrl.saving></spinner> </div> </form> </div> <div class=text-center ng-if=!$ctrl.showForm()> <p>Sorry, you can not change guest details while editing a reservation.</p> </div> ";

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(713)
};

/***/ }),
/* 713 */
/***/ (function(module, exports) {

module.exports = "<div class=grid-x> <div class=\"cell medium-1 large-3\"></div> <div class=\"cell medium-10 large-6\"> <guest-edit></guest-edit> </div> <div class=\"cell medium-1 large-3\"></div> </div>";

/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['ModalService', '$window', '$timeout', 'basketPopupService', function (ModalService, $window, $timeout, basketPopupService) {
    var prompt = {};

    prompt.openProblemPrompt = function (title, text, issues) {
        basketPopupService.remove();
        var issuelist = '';
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = issues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var issue = _step.value;
                issuelist += '<li>' + issue + '</li>';
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return ModalService.showModal({
            template: '<div class="c-prompt">\n    <div class="c-prompt__header">\n        ' + title + '\n    </div>\n    <div class="c-prompt__body">\n\n        <p class="c-prompt__message">\n            ' + text + '\n        </p>\n\n        <ul class="c-prompt__list">\n            ' + issuelist + '\n        </ul>\n\n        <p class="c-prompt__pre-button">\n            Would you like to remove this event?\n        </p>\n\n        <div class="c-prompt__buttons">\n            <button class="c-button" ng-click="$ctrl.close(\'all\')"><span class="c-button__text">confirm</span></button>\n            <button class="c-button c-button--hollow" ng-click="$ctrl.close(false)"><span class="c-button__text">cancel</span></button>\n        </div>\n    </div>\n</div>\n<div class="c-prompt__overlay"></div>',
            controller: 'promptController as $ctrl'
        });
    };

    prompt.openLoginPrompt = function (title, text) {
        var passwordOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        basketPopupService.remove();
        $timeout(function () {
            $window.dispatchEvent(new CustomEvent('initCalendar'));
        }, 250);

        return ModalService.showModal({
            template: '<div class="c-prompt c-prompt--login">\n    <div class="c-prompt__header">\n        ' + title + '\n    </div>\n    <div class="c-prompt__body" ng-if="!$ctrl.success">\n\n        <p class="c-prompt__info" ng-if="!$ctrl.basket.empty()">Please be aware, logging in will clear your basket.</p>\n\n        <p class="c-checkout__error" ng-if="$ctrl.error" ng-bind-html="$ctrl.error"></p>\n\n        <div class="c-prompt__tabs" ng-if="' + !passwordOnly + '">\n            <button class="c-prompt__tab" ng-click="$ctrl.setTab(\'password\')" ng-class="{\'is-active\': !$ctrl.tab || $ctrl.activeTab(\'password\')}">With Password</button>\n            <button class="c-prompt__tab" ng-click="$ctrl.goToManageBooking()" ng-class="{\'is-active\': $ctrl.activeTab(\'reference\')}">With Reference</button>\n        </div>\n\n        <div ng-show="!$ctrl.tab || $ctrl.activeTab(\'password\')">\n\n            <p class="c-prompt__message">\n                ' + text + '\n            </p>\n\n            <form ng-submit="$ctrl.login()">\n                <div class="c-prompt__inputs">\n                    <div class="c-form__field">\n                        <input name="EmailAddress" class="c-form__input / c-prompt__email" type="email" autocomplete="email" ng-model="$ctrl.email" required ng-disabled="$ctrl.saving" autofocus>\n                        <label class="c-form__label t-text--secondary" for="EmailAddress">Email Address</label>\n                    </div>\n                    <div class="c-form__field">\n                        <input name="Password" class="c-form__input / c-prompt__password" type="password" autocomplete="password" ng-model="$ctrl.password" required ng-disabled="$ctrl.saving">\n                        <label class="c-form__label t-text--secondary" for="Password">Password</label>\n                    </div>\n                </div>\n\n                <div class="c-prompt__buttons">\n                    <button class="c-button" type="submit" ng-disabled="$ctrl.saving" data-dismiss="modal">\n                        <span class="c-button__text" ng-hide="$ctrl.saving">Log in</span>\n                        <spinner ng-show="$ctrl.saving"></spinner>\n                    </button>\n                    <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-if="$ctrl.isGuestAllowed()" ng-click="$ctrl.closePrompt()" data-dismiss="modal">\n                        <span class="c-button__text" ng-hide="$ctrl.saving">Continue as a Guest</span>\n                        <spinner ng-show="$ctrl.saving"></spinner>\n                    </button>\n                    <a href="/register" class="c-button c-button--hollow" ng-if="$ctrl.canRegister()" ng-disabled="$ctrl.saving" data-dismiss="modal">\n                        <span class="c-button__text" ng-hide="$ctrl.saving">Register</span>\n                        <spinner ng-show="$ctrl.saving"></spinner>\n                    </a>\n                </div>\n            </form>\n        </div>\n    </div>\n\n    <p class="c-prompt__success" ng-if="$ctrl.success" ng-bind-html="$ctrl.success"></p>\n\n    <button class="c-prompt__close" ng-click="$ctrl.closePrompt()" title="Close">\n        <span class="show-for-sr">Close the login form</span> &times;\n    </button>\n</div>\n<div class="c-prompt__overlay"></div>',
            controller: 'promptController as $ctrl'
        }).then(function (modal) {
            return modal.close.then(function (response) {
                return response;
            });
        });
    };

    prompt.openLogoutPrompt = function (title) {
        basketPopupService.remove();
        return ModalService.showModal({
            template: '<div class="c-prompt c-prompt--login">\n    <div class="c-prompt__header">\n        ' + title + '\n    </div>\n    <div class="c-prompt__body">\n\n        <p class="c-prompt__info">Are you sure you want to log out? <br />Logging out will clear your basket.</p>\n\n        <form ng-submit="$ctrl.logout()">\n            <div class="c-prompt__buttons">\n                <button class="c-button c-button--fail" type="submit" ng-disabled="$ctrl.saving">\n                    <span class="c-button__text" ng-hide="$ctrl.saving">Yes, log out</span>\n                    <spinner ng-show="$ctrl.saving"></spinner>\n                </button>\n\n                <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-click="$ctrl.close(false)">\n                    <span class="c-button__text" ng-hide="$ctrl.saving">No, stay logged in</span>\n                    <spinner ng-show="$ctrl.saving"></spinner>\n                </button>\n            </div>\n        </form>\n    </div>\n\n    <button class="c-prompt__close" ng-click="$ctrl.close(false)" title="Close">\n        <span class="show-for-sr">Close the logout prompt</span> &times;\n    </button>\n</div>\n<div class="c-prompt__overlay"></div>',
            controller: 'promptController as $ctrl'
        }).then(function (modal) {
            return modal.close.then(function (response) {
                return response;
            });
        });
    };

    prompt.openStopReservationPrompt = function (title) {
        basketPopupService.remove();
        return ModalService.showModal({
            template: '<div class="c-prompt c-prompt--login">\n    <div class="c-prompt__header">\n        ' + title + '\n    </div>\n    <div class="c-prompt__body">\n\n        <p class="c-prompt__info">Are you sure you want to logout? <br />Logging out will clear your basket and stop any additions persisting.</p>\n\n        <form ng-submit="$ctrl.logout()">\n            <div class="c-prompt__buttons">\n                <button class="c-button c-button--fail" type="submit" ng-disabled="$ctrl.saving">\n                    <span class="c-button__text" ng-hide="$ctrl.saving">Yes, logout</span>\n                    <spinner ng-show="$ctrl.saving"></spinner>\n                </button>\n\n                <button class="c-button c-button--hollow" type="button" ng-disabled="$ctrl.saving" ng-click="$ctrl.close(false)">\n                    <span class="c-button__text" ng-hide="$ctrl.saving">No, keep editing</span>\n                    <spinner ng-show="$ctrl.saving"></spinner>\n                </button>\n            </div>\n        </form>\n    </div>\n\n    <button class="c-prompt__close" ng-click="$ctrl.close(false)" title="Close">\n        <span class="show-for-sr">Close the logout prompt</span> &times;\n    </button>\n</div>\n<div class="c-prompt__overlay"></div>',
            controller: 'promptController as $ctrl'
        }).then(function (modal) {
            return modal.close.then(function (response) {
                return response;
            });
        });
    };

    return prompt;
}];

/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        save: function save(basketCode, guests) {
            return api.post('guests', {
                basket: basketCode,
                guests: guests
            }).then(function (response) {
                return response.data;
            });
        },
        getLeadGuest: function getLeadGuest(basketCode) {
            return api.post('api/getLeadGuest', { basketCode: basketCode }).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _page = __webpack_require__(717);

var _page2 = _interopRequireDefault(_page);

var _page3 = __webpack_require__(718);

var _page4 = _interopRequireDefault(_page3);

var _message = __webpack_require__(719);

var _message2 = _interopRequireDefault(_message);

var _availabilitySlider = __webpack_require__(720);

var _availabilitySlider2 = _interopRequireDefault(_availabilitySlider);

var _searchForm = __webpack_require__(721);

var _searchForm2 = _interopRequireDefault(_searchForm);

var _selectType = __webpack_require__(722);

var _selectType2 = _interopRequireDefault(_selectType);

var _quickBook = __webpack_require__(723);

var _quickBook2 = _interopRequireDefault(_quickBook);

var _message3 = __webpack_require__(724);

var _message4 = _interopRequireDefault(_message3);

var _icon = __webpack_require__(726);

var _icon2 = _interopRequireDefault(_icon);

var _spinner = __webpack_require__(752);

var _spinner2 = _interopRequireDefault(_spinner);

var _loading = __webpack_require__(754);

var _loading2 = _interopRequireDefault(_loading);

var _availabilitySlider3 = __webpack_require__(756);

var _availabilitySlider4 = _interopRequireDefault(_availabilitySlider3);

var _searchForm3 = __webpack_require__(758);

var _searchForm4 = _interopRequireDefault(_searchForm3);

var _selectType3 = __webpack_require__(760);

var _selectType4 = _interopRequireDefault(_selectType3);

var _quickBook3 = __webpack_require__(762);

var _quickBook4 = _interopRequireDefault(_quickBook3);

var _required = __webpack_require__(764);

var _required2 = _interopRequireDefault(_required);

var _formFieldErrors = __webpack_require__(765);

var _formFieldErrors2 = _interopRequireDefault(_formFieldErrors);

var _disabled = __webpack_require__(766);

var _disabled2 = _interopRequireDefault(_disabled);

var _message5 = __webpack_require__(767);

var _message6 = _interopRequireDefault(_message5);

var _content = __webpack_require__(768);

var _content2 = _interopRequireDefault(_content);

var _markdown = __webpack_require__(769);

var _markdown2 = _interopRequireDefault(_markdown);

var _loginout = __webpack_require__(771);

var _loginout2 = _interopRequireDefault(_loginout);

var _url = __webpack_require__(772);

var _url2 = _interopRequireDefault(_url);

var _event = __webpack_require__(773);

var _event2 = _interopRequireDefault(_event);

var _property = __webpack_require__(774);

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var pageModule = angular.module('spabooker.page', ['ui.select']).config(_page2.default).controller('pageController', _page4.default).controller('messageController', _message2.default).controller('availabilitySliderController', _availabilitySlider2.default).controller('searchFormController', _searchForm2.default).controller('selectTypeController', _selectType2.default).controller('quickBookController', _quickBook2.default).component('message', _message4.default).component('icon', _icon2.default).component('spinner', _spinner2.default).component('loading', _loading2.default).component('availabilitySlider', _availabilitySlider4.default).component('searchForm', _searchForm4.default).component('selectType', _selectType4.default).component('quickBook', _quickBook4.default).directive('required', _required2.default).directive('formFieldErrors', _formFieldErrors2.default).directive('a', _disabled2.default).factory('messageService', _message6.default).factory('contentService', _content2.default).factory('markdownService', _markdown2.default).factory('loginoutService', _loginout2.default).factory('urlService', _url2.default).factory('eventService', _event2.default).factory('propertyService', _property2.default);
exports.default = pageModule.name;

/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('quickBook', {
        url: '/quickbook',
        component: 'quickBook'
    });
}];

/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageController = function () {
  function PageController($window, availabilityService, availabilityApiService, dateService, basket, itemService, checkout, storeService, $timeout, quantityService, loginoutService, configService, addGuestService, loadingService, imgix) {
    _classCallCheck(this, PageController);

    this.$window = $window;
    this.availabilityService = availabilityService;
    this.availabilityApiService = availabilityApiService;
    this.dateService = dateService;
    this.basket = basket;
    this.itemService = itemService;
    this.checkout = checkout;
    this.storeService = storeService;
    this.$timeout = $timeout;
    this.quantityService = quantityService;
    this.loginoutService = loginoutService;
    this.configService = configService;
    this.addGuestService = addGuestService;
    this.loadingService = loadingService;
    this.imgix = imgix; // Loads the factory so images auto-load in the storefront
  }

  _createClass(PageController, [{
    key: '$onInit',
    value: function $onInit() {
      this.loadingService.clearLoading();
      this.guests = this.guests || [];

      this.today = (0, _moment2.default)().format('YYYY-MM-DD');

      this.category = this.category || '*';

      this.stopAvailability = this.configService.get('property').stopAvailability;

      if (this.item) {
        this.itemService.setItem(this.item);
      }

      this.determineAnnouncementState();
    }
  }, {
    key: 'checkStoredDate',
    value: function checkStoredDate() {
      this.storeService.set('searchDate', this.date);
      this.date = this.dateService.checkStoredDate(true);
    }
  }, {
    key: 'checkDateExists',
    value: function checkDateExists() {
      var date = this.dateService.checkStoredDate(true);
      this.date = this.dateService.checkMaxDate(date, true).format('YYYY-MM-DD');

      this.storeService.set('searchDate', this.date);
    }
  }, {
    key: 'getStoredDate',
    value: function getStoredDate() {
      if (this.loginoutService.isEditing()) {
        return this.storeService.get('start_date');
      }

      return this.storeService.get('searchDate');
    }
  }, {
    key: 'getAvailabilitySingle',
    value: function getAvailabilitySingle() {
      var _this = this;

      var checkDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.loadingService.startLoading(['availability', 'times']);
      this.availabilityService.resetSingleDays();

      if (checkDate) {
        this.checkDateExists();
      }

      var toDate = (0, _moment2.default)(this.date, 'YYYY-MM-DD').add(6, 'days').format('YYYY-MM-DD');

      return this.basket.promise.then(function () {
        if (_this.basket.contents.store_offer) {
          _this.item.offer = _this.basket.contents.store_offer;
        }

        return _this.availabilityApiService.requestAvailability(_this.date, toDate, _this.eventType, _this.item.id, _this.item.offer || null).then(function (response) {
          _this.loadingService.stopLoading('availability');
          _this.availability = response;

          if (_this.availability && _this.$window.fpInput && _typeof(_this.$window.fpInput) === 'object' && typeof _this.$window.fpInput.setDate === 'function') {
            _this.$window.fpInput.setDate((0, _lodash.head)(_this.availability).date, false, 'Y-m-d');
          }
        });
      });
    }
  }, {
    key: 'getAvailabilityList',
    value: function getAvailabilityList() {
      var _this2 = this;

      var shouldUpdateDate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.date && shouldUpdateDate) {
        this.storeService.set('searchDate', this.date);
      }
      this.date = this.dateService.checkStoredDate(shouldUpdateDate);

      if (!this.availability && this.date || shouldUpdateDate && this.eventType || this.storeService.get('searchDate') && this.eventType) {
        this.startAvailability(shouldUpdateDate);

        if (this.stopAvailability) {
          return false;
        }

        if (this.eventType === 'category' || this.$window.location.pathname.indexOf('/search') > -1 || this.$window.location.pathname.indexOf('/category') > -1) {
          return this.getCategoryAvailabilityList();
        }

        return this.requestAvailability(this.date, this.eventType, (0, _lodash.clone)(this.eventIds)).then(function (response) {
          _this2.availability = {};
          _this2.availability[_this2.eventType] = response;

          _this2.$timeout(function () {
            _this2.updateIsotope(100);
          }, 0);
        });
      }
    }
  }, {
    key: 'startAvailability',
    value: function startAvailability(shouldUpdateDate) {
      if (shouldUpdateDate) {
        this.storeService.set('searchDate', this.date);
      }

      if (this.stopAvailability) {
        return false;
      }

      this.loadingService.startLoading('availability');
    }
  }, {
    key: 'getCategoryAvailabilityList',
    value: function getCategoryAvailabilityList() {
      var _this3 = this;

      if (!this.date) {
        this.loadingService.stopLoading('availability');
        return;
      }

      if (this.stopAvailability) {
        this.loadingService.stopLoading('availability');
        return false;
      }

      var spadays = this.categoryDays;
      var treatments = this.categoryTreatments;

      this.availability = {};

      var promises = [];

      if (spadays && spadays.length) {
        promises.push(this.requestAvailability(this.date, 'day', (0, _lodash.clone)(spadays)).then(function (response) {
          _this3.availability.day = response;
        }));
      }

      if (treatments && treatments.length) {
        promises.push(this.requestAvailability(this.date, 'treatment', (0, _lodash.clone)(treatments)).then(function (response) {
          _this3.availability.treatment = response;
        }));
      }

      return Promise.all(promises).then(function () {
        _this3.$timeout(function () {
          _this3.updateIsotope();
        }, 0);
      });
    }
  }, {
    key: 'day',
    value: function day() {
      if (this.item && this.item.date) {
        return (0, _moment2.default)(this.item.date, 'YYYY-MM-DD').format('DD');
      }
    }
  }, {
    key: 'month',
    value: function month() {
      if (this.item && this.item.date) {
        return (0, _moment2.default)(this.item.date, 'YYYY-MM-DD').format('MMM');
      }
    }
  }, {
    key: 'hideBasket',
    value: function hideBasket() {
      if (this.$window.location.href.indexOf('/payment') > -1) {
        return true;
      }

      return false;
    }
  }, {
    key: 'resetBasket',
    value: function resetBasket() {
      this.checkout.createAnalytics();
      this.storeService.set('basket', '');
      this.resetSearchDate();
      this.loginoutService.removeReservationData();
    }
  }, {
    key: 'resetSearchDate',
    value: function resetSearchDate() {
      this.storeService.remove('searchDate');
    }
  }, {
    key: 'updateIsotope',
    value: function updateIsotope() {
      var _this4 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      this.loadingService.stopLoading('availability');
      this.$timeout(function () {
        _this4.updateIsotopeData();
      }, delay);
    }
  }, {
    key: 'isEventUnavailable',
    value: function isEventUnavailable(eventId, eventType) {
      if (!this.loadingService.isLoading('availability') && this.availability && this.availability[eventType]) {
        var event = (0, _lodash.find)(this.availability[eventType], function (event) {
          return event.id === eventId;
        });
        return !event || !event.availability.available;
      }

      return false;
    }
  }, {
    key: 'displayPriceFrom',
    value: function displayPriceFrom(eventId, eventType, basePrice) {
      var minimumGuests = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      return this.getPrice(eventId, eventType, basePrice, minimumGuests);
    }
  }, {
    key: 'displayOriginalPrice',
    value: function displayOriginalPrice(eventId, eventType, basePrice) {
      var minimumGuests = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      var event = this.getAvailableEvent(eventId, eventType);
      if (event && event.availability) {
        basePrice = event.availability.original_price;
      }

      return basePrice * minimumGuests;
    }
  }, {
    key: 'getPrice',
    value: function getPrice(eventId, eventType, basePrice) {
      var minimumGuests = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

      var event = this.getAvailableEvent(eventId, eventType);
      if (event) {
        var price = event.availability.price;
        if (price && price < basePrice) {
          basePrice = price;
        }
      }

      return basePrice * minimumGuests;
    }
  }, {
    key: 'updateIsotopeData',
    value: function updateIsotopeData() {
      var _this5 = this;

      if (this.$window.isotope) {
        this.$window.isotope.forEach(function (container) {
          container.isotope.updateSortData();
          container.isotope.arrange({ sortBy: 'available' });
        });

        this.$timeout(function () {
          _this5.$window.dispatchEvent(new CustomEvent('imgixRefresh'));
        }, 250);
      }
    }
  }, {
    key: 'categorySelected',
    value: function categorySelected(type) {
      if (_typeof(this.eventType) !== undefined && this.eventType === type) {
        return true;
      }

      return false;
    }
  }, {
    key: 'presentModel',
    value: function presentModel(model) {
      return model.split('\\')[1].replace(/([A-Z])/g, ' $1').trim();
    }
  }, {
    key: 'displaySavedDate',
    value: function displaySavedDate() {
      if (this.date) {
        return (0, _moment2.default)(this.date).format('MMMM D, YYYY');
      }

      return (0, _moment2.default)().format('MMMM D, YYYY');
    }
  }, {
    key: 'offcanvasCollapsed',
    value: function offcanvasCollapsed() {
      return this.storeService.get('offcanvasCollapsed');
    }
  }, {
    key: 'getAvailableEvent',
    value: function getAvailableEvent(eventId, eventType) {
      if (!this.loadingService.isLoading('availability') && this.availability && this.availability[eventType]) {
        return (0, _lodash.find)(this.availability[eventType], { id: eventId });
      }
    }
  }, {
    key: 'eventHasOffer',
    value: function eventHasOffer(eventId, eventType) {
      var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (initialState && !this.availability) {
        return initialState;
      }
      var event = this.getAvailableEvent(eventId, eventType);
      if (event && event.availability.offer) {
        return event.availability.offer.name;
      }
    }
  }, {
    key: 'offerName',
    value: function offerName(eventId, eventType) {
      var initialState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      if (initialState && !this.availability) {
        return initialState;
      }

      return this.eventHasOffer(eventId, eventType);
    }
  }, {
    key: 'displayCross',
    value: function displayCross(display) {
      if (!this.loadingService.isLoading('availability') && this.availability) {
        var firstDay = (0, _lodash.head)(this.availability);
        return display && !firstDay.available && !this.item.interacted;
      }
    }
  }, {
    key: 'getQuantity',
    value: function getQuantity() {
      var _this6 = this;

      var numberOfGuests = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.quantity = undefined;
      var contentsQuantity = undefined;

      if (this.item.preferred_time) {
        var promises = [];

        this.loadingService.startLoading('quantity');
        if (this.integrationContents) {
          promises.push(this.quantityService.getContentsQuantity(this.item.date, this.item.preferred_time, this.item.end_time, this.integrationContents).then(function (response) {
            contentsQuantity = response;
          }));
        }

        promises.push(this.quantityService.getQuantity(this.item, numberOfGuests).then(function (response) {
          _this6.quantity = response.quantity;
          _this6.staff = (0, _lodash.map)(response.staff, function (staffId, staffName) {
            return {
              id: staffId,
              label: staffName
            };
          }) || undefined;
        }));

        return Promise.all(promises).then(function () {
          _this6.validateQuantity(contentsQuantity);

          _this6.$timeout(function () {
            _this6.loadingService.stopLoading('quantity');
          });
        });
      }
    }
  }, {
    key: 'validateQuantity',
    value: function validateQuantity() {
      var contentsQuantity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      if (contentsQuantity !== undefined) {
        if (contentsQuantity !== true && !Number.isInteger(contentsQuantity)) {
          this.quantity = 0;
          return;
        }

        if (Number.isInteger(contentsQuantity)) {
          this.quantity = Math.min(this.quantity, contentsQuantity);
        }
      }

      if (this.item.minimum_guests > this.quantity) {
        this.quantity = 0;
        return;
      }

      this.quantity = Math.floor(this.quantity / this.item.minimum_guests) * this.item.minimum_guests;
    }
  }, {
    key: 'resetStaff',
    value: function resetStaff() {
      (0, _lodash.each)(this.guests, function (guest) {
        delete guest.staff;
      });

      (0, _lodash.each)(this.staff, function (staff) {
        delete staff.disabled;
      });
    }
  }, {
    key: 'availableStaff',
    value: function availableStaff() {
      return this.staff;
    }
  }, {
    key: 'notEnoughGuests',
    value: function notEnoughGuests() {
      this.error = null;
      if (this.quantity && parseInt(this.item.minimum_guests) > parseInt(this.quantity)) {
        this.error = '<em>Sorry, there is currently no availability for the selected time.</em>';
        return true;
      }

      return false;
    }
  }, {
    key: 'subtotalOriginal',
    value: function subtotalOriginal() {
      this.guests = this.addGuestService.getGuests();

      if (!this.guests.length) {
        return this.item.original_price;
      }

      return this.guests.length * this.item.original_price;
    }
  }, {
    key: 'subtotalPrice',
    value: function subtotalPrice() {
      this.guests = this.addGuestService.getGuests();

      if (!this.guests.length) {
        return this.item.minimum_guests * this.item.price;
      }

      return this.guests.length * this.item.price;
    }
  }, {
    key: 'isLoginAllowed',
    value: function isLoginAllowed() {
      return this.loginoutService.isAllowed();
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      return this.loginoutService.isLoggedIn();
    }
  }, {
    key: 'isEditing',
    value: function isEditing() {
      return this.loginoutService.isEditing();
    }
  }, {
    key: 'isCurrentPage',
    value: function isCurrentPage(page) {
      var pathname = this.$window.location.pathname;

      return pathname.includes(page);
    }
  }, {
    key: 'maybeRequestAvailability',
    value: function maybeRequestAvailability(response) {
      var _this7 = this;

      return new Promise(function (resolve) {
        if (response) {
          var pathname = _this7.$window.location.pathname;
          _this7.availability = null;

          _this7.checkDateExists();

          if (pathname.includes('/category') || pathname.includes('/search')) {
            return _this7.getCategoryAvailabilityList().then(function () {
              resolve();
            });
          }

          if (pathname.includes('/treatments') || pathname.includes('/spa-days') || pathname.includes('/activities')) {
            return _this7.getAvailabilityList().then(function () {
              resolve();
            });
          }

          if (pathname.includes('/treatment') || pathname.includes('/spa-day')) {
            return _this7.getAvailabilitySingle(false).then(function () {
              resolve();
            });
          }
        }

        resolve();
      });
    }
  }, {
    key: 'homeSearch',
    value: function homeSearch() {
      var category = '';

      if (this.category) {
        this.category = this.category.replace('.', '');
        category = this.category !== '*' ? '?category=' + this.category : '';
      }

      switch (this.eventType) {
        case 'day':
          this.$window.location = '/spa-days' + category;
          break;
        case 'treatment':
          this.$window.location = '/treatments' + category;
          break;
      }
    }
  }, {
    key: 'isAvailable',
    value: function isAvailable(itemAvailable, telephoneEvent) {
      return itemAvailable && !telephoneEvent;
    }
  }, {
    key: 'openSearch',
    value: function openSearch() {
      this.searchIsOpen = true;
    }
  }, {
    key: 'closeSearch',
    value: function closeSearch() {
      this.searchIsOpen = false;
    }
  }, {
    key: 'requestAvailability',
    value: function requestAvailability(date, eventType, eventIds) {
      var _this8 = this;

      if (!eventIds || !eventIds.length) {
        return Promise.resolve();
      }

      return Promise.all(this.processAvailability(date, eventType, eventIds)).then(function (response) {
        return _this8.flattenResponse(response);
      });
    }
  }, {
    key: 'processAvailability',
    value: function processAvailability(date, eventType, eventIds) {
      var promises = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      if (!eventIds.length) {
        return promises;
      }

      var currentRequest = eventIds.splice(0, 20);

      promises.push(this.availabilityApiService.requestAvailabilityList(date, eventType, currentRequest));

      return this.processAvailability(date, eventType, eventIds, promises);
    }
  }, {
    key: 'flattenResponse',
    value: function flattenResponse(arrayOfArrays) {
      return [].concat.apply([], arrayOfArrays);
    }
  }, {
    key: 'noActivityAvailability',
    value: function noActivityAvailability() {
      if (!this.loadingService.isLoading('availability') && this.availability) {
        return !!this.availability.activity && !this.availability.activity.find(function (activity) {
          return activity.availability.available === true;
        });
      }

      return false;
    }
  }, {
    key: 'canRegister',
    value: function canRegister() {
      return !!(this.configService.get('login').canRegister && !(this.isLoggedIn() || this.isEditing()));
    }
  }, {
    key: 'propertyConfig',
    value: function propertyConfig(value) {
      var config = this.configService.get('property');
      return !!config[value];
    }
  }, {
    key: 'displaySpaDays',
    value: function displaySpaDays() {
      if (this.showSpaDays !== undefined) {
        return this.showSpaDays;
      }

      this.showSpaDays = this.propertyConfig('hasSpaDays') && !this.preventSpaDays() ? 1 : 0;

      return this.showSpaDays;
    }
  }, {
    key: 'preventSpaDays',
    value: function preventSpaDays() {
      if (this.hideSpaDays !== undefined) {
        return this.hideSpaDays;
      }

      this.hideSpaDays = this.isEditing() && this.configService.get('integration').preventEditSpadays ? 1 : 0;

      return this.hideSpaDays;
    }
  }, {
    key: 'openActivities',
    value: function openActivities() {
      return this.propertyConfig('openActivities');
    }
  }, {
    key: 'buttonCount',
    value: function buttonCount() {
      if (this.buttonCounter) {
        return this.buttonCounter;
      }

      var count = this.hasPromotedCategory ? 1 : 0;
      if (this.propertyConfig('hasTreatments')) {
        ++count;
      }

      if (this.displaySpaDays()) {
        ++count;
      }

      if (this.propertyConfig('hasActivities') && (this.isLoggedIn() || this.openActivities())) {
        ++count;
      }

      this.buttonCounter = count;
      return count;
    }
  }, {
    key: 'setMaxSearchDate',
    value: function setMaxSearchDate() {
      var searchDays = this.configService.get('property').maxActivitySearchDays;
      if (searchDays && searchDays > 0) {
        this.dateService.checkStoredDate(true);
        this.dateService.setCalendarParameter('maxDate', (0, _moment2.default)().add(searchDays, 'days'));
      }
    }
  }, {
    key: 'determineAnnouncementState',
    value: function determineAnnouncementState() {
      this.announcementIsVisible = true;
      var hideAnnouncement = this.storeService.get('hideAnnouncement');
      if (hideAnnouncement) {
        if ((0, _moment2.default)(hideAnnouncement).diff((0, _moment2.default)(), 'days') >= 0) {
          this.announcementIsVisible = false;
          return;
        }
      }
    }
  }, {
    key: 'hideAnnouncement',
    value: function hideAnnouncement() {
      this.storeService.set('hideAnnouncement', (0, _moment2.default)().format('YYYY-MM-DD'));
      this.announcementIsVisible = false;
    }
  }, {
    key: 'showAnnouncement',
    value: function showAnnouncement() {
      this.storeService.remove('hideAnnouncement');
      this.announcementIsVisible = true;
    }
  }]);

  return PageController;
}();

PageController.$inject = ['$window', 'availabilityService', 'availabilityApiService', 'dateService', 'basket', 'itemService', 'checkout', 'storeService', '$timeout', 'quantityService', 'loginoutService', 'configService', 'addGuestService', 'loadingService', 'imgix'];

exports.default = PageController;

/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MessageController = function MessageController(messageService) {
    _classCallCheck(this, MessageController);

    this.messageService = messageService;
};

MessageController.$inject = ['messageService'];

exports.default = MessageController;

/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AvailabilitySliderController = function () {
  function AvailabilitySliderController($scope, $timeout, availabilityService, availabilityApiService, dateService, itemService, storeService, loginoutService, configService, loadingService) {
    _classCallCheck(this, AvailabilitySliderController);

    this.$scope = $scope;
    this.$timeout = $timeout;
    this.availabilityService = availabilityService;
    this.availabilityApiService = availabilityApiService;
    this.dateService = dateService;
    this.itemService = itemService;
    this.storeService = storeService;
    this.loginoutService = loginoutService;
    this.configService = configService;
    this.loadingService = loadingService;
  }

  _createClass(AvailabilitySliderController, [{
    key: '$onInit',
    value: function $onInit() {
      this.travelNext = null;
      this.travelPrevious = null;
      this.today = (0, _moment2.default)();
      this.startDate = null;
      this.endDate = null;
      this.error = false;
      this.isSearching = false;

      this.availabilityService.resetSingleDays();
    }
  }, {
    key: 'setupDays',
    value: function setupDays() {
      if (!this.loadingService.isLoading('availability') && this.availability) {
        if (!this.availabilityService.hasSingleDays()) {
          this.setDays();
        }

        return this.availabilityService.getSingleDays();
      }
    }
  }, {
    key: 'setDays',
    value: function setDays() {
      var _this = this;

      this.availabilityService.resetSingleDays();
      var days = [];

      this.filterAvailability();

      this.availability.forEach(function (availability) {
        var day = (0, _moment2.default)(availability.date);

        days.push((0, _lodash.merge)({
          name: day.format('ddd'),
          number: day.format('DD')
        }, availability));

        _this.availabilityService.setSingleDays(days);
      });

      this.itemService.setItem(this.item);

      if (this.item.phone_only) {
        this.item.date = (0, _lodash.head)(this.availability).date || null;
        return Promise.resolve();
      }

      return this.itemService.setupItemAvailability(this.availability, this.startDate).then(function () {
        return _this.getQuantity();
      });
    }
  }, {
    key: 'monthYear',
    value: function monthYear() {
      if (this.availability) {
        this.startDate = (0, _moment2.default)((0, _lodash.head)(this.availability).date, 'YYYY-MM-DD');
        this.endDate = (0, _moment2.default)((0, _lodash.last)(this.availability).date, 'YYYY-MM-DD');

        if (this.startDate.isSame(this.endDate, 'month')) {
          return this.startDate.format('MMMM YYYY');
        }

        if (this.startDate.isSame(this.endDate, 'year')) {
          return this.startDate.format('MMM') + '\u2013' + this.endDate.format('MMM YYYY');
        }

        return this.startDate.format('MMM YYYY') + '\u2013' + this.endDate.format('MMM YYYY');
      }

      var searchDate = this.storeService.get('searchDate');
      if (searchDate) {
        return (0, _moment2.default)(searchDate).format('MMMM YYYY');
      }

      return this.today.format('MMMM YYYY');
    }
  }, {
    key: 'selectDay',
    value: function selectDay(availableDay) {
      var _this2 = this;

      if (!this.isDateSelected(availableDay)) {
        this.staff = undefined;

        this.itemService.setItem(this.item);

        if (this.item.phone_only) {
          this.item.date = availableDay.date;
          return Promise.resolve();
        }

        this.loadingService.startLoading('times');

        return this.itemService.updateAvailability(availableDay).then(function () {
          _this2.item = _this2.itemService.getItem();
          _this2.item.interacted = true;
          _this2.loadingService.stopLoading('times');

          _this2.getQuantity();
        });
      }
    }
  }, {
    key: 'isDateSelected',
    value: function isDateSelected(day) {
      return this.item.date === day.date;
    }
  }, {
    key: 'isNextDateValid',
    value: function isNextDateValid() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.loadingService.isLoading('availability') && !this.error) {
        if (this.availability) {
          if (direction === 'previous') {
            return !this.startDate.isSame(this.today, 'day');
          }

          return !(0, _moment2.default)(this.endDate).add(1, 'days').diff(this.today, 'years') > 0;
        }
      }

      return false;
    }
  }, {
    key: 'nextAvailability',
    value: function nextAvailability() {
      var _this3 = this;

      this.travelNext = true;
      this.isSearching = true;

      return this.updateAvailability('next').then(function () {
        _this3.travelNext = null;
      });
    }
  }, {
    key: 'previousAvailability',
    value: function previousAvailability() {
      var _this4 = this;

      this.travelPrevious = true;
      this.isSearching = true;

      return this.updateAvailability('previous').then(function () {
        _this4.travelPrevious = null;
      });
    }
  }, {
    key: 'updateAvailability',
    value: function updateAvailability() {
      var _this5 = this;

      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;

      this.loadingService.startLoading(['availability', 'times']);
      this.error = false;
      this.noEditAvailability = false;
      this.availabilityService.resetSingleDays();

      this.setStartEndDates(direction);

      if (this.basket && this.basket.store_offer) {
        this.item.offer = {
          id: this.basket.store_offer
        };
      }

      return this.availabilityApiService.requestAvailability(this.startDate.format('YYYY-MM-DD'), this.endDate.format('YYYY-MM-DD'), this.eventType, this.item.id, this.item.offer ? this.item.offer.id : 'storefront').then(function (response) {
        _this5.availability = response;

        _this5.availabilityService.resetSingleDays();
        return _this5.setupDays();
      }).catch(function () {
        _this5.availabilityService.resetSingleDays();
        _this5.error = true;
      }).then(function (response) {
        _this5.loadingService.stopLoading('availability');
        _this5.$timeout(function () {
          _this5.$scope.$digest();
        });
        return response;
      });
    }
  }, {
    key: 'setStartEndDates',
    value: function setStartEndDates(direction) {
      var start = null;
      var end = null;

      switch (direction) {
        case 'next':
          start = (0, _moment2.default)(this.endDate.add(1, 'days'));
          end = this.endDate.add(6, 'days');
          break;
        case 'previous':
          end = (0, _moment2.default)(this.startDate.subtract(1, 'days'));
          start = this.startDate.subtract(6, 'days');
          break;
        default:
          start = (0, _moment2.default)(this.startDate);
          end = this.startDate.add(6, 'days');
          this.isSearching = false;
      }

      this.startDate = this.dateService.checkMaxDate(start, true);
      this.endDate = this.dateService.checkMaxDate(end);

      this.startDateNotBeforeToday();
    }
  }, {
    key: 'startDateNotBeforeToday',
    value: function startDateNotBeforeToday() {
      if (this.startDate.isBefore(this.today, 'day')) {
        this.startDate = (0, _moment2.default)();
        this.endDate = (0, _moment2.default)().add(6, 'days');
      }

      this.storeService.set('searchDate', this.startDate.format('YYYY-MM-DD'));
    }
  }, {
    key: 'goToToday',
    value: function goToToday() {
      this.startDate = (0, _moment2.default)();
      return this.updateAvailability();
    }
  }, {
    key: 'updateDate',
    value: function updateDate() {
      var update = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.item.date) {
        if (update) {
          this.storeService.set('searchDate', this.item.date);
        }
        this.startDate = (0, _moment2.default)(this.item.date);
        this.updateAvailability();
      }
    }
  }, {
    key: 'displayOriginalPrice',
    value: function displayOriginalPrice(day) {
      return day.available && day.original_price !== day.price;
    }
  }, {
    key: 'hasLoaded',
    value: function hasLoaded() {
      return !!(!this.loadingService.isLoading('availability') && this.availability);
    }
  }, {
    key: 'filterAvailability',
    value: function filterAvailability() {
      if (this.isNotEditing()) {
        return false;
      }

      var start = (0, _moment2.default)(this.storeService.get('start_date'), 'YYYY-MM-DD');
      var end = (0, _moment2.default)(this.storeService.get('end_date'), 'YYYY-MM-DD');

      this.availability = this.availability.map(function (day) {
        var date = (0, _moment2.default)(day.date, 'YYYY-MM-DD');
        if (date.isBefore(start) || date.isAfter(end)) {
          day.available = false;
        }

        return day;
      });

      if (this.availability.findIndex(function (day) {
        return day.available;
      }) === -1) {
        this.loadingService.stopLoading(['availability', 'times']);
        this.noEditAvailability = true;
      }
    }
  }, {
    key: 'isNotEditing',
    value: function isNotEditing() {
      return !this.loginoutService.isEditing();
    }
  }, {
    key: 'availableContactMethods',
    value: function availableContactMethods() {
      var contactMethods = this.configService.get('property').contactMethods;

      if (!contactMethods.email && !contactMethods.phone) {
        return false;
      }

      return '<strong>' + Object.values(contactMethods).filter(Boolean).join('</strong> or <strong>') + '</strong>';
    }
  }]);

  return AvailabilitySliderController;
}();

AvailabilitySliderController.$inject = ['$scope', '$timeout', 'availabilityService', 'availabilityApiService', 'dateService', 'itemService', 'storeService', 'loginoutService', 'configService', 'loadingService'];

exports.default = AvailabilitySliderController;

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SearchFormController = function () {
    function SearchFormController($scope, $window, $timeout, configService) {
        _classCallCheck(this, SearchFormController);

        this.$scope = $scope;
        this.$window = $window;
        this.$timeout = $timeout;
        this.configService = configService;
    }

    _createClass(SearchFormController, [{
        key: '$onInit',
        value: function $onInit() {
            this.property = this.configService.get('property');
            this.error = null;
            this.searchValue = this.query || '';

            this.setFocusOnFullscreen();
        }
    }, {
        key: 'displaySelect',
        value: function displaySelect() {
            return !!(this.property.hasTreatments && this.property.hasSpaDays);
        }
    }, {
        key: 'submit',
        value: function submit() {
            this.error = null;

            if (this.searchValue.length < 3) {
                this.error = 'Your search term must be at least 3 characters long.';
                return;
            }

            this.loading = true;
            this.$window.location = '/search/' + this.eventType + '?q=' + this.searchValue;
        }
    }, {
        key: 'close',
        value: function close() {
            this.isOpen = undefined;
        }
    }, {
        key: 'setFocusOnFullscreen',
        value: function setFocusOnFullscreen() {
            var _this = this;

            if (this.fullscreen === true) {
                this.$timeout(function () {
                    var inputEl = _this.$window.document.querySelectorAll('.c-search.is-fullscreen .c-input') && _this.$window.document.querySelectorAll('.c-search.is-fullscreen .c-input')[0];

                    if (inputEl) {
                        _this.$scope.$watch(function () {
                            return _this.isOpen;
                        }, function (newVal) {
                            if (newVal && newVal === true) {
                                inputEl.focus();
                            }
                        });
                    }
                });
            }
        }
    }]);

    return SearchFormController;
}();

SearchFormController.$inject = ['$scope', '$window', '$timeout', 'configService'];

exports.default = SearchFormController;

/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SelectTypeController = function () {
    function SelectTypeController($window, configService) {
        _classCallCheck(this, SelectTypeController);

        this.$window = $window;
        this.configService = configService;
    }

    _createClass(SelectTypeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.property = this.configService.get('property');

            this.getExistingType();

            if (!this.eventType || this.eventType === 'category') {
                if (this.property.hasTreatments) {
                    this.eventType = 'treatment';
                    return;
                }

                this.eventType = 'day';
            }
        }
    }, {
        key: 'displaySelect',
        value: function displaySelect() {
            return !!(this.property.hasTreatments && this.property.hasSpaDays);
        }
    }, {
        key: 'getExistingType',
        value: function getExistingType() {
            var selectEl = this.$window.document.getElementsByClassName('select-type')[0];
            if (selectEl) {
                this.eventType = selectEl.value;
            }
        }
    }]);

    return SelectTypeController;
}();

SelectTypeController.$inject = ['$window', 'configService'];

exports.default = SelectTypeController;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var QuickBookController = function () {
    function QuickBookController($window, basket, eventService, availabilityApiService, loginoutService, quantityService, configService, dateService, validateService, messageService, availabilityService) {
        _classCallCheck(this, QuickBookController);

        this.$window = $window;
        this.basket = basket;
        this.eventService = eventService;
        this.availabilityApiService = availabilityApiService;
        this.loginoutService = loginoutService;
        this.quantityService = quantityService;
        this.configService = configService;
        this.dateService = dateService;
        this.validateService = validateService;
        this.messageService = messageService;
        this.availabilityService = availabilityService;
    }

    _createClass(QuickBookController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = ['events'];

            this.showTreatments = true;
            this.showSpaDays = true;

            this.hasTreatments = false;
            this.hasSpaDays = false;

            this.fromDate = this.dateService.checkStoredDate();
            this.toDate = (0, _moment2.default)(this.fromDate).add(6, 'days').format('YYYY-MM-DD');

            return this.basket.promise && this.basket.promise.then(function () {
                _this.guest = (0, _lodash.head)(_this.basket.contents.guest_details);
                return _this.getAllEvents();
            });
        }
    }, {
        key: 'getAllEvents',
        value: function getAllEvents() {
            var _this2 = this;

            return this.eventService.getAllEvents().then(function (response) {
                _this2.stopLoading('events');
                _this2.originalData = response;
                _this2.filterEvents();
            }).catch(function () {});
        }
    }, {
        key: 'selectEvent',
        value: function selectEvent(item) {
            var _this3 = this;

            this.resetAvailability(false);

            this.loading.push('availability');
            this.item = item;
            this.item.preferred_time = undefined;
            this.item.date = this.fromDate;

            return this.availabilityApiService.requestAvailability(this.fromDate, this.toDate, item.type_name, item.id).then(function (response) {
                _this3.stopLoading('availability');
                _this3.availability = response;

                if (_this3.$window.fpInput) {
                    _this3.$window.fpInput.setDate((0, _lodash.head)(_this3.availability).date, false, 'Y-m-d');
                }
                return;
            });
        }
    }, {
        key: 'placeholder',
        value: function placeholder() {
            if (this.isLoading('events')) {
                return 'Loading...';
            }

            var string = 'Search';

            if (this.hasTreatments) {
                string = string + ' Treatments';
            }

            if (this.hasTreatments && this.hasSpaDays) {
                string = string + ' and';
            }

            if (this.hasSpaDays) {
                string = string + ' Spa Days';
            }

            return string + '...';
        }
    }, {
        key: 'groupEvents',
        value: function groupEvents(item) {
            return item.type_display;
        }
    }, {
        key: 'displayUrl',
        value: function displayUrl() {
            return '/' + this.slugify(this.item.type_display) + '/' + this.item.slug;
        }
    }, {
        key: 'slugify',
        value: function slugify(string) {
            return string.replace(/\s/g, '-').toLowerCase();
        }
    }, {
        key: 'stopLoading',
        value: function stopLoading(param) {
            var index = this.loading.indexOf(param);
            if (index > -1) {
                this.loading.splice(index, 1);
            }
        }
    }, {
        key: 'isLoading',
        value: function isLoading(param) {
            if (param) {
                return this.loading.indexOf(param) > -1;
            }

            return this.loading.length > 0;
        }
    }, {
        key: 'buttonDisabled',
        value: function buttonDisabled() {
            return this.isLoading() || !this.availabilityService.hasSingleTimes();
        }
    }, {
        key: 'filter',
        value: function filter(param) {
            switch (param) {
                case 'treatments':
                    this.showTreatments = !this.showTreatments;
                    break;
                case 'spadays':
                    this.showSpaDays = !this.showSpaDays;
                    break;
            }

            this.filterEvents();
        }
    }, {
        key: 'filterEvents',
        value: function filterEvents() {
            var _this4 = this;

            this.resetAvailability();

            if (!this.originalData) {
                return;
            }

            this.data = (0, _lodash.cloneDeep)(this.originalData);
            this.data.events = this.data.events.filter(function (event) {
                if (_this4.guest.gender && event.gender && event.gender !== _this4.guest.gender) {
                    return false;
                }

                if (event.type_name === 'Treatment' && !_this4.showTreatments) {
                    return false;
                }

                if (event.type_name === 'SpaDay' && !_this4.showSpaDays) {
                    return false;
                }

                if (_this4.filterCategory && event.categories.indexOf(parseInt(_this4.filterCategory)) === -1) {
                    return false;
                }

                if (_this4.filterDuration && (event.display_duration && '' + event.display_duration !== '' + _this4.filterDuration || !event.display_duration && '' + event.duration !== '' + _this4.filterDuration)) {
                    return false;
                }

                switch (event.type_name) {
                    case 'Treatment':
                        _this4.hasTreatments = true;
                        break;
                    case 'SpaDay':
                        _this4.hasSpaDays = true;
                        break;
                }

                return true;
            });

            if (!this.data.events.length) {
                this.noEvents = true;
            }
        }
    }, {
        key: 'resetAvailability',
        value: function resetAvailability() {
            var resetEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.item = undefined;
            this.availability = undefined;
            this.noEvents = false;
            this.staff = undefined;

            this.availabilityService.resetSingleDays();
            this.availabilityService.resetSingleTimes();

            if (resetEvent) {
                this.selectedEvent = undefined;
            }
        }
    }, {
        key: 'resetFilters',
        value: function resetFilters() {
            this.showTreatments = true;
            this.showSpaDays = true;
            this.filterCategory = '';
            this.filterDuration = '';
            this.noEvents = false;

            this.filterEvents();
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            if (!this.loginoutService.isLoggedIn()) {
                if (this.item) {
                    this.resetAvailability();
                    this.resetFilters();
                }
                return false;
            }

            if (!this.guest && this.basket.contents.guest_details.length) {
                this.guest = (0, _lodash.head)(this.basket.contents.guest_details);
                this.resetFilters();
                this.$window.dispatchEvent(new CustomEvent('initCalendar'));
            }

            return true;
        }
    }, {
        key: 'getQuantity',
        value: function getQuantity() {
            var _this5 = this;

            this.quantity = undefined;

            if (this.item.preferred_time) {
                this.loading.push('quantity');
                this.resetStaff();

                return this.quantityService.getQuantity(this.item).then(function (response) {
                    _this5.staff = (0, _lodash.map)(response.staff, function (staffId, staffName) {
                        return {
                            id: staffId,
                            label: staffName
                        };
                    }) || undefined;

                    _this5.stopLoading('quantity');
                });
            }
        }
    }, {
        key: 'resetStaff',
        value: function resetStaff() {
            delete this.item.staff;

            if (this.staff) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = this.staff[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var staff = _step.value;

                        delete staff.disabled;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    }, {
        key: 'canDisplayStaff',
        value: function canDisplayStaff() {
            return !!this.configService.get('property').loadStaff;
        }
    }, {
        key: 'displayStaff',
        value: function displayStaff() {
            return !!(this.canDisplayStaff() && !this.isLoading() && this.staff && this.staff.length);
        }
    }, {
        key: 'addToBasket',
        value: function addToBasket() {
            var _this6 = this;

            this.item.quantity = 1;

            var error = this.validateService.invalidItemOrGuests(this.item, [this.guest]);
            if (error) {
                this.messageService.add(error);
                this.messageService.failure();
                return;
            }

            this.loading.push('addToBasket');

            this.basket.changeStatus('checkout');

            return this.basket.addToBasket([this.guest], this.item, false).then(function () {
                if (!_this6.basket.success) {
                    _this6.stopLoading('addToBasket');
                    _this6.selectEvent(_this6.item);
                    return;
                }

                _this6.$window.location = '/checkout/' + _this6.basket.contents.first_step;
            });
        }
    }, {
        key: 'login',
        value: function login() {
            return this.loginoutService.login();
        }
    }]);

    return QuickBookController;
}();

QuickBookController.$inject = ['$window', 'basket', 'eventService', 'availabilityApiService', 'loginoutService', 'quantityService', 'configService', 'dateService', 'validateService', 'messageService', 'availabilityService'];

exports.default = QuickBookController;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  controller: 'messageController',
  template: __webpack_require__(725)
};

/***/ }),
/* 725 */
/***/ (function(module, exports) {

module.exports = "<div class=\"alert {{ $ctrl.messageService.alerttype }}\" ng-show=$ctrl.messageService.show> <icon class=\"alert__icon alert__icon--success\" ng-if=\"$ctrl.messageService.alerttype === 'alert--success'\" icon=tick></icon> <icon class=\"alert__icon alert__icon--failure\" ng-if=\"$ctrl.messageService.alerttype === 'alert--fail'\" icon=cross></icon> <p class=alert__message ng-repeat=\"message in $ctrl.messageService.messages\">{{message}}</p> </div>";

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        icon: '@',
        large: '<'
    },
    template: __webpack_require__(727)
};

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = "<i class=c-icon ng-if=\"$ctrl.icon === 'chevron-down'\"> " + __webpack_require__(728) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'chevron-up'\"> " + __webpack_require__(729) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'chevron-left'\"> " + __webpack_require__(730) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'chevron-right'\"> " + __webpack_require__(731) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'cross'\"> " + __webpack_require__(732) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'bin'\"> " + __webpack_require__(733) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'files'\"> " + __webpack_require__(734) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'property'\"> " + __webpack_require__(735) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'dashboard'\"> " + __webpack_require__(736) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'menu'\"> " + __webpack_require__(737) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'user'\"> " + __webpack_require__(738) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'tick'\"> " + __webpack_require__(739) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'resize'\"> " + __webpack_require__(740) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'journey-arrow'\"> " + __webpack_require__(741) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'eye'\"> " + __webpack_require__(742) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'closedeye'\"> " + __webpack_require__(743) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'hierarchy'\"> " + __webpack_require__(744) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'edit'\"> " + __webpack_require__(745) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'flip-flops'\"> " + __webpack_require__(746) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'calendar'\"> " + __webpack_require__(747) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'datepicker'\"> " + __webpack_require__(748) + " </i> <i class=c-icon ng-if=\"$ctrl.icon === 'return'\"> " + __webpack_require__(749) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'filter'\"> " + __webpack_require__(750) + " </i> <i class=c-icon ng-class=\"{'c-icon--large': $ctrl.large}\" ng-if=\"$ctrl.icon === 'plus'\"> " + __webpack_require__(751) + " </i> <i class=\"c-icon c-icon--info / t-text--primary--background\" ng-if=\"$ctrl.icon === 'info'\" aria-hidden> i </i> ";

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M56.5,19c-0.5-0.5-1.3-0.5-1.6,0L31.9,42.4L9.1,19.2c-0.5-0.5-1.2-0.5-1.6,0c-0.5,0.5-0.5,1.2,0,1.6l23.6,24.1 c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.2,0.9-0.4l23.8-24.3C57,20.3,57,19.5,56.5,19z\"></path></svg>"

/***/ }),
/* 729 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\" style=\"enable-background:new 0 0 64 64;\" xml:space=\"preserve\"><path d=\"M7.5,44.9c0.5,0.5,1.3,0.5,1.6,0l23-23.4l22.8,23.2c0.5,0.5,1.2,0.5,1.6,0c0.5-0.5,0.5-1.2,0-1.6L32.9,19 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.3,0-0.6,0.2-0.9,0.4L7.3,43.3C7,43.6,7,44.4,7.5,44.9z\"></path></svg>"

/***/ }),
/* 730 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M14 20c0.128 0 0.256-0.049 0.354-0.146 0.195-0.195 0.195-0.512 0-0.707l-8.646-8.646 8.646-8.646c0.195-0.195 0.195-0.512 0-0.707s-0.512-0.195-0.707 0l-9 9c-0.195 0.195-0.195 0.512 0 0.707l9 9c0.098 0.098 0.226 0.146 0.354 0.146z\"></path></svg>"

/***/ }),
/* 731 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M5 20c-0.128 0-0.256-0.049-0.354-0.146-0.195-0.195-0.195-0.512 0-0.707l8.646-8.646-8.646-8.646c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l9 9c0.195 0.195 0.195 0.512 0 0.707l-9 9c-0.098 0.098-0.226 0.146-0.354 0.146z\"></path></svg>"

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M342.627 336l276.686-276.687c6.249-6.248 6.249-16.379 0-22.627s-16.379-6.249-22.627 0l-276.686 276.687-276.687-276.686c-6.248-6.249-16.379-6.249-22.627 0s-6.249 16.379 0 22.627l276.687 276.686-276.686 276.687c-6.249 6.248-6.249 16.379 0 22.627 3.124 3.124 7.218 4.686 11.313 4.686s8.189-1.562 11.313-4.687l276.687-276.686 276.687 276.687c3.124 3.124 7.218 4.686 11.313 4.686s8.189-1.562 11.313-4.687c6.249-6.248 6.249-16.379 0-22.627l-276.686-276.686z\"></path></svg>"

/***/ }),
/* 733 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M15.5 2h-3.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-2c-0.827 0-1.5 0.673-1.5 1.5v0.5h-3.5c-0.827 0-1.5 0.673-1.5 1.5v1c0 0.652 0.418 1.208 1 1.414v12.586c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-12.586c0.582-0.206 1-0.762 1-1.414v-1c0-0.827-0.673-1.5-1.5-1.5zM8 1.5c0-0.276 0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5v0.5h-3v-0.5zM14.5 19h-10c-0.276 0-0.5-0.224-0.5-0.5v-12.5h11v12.5c0 0.276-0.224 0.5-0.5 0.5zM16 4.5c0 0.276-0.224 0.5-0.5 0.5h-12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5h12c0.276 0 0.5 0.224 0.5 0.5v1z\"></path><path d=\"M12.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path><path d=\"M9.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path><path d=\"M6.5 7c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-10c0-0.276-0.224-0.5-0.5-0.5z\"></path></svg>"

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M16.5 4h-0.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-0.5v-0.5c0-0.827-0.673-1.5-1.5-1.5h-7.5c-0.133 0-0.26 0.053-0.354 0.146l-3.5 3.5c-0.094 0.094-0.146 0.221-0.146 0.354v10.5c0 0.827 0.673 1.5 1.5 1.5h0.5v0.5c0 0.827 0.673 1.5 1.5 1.5h0.5v0.5c0 0.827 0.673 1.5 1.5 1.5h10c0.827 0 1.5-0.673 1.5-1.5v-13c0-0.827-0.673-1.5-1.5-1.5zM5 1.207v2.293c0 0.276-0.224 0.5-0.5 0.5h-2.293l2.793-2.793zM2 14.5v-9.5h2.5c0.827 0 1.5-0.673 1.5-1.5v-2.5h6.5c0.276 0 0.5 0.224 0.5 0.5v13c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5zM4 16.5v-0.5h8.5c0.827 0 1.5-0.673 1.5-1.5v-11.5h0.5c0.276 0 0.5 0.224 0.5 0.5v13c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5zM17 18.5c0 0.276-0.224 0.5-0.5 0.5h-10c-0.276 0-0.5-0.224-0.5-0.5v-0.5h8.5c0.827 0 1.5-0.673 1.5-1.5v-11.5h0.5c0.276 0 0.5 0.224 0.5 0.5v13z\"></path></svg>"

/***/ }),
/* 735 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M448 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M448 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M192 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M128 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 192h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 256h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 320h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 384h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 512h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M256 448h32v32h-32v-32z\"></path><path fill=\"#000\" d=\"M592 608h-16v-432c0-24.411-18.14-49.579-41.298-57.298l-150.702-50.234v-52.468c0-5.058-2.392-9.818-6.449-12.837-4.058-3.018-9.305-3.941-14.148-2.488l-289.35 86.804c-23.581 7.075-42.053 31.902-42.053 56.521v464h-16c-8.836 0-16 7.163-16 16s7.164 16 16 16h576c8.837 0 16-7.163 16-16s-7.163-16-16-16zM524.583 149.060c10.162 3.387 19.417 16.228 19.417 26.94v432h-160v-505.801l140.583 46.861zM64 144c0-10.517 9.174-22.848 19.248-25.87l268.752-80.626v570.496h-288v-464z\"></path></svg>"

/***/ }),
/* 736 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3000.628 -2795.628 17.257 17.257\"><path d=\"M3.922,13.073H.261A.262.262,0,0,0,0,13.335V17a.262.262,0,0,0,.261.261H3.922A.262.262,0,0,0,4.183,17V13.335A.262.262,0,0,0,3.922,13.073Zm-.261,3.661H.523V13.6H3.661Zm6.8-3.661H6.8a.262.262,0,0,0-.261.261V17a.262.262,0,0,0,.261.261h3.661A.262.262,0,0,0,10.72,17V13.335A.262.262,0,0,0,10.459,13.073ZM10.2,16.734H7.06V13.6H10.2ZM17,13.073H13.335a.262.262,0,0,0-.261.261V17a.262.262,0,0,0,.261.261H17A.262.262,0,0,0,17.257,17V13.335A.262.262,0,0,0,17,13.073Zm-.261,3.661H13.6V13.6h3.138ZM3.922,6.537H.261A.262.262,0,0,0,0,6.8v3.661a.262.262,0,0,0,.261.261H3.922a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,3.922,6.537ZM3.661,10.2H.523V7.06H3.661Zm6.8-3.661H6.8a.262.262,0,0,0-.261.261v3.661a.262.262,0,0,0,.261.261h3.661a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,10.459,6.537ZM10.2,10.2H7.06V7.06H10.2ZM17,6.537H13.335a.262.262,0,0,0-.261.261v3.661a.262.262,0,0,0,.261.261H17a.262.262,0,0,0,.261-.261V6.8A.262.262,0,0,0,17,6.537ZM16.734,10.2H13.6V7.06h3.138ZM3.922,0H.261A.262.262,0,0,0,0,.261V3.922a.262.262,0,0,0,.261.261H3.922a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,3.922,0ZM3.661,3.661H.523V.523H3.661ZM10.459,0H6.8a.262.262,0,0,0-.261.261V3.922a.262.262,0,0,0,.261.261h3.661a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,10.459,0ZM10.2,3.661H7.06V.523H10.2ZM17,0H13.335a.262.262,0,0,0-.261.261V3.922a.262.262,0,0,0,.261.261H17a.262.262,0,0,0,.261-.261V.261A.262.262,0,0,0,17,0Zm-.261,3.661H13.6V.523h3.138Z\" transform=\"translate(-3000.628 -2795.628)\"></path></svg>"

/***/ }),
/* 737 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-2839.5 -2866 21.098 13.41\"><g transform=\"translate(-2870 -2900)\"><line id=\"Line_1\" data-name=\"Line 1\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_2\" data-name=\"Line 2\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_3\" data-name=\"Line 3\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line><line id=\"Line_4\" data-name=\"Line 4\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_5\" data-name=\"Line 5\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_6\" data-name=\"Line 6\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line><line id=\"Line_7\" data-name=\"Line 7\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 34.5)\"></line><line id=\"Line_8\" data-name=\"Line 8\" class=\"icon-menu\" x2=\"21.098\" transform=\"translate(30.5 40.705)\"></line><line id=\"Line_9\" data-name=\"Line 9\" class=\"icon-menu\" x2=\"15.513\" transform=\"translate(30.5 46.91)\"></line></g></svg>"

/***/ }),
/* 738 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><g id=\"icomoon-ignore\"></g><path fill=\"#000\" d=\"M304 352c-97.047 0-176-78.953-176-176s78.953-176 176-176 176 78.953 176 176-78.953 176-176 176zM304 32c-79.402 0-144 64.598-144 144s64.598 144 144 144c79.401 0 144-64.598 144-144s-64.599-144-144-144z\"></path><path fill=\"#000\" d=\"M560 640h-512c-26.467 0-48-21.532-48-48 0-2.178 0.445-53.928 39.2-105.6 22.559-30.079 53.446-53.975 91.802-71.021 46.848-20.821 105.053-31.379 172.998-31.379 67.944 0 126.149 10.558 172.998 31.379 38.356 17.047 69.243 40.942 91.802 71.021 38.755 51.672 39.2 103.422 39.2 105.6 0 26.468-21.532 48-48 48zM304 416c-111.575 0-193.917 30.493-238.125 88.183-33.132 43.234-33.872 87.44-33.875 87.881 0 8.758 7.178 15.936 16 15.936h512c8.822 0 16-7.178 16-16-0.004-0.377-0.743-44.583-33.874-87.817-44.209-57.69-126.552-88.183-238.126-88.183z\"></path></svg>"

/***/ }),
/* 739 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 640 640\"><path d=\"M176 560c-4.095 0-8.189-1.562-11.314-4.687l-160-160c-6.248-6.248-6.248-16.379 0-22.627s16.379-6.248 22.628 0l148.686 148.686 436.687-436.686c6.248-6.248 16.379-6.248 22.627 0s6.249 16.379 0 22.628l-448 448c-3.125 3.124-7.219 4.686-11.314 4.686z\"></path></svg>"

/***/ }),
/* 740 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M15.5 7.5c-0.128 0-0.256-0.049-0.354-0.146l-5.646-5.646-5.646 5.646c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707l6-6c0.195-0.195 0.512-0.195 0.707 0l6 6c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z\"></path><path fill=\"#000\" d=\"M9.5 19.5c-0.128 0-0.256-0.049-0.354-0.146l-6-6c-0.195-0.195-0.195-0.512 0-0.707s0.512-0.195 0.707 0l5.646 5.646 5.646-5.646c0.195-0.195 0.512-0.195 0.707 0s0.195 0.512 0 0.707l-6 6c-0.098 0.098-0.226 0.146-0.354 0.146z\"></path></svg>"

/***/ }),
/* 741 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3001.006 -2559.417 17.634 17.842\"><path d=\"M17.528.083a.319.319,0,0,0-.36-.06l-17,5.892a.312.312,0,0,0-.18.33.3.3,0,0,0,.27.27L8.833,8.883l2.354,8.68a.335.335,0,0,0,.27.27H11.5a.307.307,0,0,0,.285-.195L17.588.458A.343.343,0,0,0,17.528.083ZM11.651,16.424,9.432,8.554a.355.355,0,0,0-.27-.27L1.382,6.065,16.643.983Z\" transform=\"translate(-3000.991 -2559.409)\"></path></svg>"

/***/ }),
/* 742 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-1.047-0.748-2.1-1.344-3.13-1.773-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 1.047 0.748 2.1 1.344 3.13 1.773 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM12.574 6.438c0.907 0.763 1.426 1.873 1.426 3.062 0 2.206-1.794 4-4 4s-4-1.794-4-4c0-1.188 0.519-2.299 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394s-4.784-1.302-6.317-2.394c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 2.757 2.243 5 5 5s5-2.243 5-5c0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z\"></path></svg>"

/***/ }),
/* 743 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M19.872 10.166c-0.047-0.053-1.182-1.305-2.956-2.572-0.6-0.429-1.202-0.807-1.801-1.134l1.725-1.592c0.203-0.187 0.216-0.504 0.028-0.707s-0.504-0.216-0.707-0.028l-2.003 1.849c-0.124-0.056-0.248-0.11-0.372-0.162-1.305-0.544-2.579-0.82-3.786-0.82s-2.481 0.276-3.786 0.82c-1.030 0.429-2.083 1.026-3.13 1.773-1.774 1.267-2.909 2.52-2.956 2.572-0.171 0.19-0.171 0.479 0 0.669 0.047 0.053 1.182 1.305 2.956 2.572 0.6 0.429 1.202 0.807 1.801 1.134l-1.725 1.592c-0.203 0.187-0.216 0.504-0.028 0.707 0.099 0.107 0.233 0.161 0.368 0.161 0.121 0 0.243-0.044 0.339-0.133l2.003-1.849c0.124 0.056 0.248 0.11 0.372 0.162 1.305 0.544 2.579 0.82 3.786 0.82s2.481-0.276 3.786-0.82c1.030-0.429 2.083-1.026 3.13-1.773 1.774-1.267 2.909-2.52 2.956-2.572 0.171-0.19 0.171-0.479 0-0.669zM14 9.5c0 2.206-1.794 4-4 4-0.711 0-1.378-0.187-1.957-0.513l5.592-5.162c0.238 0.517 0.366 1.086 0.366 1.674zM12.574 6.438c0.191 0.161 0.364 0.337 0.52 0.525l-5.867 5.416c-0.756-0.728-1.227-1.75-1.227-2.88 0-1.188 0.519-2.298 1.426-3.062 0.822-0.268 1.691-0.438 2.574-0.438s1.752 0.17 2.574 0.438zM3.683 12.606c-1.157-0.824-2.042-1.658-2.489-2.106 0.447-0.448 1.332-1.281 2.489-2.106 0.53-0.378 1.156-0.78 1.85-1.145-0.347 0.688-0.533 1.455-0.533 2.251 0 1.391 0.571 2.651 1.491 3.558l-0.825 0.762c-0.747-0.383-1.419-0.813-1.983-1.214zM16.317 12.606c-1.533 1.092-3.873 2.394-6.317 2.394-1.166 0-2.309-0.297-3.352-0.726l0.63-0.582c0.784 0.51 1.718 0.808 2.721 0.808 2.757 0 5-2.243 5-5 0-0.796-0.186-1.563-0.533-2.251 0.694 0.365 1.32 0.768 1.85 1.145 1.157 0.824 2.042 1.658 2.489 2.106-0.447 0.448-1.332 1.281-2.489 2.106z\"></path></svg>"

/***/ }),
/* 744 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-3002.5 -2716.615 20.999 17.23\"><path d=\"M18.576,11.859V8.682a.27.27,0,0,0-.269-.269H10.769V5.371a2.692,2.692,0,1,0-.538,0V8.413H2.692a.27.27,0,0,0-.269.269v3.177a2.692,2.692,0,1,0,.538,0V8.952H10.23v2.908a2.692,2.692,0,1,0,.538,0V8.952h7.269v2.908a2.692,2.692,0,1,0,.538,0ZM8.346,2.692A2.154,2.154,0,1,1,10.5,4.846,2.16,2.16,0,0,1,8.346,2.692Zm-3.5,11.846a2.154,2.154,0,1,1-2.154-2.154A2.16,2.16,0,0,1,4.846,14.538Zm7.807,0A2.154,2.154,0,1,1,10.5,12.384,2.16,2.16,0,0,1,12.653,14.538Zm5.654,2.154a2.154,2.154,0,1,1,2.154-2.154A2.16,2.16,0,0,1,18.307,16.692Z\" transform=\"translate(-3002.5 -2716.615)\"></path></svg>"

/***/ }),
/* 745 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path fill=\"#000\" d=\"M19.572 0.428c-0.28-0.28-0.655-0.421-1.117-0.421-0.753 0-1.765 0.394-3.021 1.174-0.402-0.425-1.167-1.077-2.131-1.155-0.769-0.062-1.495 0.241-2.157 0.903-1.405 1.405-2.097 3.121-2.555 4.256-0.156 0.386-0.349 0.866-0.445 0.965-0.033 0.033-0.132 0.132-0.304-0.013-0.196-0.185-0.505-0.181-0.696 0.010-0.195 0.195-0.195 0.512 0 0.707 0.082 0.082 0.293 0.241 0.562 0.316 0.108 0.030 0.216 0.045 0.322 0.045 0.127 0 0.251-0.022 0.369-0.065-0.137 0.141-0.274 0.282-0.411 0.425-3.517 3.673-7.46 8.713-7.982 11.842-0.027 0.159 0.025 0.322 0.14 0.436 0.095 0.095 0.222 0.146 0.354 0.146 0.027 0 0.055-0.002 0.082-0.007 1.308-0.218 3.032-1.046 5.125-2.46 1.852-1.251 3.906-2.908 5.94-4.791 1.984-1.837 3.794-3.742 5.235-5.511 1.076-1.321 2.458-3.208 2.934-4.692 0.301-0.939 0.219-1.649-0.244-2.112zM11.854 1.635c0.45-0.45 0.896-0.651 1.365-0.614 0.561 0.044 1.053 0.418 1.365 0.72-0.247 0.172-0.501 0.355-0.763 0.552-1.424 1.069-3.040 2.488-4.65 4.081 0.107-0.218 0.216-0.488 0.349-0.816 0.427-1.060 1.073-2.662 2.334-3.923zM3.036 15.243l1.722 1.722c-1.365 0.892-2.584 1.526-3.57 1.847 0.322-0.987 0.958-2.206 1.848-3.569zM10.969 12.009c-1.876 1.736-3.71 3.228-5.367 4.386l-1.995-1.995c1.321-1.892 3.071-4.008 5.105-6.132 2.362-2.467 4.695-4.505 6.562-5.787l2.244 2.244c-1.431 2.086-3.786 4.726-6.549 7.284zM18.864 2.235c-0.148 0.462-0.418 1.013-0.791 1.631l-1.941-1.941c0.978-0.591 1.78-0.918 2.324-0.918 0.281 0 0.378 0.097 0.41 0.128 0.232 0.232 0.099 0.789-0.001 1.1z\"></path></svg>"

/***/ }),
/* 746 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M19.704 8.76c0.157-0.906 0.296-1.933 0.296-3.26 0-2.194-1.133-3.502-2.083-4.213-1.077-0.806-2.542-1.287-3.917-1.287-0.785 0-1.853 0.313-2.481 1.806-0.344 0.818-0.519 1.893-0.519 3.194 0 1.092 0.184 2.005 0.37 2.783-0.226 0.55-0.37 1.131-0.37 1.717 0 1.286 0.472 2.325 0.98 3.070-0.011 0.319-0.024 0.637-0.037 0.946-0.096 2.232-0.187 4.341 0.949 5.527 0.597 0.623 1.45 0.926 2.608 0.926 0.812 0 1.495-0.199 2.030-0.592 0.467-0.343 0.824-0.836 1.062-1.466 0.407-1.078 0.407-2.372 0.407-3.412 0-0.594 0.022-1.157 0.068-1.714 0.462-0.597 0.932-1.517 0.932-2.786 0-0.394-0.099-0.808-0.296-1.24zM14 1c1.933 0 5 1.222 5 4.5 0 0.749-0.047 1.399-0.117 1.985-0.409-0.499-0.928-1.017-1.559-1.553-0.952-0.809-1.893-1.435-2.324-1.709v-0.722c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.773c-0.362 0.325-1.191 1.119-1.886 2.147-0.068-0.437-0.114-0.91-0.114-1.42 0-1.494 0.26-4 2-4zM15.5 18.97c-0.871 0-1.488-0.202-1.886-0.618-0.824-0.861-0.762-2.705-0.677-4.675 0.147 0.134 0.246 0.209 0.264 0.223 0.22 0.165 0.533 0.121 0.699-0.099s0.122-0.533-0.098-0.7c-0.018-0.014-1.801-1.392-1.801-3.601 0-1.818 1.849-3.719 2.553-4.376 0.44 0.284 1.284 0.856 2.123 1.569 1.499 1.274 2.324 2.448 2.324 3.307 0 0.897-0.285 1.679-0.848 2.326-0.431 0.496-0.873 0.725-0.876 0.727-0.247 0.123-0.347 0.424-0.224 0.671 0.088 0.175 0.264 0.277 0.448 0.277 0.075-0 0.151-0.017 0.223-0.053 0.010-0.005 0.121-0.061 0.288-0.173-0.007 0.238-0.011 0.479-0.011 0.726 0 2.446-0.188 4.47-2.5 4.47z\"></path><path fill=\"#000\" d=\"M8.63 7.753c0.186-0.777 0.37-1.69 0.37-2.783 0-1.301-0.175-2.376-0.519-3.194-0.628-1.493-1.696-1.806-2.481-1.806-1.376 0-2.84 0.481-3.917 1.287-0.95 0.711-2.083 2.019-2.083 4.213 0 1.327 0.139 2.353 0.296 3.259-0.197 0.432-0.296 0.846-0.296 1.241 0 1.269 0.47 2.188 0.932 2.786 0.045 0.558 0.068 1.12 0.068 1.714 0 1.040 0 2.334 0.407 3.412 0.238 0.63 0.596 1.123 1.062 1.466 0.535 0.393 1.218 0.592 2.030 0.592 1.158 0 2.011-0.303 2.608-0.926 1.136-1.186 1.045-3.295 0.949-5.527-0.013-0.309-0.027-0.628-0.037-0.946 0.507-0.745 0.98-1.784 0.98-3.070 0-0.587-0.144-1.167-0.37-1.717zM6.1 13.77c0.166 0.221 0.479 0.266 0.7 0.1 0.018-0.013 0.117-0.089 0.264-0.223 0.084 1.969 0.147 3.814-0.677 4.675-0.398 0.416-1.015 0.618-1.886 0.618-2.312 0-2.5-2.024-2.5-4.47 0-0.247-0.004-0.488-0.011-0.726 0.167 0.112 0.277 0.168 0.288 0.173 0.072 0.036 0.148 0.053 0.223 0.053 0.183-0 0.36-0.101 0.448-0.277 0.123-0.247 0.023-0.547-0.224-0.671-0.017-0.009-1.724-0.887-1.724-3.053 0-0.857 0.822-2.028 2.314-3.298 0.84-0.715 1.691-1.292 2.133-1.577 0.704 0.658 2.553 2.558 2.553 4.376 0 2.209-1.783 3.587-1.801 3.601-0.22 0.166-0.264 0.479-0.099 0.699zM7.886 6.39c-0.695-1.028-1.524-1.822-1.886-2.147v-0.773c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.722c-0.431 0.274-1.372 0.9-2.324 1.709-0.631 0.536-1.15 1.054-1.559 1.553-0.070-0.586-0.117-1.236-0.117-1.985 0-3.278 3.067-4.5 5-4.5 1.74 0 2 2.506 2 4 0 0.511-0.046 0.983-0.114 1.42z\"></path></svg>"

/***/ }),
/* 747 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"-9972 4945.259 20 19.782\"><g id=\"Group_621\" data-name=\"Group 621\" transform=\"translate(-10004 4308)\"><path id=\"Path_3112\" data-name=\"Path 3112\" class=\"cls-1\" d=\"M21.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256H21.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,21.056,64.69Zm.256-3.077h2.564v2.564H21.313Z\" transform=\"translate(13.866 583.992)\"></path><path id=\"Path_3113\" data-name=\"Path 3113\" class=\"cls-1\" d=\"M64.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256H64.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,64.056,64.69Zm.256-3.077h2.564v2.564H64.313Z\" transform=\"translate(-23.62 583.992)\"></path><path id=\"Path_3114\" data-name=\"Path 3114\" class=\"cls-1\" d=\"M107.056,64.69h3.077a.257.257,0,0,0,.256-.256V61.356a.257.257,0,0,0-.256-.256h-3.077a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,107.056,64.69Zm.256-3.077h2.564v2.564h-2.564Z\" transform=\"translate(-61.107 583.992)\"></path><path id=\"Path_3115\" data-name=\"Path 3115\" class=\"cls-1\" d=\"M21.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256H21.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,21.056,107.69Zm.256-3.077h2.564v2.564H21.313Z\" transform=\"translate(13.866 546.505)\"></path><path id=\"Path_3116\" data-name=\"Path 3116\" class=\"cls-1\" d=\"M64.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256H64.056a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,64.056,107.69Zm.256-3.077h2.564v2.564H64.313Z\" transform=\"translate(-23.62 546.505)\"></path><path id=\"Path_3117\" data-name=\"Path 3117\" class=\"cls-1\" d=\"M107.056,107.69h3.077a.257.257,0,0,0,.256-.256v-3.077a.257.257,0,0,0-.256-.256h-3.077a.257.257,0,0,0-.256.256v3.077A.257.257,0,0,0,107.056,107.69Zm.256-3.077h2.564v2.564h-2.564Z\" transform=\"translate(-61.107 546.505)\"></path><path id=\"Path_3118\" data-name=\"Path 3118\" class=\"cls-1\" d=\"M17.821,1.321H15.5V.256a.256.256,0,1,0-.513,0V1.321H4.949V.256a.256.256,0,0,0-.513,0V1.321H2.179A2.178,2.178,0,0,0,0,3.5V17.6a2.178,2.178,0,0,0,2.179,2.179H17.821A2.178,2.178,0,0,0,20,17.6V3.5A2.186,2.186,0,0,0,17.821,1.321ZM19.487,17.6a1.663,1.663,0,0,1-1.667,1.667H2.179A1.663,1.663,0,0,1,.513,17.6V5.679H19.487Zm0-12.436H.513V3.5A1.663,1.663,0,0,1,2.179,1.833H4.436V3.359a.256.256,0,0,0,.513,0V1.833H14.974V3.359a.256.256,0,1,0,.513,0V1.833h2.333A1.663,1.663,0,0,1,19.487,3.5Z\" transform=\"translate(32 637.259)\"></path></g></svg>"

/***/ }),
/* 748 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M18.5 2h-2.5v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-10v-0.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v0.5h-2.5c-0.827 0-1.5 0.673-1.5 1.5v14c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-14c0-0.827-0.673-1.5-1.5-1.5zM1.5 3h2.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h10v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h2.5c0.276 0 0.5 0.224 0.5 0.5v2.5h-18v-2.5c0-0.276 0.224-0.5 0.5-0.5zM18.5 18h-17c-0.276 0-0.5-0.224-0.5-0.5v-10.5h18v10.5c0 0.276-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 10h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 12h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 14h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M4.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M7.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M10.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M13.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path><path d=\"M16.5 16h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z\"></path></svg>"

/***/ }),
/* 749 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M17.071 2.929c-1.889-1.889-4.4-2.929-7.071-2.929-3.094 0-5.975 1.425-7.853 3.807v-1.307c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5v2.972c0 0.229 0.155 0.428 0.377 0.485 0.097 0.025 0.195 0.019 0.284-0.011v0l1.353-0.461c0-0 0-0 0-0l1.5-0.511c0.261-0.089 0.401-0.373 0.312-0.634s-0.373-0.401-0.634-0.312l-1.49 0.508c1.688-2.208 4.32-3.534 7.151-3.534 4.963 0 9 4.037 9 9s-4.037 9-9 9c-3.316 0-6.354-1.815-7.928-4.737-0.131-0.243-0.434-0.334-0.677-0.203s-0.334 0.434-0.203 0.677c1.749 3.246 5.125 5.263 8.809 5.263 2.671 0 5.182-1.040 7.071-2.929s2.929-4.4 2.929-7.071c0-2.671-1.040-5.182-2.929-7.071z\"></path></svg>"

/***/ }),
/* 750 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 20 20\"><path d=\"M16.23 3.307c-0.396-0.268-0.949-0.504-1.643-0.702-1.366-0.39-3.172-0.605-5.087-0.605s-3.722 0.215-5.087 0.605c-0.694 0.198-1.246 0.434-1.643 0.702-0.637 0.43-0.77 0.886-0.77 1.193v0.5c0 0.428 0.321 1.133 0.639 1.609l4.891 7.336c0.251 0.376 0.471 1.103 0.471 1.555v3c0 0.173 0.090 0.334 0.237 0.425 0.080 0.050 0.171 0.075 0.263 0.075 0.076 0 0.153-0.018 0.224-0.053l2-1c0.169-0.085 0.276-0.258 0.276-0.447v-2c0-0.452 0.22-1.179 0.471-1.555l4.891-7.336c0.317-0.476 0.639-1.182 0.639-1.609v-0.5c0-0.307-0.134-0.763-0.77-1.193zM4.688 3.567c1.279-0.365 2.988-0.567 4.812-0.567s3.534 0.201 4.812 0.567c1.378 0.394 1.688 0.816 1.688 0.933s-0.31 0.54-1.688 0.933c-1.279 0.365-2.988 0.567-4.812 0.567s-3.534-0.201-4.812-0.567c-1.378-0.394-1.688-0.816-1.688-0.933s0.31-0.54 1.688-0.933zM10.639 13.391c-0.358 0.537-0.639 1.464-0.639 2.109v1.691l-1 0.5v-2.191c0-0.646-0.281-1.572-0.639-2.109l-4.88-7.32c0.274 0.117 0.585 0.226 0.932 0.324 1.366 0.39 3.172 0.605 5.087 0.605s3.722-0.215 5.087-0.605c0.346-0.099 0.658-0.207 0.932-0.325l-4.88 7.32z\"></path></svg>"

/***/ }),
/* 751 */
/***/ (function(module, exports) {

module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 32 32\"><path d=\"M31 12h-11v-11c0-0.552-0.447-1-1-1h-6c-0.553 0-1 0.448-1 1v11h-11c-0.553 0-1 0.448-1 1v6c0 0.553 0.447 1 1 1h11v11c0 0.553 0.447 1 1 1h6c0.553 0 1-0.447 1-1v-11h11c0.553 0 1-0.447 1-1v-6c0-0.552-0.447-1-1-1z\"></path></svg>"

/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    template: __webpack_require__(753)
};

/***/ }),
/* 753 */
/***/ (function(module, exports) {

module.exports = "<svg class=c-spinner version=1.1 id=L9 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink x=0px y=0px viewBox=\"0 0 100 100\" enable-background=\"new 0 0 0 0\" xml:space=preserve> <path d=\"M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50\"> <animateTransform attributeName=transform attributeType=XML type=rotate dur=1s from=\"0 50 50\" to=\"360 50 50\" repeatCount=indefinite /> </path> </svg>";

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  template: __webpack_require__(755)
};

/***/ }),
/* 755 */
/***/ (function(module, exports) {

module.exports = "<div class=s-loading> <spinner></spinner> <p>Loading</p> </div> ";

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'availability': '=',
        'basket': '<',
        'eventType': '<',
        'item': '=',
        'getQuantity': '&'
    },
    controller: 'availabilitySliderController',
    template: __webpack_require__(757)
};

/***/ }),
/* 757 */
/***/ (function(module, exports) {

module.exports = "<div class=c-avail-slider> <div class=c-avail-slider__header> <div class=\"grid-x grid-margin-x\"> <div class=\"cell auto\"> <span class=\"c-avail-slider__header__text c-avail-slider__header__monthyear\" ng-bind-html=$ctrl.monthYear()></span> <div class=\"c-avail-slider__header__text c-guest__info\">Unavailable dates are displayed in dark grey. If there is no availability online, please select an alternative date<span ng-if=!$ctrl.availableContactMethods()>.</span><span ng-if=\"$ctrl.availableContactMethods() && !$ctrl.item.phone_only\">, or contact us at <span ng-bind-html=$ctrl.availableContactMethods()></span>.</span> </div> </div> <div class=\"cell shrink\"> <div class=c-avail-slider__datepicker ng-if=$ctrl.isNotEditing()> <input class=\"c-avail-slider__datepicker__input / js-flatpickr\" ng-model=$ctrl.item.date ng-change=$ctrl.updateDate(true) /> <icon icon=datepicker></icon> <span class=c-avail-slider__tooltip ng-class=\"{'isVisible': $ctrl.isSearching}\">Select a date</span> </div> </div> </div> </div> <div class=\"c-avail-slider__slider c-date-slider\" ng-class=\"{'c-date-slider--previous': $ctrl.travelPrevious, 'c-date-slider--next': $ctrl.travelNext}\"> <div class=grid-x> <div class=\"cell shrink\"> <button class=\"c-date-slider__travel c-date-slider__travel--back t-text--primary--background\" ng-disabled=\"!$ctrl.isNextDateValid('previous')\" ng-click=$ctrl.previousAvailability()> <icon icon=chevron-left></icon> <span class=u-visuallyhidden>Previous week</span> </button> </div> <div class=\"cell auto / c-date-slider__days__error\" ng-if=$ctrl.error> <p> An error has occurred trying to retrieve availability. </p> <button class=c-button ng-disabled=\"$ctrl.loadingService.isLoading('availability')\" ng-click=$ctrl.goToToday()> Return to Today </button> </div> <div class=\"cell auto / c-date-slider__days\" ng-if=!$ctrl.error> <div class=\"grid-x / c-date-slider__days__internal\"> <div class=\"cell / c-date-slider__day-container\" ng-repeat=\"day in $ctrl.setupDays()\"> <button class=c-date-slider__day ng-class=\"{'c-date-slider__day--selected': $ctrl.isDateSelected(day)}\" ng-click=$ctrl.selectDay(day) ng-disabled=!day.available> <div class=c-date-slider__day__name>{{ day.name }}</div> <div class=c-date-slider__day__number>{{ day.number }}</div> <div class=c-date-slider__day__price-old> <s> <money ng-if=$ctrl.displayOriginalPrice(day) amount=\"day.original_price * $ctrl.item.minimum_guests\" decorate=true> </money></s> </div> <div class=c-date-slider__day__price> <span ng-if=day.available> <money amount=\"day.price * $ctrl.item.minimum_guests\" decorate=true> </money></span> <span ng-if=!day.available>-</span> </div> <span class=c-date-slider__day__loading ng-if=\"$ctrl.loadingService.isLoading('availability')\"> <spinner></spinner> </span> </button> </div> <div class=\"cell / c-date-slider__day-container\" ng-repeat=\"i in [1,2,3,4,5,6,7]\" ng-if=\"$ctrl.loadingService.isLoading('availability')\"> <button class=c-date-slider__day disabled=disabled> <div class=c-date-slider__day__name>DAY</div> <div class=c-date-slider__day__number>00</div> <div class=c-date-slider__day__price>£00.00</div> <span class=c-date-slider__day__loading> <spinner></spinner> </span> </button> </div> </div> </div> <div class=\"cell shrink\"> <button class=\"c-date-slider__travel c-date-slider__travel--forward t-text--primary--background\" ng-click=$ctrl.nextAvailability() ng-disabled=\"!$ctrl.isNextDateValid('next')\"> <icon icon=chevron-right></icon> <span class=u-visuallyhidden>Next week</span> </button> </div> </div> </div> <div class=c-date-slider__no-edit ng-if=$ctrl.noEditAvailability> <p>Sorry, there is no availability for this during the dates of your booking.</p> </div> </div> ";

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'fullscreen': '<',
        'isOpen': '=',
        'eventType': '=',
        'query': '@'
    },
    controller: 'searchFormController',
    template: __webpack_require__(759)
};

/***/ }),
/* 759 */
/***/ (function(module, exports) {

module.exports = "<div class=c-search ng-class=\"{'is-open': $ctrl.isOpen, 'is-fullscreen': $ctrl.fullscreen}\"> <div class=c-search__container> <div class=c-search__inner> <form class=c-form ng-submit=$ctrl.submit()> <div class=c-search__fields> <select-type event-type=$ctrl.eventType ng-if=$ctrl.displaySelect()></select-type> <div class=c-form__field> <input type=search class=\"c-input / c-form__input\" ng-class=\"{'has-error': $ctrl.error}\" name=search placeholder=\"Search by name...\" aria-label=\"Search for events by name\" required ng-model=$ctrl.searchValue> </div> </div> <div class=text-center> <p class=c-error ng-if=$ctrl.error>{{ $ctrl.error }}</p> <button class=\"c-button / c-search__button c-button--icon\" ng-class=\"{'c-button--loading': $ctrl.loading}\" ng-disabled=$ctrl.loading> Search <span class=c-button__icon ng-if=$ctrl.loading> <span class=c-button__loading> <spinner></spinner> </span> </span> </button> </div> </form> </div> </div> <button class=c-search__close aria-label=\"Close search\" type=button ng-click=$ctrl.close()> <span aria-hidden=true>&times;</span> </button> </div> ";

/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'eventType': '=',
        'filter': '<',
        'displaySpaDays': '<'
    },
    controller: 'selectTypeController',
    template: __webpack_require__(761)
};

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-form__field c-form__field--select\" ng-if=$ctrl.displaySelect()> <select name=type class=\"select-type / c-form__select / c-select c-select--type\" ng-attr-data-grid-filter=\"{{ $ctrl.filter }}\" ng-model=$ctrl.eventType> <option value=* disabled=disabled>Select a type...</option> <option value=day ng-if=$ctrl.displaySpaDays>Spa Days</option> <option value=treatment>Treatments</option> </select> <label class=\"c-form__label t-text--secondary\" for=type>I'm looking for...</label> </div> ";

/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'quickBookController',
    template: __webpack_require__(763)
};

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x / c-quick\"> <div class=\"cell medium-1 large-2 xlarge-3\"></div> <div class=\"cell medium-10 large-8 xlarge-6\"> <div class=\"\" ng-if=$ctrl.isLoggedIn()> <div class=c-quick__filter ng-if=showFilters> <div class=\"grid-x grid-margin-x\"> <div class=\"cell auto\"> <button type=button ng-click=\"$ctrl.filter('treatments')\" class=\"c-button / c-quick__filter__button\" ng-class=\"{'c-button--hollow': !$ctrl.showTreatments}\"> Treatments <icon icon=tick class=c-quick__filter__button__icon ng-if=$ctrl.showTreatments></icon> </button> </div> <div class=\"cell auto\"> <button type=button ng-click=\"$ctrl.filter('spadays')\" class=\"c-button / c-quick__filter__button\" ng-class=\"{'c-button--hollow': !$ctrl.showSpaDays}\"> Spa Days <icon icon=tick class=c-quick__filter__button__icon ng-if=$ctrl.showSpaDays></icon> </button> </div> </div> <div class=\"grid-x grid-margin-x\"> <div class=\"cell auto\"> <select ng-model=$ctrl.filterCategory class=c-quick__filter__select ng-change=$ctrl.filter()> <option value=\"\">All Categories</option> <optgroup label=Treatments ng-if=$ctrl.showTreatments> <option ng-repeat=\"category in $ctrl.data.treatmentCategories\" value=\"{{ category.id }}\">{{ category.name }}</option> </optgroup> <optgroup label=\"Spa Days\" ng-if=$ctrl.showSpaDays> <option ng-repeat=\"category in $ctrl.data.spadayCategories\" value=\"{{ category.id }}\">{{ category.name }}</option> </optgroup> </select> </div> <div class=\"cell auto\"> <select ng-model=$ctrl.filterDuration class=c-quick__filter__select ng-change=$ctrl.filter()> <option value=\"\">All Durations</option> <optgroup label=Treatments ng-if=$ctrl.showTreatments> <option ng-repeat=\"duration in $ctrl.data.treatmentDurations\" value=\"{{ duration }}\">{{ duration }} minutes</option> </optgroup> <optgroup label=\"Spa Days\" ng-if=$ctrl.showSpaDays> <option ng-repeat=\"duration in $ctrl.data.spadayDurations\" value=\"{{ duration }}\">{{ duration.charAt(0).toUpperCase() + duration.slice(1) }} day</option> </optgroup> </select> </div> </div> </div> <div class=c-quick__search> <div class=grid-x> <div class=\"cell auto / c-quick__search__input\"> <ui-select class=c-quick__search__select ng-model=$ctrl.selectedEvent ng-disabled=$ctrl.isLoading() input-id=quick-search on-select=$ctrl.selectEvent($item) reset-search-input=false> <ui-select-match placeholder=\"{{ $ctrl.placeholder() }}\"> {{ $select.selected.name }} </ui-select-match> <ui-select-choices repeat=\"event.name as event in $ctrl.data.events | filter: { name: $select.search } track by $index\" group-by=$ctrl.groupEvents> <div ng-bind-html=\"event.name | highlight: $select.search\"></div> </ui-select-choices> <ui-select-no-choice> No events match that search term... </ui-select-no-choice> </ui-select> <div class=c-quick__no-events ng-if=$ctrl.noEvents> No events match those filters. <span ng-click=$ctrl.resetFilters()>Reset filters</span> </div> <spinner ng-if=\"$ctrl.isLoading('events')\" class=c-quick__search__spinner></spinner> </div> <div class=\"cell shrink\"> <button type=button ng-click=\"showFilters = !showFilters\" class=\"c-button--hollow c-quick__filter-toggle\" ng-class=\"{'is-active': showFilters}\"> <icon icon=filter large=true></icon> </button> </div> </div> </div> <div class=\"grid-x / c-quick__info\" ng-if=$ctrl.item> <div class=\"cell shrink\"> <a href=\"{{ $ctrl.displayUrl() }}\" target=_blank title=\"More details\"> <em>More information about this {{ $ctrl.item.type_display }}</em> <icon icon=info></icon> </a> </div> </div> <div class=c-quick__availability ng-show=$ctrl.item> <availability-slider availability=$ctrl.availability loading=\"$ctrl.isLoading('availability')\" item=$ctrl.item event-type=$ctrl.item.type_name get-quantity=$ctrl.getQuantity() staff=$ctrl.staff></availability-slider> <div class=\"grid-x grid-margin-x\"> <div class=\"cell medium-auto\"> <preferred-time class=c-preferred-time ng-if=$ctrl.item.available availability=$ctrl.availability loading=\"$ctrl.isLoading('availability')\" item=$ctrl.item get-quantity=$ctrl.getQuantity(numberOfGuests) reset-staff=$ctrl.resetStaff()></preferred-time> </div> <div class=\"cell medium-auto\" ng-if=$ctrl.canDisplayStaff()> <staff-picker guest=$ctrl.item staff=$ctrl.staff ng-if=$ctrl.displayStaff()></staff-picker> </div> </div> <button class=\"c-button c-button--wide c-quick__add\" ng-if=\"$ctrl.item && $ctrl.item.preferred_time\" ng-click=$ctrl.addToBasket() ng-disabled=$ctrl.buttonDisabled()>Add to basket <spinner ng-if=$ctrl.buttonDisabled()></spinner> </button> </div> </div> <div class=text-center ng-if=!$ctrl.isLoggedIn()> <p>Sorry, you must be logged in to quick book.</p> <a ng-click=$ctrl.login() class=c-button>Log In</a> <a href=/ class=\"c-button c-button--hollow\">Return to the homepage</a> </div> </div> <div class=\"cell medium-1 large-2 xlarge-3\"></div> </div> ";

/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$compile', function ($compile) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var requiredElement = $compile('<span ng-if="required" class="c-form__required"></span>')(scope);

      element.parent()[0].insertBefore(requiredElement[0], element[0]);

      attrs.$observe('required', function () {
        scope.required = attrs.required;
      });
    }
  };
}];

/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var formFieldErrorsDirective = function formFieldErrorsDirective($compile) {
  return {
    require: ['ngModel'],
    restrict: 'A',
    link: function link(scope, element, attrs, ctrls) {
      // Can't use a real isolate scope as it clashes with other directives that
      // require one on the same element
      var isolateScope = scope.$new();
      isolateScope.model = ctrls[0];
      isolateScope.form = ctrls[1];
      isolateScope.errors = [];

      isolateScope.model.$registerApiError = function (code) {
        code = 'api.' + code;
        isolateScope.errors.push(code);

        isolateScope.model.$setValidity(code, false);
      };

      isolateScope.model.$validators.apiValidate = function () {
        while (isolateScope.errors.length) {
          isolateScope.model.$setValidity(isolateScope.errors.shift(), true);
        }
        return true;
      };

      element.after($compile('\n        <div class="c-form__field__errors" ng-if="model.$touched || form.$submitted" ng-messages="model.$error">\n          <div ng-message="email" class="c-form__field__error">Please enter a valid email address</div>\n          <div ng-message="url" class="c-form__field__error">Please enter a valid URL</div>\n          <div ng-message="required" class="c-form__field__error">Please enter a value</div>\n          <div ng-message="passwordMatch" class="c-form__field__error">Password and confirmation do not match</div>\n          <div ng-message="api.validation.mimetypes" class="c-form__field__error">Please select a valid file type</div>\n          <div ng-message="pattern" class="c-form__field__error">Please enter a valid pattern</div>\n        </div>\n      ')(isolateScope));
    }
  };
};

formFieldErrorsDirective.$inject = ['$compile'];

exports.default = formFieldErrorsDirective;

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    return {
        restrict: 'E',
        link: function link(scope, elem, attrs) {
            elem.on('click', function (e) {
                if (attrs.disabled) {
                    e.preventDefault(); // prevent link click
                }
            });
        }
    };
}];

/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$timeout', function ($timeout) {
    var messageService = {};
    messageService.messages = [];
    messageService.show = false;

    messageService.success = function () {
        if (messageService.messages.length) {
            messageService.alerttype = 'alert--success';
            messageService.push();
        }
    };

    messageService.failure = function () {
        if (messageService.messages.length) {
            messageService.alerttype = 'alert--fail';
            messageService.push();
        }
    };

    messageService.push = function () {
        $timeout.cancel(messageService.cleartimer);
        $timeout(function () {
            return messageService.show = true;
        });
        messageService.cleartimer = $timeout(function () {
            return messageService.clear();
        }, 4000);
    };

    messageService.clear = function () {
        messageService.show = false;
        $timeout(function () {
            return messageService.messages = [];
        }, 300);
    };

    messageService.add = function (message) {
        if (!messageService.messages.length || messageService.messages.length === 1 && messageService.messages[0] !== message) {
            messageService.messages.push(message);
        }
    };

    return messageService;
}];

/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var endpoint = 'checkout/content';

exports.default = ['api', function (api) {
    return {
        getContent: function getContent(slug) {
            return api.get(endpoint + '/' + slug).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marked = __webpack_require__(770);

var marked = _interopRequireWildcard(_marked);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = ['$rootScope', function ($rootScope) {

  var translateText = function translateText(text, removeP) {
    if (text) {
      var returnText = marked.parse(text);

      if (removeP && returnText) {
        returnText = returnText.replace(new RegExp('<\/?p>', 'g'), '');
      }
      return returnText;
    }
  };

  return {
    translate: function translate(text) {
      var removeP = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      return translateText(text, removeP);
    },
    translatePure: function translatePure(text) {
      text ? marked.parse(text) : '';
    }
  };
}];

/***/ }),
/* 770 */,
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['configService', 'storeService', 'prompt', '$window', function (configService, storeService, prompt, $window) {
  var _this = this;

  var getConfig = function getConfig() {
    if (!_this.config) {
      _this.config = configService.get('login');
    }
  };

  var login = function login() {
    var passwordOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return new Promise(function (resolve) {
      if (!isLoggedIn()) {
        getConfig();
        removeReservationData();
        return prompt.openLoginPrompt('Log in', _this.config.text, passwordOnly).then(function (response) {
          resolve(response);
        });
      }

      resolve(true);
    });
  };

  var logout = function logout() {
    if (isLoggedIn()) {
      return new Promise(function (resolve) {
        return prompt.openLogoutPrompt('Log out').then(function (response) {
          resolve(response);
        });
      });
    }
  };

  var isLoggedIn = function isLoggedIn() {
    return !!storeService.get('client_id');
  };

  var isAllowed = function isAllowed() {
    getConfig();
    return !!_this.config.allowed && !storeService.get('reservation');
  };

  var isRequired = function isRequired() {
    getConfig();
    return !!_this.config.required;
  };

  var canRegister = function canRegister() {
    getConfig();
    return !!_this.config.canRegister;
  };

  var stopEditing = function stopEditing() {
    return new Promise(function (resolve) {
      if (isEditing()) {
        return prompt.openStopReservationPrompt('Logout').then(function (response) {
          resolve(response);
        });
      }

      resolve(true);
    });
  };

  var removeReservationData = function removeReservationData() {
    if (isEditing()) {
      storeService.remove('reservation');
      storeService.remove('client_name');
      storeService.remove('start_date');
      storeService.remove('end_date');

      $window.dispatchEvent(new CustomEvent('initCalendar'));
    }
  };

  var isEditing = function isEditing() {
    return !!storeService.get('reservation');
  };

  return {
    login: login,
    logout: logout,
    isLoggedIn: isLoggedIn,
    isAllowed: isAllowed,
    isRequired: isRequired,
    canRegister: canRegister,
    stopEditing: stopEditing,
    removeReservationData: removeReservationData,
    isEditing: isEditing
  };
}];

/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        getUrl: function getUrl(eventType, eventId) {
            return api.post('api/url', {
                type: eventType,
                eventId: eventId
            }).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        getAllEvents: function getAllEvents() {
            return api.get('api/events').then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['configService', function (configService) {
    var property = undefined;

    var get = function get(param) {
        if (!property) {
            property = configService.get('property');
        }

        return property[param];
    };

    return {
        get: get
    };
}];

/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _statusBanner = __webpack_require__(776);

var _statusBanner2 = _interopRequireDefault(_statusBanner);

var _eventTile = __webpack_require__(777);

var _eventTile2 = _interopRequireDefault(_eventTile);

var _logInOut = __webpack_require__(778);

var _logInOut2 = _interopRequireDefault(_logInOut);

var _stopEditing = __webpack_require__(779);

var _stopEditing2 = _interopRequireDefault(_stopEditing);

var _activityRow = __webpack_require__(780);

var _activityRow2 = _interopRequireDefault(_activityRow);

var _activityAdd = __webpack_require__(781);

var _activityAdd2 = _interopRequireDefault(_activityAdd);

var _guestInputModal = __webpack_require__(782);

var _guestInputModal2 = _interopRequireDefault(_guestInputModal);

var _statusBanner3 = __webpack_require__(783);

var _statusBanner4 = _interopRequireDefault(_statusBanner3);

var _eventTile3 = __webpack_require__(785);

var _eventTile4 = _interopRequireDefault(_eventTile3);

var _logInOut3 = __webpack_require__(787);

var _logInOut4 = _interopRequireDefault(_logInOut3);

var _logInOutMenu = __webpack_require__(789);

var _logInOutMenu2 = _interopRequireDefault(_logInOutMenu);

var _stopEditing3 = __webpack_require__(791);

var _stopEditing4 = _interopRequireDefault(_stopEditing3);

var _stopEditingMenu = __webpack_require__(793);

var _stopEditingMenu2 = _interopRequireDefault(_stopEditingMenu);

var _activityRow3 = __webpack_require__(795);

var _activityRow4 = _interopRequireDefault(_activityRow3);

var _activityAdd3 = __webpack_require__(797);

var _activityAdd4 = _interopRequireDefault(_activityAdd3);

var _guestInputModal3 = __webpack_require__(799);

var _guestInputModal4 = _interopRequireDefault(_guestInputModal3);

var _guestModal = __webpack_require__(801);

var _guestModal2 = _interopRequireDefault(_guestModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var widgetModule = angular.module('spabooker.widget', []).controller('statusBannerController', _statusBanner2.default).controller('eventTileController', _eventTile2.default).controller('logInOutController', _logInOut2.default).controller('stopEditingController', _stopEditing2.default).controller('activityRowController', _activityRow2.default).controller('activityAddController', _activityAdd2.default).controller('guestInputModalController', _guestInputModal2.default).component('statusBanner', _statusBanner4.default).component('eventTile', _eventTile4.default).component('logInOut', _logInOut4.default).component('logInOutMenu', _logInOutMenu2.default).component('stopEditing', _stopEditing4.default).component('stopEditingMenu', _stopEditingMenu2.default).component('activityRow', _activityRow4.default).component('activityAdd', _activityAdd4.default).component('guestInputModal', _guestInputModal4.default).factory('guestModalService', _guestModal2.default);
exports.default = widgetModule.name;

/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StatusBannerController = function () {
    function StatusBannerController() {
        _classCallCheck(this, StatusBannerController);
    }

    _createClass(StatusBannerController, [{
        key: 'shouldDisplay',
        value: function shouldDisplay() {
            return this.showOnlineBanner() || this.showPhoneBanner();
        }
    }, {
        key: 'itemType',
        value: function itemType() {
            return this.item && this.item.type;
        }
    }, {
        key: 'showPhoneBanner',
        value: function showPhoneBanner() {
            return this.type === 'phone' && (this.status === 'telephone booking' || this.item && this.item.phone_only);
        }
    }, {
        key: 'showOnlineBanner',
        value: function showOnlineBanner() {
            return this.type === undefined && this.status === 'online only';
        }
    }]);

    return StatusBannerController;
}();

StatusBannerController.$inject = [];

exports.default = StatusBannerController;

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventTileController = function () {
    function EventTileController(basket, $window) {
        _classCallCheck(this, EventTileController);

        this.basket = basket;
        this.$window = $window;
    }

    _createClass(EventTileController, [{
        key: 'url',
        value: function url() {
            var _this = this;

            this.basket.contents.suggested_event = this.event.type_name + ':' + this.event.id;

            this.setBasketOffer();

            return this.basket.submit().then(function () {
                return _this.travel();
            });
        }
    }, {
        key: 'setBasketOffer',
        value: function setBasketOffer() {
            if (this.event.offer && this.event.offer > 0) {
                this.basket.contents.store_offer = this.event.offer;
                return;
            }
            if (this.event.availability && this.event.availability.offer) {
                this.basket.contents.store_offer = this.event.availability.offer.id;
            }
        }
    }, {
        key: 'travel',
        value: function travel() {
            var typeName = this.type;
            switch (typeName) {
                case 'Spa Day':
                case 'SpaDay':
                    typeName = 'spa-day';
                    break;
                default:
                    typeName = typeName.toLowerCase();
                    break;
            }
            this.$window.location = '//' + this.basket.contents.property.slug + '.' + this.$window.config.domain + '/' + typeName + '/' + this.event.slug;
        }
    }, {
        key: 'displayOfferName',
        value: function displayOfferName() {
            return this.event && this.event.availability && this.event.availability.offer && this.event.availability.offer.name;
        }
    }, {
        key: 'shouldDisplayPrice',
        value: function shouldDisplayPrice() {
            return !!(this.event.availability && this.event.availability.price && !this.event.availability.phone_only);
        }
    }, {
        key: 'hasReducedPrice',
        value: function hasReducedPrice() {
            return this.event.availability.price !== this.event.availability.original_price;
        }
    }]);

    return EventTileController;
}();

EventTileController.$inject = ['basket', '$window'];

exports.default = EventTileController;

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogInOutController = function () {
    function LogInOutController($scope, storeService, loginoutService) {
        _classCallCheck(this, LogInOutController);

        this.storeService = storeService;
        this.loginoutService = loginoutService;
        this.$scope = $scope;
    }

    _createClass(LogInOutController, [{
        key: 'login',
        value: function login() {
            var _this = this;

            return this.loginoutService.login().then(function (response) {
                _this.maybeRequestAvailability({ response: response });
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            var _this2 = this;

            return this.loginoutService.logout().then(function (response) {
                _this2.guests = [];
                _this2.maybeRequestAvailability({ response: response }).then(function () {
                    _this2.$scope.$apply();
                });
            });
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            return this.loginoutService.isLoggedIn();
        }
    }, {
        key: 'isLoginAllowed',
        value: function isLoginAllowed() {
            return this.loginoutService.isAllowed();
        }
    }]);

    return LogInOutController;
}();

LogInOutController.$inject = ['$scope', 'storeService', 'loginoutService'];

exports.default = LogInOutController;

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StopEditingController = function () {
    function StopEditingController($window, storeService, loginoutService) {
        _classCallCheck(this, StopEditingController);

        this.$window = $window;
        this.storeService = storeService;
        this.loginoutService = loginoutService;
    }

    _createClass(StopEditingController, [{
        key: 'isEditing',
        value: function isEditing() {
            return !!this.storeService.get('reservation');
        }
    }, {
        key: 'stopEditing',
        value: function stopEditing() {
            var _this = this;

            return this.loginoutService.stopEditing().then(function (response) {
                _this.$window.dispatchEvent(new CustomEvent('initCalendar'));
                _this.guests = [];
                _this.maybeRequestAvailability({ response: response });
            });
        }
    }]);

    return StopEditingController;
}();

StopEditingController.$inject = ['$window', 'storeService', 'loginoutService'];

exports.default = StopEditingController;

/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActivityRowController = function () {
    function ActivityRowController(startTimeService, basket, addGuestService, guestModalService, loadingService) {
        _classCallCheck(this, ActivityRowController);

        this.startTimeService = startTimeService;
        this.basket = basket;
        this.addGuestService = addGuestService;
        this.guestModalService = guestModalService;
        this.loadingService = loadingService;
    }

    _createClass(ActivityRowController, [{
        key: '$onInit',
        value: function $onInit() {
            this.loading = true;
        }
    }, {
        key: 'isLoading',
        value: function isLoading() {
            if (this.loadingService.isLoading('availability')) {
                this.startTimes = undefined;
                return true;
            }
            this.getStartTimes();

            return this.loading;
        }
    }, {
        key: 'getStartTimes',
        value: function getStartTimes() {
            var _this = this;

            if (!this.loadingService.isLoading('availability')) {
                if (this.event.available) {
                    if (this.startTimes === undefined) {
                        this.updateIsotope();

                        this.loading = true;
                        this.startTimes = [];
                        this.event.type = 'activity';

                        return this.startTimeService.getStartTimes(this.event).then(function (response) {
                            var firstTime = (0, _lodash.head)(response);
                            if (firstTime && firstTime.end.search(_this.event.date) === -1) {
                                _this.startTimes = undefined;
                                _this.getStartTimes();
                                return;
                            }

                            _this.startTimes = _this.filterTimes(response);
                            _this.loading = false;

                            _this.updateIsotope();
                        });
                    }

                    return this.startTimes;
                }

                this.loading = false;
            }

            return [];
        }
    }, {
        key: 'displayTime',
        value: function displayTime(time) {
            return this.startTimeService.displayTime(time);
        }
    }, {
        key: 'displayDuration',
        value: function displayDuration(time) {
            if (time.end) {
                return (0, _moment2.default)(time.end.replace('T', ' ') + '+00:00').diff(this.event.date + ' ' + time.time + '+00:00', 'minutes') + ' minutes';
            }

            return '';
        }
    }, {
        key: 'displayQuantity',
        value: function displayQuantity(quantity) {
            var string = quantity + ' space';
            if (quantity !== 1) {
                string += 's';
            }

            return string;
        }
    }, {
        key: 'filterTimes',
        value: function filterTimes(startTimes) {
            if (startTimes) {
                startTimes = startTimes.filter(function (time) {
                    if (!time.quantity || time.quantity <= 0) {
                        return false;
                    }

                    return true;
                });
            }

            return startTimes;
        }
    }, {
        key: 'noStartTimes',
        value: function noStartTimes() {
            if (!this.isLoading()) {
                return !!(this.startTimes && this.startTimes.length === 0);
            }

            return false;
        }
    }, {
        key: 'toggleDisplayGuests',
        value: function toggleDisplayGuests(time) {
            this.addGuestService.setState({
                gender: time.gender,
                maximumGuests: time.quantity
            });

            if (time.gender) {
                var guests = this.addGuestService.getGuests();
                guests.forEach(function (guest) {
                    if (!guest.id) {
                        guest.gender = time.gender;
                    }
                });
                this.addGuestService.setState(guests, 'guests');
            }

            this.addGuestService.buildTitlesList();
            this.addGuestService.filterExistingGuests();

            this.guestModalService.setConfig({
                event: this.event,
                maximumGuests: time.quantity,
                gender: time.gender,
                time: time
            });

            this.guestModalService.show();
        }
    }]);

    return ActivityRowController;
}();

ActivityRowController.$inject = ['startTimeService', 'basket', 'addGuestService', 'guestModalService', 'loadingService'];

exports.default = ActivityRowController;

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ActivityAddController = function () {
    function ActivityAddController(basket, addGuestService, guestModalService, validateService, messageService) {
        _classCallCheck(this, ActivityAddController);

        this.basket = basket;
        this.addGuestService = addGuestService;
        this.guestModalService = guestModalService;
        this.validateService = validateService;
        this.messageService = messageService;
    }

    _createClass(ActivityAddController, [{
        key: 'addToBasket',
        value: function addToBasket() {
            var _this = this;

            if (!this.basket.saving && this.time.quantity > 0) {
                var item = this.event;
                item.type = 'Activity';
                item.preferred_time = this.time.time;
                item.end_date_time = this.time.end;
                item.gender = this.time.gender;

                var guests = this.addGuestService.getGuests();

                if (!this.validate(item, guests)) {
                    return;
                }

                return this.basket.addToBasket(guests, item).then(function () {
                    _this.guestModalService.hide();
                    _this.addGuestService.setState({
                        existingGuests: _this.basket.contents.guest_details,
                        guests: []
                    });
                    return _this.getAvailability(false);
                });
            }
        }
    }, {
        key: 'validate',
        value: function validate(item, guests) {
            var error = this.validateService.invalidItemOrGuests(item, guests);

            if (error) {
                this.messageService.add(error);
                this.messageService.failure();
                return false;
            }

            return true;
        }
    }, {
        key: 'isDisabled',
        value: function isDisabled() {
            return this.basket.saving || !this.time.quantity || this.time.quantity < 1;
        }
    }]);

    return ActivityAddController;
}();

ActivityAddController.$inject = ['basket', 'addGuestService', 'guestModalService', 'validateService', 'messageService'];

exports.default = ActivityAddController;

/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GuestInputModalController = function () {
    function GuestInputModalController(guestModalService, addGuestService, moneyService) {
        _classCallCheck(this, GuestInputModalController);

        this.guestModalService = guestModalService;
        this.addGuestService = addGuestService;
        this.moneyService = moneyService;
    }

    _createClass(GuestInputModalController, [{
        key: 'displayTotal',
        value: function displayTotal() {
            var price = this.guestModalService.getConfig('time').price;
            var guestCount = this.addGuestService.getGuests().length;
            return this.moneyService.reduce(price * guestCount, true);
        }
    }, {
        key: 'capitalizeType',
        value: function capitalizeType() {
            if (this.type) {
                return this.type;
            }

            var type = this.guestModalService.getConfig('event').type;
            if (type) {
                var words = type.split(' ');
                for (var index in words) {
                    var word = words[index];
                    words[index] = '' + word.charAt(0).toUpperCase() + word.slice(1);
                }
                this.type = words.join(' ').trim();
                return this.type;
            }
        }
    }, {
        key: 'displayName',
        value: function displayName() {
            return this.guestModalService.getConfig('event').name;
        }
    }]);

    return GuestInputModalController;
}();

GuestInputModalController.$inject = ['guestModalService', 'addGuestService', 'moneyService'];

exports.default = GuestInputModalController;

/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'status': '@',
        'number': '@',
        'item': '=',
        'type': '@'
    },
    controller: 'statusBannerController',
    template: __webpack_require__(784)
};

/***/ }),
/* 784 */
/***/ (function(module, exports) {

module.exports = "<div class=c-status-banner ng-if=$ctrl.shouldDisplay()> <div class=grid-x> <div class=\"cell shrink\"> <icon icon=info></icon> </div> <div class=\"cell auto\"> <div class=c-status-banner__phone ng-if=$ctrl.showPhoneBanner()> <h5>Telephone only</h5> <p ng-if=$ctrl.number>Please call us on <strong>{{ $ctrl.number }}</strong> to find out if we have any availability.</p> </div> <div class=c-status-banner__online ng-if=$ctrl.showOnlineBanner()> <h5>Online exclusive</h5> <p>This event is only bookable online.</p> </div> </div> </div> </div> ";

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'event': '<',
        'link': '<',
        'price': '<',
        'addClass': '@',
        'type': '@'
    },
    controller: 'eventTileController',
    template: __webpack_require__(786)
};

/***/ }),
/* 786 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-tile {{ $ctrl.addClass || '' }}\"> <div class=\"c-tile__offer / t-text--secondary--background\" ng-show=$ctrl.displayOfferName() ng-bind-html=$ctrl.displayOfferName()></div> <div class=\"c-tile__image imgix-fluid\" imgix-src=\"{{ $ctrl.event.image }}\" imgix-refresh> <div class=c-tile__price ng-if=$ctrl.shouldDisplayPrice()> From <s ng-if=$ctrl.hasReducedPrice()> <money amount=$ctrl.event.availability.original_price decorate=true round=true></money> </s> <money amount=$ctrl.event.availability.price decorate=true round=true></money> </div> </div> <div class=c-tile__content> <div class=c-tile__headings> <p class=c-tile__preheading> {{ $ctrl.event.primary_category_name || $ctrl.type }} </p> <h3 class=c-tile__heading>{{ $ctrl.event.name }}</h3> </div> </div> <div class=c-tile__overlay> <div class=c-tile__overlay__inner> <p>We are fully booked on this {{ $ctrl.event.type_name }}</p> <span class=c-button>Find alternative dates</span> </div> </div> <a ng-click=$ctrl.url() ng-if=\"$ctrl.link !== false\" class=c-tile__anchor><span>{{ 'View '+ $ctrl.tile.name }}</span></a> </div> ";

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'logInOutController',
    template: __webpack_require__(788)
};

/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports = "<div class=c-loginout ng-class=\"{'c-loginout--allowed': $ctrl.isLoginAllowed(), 'c-loginout--logged-in': $ctrl.isLoggedIn()}\"> <button class=\"c-loginout__action c-login / t-text--secondary--action\" ng-click=$ctrl.login()>Log in</button> <button class=\"c-loginout__action c-logout / t-text--secondary--action\" ng-click=$ctrl.logout()>Log out <span class=c-logout__tooltip>Logged in as: {{ $ctrl.storeService.get('client_name') }}</span> </button> </div> ";

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'logInOutController',
    template: __webpack_require__(790)
};

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports = "<li class=c-nav__list-item ng-if=\"$ctrl.isLoginAllowed() && !$ctrl.isLoggedIn()\"> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.login()>Log in</a> </li> <li ng-if=$ctrl.isLoggedIn()> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.logout()>Log out</a> <span class=c-nav__list-item__description>Logged in as: {{ $ctrl.storeService.get('client_name') }}</span> </li> ";

/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'stopEditingController',
    template: __webpack_require__(792)
};

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<div class=c-edit-reservation ng-if=$ctrl.isEditing()> <button class=\"c-loginout__action / t-text--secondary--action\" ng-click=$ctrl.stopEditing()>Logout</button> </div> ";

/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        guests: '=',
        maybeRequestAvailability: '&'
    },
    controller: 'stopEditingController',
    template: __webpack_require__(794)
};

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<li ng-if=$ctrl.isEditing()> <a class=\"c-nav__list-item__anchor / t-navigation-link\" ng-click=$ctrl.stopEditing()>Logout</a> </li> ";

/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'event': '<',
        'updateIsotope': '&'
    },
    controller: 'activityRowController',
    template: __webpack_require__(796)
};

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports = "<div class=\"js-grid__item / c-list__event c-list__event--activity / {{ $ctrl.event.categories }}\" ng-class=\"{'js-grid__item--not-available': !$ctrl.event.available}\" ng-value=$ctrl.event.base_price> <div class=grid-x ng-if=\"$ctrl.isLoading() || !$ctrl.isLoading() && $ctrl.event.available\"> <div class=cell> <h3><span class=\"c-list__event__name / js-grid__item__heading\">{{ $ctrl.event.name }}</span></h3> </div> <div class=cell> <div class=c-list__row> <spinner ng-if=$ctrl.isLoading() class=c-list__spinner></spinner> <div class=\"c-list__row__line / ng-cloak\" ng-if=!$ctrl.isLoading() ng-repeat=\"time in $ctrl.startTimes\"> <div class=grid-x> <div class=\"cell small-4 medium-auto\"> <div class=\"c-list__row__data / ng-cloak\">{{ $ctrl.displayTime(time.time) }}</div> </div> <div class=\"cell small-4 medium-auto\"> <div class=\"c-list__row__data / ng-cloak\">{{ $ctrl.displayDuration(time) }}</div> </div> <div class=\"cell small-4 medium-auto\" ng-if=\"time.quantity !== undefined\"> <div class=\"c-list__row__data / ng-cloak\">{{ $ctrl.displayQuantity(time.quantity) }}</div> </div> <div class=\"cell small-6 medium-auto\" ng-if=time.staff> <div class=\"c-list__row__data / ng-cloak\">with {{ time.staff }}</div> </div> <div class=\"cell small-6 medium-shrink\"> <div class=\"c-list__row__data / ng-cloak\"> <money amount=time.price decorate=true ng-if=\"time.price > 0\"></money> <span ng-if=\"time.price === 0\">FREE</span> </div> </div> <div class=\"cell medium-shrink\" ng-class=\"{'small-12': !!time.staff, 'small-6': !time.staff}\"> <button class=\"c-button c-button--hollow\" ng-click=$ctrl.toggleDisplayGuests(time)>Select Guests</button> </div> </div> </div> <div ng-if=$ctrl.noStartTimes() class=\"js-grid__item / c-empty c-empty--box ng-cloak\"> <p class=\"c-empty__message text-center\"> Sorry, there are no times available for the selected day </p> </div> </div> </div> </div> </div> ";

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'event': '<',
        'time': '<',
        'getAvailability': '&'
    },
    controller: 'activityAddController',
    template: __webpack_require__(798)
};

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports = "<div class=c-activity__add> <button type=button class=\"c-button c-button--icon\" ng-click=$ctrl.addToBasket() ng-disabled=$ctrl.isDisabled() ng-class=\"{\n            'c-button--loading': $ctrl.basket.saving\n        }\"> <span class=c-button__text>Add to Basket</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </span> </button> </div> ";

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        getAvailability: '&'
    },
    controller: 'guestInputModalController',
    template: __webpack_require__(800)
};

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-guests-modal ng-hide ng-cloak\" ng-show=$ctrl.guestModalService.getState()> <div class=c-guests-modal__window> <h2 class=c-guest__heading>Guest Details</h2> <p class=c-guest__info ng-bind-html=\"$ctrl.addGuestService.displayGuestQuantity($ctrl.capitalizeType(), 1, $ctrl.guestModalService.getConfig('maximumGuests'), $ctrl.guestModalService.getConfig('gender'))\"></p> <guest-addition minimum-guests=1 maximum-guests=\"$ctrl.guestModalService.getConfig('maximumGuests')\" gender=\"$ctrl.guestModalService.getConfig('gender')\"></guest-addition> </div> <div class=c-guests-modal__footer> <div class=grid-x> <div class=\"cell auto\"> <p class=\"c-guests-modal__name / show-for-large\" ng-bind-html=$ctrl.displayName()></p> </div> <div class=\"cell shrink\"> <div class=c-guests-modal__total ng-bind-html=$ctrl.displayTotal()></div> </div> <div class=\"cell shrink\"> <activity-add event=\"$ctrl.guestModalService.getConfig('event')\" time=\"$ctrl.guestModalService.getConfig('time')\" get-availability=$ctrl.getAvailability()></activity-add> </div> </div> </div> <div class=c-guests-modal__header> <div class=grid-x> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <button class=\"c-guests-modal__close / t-text--secondary--action--dark\" ng-click=$ctrl.guestModalService.hide() title=Close>&times; <span class=show-for-sr>Close</span></button> </div> </div> </div> </div> ";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [function () {
    var _this = this;

    this.showModal = false;
    this.config = {
        event: {},
        maximumGuests: undefined,
        gender: undefined,
        time: {}
    };

    var show = function show() {
        _this.showModal = true;
    };

    var hide = function hide() {
        _this.showModal = false;
    };

    var getState = function getState() {
        return _this.showModal;
    };

    var setConfig = function setConfig(config) {
        _this.config = config;
    };

    var getConfig = function getConfig() {
        var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (param) {
            return _this.config[param];
        }

        return _this.config;
    };

    return {
        show: show,
        hide: hide,
        getState: getState,
        setConfig: setConfig,
        getConfig: getConfig
    };
}];

/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _basketPopup = __webpack_require__(803);

var _basketPopup2 = _interopRequireDefault(_basketPopup);

var _basketPopup3 = __webpack_require__(804);

var _basketPopup4 = _interopRequireDefault(_basketPopup3);

var _basketPopup5 = __webpack_require__(805);

var _basketPopup6 = _interopRequireDefault(_basketPopup5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var popupModule = angular.module('spabooker.popup', []).controller('basketPopupController', _basketPopup2.default).factory('basketPopupService', _basketPopup4.default).component('basketPopup', _basketPopup6.default);

exports.default = popupModule.name;

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BasketPopupController = function () {
  function BasketPopupController(basketPopupService, basket, guestnameService) {
    _classCallCheck(this, BasketPopupController);

    this.basketPopupService = basketPopupService;
    this.basket = basket;
    this.nameService = guestnameService;
    this.item = null;
  }

  _createClass(BasketPopupController, [{
    key: 'reveal',
    value: function reveal() {
      if (this.basketPopupService.show) {
        this.item = this.basketPopupService.item;
        if (!this.guests) {
          this.guests = (0, _lodash.cloneDeep)(this.basketPopupService.guests);
        }

        return true;
      }

      this.item = null;
      this.guests = null;
      this.expiresAt = null;

      return false;
    }
  }, {
    key: 'formatName',
    value: function formatName(guest) {
      return this.item && this.nameService.format(guest);
    }
  }, {
    key: 'reducedPrice',
    value: function reducedPrice() {
      return this.item && this.item.item_summary.price.price !== this.item.item_summary.price.original_price;
    }
  }, {
    key: 'subtotal',
    value: function subtotal() {
      return this.item && this.item.item_summary.price.price * this.guests.length;
    }
  }]);

  return BasketPopupController;
}();

BasketPopupController.$inject = ['basketPopupService', 'basket', 'guestnameService'];

exports.default = BasketPopupController;

/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['$timeout', function ($timeout) {
    var basketPopup = {};
    basketPopup.item = undefined;
    basketPopup.guests = [];
    basketPopup.show = false;

    basketPopup.success = function (item, guests, expiresAt) {
        $timeout.cancel(basketPopup.fadeTimer);
        basketPopup.alerttype = 'alert--success';
        basketPopup.guests = guests;
        basketPopup.item = item;
        basketPopup.expiresAt = expiresAt;
        basketPopup.show = true;
    };

    basketPopup.failure = function (item) {
        $timeout.cancel(basketPopup.fadeTimer);
        basketPopup.alerttype = 'alert--fail';
        basketPopup.item = item;
        basketPopup.show = true;
    };

    basketPopup.remove = function () {
        basketPopup.show = false;

        basketPopup.fadeTimer = $timeout(function () {
            basketPopup.item = undefined;
            basketPopup.expiresAt = undefined;
        }, 500);
    };

    return basketPopup;
}];

/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        closable: '<'
    },
    controller: 'basketPopupController',
    template: __webpack_require__(806)
};

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-basket-popup {{ $ctrl.basketPopupService.alerttype }}\" ng-show=$ctrl.reveal()> <div class=c-basket-popup__status> <span ng-if=\"!$ctrl.basketPopupService.alerttype.includes('fail')\">Added to basket</span> </div> <expires-at date-time=$ctrl.basketPopupService.expiresAt></expires-at> <div ng-if=\"$ctrl.reveal() && !$ctrl.basketPopupService.alerttype.includes('fail')\"> <div class=c-basket-item> <div class=c-basket-item__header> <div class=grid-x> <div class=\"cell auto\"> <p class=c-basket-item__name ng-bind-html=$ctrl.item.item_summary.name></p> </div> <div class=\"cell shrink\"> <p class=\"c-basket-item__date c-event__date\"> <span class=c-event__day>{{ $ctrl.item.date.replace(' ','T') | date:'dd' }}</span> <span class=c-event__month>{{ $ctrl.item.date.replace(' ','T') | date:'MMM' }}</span> <span class=c-event__time>{{ $ctrl.item.preferred_time.substring(0, 5) }}</span> </p> </div> </div> <div ng-if=$ctrl.reveal() class=\"c-basket-item__background c-background c-background--overlay\" imgix-src=\"{{ $ctrl.item.item_summary.image_url }}\" imgix-refresh> </div> </div> </div> <div class=c-basket__guests> <div class=\"grid-x / c-basket__guest / c-guest\" ng-repeat=\"guest in $ctrl.guests\"> <div class=\"cell auto\"> <span class=c-guest__name>{{ $ctrl.formatName(guest) }}</span> </div> <div class=\"cell shrink / c-basket__guest__price\"> <s ng-if=$ctrl.reducedPrice()> <money amount=$ctrl.item.item_summary.price.original_price decorate=true> </money></s> <money amount=$ctrl.item.item_summary.price.price decorate=true></money> </div> </div> </div> <div class=c-basket__footer> <div class=c-basket__subtotal> <div class=grid-x> <div class=\"cell shrink\"> <span>Subtotal</span> </div> <div class=\"cell auto\"> <money amount=$ctrl.subtotal() decorate=true></money> </div> </div> </div> <div class=c-basket__total> <div class=grid-x> <div class=\"cell shrink\"> <span>Basket Total</span> </div> <div class=\"cell auto\"> <money amount=$ctrl.basket.contents.total decorate=true></money> </div> </div> </div> <div class=c-basket__actions> <div class=\"grid-x small-up-2\"> <div class=cell> <a href=/ class=c-action--secondary> <span ng-if=!$ctrl.basket.saving>Continue Shopping</span> <spinner ng-if=$ctrl.basket.saving></spinner> </a> </div> <div class=cell> <a class=c-button href=\"{{ '/checkout/'+$ctrl.basket.contents.first_step }}\">Go to checkout</a> </div> </div> </div> </div> </div> <div ng-if=\"$ctrl.basketPopupService.alerttype.includes('fail')\"> <div class=c-basket__icon> <icon icon=cross></icon> </div> <p class=c-basket-popup__message>Sorry, we couldn't add <em>{{ $ctrl.item.name }}</em> to your basket. <br>Please refresh the page and try again.</p> </div> <button ng-if=$ctrl.closable type=button class=close ng-click=$ctrl.basketPopupService.remove()>&times;</button> </div> ";

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkout = __webpack_require__(808);

var _checkout2 = _interopRequireDefault(_checkout);

var _payment = __webpack_require__(810);

var _payment2 = _interopRequireDefault(_payment);

var _checkout3 = __webpack_require__(811);

var _checkout4 = _interopRequireDefault(_checkout3);

var _customise = __webpack_require__(812);

var _customise2 = _interopRequireDefault(_customise);

var _options = __webpack_require__(813);

var _options2 = _interopRequireDefault(_options);

var _suggestions = __webpack_require__(814);

var _suggestions2 = _interopRequireDefault(_suggestions);

var _review = __webpack_require__(815);

var _review2 = _interopRequireDefault(_review);

var _steps = __webpack_require__(816);

var _steps2 = _interopRequireDefault(_steps);

var _navigation = __webpack_require__(817);

var _navigation2 = _interopRequireDefault(_navigation);

var _payment3 = __webpack_require__(818);

var _payment4 = _interopRequireDefault(_payment3);

var _checkout5 = __webpack_require__(820);

var _checkout6 = _interopRequireDefault(_checkout5);

var _customise3 = __webpack_require__(822);

var _customise4 = _interopRequireDefault(_customise3);

var _options3 = __webpack_require__(824);

var _options4 = _interopRequireDefault(_options3);

var _suggestions3 = __webpack_require__(826);

var _suggestions4 = _interopRequireDefault(_suggestions3);

var _review3 = __webpack_require__(828);

var _review4 = _interopRequireDefault(_review3);

var _steps3 = __webpack_require__(830);

var _steps4 = _interopRequireDefault(_steps3);

var _navigation3 = __webpack_require__(832);

var _navigation4 = _interopRequireDefault(_navigation3);

var _storePaymentErrors = __webpack_require__(834);

var _storePaymentErrors2 = _interopRequireDefault(_storePaymentErrors);

var _checkout7 = __webpack_require__(836);

var _checkout8 = _interopRequireDefault(_checkout7);

var _checkoutValidation = __webpack_require__(837);

var _checkoutValidation2 = _interopRequireDefault(_checkoutValidation);

var _optionExtras = __webpack_require__(838);

var _optionExtras2 = _interopRequireDefault(_optionExtras);

var _throttle = __webpack_require__(839);

var _throttle2 = _interopRequireDefault(_throttle);

var _upgrade = __webpack_require__(840);

var _upgrade2 = _interopRequireDefault(_upgrade);

var _suggestionsApi = __webpack_require__(841);

var _suggestionsApi2 = _interopRequireDefault(_suggestionsApi);

var _promoApi = __webpack_require__(842);

var _promoApi2 = _interopRequireDefault(_promoApi);

var _voucherApi = __webpack_require__(843);

var _voucherApi2 = _interopRequireDefault(_voucherApi);

var _navigation5 = __webpack_require__(844);

var _navigation6 = _interopRequireDefault(_navigation5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkoutModule = angular.module('spabooker.checkout', ['ngMask']).config(_checkout2.default).controller('paymentController', _payment2.default).controller('checkoutController', _checkout4.default).controller('customiseController', _customise2.default).controller('optionsController', _options2.default).controller('suggestionsController', _suggestions2.default).controller('reviewController', _review2.default).controller('stepsController', _steps2.default).controller('navigationController', _navigation2.default).component('payment', _payment4.default).component('checkout', _checkout6.default).component('customise', _customise4.default).component('options', _options4.default).component('suggestions', _suggestions4.default).component('review', _review4.default).component('steps', _steps4.default).component('navigation', _navigation4.default).component('storePaymentErrors', _storePaymentErrors2.default).factory('checkout', _checkout8.default).factory('checkoutValidationService', _checkoutValidation2.default).factory('optionExtrasService', _optionExtras2.default).factory('throttleService', _throttle2.default).factory('upgradeService', _upgrade2.default).factory('suggestionsApiService', _suggestionsApi2.default).factory('promoApiService', _promoApi2.default).factory('voucherApiService', _voucherApi2.default).factory('navigationService', _navigation6.default).run(['configService', 'paymentGatewayService', function (configService, paymentGatewayService) {
  var config = configService.get('gateways');

  if (paymentGatewayService && config) {
    paymentGatewayService.load(config);
  }
}]);
exports.default = checkoutModule.name;

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkout = __webpack_require__(809);

exports.default = ['$stateProvider', function ($stateProvider) {
    $stateProvider.state('checkout', {
        url: '/checkout',
        component: 'checkout',
        abstract: true
    }).state('checkout.credit', {
        url: '/credit',
        component: 'customise',
        resolve: {
            content: (0, _checkout.resolveContent)('checkoutdays')
        }
    }).state('checkout.customise', {
        url: '/customise',
        component: 'options',
        resolve: {
            content: (0, _checkout.resolveContent)('options')
        }
    }).state('checkout.suggestions', {
        url: '/suggestions',
        component: 'suggestions',
        resolve: {
            content: (0, _checkout.resolveContent)('suggestions')
        }
    }).state('checkout.payment', {
        url: '/payment',
        component: 'payment',
        resolve: {
            content: (0, _checkout.resolveContent)('payment')
        }
    }).state('checkout.review', {
        url: '/review',
        component: 'review',
        resolve: {
            content: (0, _checkout.resolveContent)('review')
        }
    }).state('checkout.confirmation', {
        url: '/confirmation',
        component: 'confirmation'
    });
}];

/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveContent = exports.resolveContent = function resolveContent(slug) {
  return ['contentService', function (contentService) {
    return contentService.getContent(slug).then(function (data) {
      return data;
    });
  }];
};

/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentController = function () {
  function PaymentController($scope, $window, $timeout, basket, order, checkout, configService, messageService, markdownService, storeService, guestnameService, checkoutValidationService, guestApi, navigationService) {
    _classCallCheck(this, PaymentController);

    this.$scope = $scope;
    this.$window = $window;
    this.$timeout = $timeout;
    this.basket = basket;
    this.order = order;
    this.checkout = checkout;
    this.config = configService;
    this.messageService = messageService;
    this.moment = _moment2.default;
    this.markdownService = markdownService;
    this.storeService = storeService;
    this.guestName = guestnameService;
    this.checkoutValidation = checkoutValidationService;
    this.guestApi = guestApi;
    this.navigationService = navigationService;
  }

  _createClass(PaymentController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      this.loading = true;
      this.form = {};
      this.showDiscountInputs = false;

      this.gateway = this.config.get('gateways');

      this.watchForErrors();

      return this.basket.promise.then(function () {
        if (!_this.basket.empty()) {
          return _this.order.generateOrder(_this.basket.contents.identity_code).then(function () {
            if (_this.order.contents.vouchers.length > 0 && _this.order.contents.vouchers[0] && _this.order.contents.vouchers[0].code) {
              _this.codetype = 'Voucher';
              _this.showDiscountInputs = true;
            } else if (_this.order.contents.promo_details) {
              _this.codetype = 'Promotional Code';
              _this.showDiscountInputs = true;
            }

            if (_this.order.contents.customer) {
              if (_this.order.contents.customer.marketing === 1) {
                _this.order.contents.customer.marketing = true;
              } else {
                _this.order.contents.customer.marketing = false;
              }
            }

            _this.checkout.setTokenCountdown();
            _this.setIntegrationGuestDetails();
            _this.generatePaymentRequestConfig();

            return true;
          }).catch(function () {
            _this.hasError = true;

            return false;
          }).then(function (response) {
            _this.checkout.setStepByName('payment');
            _this.loading = false;

            return response;
          });
        }
      });
    }
  }, {
    key: 'handlePaymentGatewayError',
    value: function handlePaymentGatewayError(error) {
      var _this2 = this;

      var report = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.checkout.error = error;
      this.checkout.scrollToError();
      this.basket.saving = false;
      this.checkout.saving = false;
      if (report && this.$window.Sentry) {
        this.$window.Sentry.withScope(function () {
          _this2.$window.Sentry.captureMessage(report + ': ' + _this2.order.contents.basket_identity_code);
        });
      }
    }
  }, {
    key: 'watchForErrors',
    value: function watchForErrors() {
      var _this3 = this;

      this.$scope.$watch(function () {
        return _this3.checkout.error;
      }, function (newVal) {
        if (newVal) {
          _this3.loading = false;
          _this3.hasError = true;
        }

        if (!newVal) {
          _this3.hasError = false;
        }
      });
    }
  }, {
    key: 'voucherType',
    value: function voucherType() {
      switch (this.codetype) {
        case 'Voucher':
          this.order.contents.promo_details = null;
          if (this.order.contents.vouchers.length < 1) {
            this.order.contents.vouchers = [{}];
          }
          break;

        case '':
        default:
          this.order.contents.vouchers = [];
          break;
      }
    }
  }, {
    key: 'getSetting',
    value: function getSetting(field) {
      if (this.content && this.content.settings && this.content.settings[field]) {
        return this.content.settings[field];
      }
    }
  }, {
    key: 'orderGenerated',
    value: function orderGenerated() {
      if (!this.loading && this.order.contents.basket_identity_code) {
        return true;
      }

      return false;
    }
  }, {
    key: 'paysafeTimestampInvalid',
    value: function paysafeTimestampInvalid() {
      return this.gateway && this.gateway.paysafe && !this.checkout.checkTimestamp();
    }
  }, {
    key: 'displayPaymentGatewayName',
    value: function displayPaymentGatewayName() {
      if (this.gateway) {
        if (this.gateway.stripe) {
          return 'Stripe';
        }

        if (this.gateway.paysafe) {
          return 'Paysafe';
        }
      }

      return null;
    }
  }, {
    key: 'displayPaymentFields',
    value: function displayPaymentFields() {
      return !this.checkout.checkTimestamp() && !!this.displayPaymentGatewayName() && this.order.contents.total > 0;
    }
  }, {
    key: 'setIntegrationGuestDetails',
    value: function setIntegrationGuestDetails() {
      var _this4 = this;

      this.integrationGuestDetails = [];
      var loggedInId = this.basket.contents.client_id;

      return this.guestApi.getLeadGuest(this.basket.contents.identity_code).then(function (leadGuest) {
        if (leadGuest) {
          _this4.createPaymentGuest(leadGuest, loggedInId);
        }
      }).catch(function () {
        //
      }).then(function () {
        _this4.basket.contents.guest_details.forEach(function (guest) {
          _this4.createPaymentGuest(guest, loggedInId);
        });

        _this4.integrationGuestDetails = (0, _lodash.uniqBy)(_this4.integrationGuestDetails.map(function (guest) {
          if (guest.integrationReference) {
            guest.integrationReference = parseInt(guest.integrationReference);
          }

          return guest;
        }), 'integrationReference');
      });
    }
  }, {
    key: 'createPaymentGuest',
    value: function createPaymentGuest(guest, loggedInId) {
      if (guest.integration_reference) {
        var paymentGuest = {
          id: guest.id,
          firstName: guest.first_name,
          lastName: guest.last_name,
          email: guest.email || '',
          phone: guest.phone || guest.homePhone || guest.mobilePhone || guest.workPhone || '',
          fullName: this.guestName.format(guest),
          integrationReference: guest.integration_reference
        };

        if (loggedInId && guest.integration_reference === loggedInId) {
          paymentGuest.loggedIn = true;
        }

        this.integrationGuestDetails.push(paymentGuest);
      }
    }
  }, {
    key: 'showPromoFields',
    value: function showPromoFields() {
      return this.showDiscountInputs && (this.codetype === 'Promotional Code' && this.getSetting('allow_promos') || !this.codetype && this.getSetting('allow_promos') && !this.displayVoucherInput());
    }
  }, {
    key: 'showVoucherFields',
    value: function showVoucherFields() {
      return this.showDiscountInputs && (this.codetype === 'Voucher' && this.displayVoucherInput() || !this.codetype && this.displayVoucherInput() && !this.getSetting('allow_promos'));
    }
  }, {
    key: 'showHideVoucher',
    value: function showHideVoucher() {
      if (!this.showDiscountInputs) {
        this.order.contents.vouchers = [];
        this.order.contents.promo_details = '';
        this.codetype = '';
      }

      if (this.showPromoFields()) {
        this.order.contents.vouchers = [];
      }

      if (this.showVoucherFields()) {
        this.order.contents.vouchers = [{}];
      }
    }
  }, {
    key: 'displayPaymentInformation',
    value: function displayPaymentInformation() {
      return this.displayPaymentGatewayName() && this.orderGenerated() && this.order.contents.total > 0;
    }
  }, {
    key: 'validatePromo',
    value: function validatePromo() {
      var _this5 = this;

      if (this.order.contents.promo_details) {
        this.$timeout.cancel(this.promoTimeout);
        return new Promise(function (resolve) {
          _this5.promoTimeout = _this5.$timeout(function () {
            _this5.promoSaving = true;
            return _this5.checkoutValidation.validatePromo(_this5.order).then(function (response) {
              _this5.discountFeedback = response;
            }).catch(function () {
              _this5.clearDiscount();
            }).then(function () {
              _this5.promoSaving = false;
              resolve();
            });
          }, 750);
        });
      }

      this.$timeout.cancel(this.promoTimeout);
      this.clearDiscount();
    }
  }, {
    key: 'validateVoucher',
    value: function validateVoucher() {
      var _this6 = this;

      this.discountFeedback = null;

      if (this.order.contents.vouchers && this.order.contents.vouchers[0].code) {
        this.voucherSaving = true;
        return this.checkoutValidation.validateVoucher(this.order).then(function (response) {
          _this6.discountFeedback = response;
        }).catch(function () {
          _this6.clearDiscount();
        }).then(function () {
          _this6.voucherSaving = false;
        });
      }

      this.clearDiscount();
    }
  }, {
    key: 'clearDiscount',
    value: function clearDiscount() {
      this.discountFeedback = null;
      this.order.contents.total = this.order.contents.original_total;
    }
  }, {
    key: 'hasDiscountFeedback',
    value: function hasDiscountFeedback() {
      return !!this.discountFeedback;
    }
  }, {
    key: 'displayDiscountInputs',
    value: function displayDiscountInputs() {
      return (this.displayVoucherInput() || this.getSetting('allow_promos')) && this.order.contents.original_total > 0;
    }
  }, {
    key: 'displayDiscountSelect',
    value: function displayDiscountSelect() {
      return this.displayVoucherInput() && this.getSetting('allow_promos') && this.order.contents.original_total > 0;
    }
  }, {
    key: 'displayVoucherInput',
    value: function displayVoucherInput() {
      return !!(this.getSetting('oevoucher') || this.getSetting('allow_gifted_vouchers'));
    }
  }, {
    key: 'alexanderPromo',
    value: function alexanderPromo() {
      return !!(this.getSetting('oevoucher') && this.getSetting('allow_promos'));
    }
  }, {
    key: 'displayPaymentRequestButton',
    value: function displayPaymentRequestButton() {
      return !!this.gateway.stripe && this.displayPaymentFields();
    }
  }, {
    key: 'generatePaymentRequestConfig',
    value: function generatePaymentRequestConfig() {
      this.paymentRequestConfig = {
        country: this.gateway.stripe.country.toUpperCase(),
        currency: this.order.contents.currency_code.toLowerCase(),
        amount: this.order.contents.total
      };
    }
  }, {
    key: 'handlePaymentButtonSuccess',
    value: function handlePaymentButtonSuccess(response) {
      this.order.contents.customer = response.customer;
      this.order.handleUpdateSuccess(response.token, response.timestamp, response.card);

      this.checkout.setTokenCountdown();

      return this.navigationService.next();
    }
  }]);

  return PaymentController;
}();

PaymentController.$inject = ['$scope', '$window', '$timeout', 'basket', 'order', 'checkout', 'configService', 'messageService', 'markdownService', 'storeService', 'guestnameService', 'checkoutValidationService', 'guestApi', 'navigationService'];

exports.default = PaymentController;

/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutController = function () {
    function CheckoutController($scope, checkout, basket) {
        _classCallCheck(this, CheckoutController);

        this.$scope = $scope;
        this.checkout = checkout;
        this.basket = basket;
    }

    _createClass(CheckoutController, [{
        key: '$onInit',
        value: function $onInit() {
            this.watchCheckoutError();
            this.watchBasketPaymentError();
            this.watchBasketContentsOption();
            this.watchBasketSubmitSuccess();
        }
    }, {
        key: 'watchCheckoutError',
        value: function watchCheckoutError() {
            var _this = this;

            this.$scope.$watch(function () {
                return _this.checkout.error;
            }, function (newVal, oldVal) {
                if (!newVal) {
                    _this.checkoutError = [];
                    _this.combineErrors();
                }
                if (newVal !== oldVal) {
                    _this.checkoutError = newVal;
                    _this.combineErrors();
                    _this.checkout.scrollToError();
                }
            }, true);
        }
    }, {
        key: 'watchBasketPaymentError',
        value: function watchBasketPaymentError() {
            var _this2 = this;

            this.$scope.$watch(function () {
                return _this2.basket.paymentErrors;
            }, function (newVal, oldVal) {
                _this2.basketPaymentError = {};
                if (!newVal) {
                    _this2.showPaymentError = false;
                    _this2.basketPaymentError = {};
                }
                if (newVal !== oldVal && newVal) {
                    newVal.forEach(function (error) {
                        return _this2.basketPaymentError[error] = true;
                    });
                    _this2.showPaymentError = true;
                    _this2.checkout.scrollToError();
                }
            }, true);
        }
    }, {
        key: 'watchBasketContentsOption',
        value: function watchBasketContentsOption() {
            var _this3 = this;

            this.$scope.$watch(function () {
                return _this3.basket.contents.option;
            }, function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    switch (newVal) {
                        case 'delete_orders':
                            _this3.checkout.invalidateOrder();
                            break;
                    }
                }
            }, true);
        }
    }, {
        key: 'watchBasketSubmitSuccess',
        value: function watchBasketSubmitSuccess() {
            var _this4 = this;

            this.$scope.$watch(function () {
                return _this4.basket.success;
            }, function (newVal, oldVal) {
                if (newVal && newVal === true) {
                    _this4.checkout.setSteps();
                }
            });
        }
    }, {
        key: 'combineErrors',
        value: function combineErrors() {
            if (this.checkoutError && this.checkoutError.length > 0) {
                this.totalErrors = this.checkoutError.filter(function (error) {
                    return !!error;
                });
                return;
            }
            this.totalErrors = undefined;
        }
    }]);

    return CheckoutController;
}();

CheckoutController.$inject = ['$scope', 'checkout', 'basket'];

exports.default = CheckoutController;

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(13);

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CustomiseController = function () {
    function CustomiseController($scope, basket, checkout, availabilityApiService, markdownService, checkoutValidationService, guestnameService) {
        _classCallCheck(this, CustomiseController);

        this.$scope = $scope;
        this.basket = basket;
        this.checkout = checkout;
        this.availabilityApiService = availabilityApiService;
        this.markdownService = markdownService;
        this.checkoutValidationService = checkoutValidationService;
        this.nameService = guestnameService;
    }

    _createClass(CustomiseController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            //For Alexander's purposes...
            this.autoExpand = true;

            this.spadays = {};
            this.availability = {};
            this.display = [];
            this.displayDropdown = null;
            this.unavailableDays = [];

            this.hasError = false;
            this.loading = true;
            this.basket.saving = true;
            this.dates = [];

            return this.basket.promise.then(function () {
                _this.dates = _this.basketDates();

                if (_this.dates.length) {
                    for (var key in _this.dates) {
                        _this.dates[key] = (0, _moment2.default)(_this.dates[key]).format('YYYY-MM-DD');
                    };
                    _this.dates = (0, _lodash.uniq)(_this.dates);

                    return _this.requestCreditListForDates().then(function () {
                        _this.populateSpaDays();
                    }).catch(function () {
                        _this.hasError = true;
                    }).then(function () {
                        _this.checkout.setStepByName('credit');
                        _this.stopLoading();
                        // In order to update the basket.saving
                        // value in other components, we need to
                        // force $rootScope to recheck everything...
                        _this.$scope.$apply();
                    });
                }

                _this.stopLoading();
            });
        }
    }, {
        key: 'requestCreditListForDates',
        value: function requestCreditListForDates() {
            var _this2 = this;

            var dateRequests = this.dates.map(function (date) {
                return _this2.availabilityApiService.requestCreditAvailabilityList(date).then(function (response) {
                    _this2.availability[date] = response;
                });
            });

            return Promise.all(dateRequests);
        }
    }, {
        key: 'stopLoading',
        value: function stopLoading() {
            this.loading = false;
            this.basket.saving = false;
        }
    }, {
        key: 'guestHasDays',
        value: function guestHasDays(guest) {
            if (guest.spaday > 0) {
                var days = (0, _lodash.filter)(guest.item_details, { item_type: 'App\\SpaDay' });
                if (days) {
                    var _iteratorNormalCompletion = true;
                    var _didIteratorError = false;
                    var _iteratorError = undefined;

                    try {
                        for (var _iterator = days[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                            var day = _step.value;

                            if (this.hasDayReference(day.reference)) {
                                return true;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return) {
                                _iterator.return();
                            }
                        } finally {
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
            return false;
        }
    }, {
        key: 'hasDayReference',
        value: function hasDayReference(reference) {
            return Object.keys(this.spadays).indexOf(reference) > -1;
        }
    }, {
        key: 'findDay',
        value: function findDay(reference) {
            return (0, _lodash.find)(this.spadays, { 'reference': reference });
        }
    }, {
        key: 'findDayTreatments',
        value: function findDayTreatments(reference) {
            var day = (0, _lodash.find)(this.spadays, { 'reference': reference });
            if (day) {
                return day.treatments;
            }
        }
    }, {
        key: 'addEvent',
        value: function addEvent(reference, treatment, guests) {
            if (guests || guests === 'all') {
                var original_guests = null;

                if (guests === 'all') {
                    original_guests = 'all';
                    guests = (0, _lodash.map)(this.referenceGuests(reference), 'id');
                }

                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                    for (var _iterator2 = guests[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                        var guestId = _step2.value;

                        var guest = (0, _lodash.find)(this.basket.contents.guest_details, { id: parseInt(guestId) });
                        if (guest) {
                            var day = (0, _lodash.find)(guest.item_details, { reference: reference });
                            if (day) {
                                var existingTreatment = this.hasEvent(day, treatment.id, false);
                                if (existingTreatment) {
                                    if (original_guests !== 'all') {
                                        if (day.item_children) {
                                            day.item_children.splice(existingTreatment, 1);
                                        }
                                        if (day.credit_state) {
                                            day.credit_state.splice(existingTreatment, 1);
                                        }
                                        if (this.spadays[reference].selected[treatment.id]) {
                                            this.spadays[reference].selected[treatment.id][guest.id] = false;
                                        }
                                    }
                                } else {
                                    treatment.type = 'Treatment';
                                    treatment.date = day.date;
                                    if (day.item_children) {
                                        day.item_children.push(this.basket.assignItem(treatment, this.basket.referenceGenerator()));
                                    }
                                    if (!this.spadays[reference].selected) {
                                        this.spadays[reference].selected = [];
                                    }
                                    if (!this.spadays[reference].selected[treatment.id]) {
                                        this.spadays[reference].selected[treatment.id] = [];
                                    }
                                    this.spadays[reference].selected[treatment.id][guest.id] = true;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return) {
                            _iterator2.return();
                        }
                    } finally {
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }

                this.displayDropdown = null;
                this.basket.submit('delete_orders');
            }
        }
    }, {
        key: 'addEventSelected',
        value: function addEventSelected(reference, treatment, guests) {
            if (guests && Object.keys(guests).length > 0) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                    for (var _iterator3 = this.basket.contents.guest_details[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                        var guest = _step3.value;

                        var day = (0, _lodash.find)(guest.item_details, { reference: reference });
                        if (day) {
                            var existingTreatment = this.hasEvent(day, treatment.id, false);
                            var treatmentSelection = guests[treatment.id];

                            if (treatmentSelection[guest.id] && treatmentSelection[guest.id] === true) {
                                if (!existingTreatment) {
                                    treatment.type = 'Treatment';
                                    treatment.date = day.date;
                                    day.item_children.push(this.basket.assignItem(treatment));
                                }
                            } else {
                                if (existingTreatment !== undefined) {
                                    day.item_children.splice(existingTreatment, 1);
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return) {
                            _iterator3.return();
                        }
                    } finally {
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }

                this.displayDropdown = null;
                this.basket.submit('delete_orders');
            }
        }
    }, {
        key: 'hasEvent',
        value: function hasEvent(guestDay, treatmentId) {
            var boolean = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

            var existing = (0, _lodash.findKey)(guestDay.item_children, { item_type: 'App\\Treatment', item_id: treatmentId });
            if (boolean) {
                return existing > -1;
            }
            return existing;
        }
    }, {
        key: 'guestHasEvent',
        value: function guestHasEvent(guestId, guestDay, treatmentId) {
            var guest = (0, _lodash.find)(this.basket.contents.guest_details, { 'id': guestId });
            if (guest) {
                var ref = guestDay.reference;
                var guestGuestDay = (0, _lodash.find)(guest.item_details, { 'reference': ref });
                if (guestGuestDay) {
                    return this.hasEvent(guestGuestDay, treatmentId);
                }
            }
            return false;
        }
    }, {
        key: 'switchVisible',
        value: function switchVisible(guestId, dayId) {
            var treatmentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var single = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            var id = guestId + '-' + dayId;
            if (treatmentId) {
                id += '-' + treatmentId;
            }
            if (single) {
                var existing = this.displayDropdown === id;
                if (existing) {
                    this.displayDropdown = null;
                } else {
                    this.displayDropdown = id;
                }
            } else {
                var _existing = this.display.indexOf(id);
                if (_existing > -1) {
                    if (this.display.length === 1) {
                        this.display = [];
                    } else {
                        this.display.splice(_existing, 1);
                    }
                } else {
                    this.display.push(id);
                }
            }
        }
    }, {
        key: 'isDisplayed',
        value: function isDisplayed(guestId, dayId) {
            var treatmentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var single = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            // Error override
            if (this.checkout.spadayError && this.checkout.spadayError.indexOf(dayId) > -1 && !treatmentId) {
                return true;
            }

            var id = guestId + '-' + dayId;
            if (treatmentId) {
                id += '-' + treatmentId;
            }
            if (single) {
                return this.displayDropdown === id;
            } else {
                return this.display.indexOf(id) > -1;
            }
        }
    }, {
        key: 'isDisplayedError',
        value: function isDisplayedError(dayId) {
            if (this.checkout.spadayError && this.checkout.spadayError.indexOf(dayId) > -1) {
                return true;
            }
            return false;
        }
    }, {
        key: 'referenceGuests',
        value: function referenceGuests(reference) {
            var guests = [];

            var _iteratorNormalCompletion4 = true;
            var _didIteratorError4 = false;
            var _iteratorError4 = undefined;

            try {
                for (var _iterator4 = this.basket.contents.guest_details[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var guest = _step4.value;

                    if ((0, _lodash.find)(guest.item_details, { 'reference': reference })) {
                        guests.push(guest);
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                        _iterator4.return();
                    }
                } finally {
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }

            return guests;
        }
    }, {
        key: 'treatmentsSelected',
        value: function treatmentsSelected(day) {
            var found = (0, _lodash.filter)(day.item_children, { item_type: 'App\\Treatment' });
            if (found) {
                return found.length;
            }
            return 0;
        }
    }, {
        key: 'noSpaDays',
        value: function noSpaDays() {
            if (!this.loading && Object.keys(this.spadays).length === 0) {
                return true;
            }
            return false;
        }
    }, {
        key: 'populateSpaDays',
        value: function populateSpaDays() {
            var _iteratorNormalCompletion5 = true;
            var _didIteratorError5 = false;
            var _iteratorError5 = undefined;

            try {
                for (var _iterator5 = this.basket.contents.guest_details[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                    var guest = _step5.value;
                    var _iteratorNormalCompletion6 = true;
                    var _didIteratorError6 = false;
                    var _iteratorError6 = undefined;

                    try {
                        for (var _iterator6 = (0, _lodash.filter)(guest.item_details, { 'item_type': 'App\\SpaDay' })[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                            var guestDay = _step6.value;

                            if (this.autoExpand) {
                                this.switchVisible(guest.id, guestDay.id);
                            }

                            this.addDayAndTreatments(guestDay);

                            this.reassignSelectedTreatments(guestDay, guest.id);
                        }
                    } catch (err) {
                        _didIteratorError6 = true;
                        _iteratorError6 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                _iterator6.return();
                            }
                        } finally {
                            if (_didIteratorError6) {
                                throw _iteratorError6;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion5 && _iterator5.return) {
                        _iterator5.return();
                    }
                } finally {
                    if (_didIteratorError5) {
                        throw _iteratorError5;
                    }
                }
            }

            this.updateValidation();
        }
    }, {
        key: 'addDayAndTreatments',
        value: function addDayAndTreatments(guestDay) {
            if (guestDay.item.treatments && guestDay.item.treatments.length && !this.spadays[guestDay.reference]) {
                this.buildDayByReference(guestDay);

                this.addCreditTreatmentsIfAvailable(guestDay);

                this.removeEmptyCategoriesAndDaysByReference(guestDay.reference);
            }
        }
    }, {
        key: 'buildDayByReference',
        value: function buildDayByReference(guestDay) {
            this.spadays[guestDay.reference] = (0, _lodash.cloneDeep)(guestDay);
            this.spadays[guestDay.reference].treatments = {};
            this.spadays[guestDay.reference].selected = [];
        }
    }, {
        key: 'addCreditTreatmentsIfAvailable',
        value: function addCreditTreatmentsIfAvailable(guestDay) {
            var _iteratorNormalCompletion7 = true;
            var _didIteratorError7 = false;
            var _iteratorError7 = undefined;

            try {
                for (var _iterator7 = this.availability[(0, _moment2.default)(guestDay.date).format('YYYY-MM-DD')][Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                    var treatment = _step7.value;

                    this.addSpaDayCategoryName(guestDay.reference, treatment.category_name);

                    if ((0, _lodash.find)(guestDay.item.treatments, { id: parseInt(treatment.id) }) && treatment.availability.available === true) {
                        this.spadays[guestDay.reference].treatments[treatment.category_name].push(treatment);
                    }
                }
            } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
                        _iterator7.return();
                    }
                } finally {
                    if (_didIteratorError7) {
                        throw _iteratorError7;
                    }
                }
            }
        }
    }, {
        key: 'addSpaDayCategoryName',
        value: function addSpaDayCategoryName(reference, categoryName) {
            if (!this.spadays[reference].treatments[categoryName]) {
                this.spadays[reference].treatments[categoryName] = [];
            }
        }
    }, {
        key: 'removeEmptyCategoriesAndDaysByReference',
        value: function removeEmptyCategoriesAndDaysByReference(reference) {
            var _this3 = this;

            (0, _lodash.forEach)(this.spadays[reference].treatments, function (value, key) {
                if (!value.length) {
                    delete _this3.spadays[reference].treatments[key];
                }
            });

            if ((0, _lodash.isEmpty)(this.spadays[reference].treatments)) {
                this.unavailableDays.push({ id: this.spadays[reference].id });
                delete this.spadays[reference];
            }
        }
    }, {
        key: 'reassignSelectedTreatments',
        value: function reassignSelectedTreatments(guestDay, guestId) {
            if (this.spadays[guestDay.reference]) {
                var _iteratorNormalCompletion8 = true;
                var _didIteratorError8 = false;
                var _iteratorError8 = undefined;

                try {

                    for (var _iterator8 = guestDay.item_children[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
                        var child = _step8.value;

                        if (!this.spadays[guestDay.reference].selected[child.item_summary.id]) {
                            this.spadays[guestDay.reference].selected[child.item_summary.id] = [];
                        }
                        this.spadays[guestDay.reference].selected[child.item_summary.id][guestId] = true;
                    }
                } catch (err) {
                    _didIteratorError8 = true;
                    _iteratorError8 = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion8 && _iterator8.return) {
                            _iterator8.return();
                        }
                    } finally {
                        if (_didIteratorError8) {
                            throw _iteratorError8;
                        }
                    }
                }
            }
        }
    }, {
        key: 'updateValidation',
        value: function updateValidation() {
            this.checkoutValidationService.additionalRequirements(this.unavailableDays);
        }
    }, {
        key: 'presentGuestName',
        value: function presentGuestName(guest) {
            return this.nameService.format(guest, true, 'Spa Day', guest.spaday);
        }
    }, {
        key: 'presentDate',
        value: function presentDate(date) {
            return (0, _moment2.default)(date).format('Do MMMM, YYYY');
        }
    }, {
        key: 'sumCredit',
        value: function sumCredit(children) {
            var total = 0;
            if (children.length) {
                children.forEach(function (child) {
                    if (child.item_type === 'App\\Treatment') {
                        total += child.credit_value;
                    }
                });
            }
            return total;
        }
    }, {
        key: 'basketDates',
        value: function basketDates() {
            var dates = [];

            if (!this.basket.contents || !this.basket.contents.guest_details || this.basket.contents.guest_details.length === 0) {
                return dates;
            }

            this.basket.contents.guest_details.forEach(function (guest) {
                guest.item_details.forEach(function (item) {
                    if (item.item_type === 'App\\SpaDay' && item.item && item.item.treatments && Object.keys(item.item.treatments).length > 0 && (0, _moment2.default)(item.date).isValid()) {
                        dates.push(item.date);
                    }
                });
            });

            return dates;
        }
    }]);

    return CustomiseController;
}();

CustomiseController.$inject = ['$scope', 'basket', 'checkout', 'availabilityApiService', 'markdownService', 'checkoutValidationService', 'guestnameService'];

exports.default = CustomiseController;

/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OptionsController = function () {
    function OptionsController(basket, checkout, optionExtrasService, markdownService, guestnameService, messageService) {
        _classCallCheck(this, OptionsController);

        this.basket = basket;
        this.checkout = checkout;
        this.optionExtrasService = optionExtrasService;
        this.markdownService = markdownService;
        this.guestnameService = guestnameService;
        this.messageService = messageService;
    }

    _createClass(OptionsController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.hasOptions = false;
            this.optionsLoading = true;
            this.display = [];
            this.displayDropdown = null;
            this.optionExtras = {
                'SpaDay': {},
                'Treatment': {}
            };

            return this.basket.promise.then(function () {
                _this.transformCurrentOptions();
                _this.getOptionsAndExtras();
                _this.checkout.setStepByName('customise');
            });
        }
    }, {
        key: 'getOptionsAndExtras',
        value: function getOptionsAndExtras() {
            var _this2 = this;

            this.basket.saving = true;

            return this.basket.promise.then(function () {
                return Promise.all([_this2.collectOptions(), _this2.collectExtras()]);
            });
        }
    }, {
        key: 'collectOptions',
        value: function collectOptions() {
            var _this3 = this;

            return this.optionExtrasService.collectOptions(this.optionExtras).then(function (response) {
                if (Object.keys(response.Treatment).length > 0 || Object.keys(response.SpaDay).length > 0) {
                    _this3.hasOptions = true;
                }

                _this3.checkout.options = response;
                _this3.optionsLoading = false;
                _this3.basket.saving = false;
            });
        }
    }, {
        key: 'collectExtras',
        value: function collectExtras() {
            var _this4 = this;

            return this.optionExtrasService.collectExtras(this.optionExtras).then(function (response) {
                if (Object.keys(response.Treatment).length > 0 || Object.keys(response.SpaDay).length > 0) {
                    _this4.hasOptions = true;
                }

                _this4.checkout.extras = response;
                _this4.optionsLoading = false;
                _this4.basket.saving = false;
            });
        }
    }, {
        key: 'guestHasChoices',
        value: function guestHasChoices(guest) {
            var _this5 = this;

            var hasOptions = false;

            var _loop = function _loop(item) {
                if (_this5.eventHasChoices(item, guest.id)) {
                    item.requiredOptions = 0;
                    if (_this5.checkout.options && _this5.checkout.options[item.item_summary.type_name] && _this5.checkout.options[item.item_summary.type_name][item.item_summary.id] && _this5.checkout.options[item.item_summary.type_name][item.item_summary.id].OptionGroupOption) {
                        _this5.checkout.options[item.item_summary.type_name][item.item_summary.id].OptionGroupOption.forEach(function (group) {
                            item.requiredOptions += group.selections;
                        });
                    }
                    hasOptions = true;
                }
            };

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = guest.item_details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var item = _step.value;

                    _loop(item);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return hasOptions;
        }
    }, {
        key: 'eventHasChoices',
        value: function eventHasChoices(event) {
            if (this.checkout.options && Object.keys(this.checkout.options[event.item_summary.type_name]).indexOf(event.item_summary.id.toString()) > -1 || this.checkout.extras && Object.keys(this.checkout.extras[event.item_summary.type_name]).indexOf(event.item_summary.id.toString()) > -1) {
                return true;
            }

            return false;
        }
    }, {
        key: 'addOption',
        value: function addOption(guest, event, optionGroup, option) {
            var doSubmit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;

            var guestEvent = guest.item_details.find(function (item) {
                return item.reference === event.reference;
            });

            if (!this.hasOption(guestEvent, option)) {
                if (guestEvent.item_children && optionGroup.selections === 1) {
                    this.removeExistingOption(guestEvent, option);
                }

                if (this.countSelectedOptions(guest, event, optionGroup) < optionGroup.selections) {
                    option.date = guestEvent.date;
                    guestEvent.item_children.push(this.basket.assignItem(option));

                    if (doSubmit) {
                        return this.submitBasket();
                    }

                    return;
                }

                this.messageService.add('Maximum selections chosen');
                this.messageService.failure();
                return;
            }

            this.removeExistingOption(guestEvent, option, true);

            if (doSubmit) {
                return this.submitBasket();
            }
        }
    }, {
        key: 'removeExistingOption',
        value: function removeExistingOption(guestEvent, option) {
            var findOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            var existingOption = this.findOptionIndex(guestEvent, option, findOption);

            if (existingOption > -1) {
                guestEvent.item_children.splice(existingOption, 1);

                if (guestEvent.credit_state) {
                    guestEvent.credit_state.splice(existingOption, 1);
                }
            }
        }
    }, {
        key: 'hasOption',
        value: function hasOption(guestEvent, option) {
            return this.findOptionIndex(guestEvent, option, true) > -1;
        }
    }, {
        key: 'guestHasOption',
        value: function guestHasOption(guest, option) {
            var _this6 = this;

            return !!guest.item_details.find(function (item) {
                return _this6.hasOption(item, option);
            });
        }
    }, {
        key: 'findOptionIndex',
        value: function findOptionIndex(guestEvent, option) {
            var findOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

            return guestEvent.item_children.findIndex(function (child) {
                if (child.item_type !== 'App\\OptionGroupOption') {
                    return false;
                }

                if (findOption) {
                    if (child.item_summary) {
                        return child.item_summary.id === option.id;
                    }
                    return child.item_id === option.id;
                }
                return !!(child.item && child.item.option_group_id === parseInt(option.group_id));
            });
        }
    }, {
        key: 'hasExtra',
        value: function hasExtra(guest, event, extra) {
            var boolean = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            if (guest) {
                var item = guest.item_details.find(function (item) {
                    return item.reference === event.reference;
                });
                var foundExtra = item.item_children.findIndex(function (child) {
                    return child.item_type === 'App\\EventExtra' && child.item_id === extra.id;
                });

                if (boolean) {
                    return foundExtra > -1;
                }

                return foundExtra;
            }
        }
    }, {
        key: 'addExtra',
        value: function addExtra(guest, event, extra) {
            var doSubmit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

            var guestEvent = guest.item_details.find(function (item) {
                return item.reference === event.reference;
            });

            var existingExtra = this.hasExtra(guest, guestEvent, extra, false);
            if (existingExtra > -1) {
                guestEvent.item_children.splice(existingExtra, 1);
            } else {
                extra.type = extra.type_name;
                guestEvent.item_children.push(this.basket.assignItem(extra));
            }

            if (doSubmit) {
                return this.submitBasket();
            }
        }
    }, {
        key: 'submitBasket',
        value: function submitBasket() {
            var _this7 = this;

            var basketOption = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'delete_orders';

            this.ignoreFeatured = true;
            return this.basket.submit(basketOption).then(function () {
                _this7.displayDropdown = null;
            });
        }
    }, {
        key: 'switchVisible',
        value: function switchVisible(guestId, type) {
            var eventId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var single = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            var visibleId = guestId + '-' + type;
            if (eventId) {
                visibleId += '-' + eventId;
            }
            if (group) {
                visibleId += '-' + group;
            }
            if (single) {
                if (this.displayDropdown === visibleId) {
                    this.displayDropdown = null;
                    return;
                }
                this.displayDropdown = visibleId;
                return;
            }

            var existing = this.display.indexOf(visibleId);
            if (existing > -1) {
                if (this.display.length === 1) {
                    this.display = [];
                    return;
                }
                this.display.splice(existing, 1);
                return;
            }

            this.display.push(visibleId);
        }
    }, {
        key: 'switchVisibleOn',
        value: function switchVisibleOn(guestId, type, eventId, group) {
            if (!this.ignoreFeatured) {
                var visibleId = guestId + '-' + type + '-' + eventId + '-' + group;
                if (this.display.indexOf(visibleId) === -1) {
                    this.display.push(visibleId);
                }
            }
        }
    }, {
        key: 'isDisplayed',
        value: function isDisplayed(guestId, type) {
            var eventId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
            var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
            var single = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

            // Error override
            if (this.checkout.optionError && group === 'options' && single === null) {
                return false;
            }

            var visibleId = guestId + '-' + type;
            if (eventId) {
                visibleId += '-' + eventId;
            }
            if (group) {
                visibleId += '-' + group;
            }
            if (single) {
                return this.displayDropdown === visibleId;
            }

            return this.display.indexOf(visibleId) > -1;
        }
    }, {
        key: 'referenceGuests',
        value: function referenceGuests(reference) {
            return this.basket.contents.guest_details.filter(function (guest) {
                return guest.item_details.some(function (guest) {
                    return guest.reference === reference;
                });
            });
        }
    }, {
        key: 'countSelected',
        value: function countSelected(event, type) {
            switch (type) {
                case 'option':
                    if (event.item_children) {
                        return event.item_children.filter(function (child) {
                            return child.item_type === 'App\\OptionGroupOption';
                        }).length;
                    }
                    break;

                case 'extra-free':
                    if (event.item_children) {
                        return event.item_children.filter(function (child) {
                            var price = child.price;

                            if (child.item_summary) {
                                price = child.item_summary.price;
                            }

                            price = parseInt(price.price);
                            return child.item_type === 'App\\EventExtra' && price === 0;
                        }).length;
                    }
                    break;

                case 'extra-paid':
                    if (event.item_children) {
                        return event.item_children.filter(function (child) {
                            var price = child.price;

                            if (child.item_summary) {
                                price = child.item_summary.price;
                            }

                            price = parseInt(price.price);
                            return child.item_type === 'App\\EventExtra' && price > 0;
                        }).length;
                    }
                    break;
            }

            return 0;
        }
    }, {
        key: 'countMaximum',
        value: function countMaximum(eventType, id, choiceType) {
            var choiceId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

            if (this.checkout.options && this.checkout.options[eventType] && this.checkout.options[eventType][id] && this.checkout.options[eventType][id][choiceType]) {
                var number = void 0;
                switch (choiceType) {
                    case 'OptionGroupOption':
                        number = this.checkout.options[eventType][id][choiceType].reduce(function (accumulator, choice) {
                            return accumulator + choice.selections;
                        }, 0);
                        break;
                    default:
                        number = this.checkout.options[eventType][id][choiceType].length;
                        break;
                }
                return '/' + number;
            }
        }
    }, {
        key: 'selectedMaximum',
        value: function selectedMaximum(chosen, maximum) {
            if (this.checkout.optionError) {
                if ('/' + chosen === maximum) {
                    return true;
                }
                return false;
            }
            return true;
        }
    }, {
        key: 'markdown',
        value: function markdown(text) {
            return this.markdownService.translate(text);
        }
    }, {
        key: 'presentGuest',
        value: function presentGuest(guest) {
            return this.guestnameService.format(guest, true, 'experience', guest.item_count);
        }
    }, {
        key: 'transformCurrentOptions',
        value: function transformCurrentOptions() {
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = this.basket.contents.guest_details[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var guest = _step2.value;
                    var _iteratorNormalCompletion3 = true;
                    var _didIteratorError3 = false;
                    var _iteratorError3 = undefined;

                    try {

                        for (var _iterator3 = guest.item_details[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                            var event = _step3.value;


                            if (Object.keys(this.optionExtras[event.item_summary.type_name]).indexOf(event.item_id) === -1) {
                                this.optionExtras[event.item_summary.type_name][event.item_id] = event.item_summary.id;
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally {
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                _iterator3.return();
                            }
                        } finally {
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
        }
    }, {
        key: 'presentDate',
        value: function presentDate(date) {
            return (0, _moment2.default)(date).format('Do MMMM, YYYY');
        }
    }, {
        key: 'guestHasChildTreatment',
        value: function guestHasChildTreatment(extra, guest) {
            return guest.item_details.find(function (item) {
                if (item.item_children) {
                    return item.item_children.find(function (itemChild) {
                        return itemChild.item_type === 'App\\Treatment' && itemChild.item_id === extra.treatment_id;
                    });
                }
            });
        }
    }, {
        key: 'hasDescription',
        value: function hasDescription(extra) {
            return !!(extra.description && extra.description !== 'null');
        }
    }, {
        key: 'displayDescription',
        value: function displayDescription(description) {
            if (description === 'null') {
                return '';
            }

            return this.markdown(description);
        }
    }, {
        key: 'countSelectedOptions',
        value: function countSelectedOptions(guest, event, optionGroup) {
            var count = 0;
            var guestEvent = guest.item_details.find(function (item) {
                return item.reference === event.reference;
            });

            if (guestEvent) {
                count = guestEvent.item_children.filter(function (child) {
                    return child.item_type === 'App\\OptionGroupOption' && child.item && child.item.option_group_id === optionGroup.id;
                }).length;
            }

            return count;
        }
    }]);

    return OptionsController;
}();

OptionsController.$inject = ['basket', 'checkout', 'optionExtrasService', 'markdownService', 'guestnameService', 'messageService'];

exports.default = OptionsController;

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SuggestionsController = function () {
    function SuggestionsController(markdownService) {
        _classCallCheck(this, SuggestionsController);

        this.markdownService = markdownService;
    }

    _createClass(SuggestionsController, [{
        key: 'markdown',
        value: function markdown(string) {
            return this.markdownService.translate(string);
        }
    }]);

    return SuggestionsController;
}();

SuggestionsController.$inject = ['markdownService'];

exports.default = SuggestionsController;

/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReviewController = function () {
    function ReviewController($scope, checkout, basket, markdownService, configService, loginoutService) {
        _classCallCheck(this, ReviewController);

        this.$scope = $scope;
        this.checkout = checkout;
        this.basket = basket;
        this.moment = _moment2.default;
        this.markdownService = markdownService;
        this.config = configService;
        this.loginoutService = loginoutService;
    }

    _createClass(ReviewController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.loading = true;

            return this.basket.promise.then(function () {
                if (_this.getSetting('cancellation_agreement') && _this.getSetting('cancellation_agreement_duration') > 0) {
                    _this.basketWithinAgreementWindow = _this.moment(_this.basket.earliestDate()).diff(_this.moment().add(_this.getSetting('cancellation_agreement_duration'), 'hours')) < 0;
                    if (_this.basketWithinAgreementWindow) {
                        _this.basket.contents.cancellation_agreement = false;
                    }
                }

                _this.isFirstStep = _this.basket.contents.first_step === 'review';
                _this.checkout.setStepByName('review');
                _this.loading = false;
                _this.checkout.saving = false;
            });
        }
    }, {
        key: 'getSetting',
        value: function getSetting(field) {
            if (this.content && this.content.settings && this.content.settings[field]) {
                return this.content.settings[field];
            }
        }
    }, {
        key: 'paymentGateway',
        value: function paymentGateway(gateway) {
            return this.config.get('gateways')[gateway];
        }
    }, {
        key: 'isEditing',
        value: function isEditing() {
            return this.loginoutService.isEditing();
        }
    }]);

    return ReviewController;
}();

ReviewController.$inject = ['$scope', 'checkout', 'basket', 'markdownService', 'configService', 'loginoutService'];

exports.default = ReviewController;

/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StepsController = function () {
    function StepsController($scope, checkout) {
        _classCallCheck(this, StepsController);

        this.$scope = $scope;
        this.checkout = checkout;
    }

    _createClass(StepsController, [{
        key: 'travel',
        value: function travel(index, step) {
            if (index <= this.checkout.laststep) {
                this.checkout.step = step;
                return this.checkout.travel();
            }
        }
    }]);

    return StepsController;
}();

StepsController.$inject = ['$scope', 'checkout'];

exports.default = StepsController;

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NavigationController = function () {
  function NavigationController(navigationService, checkout, basket) {
    _classCallCheck(this, NavigationController);

    this.navigationService = navigationService;
    this.checkout = checkout;
    this.basket = basket;
  }

  _createClass(NavigationController, [{
    key: 'next',
    value: function next() {
      return this.navigationService.next();
    }
  }, {
    key: 'nextDisabled',
    value: function nextDisabled() {
      if (this.basket.empty() || this.checkout.saving || this.basket.saving || !this.basket.hasLoaded) {
        return true;
      }

      return false;
    }
  }]);

  return NavigationController;
}();

NavigationController.$inject = ['navigationService', 'checkout', 'basket'];

exports.default = NavigationController;

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'paymentController',
    template: __webpack_require__(819)
};

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports = "<div class=c-payment__description> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdownService.translate($ctrl.content.body.text)></span> <hr/> </div> <div class=c-payment__loading ng-if=$ctrl.loading> <spinner></spinner> </div> <div class=\"c-payment c-payment--error\" ng-if=\"!$ctrl.orderGenerated() && $ctrl.hasError\"> <h3 class=c-payment__heading>Error</h3> <div class=\"grid-x grid-padding-x\"> <div class=cell> <p> Sorry, there was an error generating your order. Please refresh the page and try again. If this error persists, please contact us to complete your booking. </p> </div> </div> </div> <div class=\"c-payment c-payment--paysafe\" ng-show=$ctrl.orderGenerated()> <div class=c-basket__overlay ng-class=\"{ 'is-active': $ctrl.basket.saving }\"> <spinner></spinner> </div> <form name=$ctrl.form> <h3 class=c-payment__heading ng-if=$ctrl.gateway.none>Order details</h3> <h3 class=c-payment__heading ng-if=!$ctrl.gateway.none> Payment details </h3> <div class=\"cell medium-12\"> <div class=outcome> {{$ctrl.error}} </div> </div> <fieldset> <customer-details model=$ctrl.order.contents.customer property-name=$ctrl.basket.contents.property.name existing-details=$ctrl.integrationGuestDetails></customer-details> <billing-details model=$ctrl.order.contents ng-show=$ctrl.paysafeTimestampInvalid()></billing-details> <div class=\"grid-x grid-padding-x\" ng-show=\"$ctrl.order.contents.payment_token && $ctrl.checkout.timestampDiff() <= 0\"> <div class=cell> <p class=c-payment__warning> Your encrypted card details have timed out. Please re-enter your card details below to complete this transaction. </p> </div> </div> <div ng-show=\"$ctrl.checkout.checkTimestamp() && !$ctrl.checkout.saving\"> <div class=\"grid-x grid-padding-x\"> <div class=cell> <p class=c-payment__token-valid> Your payment details are still valid for <strong>{{ $ctrl.checkout.timestampRemaining }}</strong>. <br/>If you do not complete your order within that time you will need to re-enter your card details. </p> </div> </div> <div class=\"grid-x grid-padding-x\"> <div class=cell> <hr/> </div> </div> </div> <payment-details ng-show=$ctrl.displayPaymentFields() gateway=$ctrl.gateway error-callback=$ctrl.handlePaymentGatewayError(error) total-amount=$ctrl.checkout.grandTotal()> </payment-details> <div class=c-payment__vouchers ng-if=$ctrl.displayDiscountInputs()> <div class=\"grid-x grid-padding-x\"> <div class=cell> <label for=voucherDropdown class=c-payment__marketing> <input type=checkbox id=voucherDropdown ng-model=$ctrl.showDiscountInputs ng-change=$ctrl.showHideVoucher() /> <span ng-if=!$ctrl.alexanderPromo()> Enter a <span ng-if=$ctrl.displayVoucherInput()>gift voucher</span> <span ng-if=$ctrl.displayDiscountSelect()> or </span> <span ng-if=\"$ctrl.getSetting('allow_promos')\"> promotional </span> code. </span> <span ng-if=$ctrl.alexanderPromo()>Enter a gift voucher number or promotional code</span> </label> </div> </div> <div class=\"grid-x grid-padding-x\" ng-show=$ctrl.showDiscountInputs> <div class=\"cell small-12\" ng-if=$ctrl.hasDiscountFeedback()> <div class=\"c-promo__feedback {{ $ctrl.discountFeedback.class }}\"> <p ng-bind-html=$ctrl.discountFeedback.text></p> </div> </div> <div class=\"cell medium-6\" ng-if=$ctrl.displayDiscountSelect()> <div class=c-form__field> <select ng-model=$ctrl.codetype class=\"c-form__select c-form__select--input\" autocomplete=off ng-change=$ctrl.voucherType()> <option value=\"\" disabled=disabled>Select code type...</option> <option>Promotional Code</option> <option>Voucher</option> </select> </div> </div> <div class=\"cell medium-6\" ng-if=$ctrl.showPromoFields()> <div class=\"c-form__field c-promo-input\"> <input name=promo_details class=\"c-input / c-form__input\" type=text autocomplete=off ng-model=$ctrl.order.contents.promo_details form-field-errors ng-keyup=$ctrl.validatePromo() ng-disabled=$ctrl.promoSaving /> <label class=c-form__label for=name> Enter Promotional Code </label> <spinner ng-if=$ctrl.promoSaving></spinner> </div> </div> </div> <div class=c-payment__voucher ng-if=$ctrl.showVoucherFields() ng-repeat=\"(key, voucher) in $ctrl.order.contents.vouchers\"> <div class=\"grid-x grid-padding-x\" ng-if=\"$ctrl.getSetting('oevoucher')\"> <div class=cell ng-class=\"{'medium-6': $ctrl.getSetting('voucher_pin'), 'medium-12': !$ctrl.getSetting('voucher_pin')}\"> <div class=\"c-form__field c-form__field--transparent\"> <select ng-model=voucher.codetype class=\"c-form__select c-form__select--input\" autocomplete=off required> <option value=\"\" disabled=disabled>Select Voucher Type...</option> <option>Monetary Voucher</option> <option>Spa Day Voucher</option> <option>Treatment Voucher</option> </select> </div> </div> <div class=\"cell medium-6\" ng-if=\"$ctrl.getSetting('voucher_pin')\"> <div class=c-form__field> <input name=voucher_code class=\"c-input / c-form__input\" type=text autocomplete=off ng-model=voucher.pin /> <label class=c-form__label for=name> Voucher Pin (optional) </label> </div> </div> <div class=\"cell medium-6\"> <div class=c-form__field> <input name=voucher_code class=\"c-input / c-form__input\" type=text autocomplete=off ng-model=voucher.code form-field-errors required/> <label class=c-form__label for=name>Voucher Code</label> </div> </div> <div class=\"cell medium-6\"> <div class=\"c-form__field c-form__field--money\"> <money-input name=voucher_value ng-model=voucher.codevalue form-field-errors required></money-input> <label class=c-form__label for=name>Voucher Value</label> </div> </div> <a class=c-payment__voucher__remove ng-if=!$first ng-click=\"$ctrl.order.contents.vouchers.splice(key, 1)\"> &times; </a> </div> <div class=\"grid-x grid-padding-x\" ng-if=\"$ctrl.getSetting('allow_gifted_vouchers')\"> <div class=cell> <p> Please enter your 8-character monetary gift voucher code below </p> </div> <div class=\"cell medium-auto\"> <div class=\"c-form__field c-promo-input\"> <input name=voucher_code class=\"c-input / c-form__input\" type=text autocomplete=off ng-model=voucher.code ng-disabled=$ctrl.voucherSaving mask=wwww-wwww placeholder=\"e.g. A1B2-C3D4\" form-field-errors required/> <label class=\"c-form__label c-form__label--activated\" for=voucher_code> Voucher Code </label> <spinner ng-if=$ctrl.voucherSaving></spinner> </div> </div> <div class=\"cell medium-shrink\"> <button type=button class=\"c-button c-button--hollow c-button--no-margin\" ng-click=$ctrl.validateVoucher() ng-disabled=$ctrl.voucherSaving> Apply Voucher </button> </div> </div> </div> <div class=\"grid-x grid-padding-x\" ng-if=\"$ctrl.getSetting('multivoucher') && $ctrl.showVoucherFields()\"> <div class=\"cell auto\"></div> <div class=\"cell shrink\"> <a ng-click=$ctrl.order.contents.vouchers.push({}) class=c-payment__voucher__add> Add another voucher </a> </div> </div> </div> <expires-at date-time=$ctrl.basket.contents.expires_at></expires-at> </fieldset> <div class=c-payment__footer> <div ng-show=$ctrl.displayPaymentGatewayName()> <span class=c-cards> <img src=//s3-eu-west-1.amazonaws.com/spa-booker-live-uploads/public/checkout-media/visa.png alt=\"VISA card\" class=c-card /> <img src=//s3-eu-west-1.amazonaws.com/spa-booker-live-uploads/public/checkout-media/mastercard.png alt=\"Mastercard card\" class=c-card /> <img src=//s3-eu-west-1.amazonaws.com/spa-booker-live-uploads/public/checkout-media/american-express.png alt=\"American Express card\" class=c-card ng-show=\"$ctrl.displayPaymentGatewayName() === 'Stripe'\"/> </span> <p class=c-description> The card postcode/ZIP must match the address on file with the issuing bank </p> </div> <div ng-show=!$ctrl.displayPaymentGatewayName()> <p class=c-description> We will be in contact to handle payment after you confirm your order on the next step </p> </div> </div> </form> </div> <ul class=\"c-accordion c-accordion--no-margin / c-payment__info / t-slab--secondary-light\" ng-show=$ctrl.displayPaymentInformation() ng-class=\"{ 'c-accordion--active': expandPaymentInformation }\"> <li class=c-accordion__item> <label class=c-accordion__handle ng-click=\"expandPaymentInformation = !expandPaymentInformation\"> <h4 class=t-text--secondary--light> <icon icon=chevron-up ng-if=expandPaymentInformation></icon> <icon icon=chevron-down ng-if=!expandPaymentInformation></icon> How your payment information is handled </h4> </label> <div class=c-accordion__content> <p> {{$ctrl.basket.contents.property.name}} uses {{ $ctrl.displayPaymentGatewayName() }} for the payment processor. {{ $ctrl.displayPaymentGatewayName() }} is well-regarded in the payment process industry and is certified to PCI Service Provider Level 1. This is the most stringent level of certification available. </p> <p> {{ $ctrl.displayPaymentGatewayName() }} and {{$ctrl.basket.contents.property.name}} forces HTTPS to ensure your payment data is transmitted safely. HTTPS encrypts your information and verifies the integrity of traffic between your browser and the destination server. </p> <p> We not do store your payment information on our servers. All information is sent to {{ $ctrl.displayPaymentGatewayName() }}, which is then encrypted on disk with AES-256. {{$ctrl.basket.contents.property.name}} is given a unique identification key which is how we reference your payment information when requesting charges with {{ $ctrl.displayPaymentGatewayName() }}. </p> <p> More information on {{ $ctrl.displayPaymentGatewayName() }}'s security practices can be found on their website. </p> </div> </li> </ul> ";

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'checkoutController',
    template: __webpack_require__(821)
};

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout-spadays__spinner ng-if=!$ctrl.basket.hasLoaded> <spinner></spinner> </div> <div ng-if=\"$ctrl.basket.hasLoaded && $ctrl.basket.empty()\"> <div class=\"grid-x grid-x-padding\"> <div class=\"columns medium-1 large-2\"></div> <div class=\"columns medium-10 large-8\"> <div class=\"c-basket__empty c-basket__empty--margin\"> <p>Your order is currently empty.</p> <a href=/ class=c-button>Return to homepage</a> </div> </div> <div class=\"columns medium-1 large-2\"></div> </div> </div> <div ng-if=!$ctrl.basket.empty()> <steps></steps> <div id=error_box class=c-checkout__error ng-show=\"$ctrl.showPaymentError || $ctrl.totalErrors.length\"> <p>There was a problem with this checkout step.</p> <div ng-show=$ctrl.totalErrors.length> <ul> <li ng-repeat=\"error in $ctrl.totalErrors\">{{error}}</li> </ul> </div> <store-payment-errors ng-show=$ctrl.showPaymentError error=$ctrl.basketPaymentError></store-payment-errors> </div> <div class=\"grid-x grid-x-padding\"> <div class=\"columns medium-1 large-2\"></div> <div class=\"columns small-12 medium-10 large-8\"> <div ui-view ng-if=$ctrl.checkout.step></div> <div class=\"c-checkout__total t-border-top--primary\" ng-if=$ctrl.basket.contents.total> <div class=grid-x> <div class=\"cell auto\"> <div class=c-checkout__total-content>Grand Total:</div> </div> <div class=\"cell shrink\"> <div class=c-checkout__total-content> <s ng-if=$ctrl.checkout.originalTotal() class=c-checkout__total-content__original> <money amount=$ctrl.checkout.originalTotal() decorate=true></money> </s> <money amount=$ctrl.checkout.grandTotal() decorate=true></money> </div> </div> </div> </div> <navigation></navigation> </div> <div class=\"columns medium-1 large-2\"></div> </div> </div> ";

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'customiseController',
    template: __webpack_require__(823)
};

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout-spadays> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdownService.translate($ctrl.content.body.text)></span> <hr> <div class=\"c-payment c-payment--error\" ng-if=\"!$ctrl.loading && $ctrl.hasError\"> <h3 class=c-payment__heading>Error</h3> <div class=\"grid-x grid-padding-x\"> <div class=cell> <p>Sorry, there was an error finding treatments for your Spa Days. Please refresh the page and try again. If this error persists, please contact us to complete your booking.</p> </div> </div> </div> <div class=c-checkout__spinner ng-if=$ctrl.loading> <spinner></spinner> </div> <div class=c-choices ng-if=!$ctrl.loading> <div class=c-choices__guest ng-repeat=\"guest in $ctrl.basket.contents.guest_details\" ng-if=$ctrl.guestHasDays(guest)> <div class=c-choices__guest> <h3 class=c-choices__guest__header>{{ $ctrl.presentGuestName(guest) }}</h3> <div class=c-choices__events-container> <div class=c-choices__event ng-repeat=\"guestDay in guest.item_details\" ng-if=$ctrl.hasDayReference(guestDay.reference)> <p class=c-choices__event__heading>{{ guestDay.item.name }}</p> <p class=c-choices__muted>{{ $ctrl.presentDate(guestDay.date) }} at {{ guestDay.preferred_time }} <span ng-if=guestDay.integration_staff>with {{ guestDay.integration_staff_name }}</span></p> <div class=c-choices__selector ng-class=\"{'c-choices__selector--visible': $ctrl.isDisplayed(guest.id, guestDay.id),'c-choices__selector--error': $ctrl.isDisplayedError(guestDay.id)}\"> <div class=c-choices__selector__header ng-click=\"$ctrl.switchVisible(guest.id, guestDay.id)\"> <div class=grid-x> <div class=\"cell shrink / c-choices__icon\"> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, guestDay.id)\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, guestDay.id)\"></icon> </div> <div class=\"cell auto / c-choices__toggle / t-text--secondary--action\">Select your treatments: <span class=c-choices__toggle__small>{{ $ctrl.treatmentsSelected(guestDay) }} selected.</span></div> </div> <p class=c-choices__description> <span ng-if=!guestDay.item.credit> Please select any additional treatments to be added to your spa experience. </span> <span ng-if=guestDay.item.credit> Treatments up to a total value of <money amount=guestDay.item.credit decorate=true></money> are included with this Spa Day. <br> <span ng-if=\"guestDay.item.credit !== guestday.remaining_credit\"> Remaining credit: <money ng-if=\"guestDay.remaining_credit > 0\" amount=guestDay.remaining_credit decorate=true></money> <money ng-if=\"guestDay.remaining_credit <= 0\" amount=0 decorate=true> </money> <span ng-if=\"guestDay.remaining_credit <= 0\" class=c-choices__alert> Additional cost: <money amount=$ctrl.sumCredit(guestDay.item_children) decorate=true></money> </span> </span> </span> </p> </div> <div class=c-choices__events> <div class=c-choices__category ng-repeat=\"(category, treatments) in $ctrl.findDayTreatments(guestDay.reference)\"> <p class=c-choices__category__heading>{{ category }}</p> <div class=c-choices__treatments> <div class=c-choices__treatment ng-repeat=\"treatment in treatments track by $index\"> <div class=grid-x> <div class=\"cell large-auto\"> <div class=c-choices__treatment__selector ng-class=\"{'c-choices__treatment__selector--visible': $ctrl.isDisplayed(guest.id, guestDay.id, treatment.id)}\"> <div class=grid-x ng-click=\"$ctrl.switchVisible(guest.id, guestDay.id, treatment.id)\"> <div class=\"cell shrink / c-choices__icon\"> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, guestDay.id, treatment.id)\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, guestDay.id, treatment.id)\"></icon> </div> <div class=\"cell auto / c-choices__treatment__name / t-text--secondary--action\"> {{ treatment.name }} </div> <div class=\"cell shrink / c-choices__money\"> <money amount=treatment.availability.price decorate=true></money> </div> </div> <div class=c-choices__treatment__description> <div class=c-entry> <p>Duration: {{ treatment.duration }} minutes.</p> <span ng-bind-html=$ctrl.markdownService.translate(treatment.description)></span> </div> </div> </div> </div> <div class=\"cell large-shrink\"> <div class=grid-x> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.hasEvent(guestDay, treatment.id)}\" ng-click=\"$ctrl.addEvent(guestDay.reference, treatment, [guest.id])\" ng-disabled=$ctrl.basket.saving> <span class=c-button__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> <span class=\"c-button__overlay t-text--primary--background\" ng-if=\"$ctrl.hasEvent(guestDay, treatment.id)\"><span>Remove</span></span> Add to spa day </button> </div> <div class=\"cell shrink\" ng-if=\"$ctrl.findDay(guestDay.reference).assigned_guests > 1\"> <div class=c-choices__drop> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.isDisplayed(guest.id, guestDay.id, treatment.id, true)}\" ng-click=\"$ctrl.switchVisible(guest.id, guestDay.id, treatment.id, true)\"> <span class=show-for-sr>Add to multiple guests</span> </button> <div class=c-choices__dropdown ng-if=\"$ctrl.isDisplayed(guest.id, guestDay.id, treatment.id, true)\"> <button class=c-choices__dropdown__close ng-click=\"$ctrl.switchVisible(guest.id, event.id, option.id, 'options', true)\"> <icon icon=cross></icon> </button> <ul class=c-jumbo-check> <li ng-repeat=\"multiGuest in $ctrl.referenceGuests(guestDay.reference)\"> <input type=checkbox id=\"{{ multiGuest.id }}\" class=c-jumbo-check__input value=multiGuest.id ng-model=$ctrl.spadays[guestDay.reference].selected[treatment.id][multiGuest.id]> <label for=\"{{ multiGuest.id }}\" class=\"c-jumbo-check__label / t-border--primary t-text--primary--background--dark--action\">{{ multiGuest.title + ' ' + multiGuest.first_name + ' ' + multiGuest.last_name }}</label> </li> </ul> <div class=c-choices__dropdown__buttons> <div class=grid-x> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-click=\"$ctrl.addEventSelected(guestDay.reference, treatment, $ctrl.spadays[guestDay.reference].selected)\" ng-disabled=$ctrl.basket.saving> Add to selected guests </button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"\" ng-if=\"$ctrl.noSpaDays() && !$ctrl.hasError\"> <div class=c-checkout__empty> <span>Your selected spa experience does not include treatment credit. Please continue to the next step.</span> </div> </div> </div> </div> ";

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'optionsController',
    template: __webpack_require__(825)
};

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout-options> <div class=c-checkout__spinner ng-if=$ctrl.optionsLoading> <spinner></spinner> </div> <div ng-if=\"!$ctrl.optionsLoading && !$ctrl.hasOptions\"> <div class=c-checkout__empty> <span>There are no additional options or extras for your chosen events. please continue to the next step.</span> </div> </div> <div ng-if=$ctrl.hasOptions> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdownService.translate($ctrl.content.body.text)></span> </div> <hr> <div class=c-choices> <div class=c-choices__guest ng-repeat=\"guest in $ctrl.basket.contents.guest_details\" ng-if=$ctrl.guestHasChoices(guest)> <div class=c-choices__guest> <h3 class=c-choices__guest__header>{{ $ctrl.presentGuest(guest) }}</h3> <div class=c-choices__events-container> <div class=c-choices__event ng-repeat=\"event in guest.item_details\" ng-if=\"$ctrl.eventHasChoices(event, guest.id)\"> <p class=c-choices__event__heading>{{ event.item_summary.name }}</p> <p class=c-choices__muted>{{ $ctrl.presentDate(event.date) }} at {{ event.preferred_time.substring(0, 5) }} <span ng-if=event.integration_staff>with {{ event.integration_staff_name }}</span></p> <div class=\"c-choices__selector c-choices__selector--options\" ng-class=\"{\n                                'c-choices__selector--visible': !$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'options'),\n                                'c-choices__selector--error': !$ctrl.selectedMaximum($ctrl.countSelected(event, 'option'), $ctrl.countMaximum(event.item_summary.type_name, event.item_summary.id, 'OptionGroupOption'))\n                                }\" ng-if=$ctrl.checkout.options[event.item_summary.type_name][event.item_summary.id].OptionGroupOption.length> <div class=c-choices__selector__header ng-click=\"$ctrl.switchVisible(guest.id, event.item_summary.type_name, event.id, 'options')\"> <div class=grid-x> <div class=\"cell shrink / c-choices__icon\"> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'options')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'options')\"></icon> </div> <div class=\"cell auto / c-choices__toggle / t-text--secondary--action\">Choose your included options <span class=c-choices__toggle__small>{{ $ctrl.countSelected(event, 'option') }}{{ $ctrl.countMaximum(event.item_summary.type_name, event.item_summary.id, 'OptionGroupOption', optionGroup.id) }} selected</span></div> </div> </div> <div class=c-choices__events> <div class=c-choices__category ng-repeat=\"optionGroup in $ctrl.checkout.options[event.item_summary.type_name][event.item_summary.id].OptionGroupOption\"> <p class=c-choices__category__heading> {{ optionGroup.name }} <span class=c-choices__category__heading__selections>{{ $ctrl.countSelectedOptions(guest, event, optionGroup) || 0 }}/{{ optionGroup.selections }}</span> </p> <div class=c-choices__treatments> <div class=c-choices__treatment ng-repeat=\"option in optionGroup.group_options\"> <div class=grid-x> <div class=\"cell large-auto\"> <div class=c-choices__treatment__selector ng-class=\"{'c-choices__treatment__selector--visible': $ctrl.isDisplayed(guest.id, event.id, option.id, 'option')}\"> <div class=grid-x ng-click=\"$ctrl.switchVisible(guest.id, event.id, option.id, 'option')\"> <div class=\"cell shrink / c-choices__icon\"> <span ng-if=$ctrl.hasDescription(option)> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.id, option.id, 'option')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.id, option.id, 'option')\"></icon> </span> <span ng-if=!$ctrl.hasDescription(option) class=c-choices__icon__placeholder></span> </div> <div class=\"cell auto / c-choices__treatment__name / t-text--secondary--action\"> {{ option.name }} </div> </div> <div class=c-choices__treatment__description ng-if=$ctrl.hasDescription(option)> <div class=grid-x> <div class=\"cell medium-shrink\"> <div class=c-choices__image ng-if=\"option.image || option.image_url\"> <div class=c-background imgix-src=\"{{ option.image || option.image_url }}\" imgix-refresh></div> </div> </div> <div class=\"cell medium-auto\"> <div class=c-entry ng-bind-html=$ctrl.displayDescription(option.description)></div> </div> </div> </div> </div> </div> <div class=\"cell small-3 medium-2 large-shrink c-choices__money\" ng-if=\"option.price > 0\"> <money amount=option.price decorate=true></money> </div> <div class=\"cell large-shrink\"> <div class=\"grid-x / c-choices__buttons\"> <div class=\"cell auto\"> <ul class=c-jumbo-check> <li> <button class=\"c-choices__option / c-jumbo-check__label / t-border--primary t-text--primary--background--dark--action\" ng-class=\"{'c-button--active t-text--primary--background c-jumbo-check__button--selected': $ctrl.hasOption(event, option)}\" ng-click=\"$ctrl.addOption(guest, event, optionGroup, option)\" ng-disabled=$ctrl.basket.saving> CHOOSE THIS <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </li> </ul> </div> <div class=\"cell small-1 large-shrink\" ng-if=\"$ctrl.referenceGuests(event.reference).length > 1\"> <div class=c-choices__drop> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--primary': $ctrl.isDisplayed(guest.id, event.id, option.id, 'options', true)}\" ng-click=\"$ctrl.switchVisible(guest.id, event.id, option.id, 'options', true)\"> <span class=show-for-sr>Add to multiple guests</span> </button> <div class=c-choices__dropdown ng-if=\"$ctrl.isDisplayed(guest.id, event.id, option.id, 'options', true)\"> <button class=c-choices__dropdown__close ng-click=\"$ctrl.switchVisible(guest.id, event.id, option.id, 'options', true)\"> <icon icon=cross></icon> </button> <ul class=c-jumbo-check> <li ng-repeat=\"multiGuest in $ctrl.referenceGuests(event.reference)\"> <button class=\"c-choices__multi-option c-jumbo-check__label / t-border--primary\" ng-class=\"{'t-text--primary--background t-text--primary--background--light--action c-jumbo-check__button--selected': $ctrl.guestHasOption(multiGuest, option)}\" ng-click=\"$ctrl.addOption(multiGuest, event, optionGroup, option, false)\" ng-disabled=$ctrl.basket.saving> {{ $ctrl.guestnameService.format(multiGuest, false) }} <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </li> </ul> <div class=c-choices__dropdown__buttons> <div class=grid-x> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-click=$ctrl.submitBasket() ng-disabled=$ctrl.basket.saving> Add to selected </button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"c-choices__selector c-choices__selector--free\" ng-class=\"{'c-choices__selector--visible': !$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'free')}\" ng-if=$ctrl.checkout.extras[event.item_summary.type_name][event.item_summary.id].EventExtra.free.length> <div class=c-choices__selector__header ng-click=\"$ctrl.switchVisible(guest.id, event.item_summary.type_name, event.id, 'free')\"> <div class=grid-x> <div class=\"cell shrink / c-choices__icon\"> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'free')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'free')\"></icon> </div> <div class=\"cell auto / c-choices__toggle / t-text--secondary--action\">Complimentary extras <span class=c-choices__toggle__small>{{ $ctrl.countSelected(event, 'extra-free') }} selected</span></div> </div> </div> <div class=c-choices__events> <p>Fancy a little something extra? It's on us</p> <div class=c-choices__category> <div class=c-choices__treatments> <div class=c-choices__treatment ng-repeat=\"extra in $ctrl.checkout.extras[event.item_summary.type_name][event.item_summary.id].EventExtra.free\" ng-class=\"{'c-choices__treatment--featured': extra.featured}\"> <div class=grid-x> <div class=\"cell medium-12 large-auto\"> <div class=c-choices__treatment__selector ng-init=\"extra.featured && $ctrl.switchVisibleOn(guest.id, event.id, extra.id, 'extra')\" ng-class=\"{'c-choices__treatment__selector--visible': $ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')}\"> <div class=grid-x ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra')\"> <div class=\"cell shrink / c-choices__icon\"> <span ng-if=$ctrl.hasDescription(extra)> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')\"></icon> </span> <span ng-if=!$ctrl.hasDescription(extra) class=c-choices__icon__placeholder></span> </div> <div class=\"cell auto / c-choices__treatment__name / t-text--secondary--action\"> {{ extra.name }} </div> </div> <div class=c-choices__treatment__description ng-if=$ctrl.hasDescription(extra)> <div class=grid-x> <div class=\"cell medium-shrink\"> <div class=c-choices__image ng-if=\"extra.image || extra.image_url\"> <div class=c-background imgix-src=\"{{ extra.image || extra.image_url }}\" imgix-refresh></div> </div> </div> <div class=\"cell medium-auto\"> <div class=c-entry ng-bind-html=$ctrl.displayDescription(extra.description)></div> </div> </div> </div> </div> </div> <div class=\"cell large-shrink\"> <div class=\"grid-x / c-choices__buttons\"> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.hasExtra(guest,event, extra)}\" ng-click=\"$ctrl.addExtra(guest, event, extra)\" ng-disabled=$ctrl.basket.saving> <span class=\"c-button__overlay t-text--primary--background\" ng-if=\"$ctrl.hasExtra(guest, event, extra)\"><span>Remove</span></span> Add to guest <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </div> <div class=\"cell small-1 large-shrink\" ng-if=\"$ctrl.referenceGuests(event.reference).length > 1\"> <div class=c-choices__drop> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra-free', true)}\" ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra-free', true)\"> <span class=show-for-sr>Add to multiple guests</span> </button> <div class=c-choices__dropdown ng-if=\"$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra-free', true)\"> <button class=c-choices__dropdown__close ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra-free', true)\"> <icon icon=cross></icon> </button> <ul class=c-jumbo-check> <li ng-repeat=\"multiGuest in $ctrl.referenceGuests(event.reference)\"> <button class=\"c-choices__multi-option c-jumbo-check__label / t-border--primary\" ng-class=\"{'t-text--primary--background t-text--primary--background--light--action c-jumbo-check__button--selected': $ctrl.hasExtra(multiGuest, event, extra)}\" ng-click=\"$ctrl.addExtra(multiGuest, event, extra, false)\" ng-disabled=$ctrl.basket.saving> {{ $ctrl.guestnameService.format(multiGuest, false) }} <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </li> </ul> <div class=c-choices__dropdown__buttons> <div class=grid-x> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-click=$ctrl.submitBasket() ng-disabled=$ctrl.basket.saving> Update selected </button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> <div class=\"c-choices__selector c-choices__selector--paid\" ng-class=\"{'c-choices__selector--visible': !$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'paid')}\" ng-if=$ctrl.checkout.extras[event.item_summary.type_name][event.item_summary.id].EventExtra.paid.length> <div class=c-choices__selector__header ng-click=\"$ctrl.switchVisible(guest.id, event.item_summary.type_name, event.id, 'paid')\"> <div class=grid-x> <div class=\"cell shrink / c-choices__icon\"> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'paid')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.item_summary.type_name, event.id, 'paid')\"></icon> </div> <div class=\"cell auto / c-choices__toggle / t-text--secondary--action\">Treats and Additions <span class=c-choices__toggle__small>{{ $ctrl.countSelected(event, 'extra-paid') }} selected</span></div> </div> </div> <div class=c-choices__events> <div class=c-choices__category> <div class=c-choices__treatments> <div class=c-choices__treatment ng-repeat=\"extra in $ctrl.checkout.extras[event.item_summary.type_name][event.item_summary.id].EventExtra.paid\" ng-class=\"{'c-choices__treatment--featured': extra.featured}\" ng-show=\"!extra.treatment_id || !$ctrl.guestHasChildTreatment(extra, guest)\"> <div class=grid-x> <div class=\"cell large-auto\"> <div class=c-choices__treatment__selector ng-init=\"extra.featured && $ctrl.switchVisibleOn(guest.id, event.id, extra.id, 'extra')\" ng-class=\"{'c-choices__treatment__selector--visible': $ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')}\"> <div class=grid-x ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra')\"> <div class=\"cell shrink / c-choices__icon\"> <span ng-if=$ctrl.hasDescription(extra)> <icon icon=chevron-down ng-if=\"!$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')\"></icon> <icon icon=chevron-up ng-if=\"$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra')\"></icon> </span> <span ng-if=!$ctrl.hasDescription(extra) class=c-choices__icon__placeholder></span> </div> <div class=\"cell auto / c-choices__treatment__name / t-text--secondary--action\"> {{ extra.name }} </div> <div class=\"cell shrink / c-choices__money\" ng-if=\"extra.base_price > 0\"> <money amount=extra.base_price decorate=true></money> </div> </div> <div class=c-choices__treatment__description ng-if=$ctrl.hasDescription(extra)> <div class=grid-x> <div class=\"cell medium-shrink\"> <div class=c-choices__image ng-if=\"extra.image || extra.image_url\"> <div class=c-background imgix-src=\"{{ extra.image || extra.image_url }}\" imgix-refresh></div> </div> </div> <div class=\"cell medium-auto\"> <div class=c-entry ng-bind-html=$ctrl.displayDescription(extra.description)></div> </div> </div> </div> </div> </div> <div class=\"cell large-shrink\"> <div class=\"grid-x / c-choices__buttons\"> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.hasExtra(guest, event, extra)}\" ng-click=\"$ctrl.addExtra(guest, event, extra)\" ng-disabled=$ctrl.basket.saving> <span class=\"c-button__overlay t-text--primary--background\" ng-if=\"$ctrl.hasExtra(guest, event, extra)\"><span>Remove</span></span> Add to guest <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </div> <div class=\"cell shrink\" ng-if=\"$ctrl.referenceGuests(event.reference).length > 1\"> <div class=c-choices__drop> <button class=\"c-button c-button--hollow\" ng-class=\"{'c-button--active t-text--primary--background': $ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra-free', true)}\" ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra-free', true)\"> <span class=show-for-sr>Add to multiple guests</span> </button> <div class=c-choices__dropdown ng-if=\"$ctrl.isDisplayed(guest.id, event.id, extra.id, 'extra-free', true)\"> <button class=c-choices__dropdown__close ng-click=\"$ctrl.switchVisible(guest.id, event.id, extra.id, 'extra-free', true)\"> <icon icon=cross></icon> </button> <ul class=c-jumbo-check> <li ng-repeat=\"multiGuest in $ctrl.referenceGuests(event.reference)\"> <button class=\"c-choices__multi-option c-jumbo-check__label / t-border--primary\" ng-class=\"{'t-text--primary--background t-text--primary--background--light--action c-jumbo-check__button--selected': $ctrl.hasExtra(multiGuest, event, extra)}\" ng-click=\"$ctrl.addExtra(multiGuest, event, extra, false)\" ng-disabled=$ctrl.basket.saving> {{ $ctrl.guestnameService.format(multiGuest, false) }} <span class=c-jumbo-check__saving ng-if=$ctrl.basket.saving> <spinner></spinner> </span> </button> </li> </ul> <div class=c-choices__dropdown__buttons> <div class=grid-x> <div class=\"cell auto\"> <button class=\"c-button c-button--hollow\" ng-click=$ctrl.submitBasket() ng-disabled=$ctrl.basket.saving> Update selected </button> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'suggestionsController',
    template: __webpack_require__(827)
};

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-checkout-suggestions c-upsell\"> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdown($ctrl.content.body.text)></span> <display-suggestions load-on-init=true can-load-staff=$ctrl.content.settings.load_staff></display-suggestions> </div> ";

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        content: '<'
    },
    controller: 'reviewController',
    template: __webpack_require__(829)
};

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-review c-checkout--review\" ng-if=$ctrl.basket.contents.identity_code> <span ng-if=\"$ctrl.content && $ctrl.content.body.text.length\" ng-bind-html=$ctrl.markdownService.translate($ctrl.content.body.text)></span> <hr> <div class=c-review__basket> <div class=\"c-review__box t-border--secondary\"> <div class=\"c-review__box__header t-text--secondary--background\"> Guest details </div> <basket-items basket=$ctrl.basket noedit=true></basket-items> <reservation-items></reservation-items> <div class=c-basket__overlay ng-class=\"{ 'is-active': $ctrl.basket.saving }\"> <spinner></spinner> </div> </div> <div class=c-review__basket__buttons> <a class=\"c-button c-button--hollow\" href=/guests ng-disabled=$ctrl.basket.saving ng-if=!$ctrl.isEditing()>Edit guest information</a> <a class=\"c-button c-button--hollow\" ng-click=$ctrl.checkout.reset() ng-disabled=$ctrl.basket.saving ng-if=!$ctrl.isFirstStep>Edit spa experience</a> </div> </div> <div class=\"c-review__box t-border--secondary\" ng-if=\"$ctrl.getSetting('notes')\"> <div class=\"c-review__box__header t-text--secondary--background\"> Additional Notes </div> <div class=c-review__box__value> <p>Any additional information you would like {{ $ctrl.basket.contents.property.name }} to know about your booking can be added here. Please include any dietary or medical information.</p> <textarea ng-model=$ctrl.basket.contents.notes style=resize:none></textarea> </div> <div class=c-basket__overlay ng-class=\"{ 'is-active': $ctrl.basket.saving }\"> <spinner></spinner> </div> </div> <div class=c-review__tcs> <label for=tcs class=\"c-review__tcs-label c-form__label--inline-block\"> <input type=checkbox id=tcs ng-model=$ctrl.basket.tcs> <span class=c-review__tcs-text ng-class=\"{ 'error' : $ctrl.checkout.error && !$ctrl.basket.tcs }\"> I agree to the <a href=/terms-conditions target=_blank style=text-decoration:underline>terms and conditions</a> of this website </span> </label> <br> <label for=cancellation_agreement class=\"c-review__tcs-label c-form__label--inline-block\" ng-show=$ctrl.basketWithinAgreementWindow> <input type=checkbox id=cancellation_agreement ng-model=$ctrl.basket.contents.cancellation_agreement> <span class=c-review__tcs-text ng-class=\"{ 'error' : $ctrl.checkout.error && !$ctrl.basket.contents.cancellation_agreement }\" ng-bind-html=\"$ctrl.markdownService.translate($ctrl.getSetting('cancellation_agreement_text'), true)\"> </span> </label> </div> </div> ";

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'stepsController',
    template: __webpack_require__(831)
};

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<div class=c-checkout__steps> <div ng-repeat=\"(index, step) in $ctrl.checkout.validSteps\" ng-if=\"step !== 'confirmation'\" class=\"c-step{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) > index ? ' is-active' : '' }}{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) === index ? ' is-current' : '' }}\" ng-click=\"$ctrl.travel(index, step)\"> <div class=c-step__indicator></div> <div class=c-step__text> <span>{{$ctrl.checkout.displayName(step)}}</span> </div> </div> </div> ";

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'navigationController',
    template: __webpack_require__(833)
};

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "<div class=\"c-checkout__navigation / grid-x\"> <div class=\"cell medium-auto\"> <button type=button class=\"c-button c-button--hollow t-text--secondary--background--dark--action\" ng-if=$ctrl.checkout.prev ng-click=$ctrl.checkout.travelPrevious() ng-disabled=\"$ctrl.basket.saving || $ctrl.basket.empty()\" ng-bind=$ctrl.checkout.prev></button> </div> <div class=\"cell medium-shrink\"> <button id={{$ctrl.checkout.nextid}} type=button ng-if=$ctrl.checkout.next class=\"c-button c-button--icon\" ng-click=$ctrl.next() ng-disabled=$ctrl.nextDisabled() ng-class=\"{\n                'c-button--loading': $ctrl.checkout.saving,\n            }\"> <span class=c-button__text ng-bind=$ctrl.checkout.next></span> <span class=c-button__icon> <spinner ng-if=$ctrl.checkout.saving></spinner> </span> </button> </div> </div> ";

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        error: '<'
    },
    template: __webpack_require__(835)
};

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.error ng-messages=$ctrl.error> <div ng-message=charge_expired_for_capture> The payment details have expired. Please try again </div> <div ng-message=resource_already_exists> An error occurred while processing the card. Please try again. </div> <div ng-message=call_issuer> The card has been declined for an unknown reason. Please contact your card issuer for more information. </div> <div ng-message=incorrect_number> The card details you have entered are not correct. </div> <div ng-message=expired_card> An error occurred while processing the card. Please use an alternate payment method. </div> <div ng-message=refresh_order> The order could not be completed. Please refresh the page, and try again. </div> <div ng-message=generic_decline> The order could not be completed. Please contact us for more information. </div> </div> ";

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_moment2.default.updateLocale('en', {
  relativeTime: {
    future: "%s",
    past: "%s ago",
    s: 'less than a minute',
    ss: '%d seconds',
    m: "a minute",
    mm: "%d minutes",
    h: "an hour",
    hh: "%d hours",
    d: "a day",
    dd: "%d days",
    M: "a month",
    MM: "%d months",
    y: "a year",
    yy: "%d years"
  }
});

exports.default = ['$rootScope', '$state', '$window', 'basket', 'order', 'throttleService', '$anchorScroll', '$timeout', '$interval', 'configService', 'googleAnalytics', 'moneyService', function ($rootScope, $state, $window, basket, order, throttleService, $anchorScroll, $timeout, $interval, configService, googleAnalytics, moneyService) {

  var withinCheckout = function withinCheckout() {
    return !!($window.location.pathname && $window.location.pathname.indexOf('/checkout') > -1);
  };

  var checkout = {};

  checkout.setup = function () {
    checkout.optionExtras = {
      'SpaDay': {},
      'Treatment': {}
    };

    checkout.selectedOptions = {};

    checkout.createAnalytics();
  };

  checkout.setupSteps = function () {
    // Explanation: each step defines the text that shows when travelling to it either as a next destination or as a previous destination. If there are no steps ahead of it (or backwards travel should not be encouraged) there is no previous and similar for next.
    checkout.travelSteps = {
      'credit': {
        'prev': '← Select credit options',
        'next': 'Select credit options →'
      },
      'customise': {
        'prev': '← Customise your experience',
        'next': 'Customise your experience →'
      },
      'suggestions': {
        'prev': '← Suggestions',
        'next': 'Suggestions →'
      },
      'review': {
        'prev': '← Review your order',
        'next': 'Review your order →'
      },
      'payment': {
        'prev': null,
        'next': 'Payment information →'
      },
      'confirmation': {
        'prev': null,
        'next': checkout.gateway && checkout.gateway.none || order.contents.total === 0 ? 'Confirm your order →' : 'Confirm your order and pay →',
        'nextid': 'order-submit'
      }
    };

    var currentStep = checkout.step ? checkout.validateStepByName(checkout.step) : checkout.validSteps[0];
    var stepIndex = checkout.getStepIndex(currentStep);
    checkout.step = currentStep;
    checkout.laststep = stepIndex > 0 ? checkout.validSteps[stepIndex - 1] : 0;
  };

  checkout.setSteps = function () {
    var _checkout$validSteps4;

    checkout.validSteps = [];

    if (basket.contents.has_credit) {
      var _checkout$validSteps;

      (_checkout$validSteps = checkout.validSteps).push.apply(_checkout$validSteps, ['credit']);
    }

    if (basket.contents.has_options) {
      var _checkout$validSteps2;

      (_checkout$validSteps2 = checkout.validSteps).push.apply(_checkout$validSteps2, ['customise']);
    }

    if (basket.contents.has_suggestions) {
      var _checkout$validSteps3;

      (_checkout$validSteps3 = checkout.validSteps).push.apply(_checkout$validSteps3, ['suggestions']);
    }

    (_checkout$validSteps4 = checkout.validSteps).push.apply(_checkout$validSteps4, ['review', 'payment', 'confirmation']);

    if (!checkout.travelSteps || Object.keys(checkout.travelSteps).length === 0) {
      checkout.setupSteps();
    }

    checkout.setButtonText(checkout.step);
  };

  checkout.travelNext = function () {
    checkout.saving = true;
    basket.saving = true;

    checkout.setSteps();

    var target = checkout.getStepIndex(checkout.step);

    if (target < checkout.validSteps.length) {
      checkout.laststep = target;
      checkout.step = checkout.validSteps[target + 1];
      checkout.recordAnalytics(checkout.step);
    }

    return checkout.travel();
  };

  checkout.travelPrevious = function () {
    checkout.saving = true;
    basket.saving = true;

    checkout.setSteps();

    var target = checkout.getStepIndex(checkout.step);

    checkout.recordAnalytics(checkout.validSteps[target]);

    checkout.laststep = target;
    basket.changeStatus(checkout.validSteps[target]);
    checkout.step = target > 0 ? checkout.validSteps[target - 1] : checkout.validSteps[0];
    return checkout.travel();
  };

  checkout.setButtonText = function (stepName) {
    var currentIndex = checkout.getStepIndex(stepName);
    checkout.prev = currentIndex > 0 ? checkout.travelSteps[checkout.validSteps[currentIndex - 1]].prev : undefined;
    checkout.next = currentIndex < checkout.validSteps.length - 1 ? checkout.travelSteps[checkout.validSteps[currentIndex + 1]].next : undefined;
    checkout.nextid = currentIndex < checkout.validSteps.length - 1 ? checkout.travelSteps[checkout.validSteps[currentIndex + 1]].nextid : undefined;
  };

  checkout.firstStep = function () {
    checkout.step = checkout.validSteps[0];
    basket.changeStatus(checkout.step);
    checkout.setButtonText(checkout.step);
    checkout.laststep = 0;

    if (withinCheckout()) {
      $state.go('checkout.' + checkout.step);
    }
  };

  checkout.paymentStep = function () {
    checkout.setStepByName('payment');

    if (withinCheckout()) {
      $state.go('checkout.' + checkout.step);
    }
    checkout.saving = false;
  };

  checkout.setStepByName = function (name) {
    checkout.step = name;
    basket.changeStatus(checkout.step);
    checkout.setButtonText(checkout.step);
    checkout.laststep = checkout.getStepIndex(name);
  };

  checkout.travelResponseNotSuccess = function () {
    checkout.step = checkout.validSteps[checkout.laststep];

    if (basket.contents.basket_status === 'confirmation') {
      checkout.step = 'payment';
      checkout.travelFunction();
    }

    basket.saving = false;
    checkout.saving = false;

    return false;
  };

  checkout.travelResponseSuccess = function () {
    checkout.error = null;

    if (checkout.step === 'confirmation') {
      if (!basket.contents.errors || basket.contents.errors && basket.contents.errors.length < 1) {
        checkout.logTransaction();
        $window.location.href = '/confirmation/' + basket.contents.identity_code;
        return;
      }

      checkout.step = 'payment';
      return;
    }

    if (withinCheckout()) {
      return $state.go('checkout.' + checkout.step).then(function () {
        checkout.saving = false;
        basket.saving = false;
        return;
      });
    }
  };

  checkout.travelFunction = function () {
    if (basket.empty()) {
      return false;
    }

    checkout.saving = true;
    basket.saving = true;

    basket.changeStatus(checkout.step);

    return basket.submit(false, false).then(function (response) {
      if (response && response.status !== 200) {
        order.invalidateToken();
        $interval.cancel(checkout.tokenInterval);
        return checkout.travelResponseNotSuccess();
      }

      if (basket.contents && basket.contents.client_secret) {
        return 'requires_action';
      }

      checkout.travelResponseSuccess();
    }).catch(function (error) {
      return basket.submitCatch(error);
    });
  };

  checkout.travel = throttleService.throttle(checkout.travelFunction, 750, { 'trailing': false });

  checkout.displayName = function (step) {
    if (checkout.gateway && checkout.gateway.none) {
      switch (step) {
        case 'payment':
          step = 'order';
          break;
      }
    }

    return step.replace(/-+/g, ' ').replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };

  checkout.checkTimestamp = function () {
    if (order && typeof order.contents.payment_token === 'string' && checkout.timestampDiff() > 0) {
      return true;
    }

    return false;
  };

  checkout.tokenTimestamp = function () {
    if (order.contents.payment_token_timestamp) {
      return order.contents.payment_token_timestamp;
    }

    return 0;
  };

  checkout.timestampDiff = function () {
    if (order.contents.payment_token_timestamp) {
      // Timeout the token 20secs before it actually fails, to allow time to process
      return _moment2.default.unix(checkout.tokenTimestamp()).diff((0, _moment2.default)().add(20, 'seconds'), 'seconds');
    }

    return 0;
  };

  checkout.displayTimestampDiff = function () {
    if (order.contents.payment_token_timestamp) {
      // Timeout the token 20secs before it actually fails, to allow time to process
      return _moment2.default.unix(checkout.tokenTimestamp()).subtract(20, 'seconds').fromNow(true);
    }

    return '0 minutes';
  };

  checkout.validToken = function () {
    if (order.contents && (checkout.checkTimestamp() || checkout.gateway.none)) {
      return true;
    }

    return false;
  };

  checkout.originalTotal = function () {
    if (basket.contents.basket_status === 'payment' && order.contents && order.contents.basket_identity_code) {
      if (order.contents.total !== order.contents.original_total) {
        return order.contents.original_total;
      }
    }
  };

  checkout.grandTotal = function () {
    if (basket.contents.basket_status === 'payment' && order.contents && order.contents.basket_identity_code) {
      return order.contents.total;
    }

    return basket.contents.total;
  };

  checkout.reset = function () {
    $interval.cancel(checkout.tokenInterval);
    basket.changeStatus('checkout');
    return basket.submit().then(function () {
      checkout.firstStep();
    });
  };

  checkout.invalidateOrder = function () {
    if (order.contents.basket_identity_code && order.contents.payment_token && basket.contents.option === 'delete_orders') {
      order.invalidateToken();
      $interval.cancel(checkout.tokenInterval);
    }

    if (checkout.step === 'payment') {
      order.generateOrder(basket.contents.identity_code);
    }
  };

  checkout.scrollToError = function () {
    $anchorScroll('content');
  };

  checkout.init = function () {
    checkout.gateway = configService.get('gateways');

    $interval.cancel(checkout.tokenInterval);

    if (basket.promise) {
      return basket.promise.then(function () {
        checkout.setup();
        checkout.setSteps();

        checkout.recordAnalytics(checkout.step);

        // If empty basket, force to first step
        if (basket.empty() || basket.contents.basket_status === 'checkout') {
          return checkout.firstStep();
        }

        var currentURL = $window.location.pathname;
        var current = currentURL.split('/').pop();

        current = checkout.validateStepByName(current);

        if (currentURL.indexOf('checkout') > -1 && current !== basket.contents.basket_status) {
          checkout.step = basket.contents.basket_status;
          return checkout.travel();
        }

        checkout.step = current;
        checkout.setButtonText(current);

        $rootScope.$on('$locationChangeStart', function (event, toState) {
          event.targetScope.step = toState.split('/').slice(-1)[0];
        });

        return true;
      });
    } else {
      checkout.error = ['No basket was found.'];
    }
  };

  checkout.validateStepByName = function (current) {
    if (checkout.validSteps.indexOf(current) === -1) {
      return checkout.validSteps[0];
    }

    return current;
  };

  checkout.getStepIndex = function (current) {
    var index = checkout.validSteps.indexOf(current);

    if (index <= 0) {
      return 0;
    }

    if (index >= checkout.validSteps.length) {
      return checkout.validSteps.length;
    }

    return index;
  };

  checkout.createAnalytics = function () {
    var config = configService.get('analytics');
    if (!checkout.analytics && config.loadAnalytics) {
      return googleAnalytics.loadScript().then(function () {
        googleAnalytics.create({
          id: config.revSpaGAID,
          name: 'revSpa'
        });

        var propertyAnalytics = config.propertyGAID;

        if (propertyAnalytics) {
          googleAnalytics.create(propertyAnalytics);
        }

        googleAnalytics.sendData();
        checkout.analytics = true;
      });
    }
  };

  checkout.recordAnalytics = function (targetPage) {
    googleAnalytics.setData('page', '/checkout/' + targetPage);
    googleAnalytics.sendData();
  };

  checkout.logTransaction = function () {
    var currency = moneyService.getCurrencyDetails(order.contents.currency_code);
    var transaction = {
      'id': '' + basket.contents.identity_code,
      'affiliation': '' + basket.contents.property.name,
      'revenue': '' + basket.contents.total / currency.magnitude,
      'currency': '' + order.contents.currency_code
    };

    googleAnalytics.setEcommerce('addTransaction', transaction);

    googleAnalytics.sendEcommerce();
  };

  checkout.setTokenCountdown = function () {
    if (!checkout.tokenInterval && checkout.checkTimestamp()) {
      checkout.tokenInterval = $interval(function () {
        checkout.timestampRemaining = checkout.displayTimestampDiff();

        if (!checkout.checkTimestamp()) {
          $interval.cancel(checkout.tokenInterval);
          checkout.tokenInterval = null;
          return;
        }
      }, 1000).catch(function () {
        // Swallow cancel error
      });

      return;
    }
  };

  checkout.addError = function (error) {
    if (!checkout.error) {
      checkout.error = [];
    }
    checkout.error.push(error);
  };

  checkout.init();

  return checkout;
}];

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _lodash = __webpack_require__(13);

exports.default = ['checkout', 'basket', 'order', 'configService', 'validateService', 'promoApiService', 'moneyService', 'voucherApiService', function (checkout, basket, order, configService, validateService, promoApiService, moneyService, voucherApiService) {
  var _this = this;

  var additionalRequirements = function additionalRequirements(check) {
    _this.additionalCheck = check;
  };

  var validate = function validate(step) {
    return basket.promise.then(function () {
      var error = [];
      checkout.error = undefined;
      switch (step) {
        case 'credit':
          checkout.spadayError = [];
          var unavailableSpaDays = _this.additionalCheck;
          // Check for options per guest and throw error if not all selected
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = basket.contents.guest_details[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var guest = _step.value;
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = guest.item_details[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var item = _step2.value;

                  if (item.item.credit > 0 && !(0, _lodash.find)(item.item_children, { item_type: 'App\\Treatment' }) && !(0, _lodash.find)(unavailableSpaDays, { id: item.id })) {
                    if (error.length === 0) {
                      error.push('One of your Spa Days has credit but has no treatments selected');
                    }
                    checkout.spadayError.push(item.id);
                  }
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          break;
        case 'customise':
          checkout.optionError = false;
          // Check for options per guest and throw error if not all selected

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = basket.contents.guest_details[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var _guest = _step3.value;
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = _guest.item_details[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var _item = _step4.value;

                  if (checkout.optionError) {
                    continue;
                  }

                  checkout.optionError = validateService.optionError(_item, _item.requiredOptions);

                  if (checkout.optionError) {
                    error.push(checkout.optionError);
                  }
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }

          break;
        case 'review':
          if (!basket.tcs || basket.contents.cancellation_agreement === false) {
            error.push('You must agree to the terms and conditions before completing your order.');
          }
          break;
        case 'payment':
          {
            var customerFields = {
              first_name: 'First name',
              last_name: 'Last name',
              phone: 'Phone number',
              email: 'Email address'
            };
            var addressFields = {
              avs_street: 'Street details',
              avs_city: 'City details',
              avs_state: 'State/County details',
              avs_zip: 'Post Code details',
              avs_country: 'Country details'
            };

            if (!order.contents.basket_identity_code) {
              error.push('Order was not generated correctly');
            }

            if (!error.length && !order.contents.customer) {
              error.push('Your details are required');
            }

            (0, _lodash.forEach)(customerFields, function (value, key) {
              if (order.contents && order.contents.customer) {
                if (order.contents.customer.selectedGuest) {
                  if (order.contents.customer.selectedGuest.loggedIn) {
                    return false;
                  }

                  if (key === 'first_name' || key === 'last_name') {
                    return;
                  }
                }

                if (!order.contents.customer[key]) {
                  error.push(value + ' is required');
                }
              }
            });
            if (configService.get('gateways').paysafe) {
              (0, _lodash.forEach)(addressFields, function (value, key) {
                if (order.contents && !order.contents[key]) {
                  error.push(value + ' are required');
                }
              });
            }

            if (!error.length && order.contents.vouchers.length) {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = order.contents.vouchers[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var voucher = _step5.value;

                  if (!voucher.code) {
                    error.push('One of your vouchers has not been entered correctly.');
                    break;
                  }
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            }
            break;
          }
      }

      if (error.length === 0) {
        return true;
      }

      checkout.error = error;
      checkout.scrollToError();
      return false;
    });
  };

  var validatePromo = function validatePromo(order) {
    var currency = moneyService.getCurrencyDetails(configService.get('currency'));
    return promoApiService.validate(order.contents.basket_identity_code, order.contents.promo_details).then(function (response) {
      if (response && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
        setOrderTotal(response);
        var text = 'Promotional code was successful';
        if (response && response.discount) {
          text += ', discount of ' + currency.symbol + response.discount / currency.magnitude + ' was applied';
        }

        return {
          'text': text,
          'class': 'c-promo__feedback--success'
        };
      }

      return failValidateResponse('promotional');
    }).catch(function () {
      return failValidateResponse('promotional');
    });
  };

  var validateVoucher = function validateVoucher(order) {
    var currency = moneyService.getCurrencyDetails(configService.get('currency'));
    return voucherApiService.validate(order.contents.basket_identity_code, order.contents.vouchers[0].code).then(function (response) {
      if (response && (typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object') {
        setOrderTotal(response);
        var text = 'Voucher code was successful';
        if (response && response.discount) {
          text += ', discount of ' + currency.symbol + response.discount / currency.magnitude + ' was applied';
        }

        return {
          'text': text,
          'class': 'c-promo__feedback--success'
        };
      }

      return failValidateResponse('voucher');
    }).catch(function () {
      return failValidateResponse('voucher');
    });
  };

  var failValidateResponse = function failValidateResponse(type) {
    setOrderTotal();
    return {
      'text': 'Sorry, that ' + type + ' code is not valid',
      'class': 'c-promo__feedback--fail'
    };
  };

  var setOrderTotal = function setOrderTotal() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    order.contents.total = order.contents.original_total;

    if (response && response.discount) {
      order.contents.total -= response.discount;
    }

    if (order.contents.total < 0) {
      order.contents.total = 0;
    }
  };

  return {
    validate: validate,
    validatePromo: validatePromo,
    validateVoucher: validateVoucher,
    additionalRequirements: additionalRequirements
  };
}];

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['api', '$rootScope', function (api, $rootScope) {
  return {
    collectOptions: function collectOptions(data) {
      return api.post('/options', data).then(function (response) {
        return response.data;
      });
    },
    collectExtras: function collectExtras(data) {
      return api.post('/extras', data).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(13);

exports.default = [function () {
    return {
        throttle: function throttle(func, timeout, args) {
            return (0, _lodash.throttle)(func, timeout, args);
        }
    };
}];

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', 'basketApiService', 'basket', 'storeService', function (api, basketApiService, basket, storeService) {
    var callUpgradeApi = function callUpgradeApi(payload, error) {
        basket.saving = true;
        var basketCode = storeService.get('basket');

        return api.post('checkout/basket/' + basketCode + '/upgrade', payload).then(function () {
            return basketApiService.retrieveBasket(basketCode, true).then(function (response) {
                basket.contents = response;

                basket.saving = false;
            });
        }).catch(function () {
            basket.saving = false;
            throw error;
        });
    };

    var upgrade = function upgrade(events) {
        return callUpgradeApi({
            'guest_items': events.map(function (event) {
                return event.id;
            })
        }, {
            message: 'Error upgrading events'
        });
    };

    return {
        upgrade: upgrade
    };
}];

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        find: function find(basketCode) {
            return api.get('suggestions/' + basketCode).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        validate: function validate(basketCode, promoCode) {
            return api.get('api/' + basketCode + '/promocode/' + promoCode).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['api', function (api) {
  return {
    validate: function validate(basketCode, voucherCode) {
      return api.get('api/' + basketCode + '/vouchercode/' + voucherCode).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var navigationService = function navigationService(checkout, basket, order, messageService, paymentTokenService, cardActionService, checkoutValidationService, configService) {
  var next = function next() {
    return checkoutValidationService.validate(checkout.step).then(function (isValid) {
      if (isValid) {
        basket.paymentErrors = undefined;
        checkout.error = undefined;
        checkout.saving = true;
        basket.saving = true;
        if (checkout.nextid) {
          switch (checkout.nextid) {
            case 'order-submit':
              return paymentToComplete();
          }
        }

        return checkout.travelNext();
      }
    });
  };

  var paymentToComplete = function paymentToComplete() {
    var gateway = configService.get('gateways');

    if (gateway) {
      if (gateway.none || order.contents.total === 0) {
        return updateOrderAndContinue();
      }

      return validatePayment();
    }
  };

  var updateOrderAndContinue = function updateOrderAndContinue() {
    return order.updateOrder(order.contents).then(function () {
      return travelNext();
    });
  };

  var validatePayment = function validatePayment() {
    if (checkout.checkTimestamp()) {
      return updateOrderAndContinue();
    }

    return paymentTokenService.generateToken().then(function (response) {
      if (response.token) {
        return order.handleUpdateSuccess(response.token, response.timestamp, response.card).then(function () {
          return travelNext();
        });
      }
    }).catch(function (error) {
      displayErrors(error);
      return order.handleUpdateError({ code: 'token_fail', message: error[0] });
    });
  };

  var displayErrors = function displayErrors(errors) {
    if (!errors) {
      return checkout.error = undefined;
    }

    messageService.add('Sorry, something went wrong, please try resubmitting your details.');
    messageService.failure();
    checkout.error = errors || ['There has been an issue with the payment service'];
    checkout.scrollToError();
    basket.saving = false;
    checkout.saving = false;
  };

  var travelNext = function travelNext() {
    return checkout.travelNext().then(function (response) {
      if (response && response === 'requires_action') {
        checkout.setStepByName('payment');
        return cardActionService.handleCardAction(basket.contents.client_secret).then(function () {
          return travelNext();
        }).catch(function (error) {
          if (Array.isArray(error)) {
            error = error[0];
          }
          order.invalidateToken();
          checkout.addError(error);
          basket.saving = false;
          checkout.saving = false;
        });
      }
    });
  };

  return {
    next: next
  };
};

navigationService.$inject = ['checkout', 'basket', 'order', 'messageService', 'paymentTokenService', 'cardActionService', 'checkoutValidationService', 'configService'];

exports.default = navigationService;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _apiOrder = __webpack_require__(846);

var _apiOrder2 = _interopRequireDefault(_apiOrder);

var _order = __webpack_require__(847);

var _order2 = _interopRequireDefault(_order);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var storefrontOrderModule = angular.module('spabooker.storefrontOrder', []).factory('apiOrderService', _apiOrder2.default).factory('order', _order2.default);
exports.default = storefrontOrderModule.name;

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var endpoint = 'checkout/order';

exports.default = ['api', function (api) {
  return {
    generateOrder: function generateOrder(basket_id) {
      return api.post(endpoint + '/generate/' + basket_id).then(function (response) {
        return response.data;
      });
    },
    retrieveOrder: function retrieveOrder(basket_id) {
      return api.get(endpoint + '/' + basket_id).then(function (response) {
        return response.data;
      });
    },
    updateOrder: function updateOrder(order) {
      return api.post(endpoint, order).then(function (response) {
        return response.data;
      });
    },
    submitTransaction: function submitTransaction(basket_id, transaction) {
      return api.post(endpoint + '/transaction/' + basket_id, transaction).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(13);

exports.default = ['apiOrderService', 'configService', '$window', function (apiOrderService, configService, $window) {

  var order = {};
  order.contents = {
    'basket_identity_code': null,
    'customer': {},
    'customer_id': 0,
    'payment_status': '',
    'payment_token': null,
    'promo_details': '',
    'voucher_details': ''
  };

  order.generateOrder = function (basket_id) {
    return apiOrderService.generateOrder(basket_id).then(function (response) {

      if (response.customer && order.contents.customer && !Object.keys(response.customer).length) {
        response.customer = order.contents.customer;
      }

      response.vouchers = response.vouchers && response.vouchers.length ? response.vouchers : [];
      order.contents = response;
      return order.contents;
    });
  };

  order.retrieveOrder = function (basket_id) {
    return apiOrderService.retrieveOrder(basket_id).then(function (response) {
      order.contents = response;
    }).catch(function () {
      // Swallow error
    });
  };

  order.handleUpdateError = function (error) {
    order.contents.payment_status_id = 2; // token_error

    return order.handleOrderUpdates(error);
  };

  order.handleUpdateSuccess = function (token, timestamp, card) {
    order.contents.payment_status_id = 3; // token
    order.contents.payment_token = token;
    order.contents.payment_token_timestamp = timestamp;

    if (configService.get('gateways.stripe') && card) {
      order.contents.avs_country = card.country || null;
    }

    return order.handleOrderUpdates({ 'code': 'token', 'message': 'Payment token created.' });
  };

  order.handleOrderUpdates = function (submitTransaction) {
    return order.updateOrder(order.contents).then(function () {
      if (submitTransaction) {
        order.submitTransaction(submitTransaction);
      }
    }).catch(function () {
      //
    });
  };

  order.updateOrder = function () {
    if (order.contents.vouchers && order.contents.vouchers.length) {
      order.contents.promo_details = null;
    }

    return apiOrderService.updateOrder(order.contents);
  };

  order.submitTransaction = function (transaction) {
    if (order.contents.basket_identity_code) {
      return apiOrderService.submitTransaction(order.contents.basket_identity_code, transaction).catch(function () {
        //
      });
    }

    if ($window.Sentry) {
      $window.Sentry.withScope(function (scope) {
        scope.setExtra('transaction', transaction);
        $window.Sentry.captureMessage('Fail submitting transaction, no order for basket: ' + order.contents.basket_identity_code);
      });
    }

    return;
  };

  order.earliestOrder = function () {
    var dates = (0, _lodash.map)(order.contents.item, function (item) {
      return item.date + ' ' + item.preferred_time;
    });

    return (0, _lodash.min)(dates);
  };

  order.invalidateToken = function () {
    order.contents.payment_token_timestamp = 0;
    order.contents.payment_token = null;
    order.contents.order_status_id = 1;
    return true;
  };

  return order;
}];

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _availabilityApi = __webpack_require__(849);

var _availabilityApi2 = _interopRequireDefault(_availabilityApi);

var _startTimeApi = __webpack_require__(850);

var _startTimeApi2 = _interopRequireDefault(_startTimeApi);

var _quantityApi = __webpack_require__(851);

var _quantityApi2 = _interopRequireDefault(_quantityApi);

var _offerApi = __webpack_require__(852);

var _offerApi2 = _interopRequireDefault(_offerApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var availabilityModule = angular.module('spabooker.availability', []).factory('availabilityApiService', _availabilityApi2.default).factory('startTimeApiService', _startTimeApi2.default).factory('quantityApiService', _quantityApi2.default).factory('offerService', _offerApi2.default);
exports.default = availabilityModule.name;

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.default = ['api', 'availabilityCacheService', function (api, availabilityCacheService) {
  var switchEventType = function switchEventType(eventType) {
    switch (eventType.toLowerCase()) {
      case 'treatment':
        return 'treatments';
      case 'day':
      case 'spaday':
      case 'spa day':
        return 'spa-days';
      case 'activity':
        return 'activities';
      default:
        return null;
    }
  };

  return {
    switchEventType: switchEventType,
    uncacheDate: function uncacheDate(eventType, eventId, date) {
      return availabilityCacheService.uncacheDate(eventType, eventId, date);
    },

    requestAvailability: function requestAvailability(fromDate, toDate, eventType, eventId) {
      var offerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      var cached = availabilityCacheService.datesCached(eventType, eventId, fromDate, toDate);

      if (cached.length) {
        return Promise.resolve(cached);
      }

      var url = switchEventType(eventType) + '/' + eventId + '/availability?from_date=' + fromDate + '&to_date=' + toDate;

      if (offerId) {
        if ((typeof offerId === 'undefined' ? 'undefined' : _typeof(offerId)) === 'object') {
          offerId = offerId.id;
        }
        url += '&offer_id=' + offerId;
      }

      return api.get(url).then(function (response) {
        availabilityCacheService.updateCache(eventType, eventId, response.data);
        return response.data;
      });
    },

    requestAvailabilityList: function requestAvailabilityList(date, eventType) {
      var eventIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var offerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      var url = switchEventType(eventType) + '/availability?date=' + date;

      if (eventIds) {
        url += '&event_ids=' + eventIds.join(',');
      }

      if (offerId) {
        url += '&offer_id=' + offerId;
      }

      return api.get(url).then(function (response) {
        return response.data;
      });
    },

    requestCreditAvailabilityList: function requestCreditAvailabilityList(date) {
      return api.get('treatments/availability/credit?date=' + date).then(function (response) {
        return response.data;
      });
    },

    requestOfferDetails: function requestOfferDetails(offerId) {
      return api.get('offers/' + offerId).then(function (response) {
        return response.data;
      });
    },

    requestExternalAvailability: function requestExternalAvailability(eventType, dateFrom, dateTo, externalId) {
      return api.get('api/externalAvailability/' + switchEventType(eventType) + '/' + externalId + '?date_from=' + dateFrom + '&date_to=' + dateTo).then(function (response) {
        return response.data;
      });
    }
  };
}];

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: function find(date, eventType, eventId) {
            return api.get(availabilityApiService.switchEventType(eventType) + '/' + eventId + '/start-times?date=' + date).then(function (response) {
                if (!response.data.length) {
                    availabilityApiService.uncacheDate(eventType, eventId, date);
                    return false;
                }
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: function find(date, eventType, eventId, time) {
            var numberOfGuests = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

            if (numberOfGuests) {
                numberOfGuests = '&guests=' + numberOfGuests;
            }
            return api.get(availabilityApiService.switchEventType(eventType) + '/' + eventId + '/quantity?date=' + date + '&time=' + time + numberOfGuests).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        getDetails: function getDetails(offerId) {
            return api.get('offers/' + offerId).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _user = __webpack_require__(854);

var _user2 = _interopRequireDefault(_user);

var _orderHistory = __webpack_require__(855);

var _orderHistory2 = _interopRequireDefault(_orderHistory);

var _orderHistoryTimeframe = __webpack_require__(856);

var _orderHistoryTimeframe2 = _interopRequireDefault(_orderHistoryTimeframe);

var _orderHistoryPagination = __webpack_require__(857);

var _orderHistoryPagination2 = _interopRequireDefault(_orderHistoryPagination);

var _register = __webpack_require__(858);

var _register2 = _interopRequireDefault(_register);

var _accountPassword = __webpack_require__(859);

var _accountPassword2 = _interopRequireDefault(_accountPassword);

var _passwordInput = __webpack_require__(860);

var _passwordInput2 = _interopRequireDefault(_passwordInput);

var _editReservation = __webpack_require__(866);

var _editReservation2 = _interopRequireDefault(_editReservation);

var _orderHistory3 = __webpack_require__(867);

var _orderHistory4 = _interopRequireDefault(_orderHistory3);

var _orderHistoryTimeframe3 = __webpack_require__(869);

var _orderHistoryTimeframe4 = _interopRequireDefault(_orderHistoryTimeframe3);

var _orderHistoryPagination3 = __webpack_require__(871);

var _orderHistoryPagination4 = _interopRequireDefault(_orderHistoryPagination3);

var _register3 = __webpack_require__(873);

var _register4 = _interopRequireDefault(_register3);

var _accountPassword3 = __webpack_require__(875);

var _accountPassword4 = _interopRequireDefault(_accountPassword3);

var _appSetPassword = __webpack_require__(877);

var _appSetPassword2 = _interopRequireDefault(_appSetPassword);

var _passwordInput3 = __webpack_require__(879);

var _passwordInput4 = _interopRequireDefault(_passwordInput3);

var _editReservation3 = __webpack_require__(881);

var _editReservation4 = _interopRequireDefault(_editReservation3);

var _user3 = __webpack_require__(883);

var _user4 = _interopRequireDefault(_user3);

var _authenticateApi = __webpack_require__(884);

var _authenticateApi2 = _interopRequireDefault(_authenticateApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userModule = angular.module('spabooker.user', []).config(_user2.default).controller('orderHistoryController', _orderHistory2.default).controller('orderHistoryTimeframeController', _orderHistoryTimeframe2.default).controller('orderHistoryPaginationController', _orderHistoryPagination2.default).controller('registerController', _register2.default).controller('accountPasswordController', _accountPassword2.default).controller('passwordInputController', _passwordInput2.default).controller('editReservationController', _editReservation2.default).component('orderHistory', _orderHistory4.default).component('orderHistoryTimeframe', _orderHistoryTimeframe4.default).component('orderHistoryPagination', _orderHistoryPagination4.default).component('register', _register4.default).component('accountPassword', _accountPassword4.default).component('appPassword', _appSetPassword2.default).component('passwordInput', _passwordInput4.default).component('editReservation', _editReservation4.default).factory('userService', _user4.default).factory('authenticateApi', _authenticateApi2.default);
exports.default = userModule.name;

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ['$stateProvider', function ($stateProvider) {
  $stateProvider.state('orderHistory', {
    url: '/booking-history',
    component: 'orderHistory'
  }).state('register', {
    url: '/register',
    component: 'register'
  }).state('editReservation', {
    url: '/manage-booking',
    component: 'editReservation'
  });
}];

/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryController = function () {
    function OrderHistoryController(userService) {
        _classCallCheck(this, OrderHistoryController);

        this.userService = userService;
    }

    _createClass(OrderHistoryController, [{
        key: '$onInit',
        value: function $onInit() {
            this.orders = {};
            this.loading = [];

            return this.getOrders();
        }
    }, {
        key: 'getOrders',
        value: function getOrders() {
            return Promise.all([this.getOrdersByTime('future'), this.getOrdersByTime('past')]);
        }
    }, {
        key: 'getOrdersByTime',
        value: function getOrdersByTime(timeframe) {
            var _this = this;

            var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

            if (this.isLoading(timeframe)) {
                return;
            }

            this.loading.push(timeframe);
            this.orders[timeframe] = {};

            return this.userService.orderHistory(timeframe, page).then(function (response) {
                _this.orders[timeframe] = response;
            }).catch(function () {}).then(function () {
                _this.stopLoading(timeframe);
            });
        }
    }, {
        key: 'stopLoading',
        value: function stopLoading(timeframe) {
            var index = this.loading.indexOf(timeframe);
            if (index > -1) {
                this.loading.splice(index, 1);
            }
        }
    }, {
        key: 'isLoading',
        value: function isLoading(timeframe) {
            return this.loading.indexOf(timeframe) > -1;
        }
    }]);

    return OrderHistoryController;
}();

OrderHistoryController.$inject = ['userService'];

exports.default = OrderHistoryController;

/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _moment = __webpack_require__(0);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryTimeframeController = function () {
    function OrderHistoryTimeframeController($window, moneyService, userService, messageService, urlService) {
        _classCallCheck(this, OrderHistoryTimeframeController);

        this.$window = $window;
        this.moneyService = moneyService;
        this.userService = userService;
        this.messageService = messageService;
        this.urlService = urlService;
    }

    _createClass(OrderHistoryTimeframeController, [{
        key: '$onInit',
        value: function $onInit() {
            this.openOrders = [];
            this.sentEmails = [];
        }
    }, {
        key: 'hasOrders',
        value: function hasOrders() {
            return !!(this.orders && this.orders.data && this.orders.data.length);
        }
    }, {
        key: 'formatDate',
        value: function formatDate(date) {
            var removeDay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (date) {
                if (date.length === 10) {
                    date += ' 00:00:00';
                }

                var format = 'dddd Do MMMM, YYYY';
                if (removeDay) {
                    format = 'Do MMMM, YYYY';
                }

                return (0, _moment2.default)(date + '+00:00').format(format);
            }
        }
    }, {
        key: 'formatDateShort',
        value: function formatDateShort(date) {
            if (date) {
                if (date.length === 10) {
                    date += ' 00:00:00';
                }
                return (0, _moment2.default)(date + '+00:00').format('D.M.YYYY');
            }
        }
    }, {
        key: 'toggleOrder',
        value: function toggleOrder(orderReference) {
            var index = this.openOrders.indexOf(orderReference);
            if (index > -1) {
                this.openOrders.splice(index, 1);
                return;
            }

            this.openOrders.push(orderReference);
        }
    }, {
        key: 'isOrderOpen',
        value: function isOrderOpen(orderReference) {
            return this.openOrders.indexOf(orderReference) > -1;
        }
    }, {
        key: 'sendInvoice',
        value: function sendInvoice(order) {
            var _this = this;

            this.loading = true;

            return this.userService.emailInvoice(order.basket_identity_code).then(function () {
                _this.sentEmails.push(order.order_reference);
                _this.messageService.add('A sales invoice has been emailed for ' + order.order_reference);
                _this.messageService.success();
            }).catch(function () {
                _this.messageService.add('Failed to send the email. Please try again or contact us');
                _this.messageService.failure();
            }).then(function () {
                _this.loading = false;
            });
        }
    }, {
        key: 'emailSent',
        value: function emailSent(orderReference) {
            return !!(this.loading || this.sentEmails.indexOf(orderReference) > -1);
        }
    }, {
        key: 'displayTotal',
        value: function displayTotal(order) {
            var refundTotal = this.sumArray(order.refund);
            if (refundTotal > 0) {
                return this.displayPrice(order.total - refundTotal, order.currency_code);
            }
            return this.displayPrice(order.total, order.currency_code);
        }
    }, {
        key: 'displayPrice',
        value: function displayPrice(price, currencyCode) {
            return this.moneyService.reduce(price, currencyCode);
        }
    }, {
        key: 'displayRefundValue',
        value: function displayRefundValue(order) {
            var refundTotal = this.sumArray(order.refund);
            return this.displayPrice(refundTotal, order.currency_code);
        }
    }, {
        key: 'sumArray',
        value: function sumArray(array) {
            if (array && array.length) {
                return array.reduce(function (a, b) {
                    return a + b;
                }, 0);
            }
            return 0;
        }
    }, {
        key: 'orderHasDiscounts',
        value: function orderHasDiscounts(order) {
            return !!(this.isOrderOpen(order.order_reference) && (order.promo_details || order.vouchers.length || order.refund.length));
        }
    }, {
        key: 'orderHasAgreement',
        value: function orderHasAgreement(order) {
            return !!(this.isOrderOpen(order.order_reference) && this.timeframe === 'upcoming' && order.cancellation_agreement);
        }
    }, {
        key: 'getUrlAndGo',
        value: function getUrlAndGo(item) {
            var _this2 = this;

            return this.urlService.getUrl(item.item_type, item.item_id).then(function (response) {
                _this2.$window.location = response;
            }).catch(function () {});
        }
    }]);

    return OrderHistoryTimeframeController;
}();

OrderHistoryTimeframeController.$inject = ['$window', 'moneyService', 'userService', 'messageService', 'urlService'];

exports.default = OrderHistoryTimeframeController;

/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderHistoryPaginationController = function () {
    function OrderHistoryPaginationController($window, $timeout) {
        _classCallCheck(this, OrderHistoryPaginationController);

        this.$window = $window;
        this.$timeout = $timeout;
    }

    _createClass(OrderHistoryPaginationController, [{
        key: 'getPage',
        value: function getPage(pageNumber) {
            var _this = this;

            this.loading = true;
            return this.callback({ timeframe: this.timeframe, page: pageNumber }).then(function () {
                _this.loading = false;
                _this.$timeout(function () {
                    _this.$window.document.getElementById(_this.timeframe).scrollIntoView({ behavior: "smooth" });
                });
            });
        }
    }, {
        key: 'getPreviousPage',
        value: function getPreviousPage() {
            return this.getPage(this.orders.current_page - 1);
        }
    }, {
        key: 'getNextPage',
        value: function getNextPage() {
            return this.getPage(this.orders.current_page + 1);
        }
    }, {
        key: 'isPage',
        value: function isPage(pageNumber) {
            return this.orders.current_page === pageNumber;
        }
    }, {
        key: 'generatePages',
        value: function generatePages() {
            var pages = [];

            if (this.orders.last_page > 1) {
                var startPage = 1;
                var endPage = this.orders.last_page;

                if (this.orders.last_page > 10) {
                    if (this.orders.current_page <= 5) {
                        startPage = 1;
                        endPage = 10;
                    } else if (this.orders.current_page + 4 >= this.orders.last_page) {
                        startPage = this.orders.last_page - 9;
                        endPage = this.orders.last_page;
                    } else {
                        startPage = this.orders.current_page - 5;
                        endPage = this.orders.current_page + 4;
                    }
                }

                pages = this.interpolatePages(startPage, endPage);
            }

            return pages;
        }
    }, {
        key: 'interpolatePages',
        value: function interpolatePages(startPage, endPage) {
            return Array.from(Array(endPage + 1 - startPage).keys()).map(function (i) {
                return startPage + i;
            });
        }
    }]);

    return OrderHistoryPaginationController;
}();

OrderHistoryPaginationController.$inject = ['$window', '$timeout'];

exports.default = OrderHistoryPaginationController;

/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var RegisterController = function () {
  function RegisterController(authenticateApi, basket, storeService, propertyService) {
    _classCallCheck(this, RegisterController);

    this.authenticateApi = authenticateApi;
    this.basket = basket;
    this.storeService = storeService;
    this.propertyService = propertyService;
  }

  _createClass(RegisterController, [{
    key: '$onInit',
    value: function $onInit() {
      var _this = this;

      if (!!this.storeService.get('client_id') || !!this.storeService.get('reservation')) {
        this.hasAccount = true;
        return;
      }

      return this.basket.promise.then(function () {
        _this.canSubmit = true;
      });
    }
  }, {
    key: 'register',
    value: function register() {
      var _this2 = this;

      if (this.validateForm()) {
        this.saving = true;

        return this.authenticateApi.register({
          title: this.title,
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          gender: this.gender,
          password: this.password,
          basketCode: this.basket.contents.identity_code
        }).then(function (response) {
          _this2.storeService.set('client_id', response.client);
          _this2.storeService.set('client_name', response.name);
          _this2.storeService.set('basket', response.basket);
          _this2.success = true;
        }).catch(function () {
          _this2.error = 'Sorry, there was a problem registering your account. Please try again or contact us.';
        }).then(function () {
          _this2.saving = false;
        });
      }
    }
  }, {
    key: 'validateForm',
    value: function validateForm() {
      this.error = null;
      this.errorSuggestion = null;

      if (!this.title || !this.firstName || !this.lastName || !this.email || !this.gender || !this.password) {
        this.error = 'Please fill all fields';
        return false;
      }

      if (this.password.length < 8) {
        this.error = 'Please enter a longer password';
        this.errorSuggestion = 'It must be at least 8 characters in length';
        return false;
      }

      if (!this.strength || this.strength.score <= 2) {
        this.error = 'Please enter a stronger password';
        this.errorSuggestion = this.strength.feedback.suggestions.join(' ');
        return false;
      }

      return true;
    }
  }, {
    key: 'guessGender',
    value: function guessGender() {
      var _this3 = this;

      var female = ['Miss', 'Mrs.', 'Ms.'];

      if (this.title) {
        if (this.title === 'Mr.') {
          this.gender = 'M';
          return;
        }

        if (female.find(function (title) {
          return title === _this3.title;
        })) {
          this.gender = 'F';
        }
      }
    }
  }, {
    key: 'displayName',
    value: function displayName() {
      return this.storeService.get('client_name');
    }
  }, {
    key: 'displayEventTypes',
    value: function displayEventTypes() {
      var types = [];
      var link = '';

      if (this.propertyService.get('hasTreatments')) {
        link = '/treatments';
        if (this.propertyService.get('listTreatments')) {
          link = '/categories/treatments';
        }
        types.push('<a href="' + link + '">Treatments</a>');
      }

      if (this.propertyService.get('hasSpaDays')) {
        link = '/spa-days';
        if (this.propertyService.get('listSpaDays')) {
          link = '/categories/spa-days';
        }
        types.push('<a href="' + link + '">Spa Days</a>');
      }

      if (this.propertyService.get('hasActivities')) {
        types.push('<a href="/activities">Activities</a>');
      }

      if (types) {
        return types.join(' or ');
      }

      return '';
    }
  }, {
    key: 'displayForm',
    value: function displayForm() {
      return !(this.hasAccount || this.success);
    }
  }, {
    key: 'displayCheckoutLink',
    value: function displayCheckoutLink() {
      return '<a href="/checkout/' + this.basket.contents.first_step + '">continue to checkout</a>';
    }
  }]);

  return RegisterController;
}();

RegisterController.$inject = ['authenticateApi', 'basket', 'storeService', 'propertyService'];

exports.default = RegisterController;

/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AccountPasswordController = function () {
  function AccountPasswordController($timeout, authenticateApi, loginoutService) {
    _classCallCheck(this, AccountPasswordController);

    this.$timeout = $timeout;
    this.authenticateApi = authenticateApi;
    this.loginoutService = loginoutService;
  }

  _createClass(AccountPasswordController, [{
    key: 'submit',
    value: function submit() {
      var _this = this;

      this.saving = true;

      if (!this.validate()) {
        this.$timeout(function () {
          _this.saving = false;
        }, 100);
        return;
      }

      return this.authenticateApi.setCustomerPassword({
        customer_id: this.customerId,
        password: this.password
      }).then(function () {
        _this.success = true;
      }).catch(function () {
        _this.error = 'Sorry, we were unable to create your account. Please contact us or try again.';
      }).then(function () {
        _this.saving = false;
      });
    }
  }, {
    key: 'submitCorePassword',
    value: function submitCorePassword() {
      var _this2 = this;

      this.saving = true;

      if (!this.validate()) {
        this.$timeout(function () {
          _this2.saving = false;
        }, 100);
        return;
      }

      return this.authenticateApi.setCorePassword({
        core_id: this.coreId,
        password: this.password
      }).then(function () {
        _this2.success = true;
      }).catch(function () {
        _this2.error = 'Sorry, we were unable to set your password. Please contact us or try again.';
      }).then(function () {
        _this2.saving = false;
      });
    }
  }, {
    key: 'validate',
    value: function validate() {
      this.error = null;
      this.errorSuggestion = null;

      if (!this.password || this.password.length < 8) {
        this.error = 'Please enter a longer password.';
        this.errorSuggestion = 'It must be at least 8 characters in length';
        return false;
      }

      if (this.strength.score <= 2) {
        this.error = 'Please enter a stronger password.';
        this.errorSuggestion = this.strength.feedback.suggestions.join(' ');
        return false;
      }

      return true;
    }
  }, {
    key: 'openLoginPrompt',
    value: function openLoginPrompt() {
      this.loginoutService.login(true);
    }
  }]);

  return AccountPasswordController;
}();

AccountPasswordController.$inject = ['$timeout', 'authenticateApi', 'loginoutService'];

exports.default = AccountPasswordController;

/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _zxcvbn = __webpack_require__(861);

var _zxcvbn2 = _interopRequireDefault(_zxcvbn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PasswordInputController = function () {
    function PasswordInputController() {
        _classCallCheck(this, PasswordInputController);
    }

    _createClass(PasswordInputController, [{
        key: '$onInit',
        value: function $onInit() {
            this.strength = {};
        }
    }, {
        key: 'checkStrength',
        value: function checkStrength() {
            this.strength = {};
            this.error = null;

            if (this.password) {
                this.strength = (0, _zxcvbn2.default)(this.password);
            }

            if (!this.password || !this.strength || !this.strength.score || this.strength.score < 3) {
                this.error = true;
            }
        }
    }]);

    return PasswordInputController;
}();

PasswordInputController.$inject = [];

exports.default = PasswordInputController;

/***/ }),
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _momentTimezone = __webpack_require__(125);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditReservationController = function () {
  function EditReservationController($window, $timeout, authenticateApi, basket, storeService, propertyService, configService, dateService, contentService, markdownService) {
    _classCallCheck(this, EditReservationController);

    this.$window = $window;
    this.$timeout = $timeout;
    this.authenticateApi = authenticateApi;
    this.basket = basket;
    this.storeService = storeService;
    this.propertyService = propertyService;
    this.configService = configService;
    this.dateService = dateService;
    this.contentService = contentService;
    this.markdownService = markdownService;
  }

  _createClass(EditReservationController, [{
    key: '$onInit',
    value: function $onInit() {
      this.displaySuccess();

      this.setCalendarMinDate();

      this.getContent();
    }
  }, {
    key: 'editReservation',
    value: function editReservation() {
      var _this = this;

      this.error = null;

      if (this.reference && this.surname && this.date) {
        this.saving = true;

        return this.authenticateApi.byReference({
          reference: this.reference,
          surname: this.surname,
          date: this.date,
          basketCode: this.basket.contents.identity_code
        }).then(function (response) {
          _this.storeService.set('reservation', response.reference);
          _this.storeService.set('client_name', response.name);
          _this.storeService.set('basket', response.basket);
          _this.storeService.set('start_date', response.startDate);
          _this.storeService.set('end_date', response.endDate);
          _this.storeService.set('searchDate', response.startDate);
          _this.displaySuccess();

          return _this.basket.getApiBasket();
        }).catch(function (error) {
          if (error && error.data && error.data.reason) {
            switch (error.data.reason) {
              case 'inPast':
                _this.error = 'Sorry, you cannot edit this booking as the departure date has already passed.';
                break;
              case 'notFound':
                _this.error = 'Sorry, we could not find that booking';
                break;
              default:
                _this.error = 'Sorry, we could not authenticate you with those details';
                break;
            }

            return;
          }
          _this.error = 'Sorry, we could not authenticate you with those details';
        }).then(function () {
          _this.saving = false;
        });
      }
    }
  }, {
    key: 'displaySuccess',
    value: function displaySuccess() {
      if (this.storeService.get('client_id')) {
        this.isLoggedIn = true;
        return false;
      }

      if (this.storeService.get('reservation')) {
        this.isEditing = true;
        return true;
      }

      this.isEditing = false;
      this.isLoggedIn = false;
    }
  }, {
    key: 'setCalendarMinDate',
    value: function setCalendarMinDate() {
      var _this2 = this;

      this.$timeout(function () {
        if (_this2.$window.fpInput && _typeof(_this2.$window.fpInput) === 'object' && typeof _this2.$window.fpInput.set === 'function') {
          _this2.$window.fpInput.set('minDate', (0, _momentTimezone2.default)().subtract(6, 'weeks').format('YYYY-MM-DD'));
        }
      }, 1000);
    }
  }, {
    key: 'displayName',
    value: function displayName() {
      return this.storeService.get('client_name');
    }
  }, {
    key: 'displayReference',
    value: function displayReference() {
      return this.basket.contents.reservation_reference;
    }
  }, {
    key: 'displayDates',
    value: function displayDates() {
      return this.dateService.displayFromToDate(this.storeService.get('start_date'), this.storeService.get('end_date')) || '';
    }
  }, {
    key: 'displayUrl',
    value: function displayUrl(type) {
      switch (type) {
        case 'treatments':
          if (this.propertyService.get('listTreatments')) {
            return '/categories/treatments';
          }

          return '/treatments';
        case 'spadays':
          if (this.propertyService.get('listSpaDays')) {
            return '/categories/spa-days';
          }

          return '/spa-days';
        case 'activities':
          return '/activities';
      }
    }
  }, {
    key: 'displayEventTypes',
    value: function displayEventTypes() {
      var types = [];

      if (this.propertyService.get('hasTreatments')) {
        types.push('Treatments');
      }

      if (this.propertyService.get('hasSpaDays')) {
        types.push('Spa Days');
      }

      if (this.propertyService.get('hasActivities') && this.openActivities()) {
        types.push('Activities');
      }

      return types.join(' or ');
    }
  }, {
    key: 'openActivities',
    value: function openActivities() {
      return this.propertyService.get('openActivities');
    }
  }, {
    key: 'getContent',
    value: function getContent() {
      var _this3 = this;

      return this.contentService.getContent('manage-booking').then(function (response) {
        if (response && response.body) {
          _this3.content = response.body.text;
        }
      });
    }
  }]);

  return EditReservationController;
}();

EditReservationController.$inject = ['$window', '$timeout', 'authenticateApi', 'basket', 'storeService', 'propertyService', 'configService', 'dateService', 'contentService', 'markdownService'];

exports.default = EditReservationController;

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'orderHistoryController',
    template: __webpack_require__(868)
};

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "<div class=grid-x> <div class=\"cell large-auto\"></div> <div class=\"cell large-8\"> <section class=c-order-history id=future> <h2>Upcoming Bookings</h2> <spinner ng-if=\"$ctrl.isLoading('future')\"></spinner> <div ng-if=\"!$ctrl.isLoading('future')\"> <order-history-timeframe orders=$ctrl.orders.future timeframe=upcoming></order-history-timeframe> <order-history-pagination timeframe=future loading=$ctrl.loading callback=\"$ctrl.getOrdersByTime(timeframe, page)\" orders=$ctrl.orders.future></order-history-pagination> </div> </section> <section class=c-order-history id=past> <h2 class=c-order-history__heading>Past Bookings</h2> <spinner ng-if=\"$ctrl.isLoading('past')\"></spinner> <div ng-if=\"!$ctrl.isLoading('past')\"> <order-history-timeframe orders=$ctrl.orders.past timeframe=past></order-history-timeframe> {{$ctrl.pagination.past}} <order-history-pagination timeframe=past loading=$ctrl.loading callback=\"$ctrl.getOrdersByTime(timeframe, page)\" orders=$ctrl.orders.past></order-history-pagination> </div> </section> </div> <div class=\"cell large-auto\"></div> </div> ";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        orders: '<',
        timeframe: '@'
    },
    controller: 'orderHistoryTimeframeController',
    template: __webpack_require__(870)
};

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=$ctrl.hasOrders()> <div ng-repeat=\"order in $ctrl.orders.data\" class=c-order-history__order ng-class=\"{\n        'c-order-history__order--open': $ctrl.isOrderOpen(order.order_reference),\n        'c-order-history__order--cancelled': order.order_status === 'Cancelled'\n    }\"> <div class=grid-x> <div class=\"cell auto\"> <div class=c-order-history__meta><span class=show-for-medium>Order</span> {{ order.order_reference }} &bull; {{ $ctrl.displayTotal(order) }}</div> </div> <div class=\"cell shrink\"> <div class=\"c-order-history__meta show-for-small-only\">{{ $ctrl.formatDateShort(order.created_at) }}</div> <div class=\"c-order-history__meta show-for-medium\">{{ $ctrl.formatDate(order.created_at, true) }}</div> </div> </div> <div class=grid-x> <div class=\"cell medium-auto\"> <div ng-repeat=\"item in order.item\" class=c-order-history__item> <div class=c-order-history__name> <div class=grid-x> <div class=\"cell auto\"> {{ item.name }}<span ng-if=item.integration_staff_name> with {{ (item.integration_staff) ? item.integration_staff_name : item.integration_staff_name[0].toLowerCase() + item.integration_staff_name.substr(1) }}</span> <a ng-click=$ctrl.getUrlAndGo(item) class=c-order-history__book-again> <div class=c-order-history__tooltip>Book again</div> <icon icon=return></icon> </a> </div> <div class=\"cell shrink\" ng-if=$ctrl.isOrderOpen(order.order_reference)> <span class=c-order-history__item__price>{{ $ctrl.displayPrice(item.price, order.currency_code) }}</span> </div> </div> </div> <div class=c-order-history__dateTime> <em>{{ $ctrl.formatDate(item.date) }} at {{ item.display_time }}</em> </div> <div class=c-order-history__guest ng-if=$ctrl.isOrderOpen(order.order_reference)> <em>for {{ item.guest_name }}</em> </div> <div class=c-order-history__children ng-if=\"$ctrl.isOrderOpen(order.order_reference) && item.children.length\"> <strong>Customisations</strong> <div ng-repeat=\"child in item.children\" class=c-order-history__child> <div class=c-order-history__child__name> <div class=grid-x> <div class=\"cell auto\"> <span ng-if=\"child.price > 0\">+ </span>{{ child.name }} </div> <div class=\"cell shrink\" ng-if=\"child.price > 0\"> <span class=c-order-history__item__price>+{{ $ctrl.displayPrice(child.price, order.currency_code) }}</span> </div> </div> </div> </div> </div> </div> <div class=c-order-history__discounts ng-if=$ctrl.orderHasDiscounts(order)> <div ng-if=order.promo_details>Promotional code applied: <pre>{{ order.promo_details }}</pre> </div> <div ng-if=order.vouchers.length>Vouchers applied: <div ng-repeat=\"voucher in order.vouchers\"> {{ voucher.codetype }}: <pre>{{ voucher.code }}</pre> </div> </div> <div ng-if=order.refund.length>Refunded: {{ $ctrl.displayRefundValue(order) }}</div> </div> <p class=c-order-history__agreement ng-if=$ctrl.orderHasAgreement(order)> <strong>I have agreed that cancellations made at short notice may not be refundable.</strong> </p> <p class=c-order-history__status> Status: {{ order.order_status }} <span ng-if=\"order.payment_status !== 'Payment taken successfully'\"> &bull; {{ order.payment_status }} </span> </p> <p class=c-order-history__meta ng-if=$ctrl.isOrderOpen(order.order_reference)>Booked on {{ $ctrl.formatDate(order.created_at) }} by {{ order.customer }}</p> </div> <div class=\"cell medium-shrink / c-buttons\"> <div> <button type=button class=c-button ng-click=$ctrl.toggleOrder(order.order_reference)> <span ng-if=!$ctrl.isOrderOpen(order.order_reference)>View booking details</span> <span ng-if=$ctrl.isOrderOpen(order.order_reference)>View less details</span> </button> </div> <div ng-if=\"order.payment_status !== 'Refunded'\"> <button type=button class=\"c-button c-button--hollow\" ng-click=$ctrl.sendInvoice(order) ng-disabled=$ctrl.emailSent(order.order_reference)>Email sales invoice</button> </div> </div> </div> </div> </div> <div ng-if=!$ctrl.hasOrders() class=\"c-empty c-empty--box\"> <p class=\"c-empty__message text-center\"> No {{ $ctrl.timeframe }} bookings </p> </div> ";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        timeframe: '@',
        loading: '<',
        callback: '&',
        orders: '<'
    },
    controller: 'orderHistoryPaginationController',
    template: __webpack_require__(872)
};

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<nav class=\"c-order-history__pagination c-pagination\" ng-if=\"$ctrl.orders.last_page > 1\"> <ol class=grid-x> <li class=\"cell shrink / c-pagination__item\" ng-if=\"$ctrl.orders.current_page !== 1\"> <button ng-click=$ctrl.getPreviousPage() class=\"c-pagination__item--link / t-text--primary\">&lt;</button> </li> <li class=\"cell shrink / c-pagination__item\" ng-repeat=\"item in $ctrl.generatePages()\"> <button ng-click=$ctrl.getPage(item) ng-if=!$ctrl.isPage(item) class=\"c-pagination__item--link / t-text--primary\"> <span class=show-for-sr>Page </span>{{ item }} </button> <span ng-if=$ctrl.isPage(item) class=c-pagination__item--current> <span class=show-for-sr>Page </span>{{ item }} </span> </li> <li class=\"cell shrink / c-pagination__item\" ng-if=\"$ctrl.orders.current_page < $ctrl.orders.last_page\"> <button ng-click=$ctrl.getNextPage() class=\"c-pagination__item--link / t-text--primary\">&gt;</button> </li> </ol> </nav> ";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'registerController',
    template: __webpack_require__(874)
};

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "<div class=\"grid-x / c-register\"> <div class=\"cell medium-auto\"></div> <div class=\"cell medium-8 large-4\"> <div class=\"c-prompt c-prompt--login c-prompt--static\" ng-if=$ctrl.displayForm()> <div class=c-prompt__body> <p class=c-checkout__error ng-if=$ctrl.error ng-bind-html=$ctrl.error></p> <form name=register ng-submit=$ctrl.register() novalidate> <div class=\"c-prompt__inputs / grid-x\"> <div class=\"c-form__field c-form__field--select / cell medium-4\"> <select class=c-form__select name=title autocomplete=honorific-prefix ng-model=$ctrl.title required ng-change=$ctrl.guessGender() ng-disabled=$ctrl.saving> <option value=\"\" disabled=disabled>Select...</option> <option>Miss</option> <option>Mrs.</option> <option>Ms.</option> <option>Mr.</option> <option>Dr.</option> <option>Rev.</option> </select> <label class=\"c-form__label c-form__label--activated / t-text--secondary\">Title</label> </div> <div class=\"c-form__field / cell medium-4\"> <input name=firstName class=c-form__input type=text autocomplete=given-name ng-model=$ctrl.firstName required ng-disabled=$ctrl.saving autofocus> <label class=\"c-form__label t-text--secondary\" for=firstName>First Name</label> </div> <div class=\"c-form__field / cell medium-4\"> <input name=lastName class=c-form__input type=text autocomplete=family-name ng-model=$ctrl.lastName required ng-disabled=$ctrl.saving> <label class=\"c-form__label t-text--secondary\" for=lastName>Last Name</label> </div> <div class=\"c-form__field / cell small-12\"> <input name=email class=c-form__input type=email autocomplete=email ng-model=$ctrl.email required ng-disabled=$ctrl.saving> <label class=\"c-form__label t-text--secondary\" for=email>Email Address</label> </div> <div class=\"c-form__field / cell small-12\"> <div class=\"c-form__field--radio c-form__field--gender\"> <span class=c-form__required></span> <button type=button ng-model=$ctrl.gender ng-click=\"$ctrl.gender = 'F'\" class=c-form__radio ng-class=\"{'active': $ctrl.gender === 'F'}\" ng-disabled=$ctrl.saving>Female</button> <button type=button ng-model=$ctrl.gender ng-click=\"$ctrl.gender = 'M'\" class=c-form__radio ng-class=\"{'active': $ctrl.gender === 'M'}\" ng-disabled=$ctrl.saving>Male</button> <label class=\"c-form__label c-form__label--activated / t-text--secondary\">Gender</label> </div> </div> <div class=\"c-form__field / cell small-12\"> <password-input password=$ctrl.password strength=$ctrl.strength saving=$ctrl.saving></password-input> <p ng-if=$ctrl.errorSuggestion><em>Suggestion: {{ $ctrl.errorSuggestion }}</em></p> <p><small>To conform with our strong password policy, you are required to use a sufficiently strong password. Your password must be at least 8 characters long.</small></p> </div> </div> <div class=c-prompt__buttons> <button class=\"c-button c-button--icon\" type=submit ng-disabled=\"$ctrl.saving || !$ctrl.canSubmit || register.$invalid\" ng-class=\"{'c-button--loading': $ctrl.saving}\"> <span class=c-button__text>Register account</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.saving> <spinner></spinner> </span> </span> </button> </div> </form> </div> </div> <div class=c-register__success ng-if=$ctrl.success> <icon icon=tick class=c-icon--success></icon> <p>Thanks for registering, {{ $ctrl.displayName() }}!</p> <p>You can now add <span ng-bind-html=$ctrl.displayEventTypes()></span> to your basket.<span ng-if=!$ctrl.basket.empty()> You can also <span ng-bind-html=$ctrl.displayCheckoutLink()></span>.</span></p> </div> <div class=\"c-register__loggedin / c-empty c-empty--box ng-cloak\" ng-if=$ctrl.hasAccount> <p class=\"c-empty__message text-center\"> Sorry, you are already logged in. You may not register an account. </p> </div> </div> <div class=\"cell medium-auto\"></div> </div> ";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'customerId': '@',
        'customerEmail': '@'
    },
    controller: 'accountPasswordController',
    template: __webpack_require__(876)
};

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports = "<hr> <div> <h2>Create an account</h2> <div ng-if=!$ctrl.success> <p>Create a password for your spa account now, to speed up booking in future. <br><small>To conform with our strong password policy, you are required to use a sufficiently strong password. Your password must be at least 8 characters long.</small></p> <p>Account Email: {{ $ctrl.customerEmail }}</p> <p ng-if=$ctrl.error ng-bind-html=$ctrl.error class=c-form__error></p> <p ng-if=$ctrl.errorSuggestion><em>Suggestion: {{ $ctrl.errorSuggestion }}</em></p> <form name=createAccount class=\"c-form / c-form--password\" ng-submit=$ctrl.submit()> <div class=grid-x> <div class=\"cell medium-auto\"> <password-input password=$ctrl.password strength=$ctrl.strength saving=$ctrl.saving></password-input> </div> <div class=\"cell medium-shrink\"> <button class=\"c-button c-button--icon\" type=submit ng-disabled=$ctrl.saving ng-class=\"{'c-button--loading': $ctrl.saving}\"> <span class=c-button__text>Create account</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.saving> <spinner></spinner> </span> </span> </button> </div> </div> </form> </div> <div class=c-upgrade__success ng-if=$ctrl.success> <icon icon=tick></icon><span>Success, your account has been created.</span> </div> </div> ";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'coreId': '@',
        'customerName': '@'
    },
    controller: 'accountPasswordController',
    template: __webpack_require__(878)
};

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports = "<div> <div ng-if=!$ctrl.success> <h2>Hi, {{ $ctrl.customerName }},</h2> <p> Create a password for your spa account. <br/><small> To conform with our strong password policy, you are required to use a sufficiently strong password. Your password must be at least 8 characters long. </small> </p> <p ng-if=$ctrl.error ng-bind-html=$ctrl.error class=c-form__error></p> <p ng-if=$ctrl.errorSuggestion> <em>Suggestion: {{ $ctrl.errorSuggestion }}</em> </p> <form name=createAccount class=\"c-form / c-form--password\" ng-submit=$ctrl.submitCorePassword()> <div class=grid-x> <div class=\"cell medium-auto\"> <password-input password=$ctrl.password strength=$ctrl.strength saving=$ctrl.saving></password-input> </div> <div class=\"cell medium-shrink\"> <button class=\"c-button c-button--icon\" type=submit ng-disabled=$ctrl.saving ng-class=\"{'c-button--loading': $ctrl.saving}\"> <span class=c-button__text>Set password</span> <span class=c-button__icon> <span class=c-button__loading ng-if=$ctrl.saving> <spinner></spinner> </span> </span> </button> </div> </div> </form> </div> <div class=\"\" ng-if=$ctrl.success> <div class=c-upgrade__success> <icon icon=tick></icon><span>Success, your password has been set.</span> </div> <p class=text-center> You can now <a ng-click=$ctrl.openLoginPrompt()>log in</a> </p> </div> </div> ";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    bindings: {
        'password': '=',
        'strength': '=',
        'saving': '<'
    },
    controller: 'passwordInputController',
    template: __webpack_require__(880)
};

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "<div class=c-form__field> <input type=text class=c-form__input id=new-password name=new-password ng-model=$ctrl.password ng-change=$ctrl.checkStrength() autocomplete=new-password ng-minlength=8 ng-maxlength=50 ng-disabled=$ctrl.saving required/> <label class=c-form__label for=new-password>Account Password</label> </div> <div class=c-strength-meter> <div class=c-strength-meter__fill data-strength=\"{{ $ctrl.strength.score || 0 }}\"></div> </div> ";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    controller: 'editReservationController',
    template: __webpack_require__(882)
};

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports = "<div class=c-reservation-edit> <div class=grid-x> <div class=\"cell medium-auto\"></div> <div class=\"cell medium-8 / text-center\" ng-if=\"!$ctrl.isEditing && !$ctrl.isLoggedIn && $ctrl.content\"> <span ng-bind-html=$ctrl.markdownService.translate($ctrl.content)></span> <hr/> </div> <div class=\"cell medium-auto\"></div> </div> <div class=grid-x> <div class=\"cell medium-auto\"></div> <div class=\"cell medium-8\" ng-class=\"{'large-4': !$ctrl.isEditing, 'large-6': $ctrl.isEditing}\"> <div class=\"c-prompt c-prompt--login c-prompt--static\" ng-if=\"!$ctrl.isEditing && !$ctrl.isLoggedIn\"> <div class=c-prompt__body> <p class=c-prompt__info ng-if=!$ctrl.basket.empty()> Please be aware, editing a reservation will clear your basket. </p> <p class=c-checkout__error ng-if=$ctrl.error ng-bind-html=$ctrl.error></p> <form ng-submit=$ctrl.editReservation()> <div class=c-prompt__inputs> <div class=c-form__field> <input name=Reference class=c-form__input type=text autocomplete=false ng-model=$ctrl.reference required ng-disabled=$ctrl.saving autofocus/> <label class=\"c-form__label t-text--secondary\" for=Reference> Reservation Number/Reference </label> </div> <div class=c-form__field> <input name=Surname class=c-form__input type=text autocomplete=family-name ng-model=$ctrl.surname required ng-disabled=$ctrl.saving /> <label class=\"c-form__label t-text--secondary\" for=Surname> Lead Booker's Surname </label> </div> <div class=\"c-form__field c-select--date\"> <input name=Date type=text class=\"c-form__input / js-flatpickr\" autocomplete=false ng-model=$ctrl.date required readonly=readonly /> <label class=\"c-form__label t-text--secondary\" for=Date> Arrival Date </label> </div> </div> <div class=c-prompt__buttons> <button class=c-button type=submit ng-disabled=$ctrl.saving data-dismiss=modal> <span class=c-button__text ng-hide=$ctrl.saving> Manage your Booking </span> <spinner ng-show=$ctrl.saving></spinner> </button> </div> </form> </div> </div> <div class=\"c-reservation-edit__success / text-center\" ng-if=$ctrl.displaySuccess()> <h2>Welcome {{ $ctrl.displayName() }}</h2> <p> You are managing your booking {{ $ctrl.displayReference() }} <br/>{{ $ctrl.displayDates() }}. </p> <p> You can add additional {{ $ctrl.displayEventTypes() }} to enhance your stay. </p> <a class=c-button href=\"{{ $ctrl.displayUrl('treatments') }}\" ng-if=\"$ctrl.propertyService.get('hasTreatments')\"> Add Treatments </a> <a class=c-button href=\"{{ $ctrl.displayUrl('spadays') }}\" ng-if=\"$ctrl.propertyService.get('hasSpaDays') && !$ctrl.configService.get('integration').preventEditSpadays\"> Add Spa Days </a> <a class=c-button href=\"{{ $ctrl.displayUrl('activities') }}\" ng-if=\"$ctrl.propertyService.get('hasActivities') && $ctrl.openActivities()\"> Add Activities </a> <div class=c-basket__reservation ng-if=$ctrl.displayReference()> <reservation-items></reservation-items> </div> </div> <div class=\"c-reservation-edit__loggedin / text-center\" ng-if=$ctrl.isLoggedIn> <p> Sorry, you are already logged in, you may not edit another reservation. </p> </div> </div> <div class=\"cell medium-auto\"></div> </div> </div> ";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        orderHistory: function orderHistory(timeframe, page) {
            return api.get('history?timeframe=' + timeframe + '&page=' + page).then(function (response) {
                return response.data;
            });
        },

        emailInvoice: function emailInvoice(basketCode) {
            return api.post('email-invoice', {
                basketCode: basketCode
            }).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ['api', function (api) {
    return {
        login: function login(payload) {
            return api.post('api/login', payload).then(function (response) {
                return response.data;
            });
        },
        byReference: function byReference(payload) {
            return api.post('api/reservation/edit', payload).then(function (response) {
                return response.data;
            });
        },
        register: function register(payload) {
            return api.post('api/account/create', payload).then(function (response) {
                return response.data;
            });
        },
        setCustomerPassword: function setCustomerPassword(payload) {
            return api.post('api/account/setPassword', payload).then(function (response) {
                return response.data;
            });
        },
        setCorePassword: function setCorePassword(payload) {
            return api.post('api/core/setPassword', payload).then(function (response) {
                return response.data;
            });
        }
    };
}];

/***/ })
]),[322]);


// WEBPACK FOOTER //
// storefront-ce60cd2636a33025bc88.js